webpackJsonp([1],{

/***/ "+0ZI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "+4G4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-email",
  "use": "icon-email-usage",
  "viewBox": "0 0 128 96",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 96\" id=\"icon-email\"><path d=\"M64.125 56.975L120.188.912A12.476 12.476 0 0 0 115.5 0h-103c-1.588 0-3.113.3-4.513.838l56.138 56.137z\" /><path d=\"M64.125 68.287l-62.3-62.3A12.42 12.42 0 0 0 0 12.5v71C0 90.4 5.6 96 12.5 96h103c6.9 0 12.5-5.6 12.5-12.5v-71a12.47 12.47 0 0 0-1.737-6.35L64.125 68.287z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+Dip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-language",
  "use": "icon-language-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-language\"><path d=\"M84.742 36.8c2.398 7.2 5.595 12.8 11.19 18.4 4.795-4.8 7.992-11.2 10.39-18.4h-21.58zm-52.748 40h20.78l-10.39-28-10.39 28z\" /><path d=\"M111.916 0H16.009C7.218 0 .025 7.2.025 16v96c0 8.8 7.193 16 15.984 16h95.907c8.791 0 15.984-7.2 15.984-16V16c0-8.8-6.394-16-15.984-16zM72.754 103.2c-1.598 1.6-3.197 1.6-4.795 1.6-.8 0-2.398 0-3.197-.8-.8-.8-1.599 0-1.599-.8s-.799-1.6-1.598-3.2c-.8-1.6-.8-2.4-1.599-4l-3.196-8.8H28.797L25.6 96c-1.598 3.2-2.398 5.6-3.197 7.2-.8 1.6-2.398 1.6-4.795 1.6-1.599 0-3.197-.8-4.796-1.6-1.598-1.6-2.397-2.4-2.397-4 0-.8 0-1.6.799-3.2.8-1.6.8-2.4 1.598-4l17.583-44.8c.8-1.6.8-3.2 1.599-4.8.799-1.6 1.598-3.2 2.397-4 .8-.8 1.599-2.4 3.197-3.2 1.599-.8 3.197-.8 4.796-.8 1.598 0 3.196 0 4.795.8 1.598.8 2.398 1.6 3.197 3.2.799.8 1.598 2.4 2.397 4 .8 1.6 1.599 3.2 2.398 5.6l17.583 44c1.598 3.2 2.398 5.6 2.398 7.2-.8.8-1.599 2.4-2.398 4zM116.711 72c-8.791-3.2-15.185-7.2-20.78-12-5.594 5.6-12.787 9.6-21.579 12l-2.397-4c8.791-2.4 15.984-5.6 21.579-11.2C87.939 51.2 83.144 44 81.545 36h-7.992v-3.2h21.58c-1.6-2.4-3.198-5.6-4.796-8l2.397-.8c1.599 2.4 3.997 5.6 5.595 8.8h19.98v4h-7.992c-2.397 8-6.393 15.2-11.189 20 5.595 4.8 11.988 8.8 20.78 11.2l-3.197 4z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "+ZTe":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "+tsz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CIjI");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("db5a9e50", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-670f1af6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-670f1af6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "084t":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "0DNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-zip",
  "use": "icon-zip-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-zip\"><path d=\"M78.527 116.793c.178.008.348.024.527.024h40.233c4.711-.005 8.53-3.677 8.534-8.21V18.895c-.004-4.532-3.823-8.204-8.534-8.209H79.054c-.179 0-.353.016-.527.024V0L0 10.082v107.406l78.527 10.342v-11.037zm0-101.362c.174-.024.348-.052.527-.052h40.233c2.018 0 3.659 1.578 3.659 3.52v89.713c-.003 1.942-1.64 3.517-3.659 3.519H79.054c-.179 0-.353-.028-.527-.052V15.431zM30.262 75.757l-18.721-.46V72.37l11.3-16.673v-.148l-10.266.164v-4.51l17.504-.44v3.264L18.696 70.76v.144l11.566.176v4.678zm9.419.231l-5.823-.144V50.671l5.823-.144v25.461zm22.255-11.632c-2.168 1.922-5.353 2.76-9.02 2.736-.702.004-1.402-.04-2.097-.131v9.303l-5.997-.148V50.743c1.852-.352 4.473-.647 8.218-.743 3.838-.096 6.608.539 8.48 1.913 1.807 1.306 3.032 3.5 3.032 6.112s-.926 4.833-2.612 6.331h-.004zM53.36 54.45c-.856-.01-1.71.083-2.541.275v7.682c.523.116 1.167.152 2.06.152 3.301-.004 5.36-1.614 5.36-4.314 0-2.425-1.772-3.843-4.875-3.791l-.004-.004zm39.847-37.066h9.564v3.795h-9.564v-3.795zm-9.568 5.68h9.564v3.8h-9.564v-3.8zm9.568 6.216h9.564v3.799h-9.564V29.28zm0 12h9.564v3.794h-9.564V41.28zm-9.568-6.096h9.564v3.795h-9.564v-3.795zm9.472 47.064c2.512 0 4.921-.96 6.697-2.67 1.776-1.708 2.773-4.026 2.772-6.442l-1.748-15.263c0-5.033-2.492-9.112-7.725-9.112-5.232 0-7.72 4.079-7.72 9.112l-1.752 15.263c-.001 2.417.996 4.735 2.773 6.444 1.777 1.71 4.187 2.669 6.7 2.668h.003zm-3.135-16.75h6.27v12.743h-6.27V65.5z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "0PeL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Gzgn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("21d48e96", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-366925f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-366925f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "0uoj":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2f5w");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("238e44f6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-01cbbca2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-01cbbca2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "10i9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JEYi");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2b78558b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c28884e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c28884e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1ehH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "1xAo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2+48":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Bq9E");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6ddf898b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06ef5848\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-06ef5848\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "220C":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "2MVh":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "2f5w":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "2jyU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a5Jc");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("649ef0fa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c959c754\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c959c754\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3/NM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("220C");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0af2e6aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-66c77f84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-66c77f84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3Nxa":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qj5l");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("48474575", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e52d8fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4e52d8fa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3OZC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3eCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tree",
  "use": "icon-tree-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-tree\"><path d=\"M126.713 90.023c.858.985 1.287 2.134 1.287 3.447v29.553c0 1.423-.429 2.6-1.287 3.53-.858.93-1.907 1.395-3.146 1.395H97.824c-1.145 0-2.146-.465-3.004-1.395-.858-.93-1.287-2.107-1.287-3.53V93.47c0-.875.19-1.696.572-2.462.382-.766.906-1.368 1.573-1.806a3.84 3.84 0 0 1 2.146-.657h9.725V69.007a3.84 3.84 0 0 0-.43-1.806 3.569 3.569 0 0 0-1.143-1.313 2.714 2.714 0 0 0-1.573-.492h-36.47v23.149h9.725c1.144 0 2.145.492 3.004 1.478.858.985 1.287 2.134 1.287 3.447v29.553c0 .876-.191 1.696-.573 2.463-.38.766-.905 1.368-1.573 1.806a3.84 3.84 0 0 1-2.145.656H51.915a3.84 3.84 0 0 1-2.145-.656c-.668-.438-1.216-1.04-1.645-1.806a4.96 4.96 0 0 1-.644-2.463V93.47c0-1.313.43-2.462 1.288-3.447.858-.986 1.907-1.478 3.146-1.478h9.582v-23.15h-37.9c-.953 0-1.74.356-2.359 1.068-.62.711-.93 1.56-.93 2.544v19.538h9.726c1.239 0 2.264.492 3.074 1.478.81.985 1.216 2.134 1.216 3.447v29.553c0 1.423-.405 2.6-1.216 3.53-.81.93-1.835 1.395-3.074 1.395H4.29c-.476 0-.93-.082-1.358-.246a4.1 4.1 0 0 1-1.144-.657 4.658 4.658 0 0 1-.93-1.067 5.186 5.186 0 0 1-.643-1.395 5.566 5.566 0 0 1-.215-1.56V93.47c0-.437.048-.875.143-1.313a3.95 3.95 0 0 1 .429-1.15c.19-.328.429-.656.715-.984.286-.329.572-.602.858-.821.286-.22.62-.383 1.001-.493.382-.11.763-.164 1.144-.164h9.726V61.619c0-.985.31-1.833.93-2.544.619-.712 1.358-1.068 2.216-1.068h44.335V39.62h-9.582c-1.24 0-2.288-.492-3.146-1.477a5.09 5.09 0 0 1-1.287-3.448V5.14c0-1.423.429-2.627 1.287-3.612.858-.985 1.907-1.477 3.146-1.477h25.743c.763 0 1.478.246 2.145.739a5.17 5.17 0 0 1 1.573 1.888c.382.766.573 1.587.573 2.462v29.553c0 1.313-.43 2.463-1.287 3.448-.859.985-1.86 1.477-3.004 1.477h-9.725v18.389h42.762c.954 0 1.74.355 2.36 1.067.62.711.93 1.56.93 2.545v26.925h9.582c1.239 0 2.288.492 3.146 1.478z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "3m6p":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("RG2q");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6c341402", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c6d2736\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2c6d2736\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3nTM":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7q5p");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c6c59c82", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0494c3d6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0494c3d6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3q8z":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9FJF");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6d76c4f4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c1c22e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3c1c22e6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "48eA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qsCE");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("41518b7d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-695f5a96\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-695f5a96\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4S/0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("W7jK");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5c32d0a8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c7188da2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c7188da2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "4wdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 128 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 64\" id=\"icon-eye\"><path d=\"M127.072 7.994c1.37-2.208.914-5.152-.914-6.87-2.056-1.717-4.797-1.226-6.396.982-.229.245-25.586 32.382-55.74 32.382-29.24 0-55.74-32.382-55.968-32.627-1.6-1.963-4.57-2.208-6.397-.49C-.17 3.086-.399 6.275 1.2 8.238c.457.736 5.94 7.36 14.62 14.72L4.17 35.96c-1.828 1.963-1.6 5.152.228 6.87.457.98 1.6 1.471 2.742 1.471s2.284-.49 3.198-1.472l12.564-13.983c5.94 4.416 13.021 8.587 20.788 11.53l-4.797 17.418c-.685 2.699.686 5.397 3.198 6.133h1.37c2.057 0 3.884-1.472 4.341-3.68L52.6 42.83c3.655.736 7.538 1.227 11.422 1.227 3.883 0 7.767-.49 11.422-1.227l4.797 17.173c.457 2.208 2.513 3.68 4.34 3.68.457 0 .914 0 1.143-.246 2.513-.736 3.883-3.434 3.198-6.133l-4.797-17.172c7.767-2.944 14.848-7.114 20.788-11.53l12.336 13.738c.913.981 2.056 1.472 3.198 1.472s2.284-.49 3.198-1.472c1.828-1.963 1.828-4.906.228-6.87l-11.65-13.001c9.366-7.36 14.849-14.474 14.849-14.474z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "60zo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-star\"><path d=\"M70.66 4.328l14.01 29.693c1.088 2.29 3.177 3.882 5.603 4.25l31.347 4.76c6.087.926 8.528 8.756 4.117 13.247L103.05 79.395c-1.75 1.78-2.544 4.352-2.132 6.867l5.352 32.641c1.043 6.337-5.33 11.182-10.778 8.19l-28.039-15.409a7.13 7.13 0 0 0-6.91 0l-28.039 15.41c-5.448 2.99-11.821-1.854-10.777-8.19l5.352-32.642c.415-2.515-.387-5.088-2.136-6.867L2.264 56.278C-2.146 51.787.286 43.957 6.38 43.031l31.343-4.76c2.419-.368 4.51-1.96 5.595-4.25L57.334 4.328c2.728-5.77 10.605-5.77 13.325 0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "67t3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "68AW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WHiB");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e3c82cce", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00dad650\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-00dad650\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6EuI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Qpzp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3dd27c11", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5d51fc60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5d51fc60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6ZCx":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+ZTe");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c6ed5386", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eab1d754\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-eab1d754\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "6wlc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Y4jG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("bf79469c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ffe794e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ffe794e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "798r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-nested",
  "use": "icon-nested-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-nested\"><path d=\"M.002 9.2c0 5.044 3.58 9.133 7.998 9.133 4.417 0 7.997-4.089 7.997-9.133 0-5.043-3.58-9.132-7.997-9.132S.002 4.157.002 9.2zM31.997.066h95.981V18.33H31.997V.066zm0 45.669c0 5.044 3.58 9.132 7.998 9.132 4.417 0 7.997-4.088 7.997-9.132 0-3.263-1.524-6.278-3.998-7.91-2.475-1.63-5.524-1.63-7.998 0-2.475 1.632-4 4.647-4 7.91zM63.992 36.6h63.986v18.265H63.992V36.6zm-31.995 82.2c0 5.043 3.58 9.132 7.998 9.132 4.417 0 7.997-4.089 7.997-9.132 0-5.044-3.58-9.133-7.997-9.133s-7.998 4.089-7.998 9.133zm31.995-9.131h63.986v18.265H63.992V109.67zm0-27.404c0 5.044 3.58 9.133 7.998 9.133 4.417 0 7.997-4.089 7.997-9.133 0-3.263-1.524-6.277-3.998-7.909-2.475-1.631-5.524-1.631-7.998 0-2.475 1.632-4 4.646-4 7.91zm31.995-9.13h31.991V91.4H95.987V73.135z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "7EKC":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Rrua");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("77f0d699", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ebb540f2\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./app.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ebb540f2\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./app.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7KqF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("NF/t");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7f518792", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63813ed0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-63813ed0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "7pS5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "7q5p":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "7tkY":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("QSLb");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9b772abe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a8e74dc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./empty-permissions.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a8e74dc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./empty-permissions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "8e8P":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("zwJz");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("2b00c9fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e19fa7b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./activity-list.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e19fa7b4\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./activity-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "90Fk":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./404.svg": "sEM+",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./component.svg": "s2cW",
	"./dashboard.svg": "BCGP",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./ic_category.svg": "YEm6",
	"./ic_club.svg": "DKu2",
	"./ic_player.svg": "FBbj",
	"./ic_team.svg": "phNT",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./password.svg": "QjmH",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./qq.svg": "R2jY",
	"./screenfull.svg": "Qn9o",
	"./shopping.svg": "jRi0",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";

/***/ }),

/***/ "9Cl7":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "9FJF":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "9GeN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("y4wQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("618fd58c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2467e07a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2467e07a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "9nNw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WpYO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4e8fb352", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6ae5260f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6ae5260f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "AaQT":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("084t");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("55f261c1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-125fe4d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-125fe4d4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BCGP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 128 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 100\" id=\"icon-dashboard\"><path d=\"M27.429 63.638c0-2.508-.893-4.65-2.679-6.424-1.786-1.775-3.94-2.662-6.464-2.662-2.524 0-4.679.887-6.465 2.662-1.785 1.774-2.678 3.916-2.678 6.424 0 2.508.893 4.65 2.678 6.424 1.786 1.775 3.94 2.662 6.465 2.662 2.524 0 4.678-.887 6.464-2.662 1.786-1.775 2.679-3.916 2.679-6.424zm13.714-31.801c0-2.508-.893-4.65-2.679-6.424-1.785-1.775-3.94-2.662-6.464-2.662-2.524 0-4.679.887-6.464 2.662-1.786 1.774-2.679 3.916-2.679 6.424 0 2.508.893 4.65 2.679 6.424 1.785 1.774 3.94 2.662 6.464 2.662 2.524 0 4.679-.888 6.464-2.662 1.786-1.775 2.679-3.916 2.679-6.424zM71.714 65.98l7.215-27.116c.285-1.23.107-2.378-.536-3.443-.643-1.064-1.56-1.762-2.75-2.094-1.19-.33-2.333-.177-3.429.462-1.095.639-1.81 1.573-2.143 2.804l-7.214 27.116c-2.857.237-5.405 1.266-7.643 3.088-2.238 1.822-3.738 4.152-4.5 6.992-.952 3.644-.476 7.098 1.429 10.364 1.905 3.265 4.69 5.37 8.357 6.317 3.667.947 7.143.474 10.429-1.42 3.285-1.892 5.404-4.66 6.357-8.305.762-2.84.619-5.607-.429-8.305-1.047-2.697-2.762-4.85-5.143-6.46zm47.143-2.342c0-2.508-.893-4.65-2.678-6.424-1.786-1.775-3.94-2.662-6.465-2.662-2.524 0-4.678.887-6.464 2.662-1.786 1.774-2.679 3.916-2.679 6.424 0 2.508.893 4.65 2.679 6.424 1.786 1.775 3.94 2.662 6.464 2.662 2.524 0 4.679-.887 6.465-2.662 1.785-1.775 2.678-3.916 2.678-6.424zm-45.714-45.43c0-2.509-.893-4.65-2.679-6.425C68.68 10.01 66.524 9.122 64 9.122c-2.524 0-4.679.887-6.464 2.661-1.786 1.775-2.679 3.916-2.679 6.425 0 2.508.893 4.65 2.679 6.424 1.785 1.774 3.94 2.662 6.464 2.662 2.524 0 4.679-.888 6.464-2.662 1.786-1.775 2.679-3.916 2.679-6.424zm32 13.629c0-2.508-.893-4.65-2.679-6.424-1.785-1.775-3.94-2.662-6.464-2.662-2.524 0-4.679.887-6.464 2.662-1.786 1.774-2.679 3.916-2.679 6.424 0 2.508.893 4.65 2.679 6.424 1.785 1.774 3.94 2.662 6.464 2.662 2.524 0 4.679-.888 6.464-2.662 1.786-1.775 2.679-3.916 2.679-6.424zM128 63.638c0 12.351-3.357 23.78-10.071 34.286-.905 1.372-2.19 2.058-3.858 2.058H13.93c-1.667 0-2.953-.686-3.858-2.058C3.357 87.465 0 76.037 0 63.638c0-8.613 1.69-16.847 5.071-24.703C8.452 31.08 13 24.312 18.714 18.634c5.715-5.68 12.524-10.199 20.429-13.559C47.048 1.715 55.333.035 64 .035c8.667 0 16.952 1.68 24.857 5.04 7.905 3.36 14.714 7.88 20.429 13.559 5.714 5.678 10.262 12.446 13.643 20.301 3.38 7.856 5.071 16.09 5.071 24.703z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "BLO3":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Blf9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Bq9E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "CIjI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.player-uploader{\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.player-uploader:hover {\n  border-color: #409EFF;\n}\n.player-uploader-icon {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports


/***/ }),

/***/ "CJdp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Cr4N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-size",
  "use": "icon-size-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-size\"><path d=\"M0 54.857h54.796v18.286H36.531V128H18.265V73.143H0V54.857zm127.857-36.571H91.935V128H72.456V18.286H36.534V0h91.326l-.003 18.286z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "D6Jq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PwkO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5c86ad9b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47227766\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./login.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47227766\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./login.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DFbB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Pvew");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b2f59ab2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64ccd7d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-import.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-64ccd7d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-import.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "DKu2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-ic_club",
  "use": "icon-ic_club-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_club\">\n<style type=\"text/css\">\n\t#icon-ic_club .st0{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M94.2,19.4C76.8,19.1,67.4,11.3,65,9c-1.2-1.1-3-1.1-4.2,0C58.4,11.4,49,19.1,31.6,19.5\n\t\tc-1.6,0.1-2.9,1.4-2.9,3v22.1c0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8\n\t\tc11.6-9.1,18.6-23.8,18.6-39.3V22.4C97.1,20.8,95.8,19.5,94.2,19.4z\" />\n</g>\n<title>15</title>\n<g>\n\t<path class=\"st0\" d=\"M65.5,39.4C48.1,39.1,38.7,31.3,36.3,29c-1.2-1.1-3-1.1-4.2,0c-2.4,2.4-11.8,10.1-29.2,10.5\n\t\tc-1.6,0.1-2.9,1.4-2.9,3v22.1c0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8\n\t\tc11.6-9.1,18.6-23.8,18.6-39.3V42.4C68.4,40.8,67.1,39.5,65.5,39.4z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "DMMu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "E+mH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n@charset \"UTF-8\";\n@-webkit-keyframes vicp_progress {\n0% {\r\n    background-position-y: 0;\n}\n100% {\r\n    background-position-y: 40px;\n}\n}\n@keyframes vicp_progress {\n0% {\r\n    background-position-y: 0;\n}\n100% {\r\n    background-position-y: 40px;\n}\n}\n@-webkit-keyframes vicp {\n0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0) translatey(-60px);\r\n            transform: scale(0) translatey(-60px);\n}\n100% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1) translatey(0);\r\n            transform: scale(1) translatey(0);\n}\n}\n@keyframes vicp {\n0% {\r\n    opacity: 0;\r\n    -webkit-transform: scale(0) translatey(-60px);\r\n            transform: scale(0) translatey(-60px);\n}\n100% {\r\n    opacity: 1;\r\n    -webkit-transform: scale(1) translatey(0);\r\n            transform: scale(1) translatey(0);\n}\n}\n.vue-image-crop-upload {\r\n  position: fixed;\r\n  display: block;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\r\n  z-index: 10000;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.65);\r\n  -webkit-tap-highlight-color: transparent;\r\n  -moz-tap-highlight-color: transparent;\n}\n.vue-image-crop-upload .vicp-wrap {\r\n    -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n    position: fixed;\r\n    display: block;\r\n    -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n    z-index: 10000;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    margin: auto;\r\n    width: 600px;\r\n    height: 330px;\r\n    padding: 25px;\r\n    background-color: #fff;\r\n    border-radius: 2px;\r\n    -webkit-animation: vicp 0.12s ease-in;\r\n            animation: vicp 0.12s ease-in;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-close {\r\n      position: absolute;\r\n      right: -30px;\r\n      top: -30px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4 {\r\n        position: relative;\r\n        display: block;\r\n        width: 30px;\r\n        height: 30px;\r\n        cursor: pointer;\r\n        -webkit-transition: -webkit-transform 0.18s;\r\n        transition: -webkit-transform 0.18s;\r\n        transition: transform 0.18s;\r\n        transition: transform 0.18s, -webkit-transform 0.18s;\r\n        -webkit-transform: rotate(0);\r\n                transform: rotate(0);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::after, .vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::before {\r\n          -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n                  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n          content: '';\r\n          position: absolute;\r\n          top: 12px;\r\n          left: 4px;\r\n          width: 20px;\r\n          height: 3px;\r\n          -webkit-transform: rotate(45deg);\r\n                  transform: rotate(45deg);\r\n          background-color: #fff;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4::after {\r\n          -webkit-transform: rotate(-45deg);\r\n                  transform: rotate(-45deg);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:hover {\r\n          -webkit-transform: rotate(90deg);\r\n                  transform: rotate(90deg);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area {\r\n      position: relative;\r\n      -webkit-box-sizing: border-box;\r\n              box-sizing: border-box;\r\n      padding: 35px;\r\n      height: 170px;\r\n      background-color: rgba(0, 0, 0, 0.03);\r\n      text-align: center;\r\n      border: 1px dashed rgba(0, 0, 0, 0.08);\r\n      overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 {\r\n        display: block;\r\n        margin: 0 auto 6px;\r\n        width: 42px;\r\n        height: 42px;\r\n        overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-arrow {\r\n          display: block;\r\n          margin: 0 auto;\r\n          width: 0;\r\n          height: 0;\r\n          border-bottom: 14.7px solid rgba(0, 0, 0, 0.3);\r\n          border-left: 14.7px solid transparent;\r\n          border-right: 14.7px solid transparent;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-body {\r\n          display: block;\r\n          width: 12.6px;\r\n          height: 14.7px;\r\n          margin: 0 auto;\r\n          background-color: rgba(0, 0, 0, 0.3);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-bottom {\r\n          -webkit-box-sizing: border-box;\r\n                  box-sizing: border-box;\r\n          display: block;\r\n          height: 12.6px;\r\n          border: 6px solid rgba(0, 0, 0, 0.3);\r\n          border-top: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-hint {\r\n        display: block;\r\n        padding: 15px;\r\n        font-size: 14px;\r\n        color: #666;\r\n        line-height: 30px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-no-supported-hint {\r\n        display: block;\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        padding: 30px;\r\n        width: 100%;\r\n        height: 60px;\r\n        line-height: 30px;\r\n        background-color: #eee;\r\n        text-align: center;\r\n        color: #666;\r\n        font-size: 14px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area:hover {\r\n        cursor: pointer;\r\n        border-color: rgba(0, 0, 0, 0.1);\r\n        background-color: rgba(0, 0, 0, 0.05);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop {\r\n      overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left {\r\n        float: left;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container {\r\n          position: relative;\r\n          display: block;\r\n          width: 240px;\r\n          height: 180px;\r\n          background-color: #e5e5e0;\r\n          overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img {\r\n            position: absolute;\r\n            display: block;\r\n            cursor: move;\r\n            -webkit-user-select: none;\r\n               -moz-user-select: none;\r\n                -ms-user-select: none;\r\n                    user-select: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade {\r\n            -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n                    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n            position: absolute;\r\n            background-color: rgba(241, 242, 243, 0.8);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-1 {\r\n              top: 0;\r\n              left: 0;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-2 {\r\n              bottom: 0;\r\n              right: 0;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate {\r\n          position: relative;\r\n          width: 240px;\r\n          height: 18px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i {\r\n            display: block;\r\n            width: 18px;\r\n            height: 18px;\r\n            border-radius: 100%;\r\n            line-height: 18px;\r\n            text-align: center;\r\n            font-size: 12px;\r\n            font-weight: bold;\r\n            background-color: rgba(0, 0, 0, 0.08);\r\n            color: #fff;\r\n            overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:hover {\r\n              -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n                      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n              cursor: pointer;\r\n              background-color: rgba(0, 0, 0, 0.14);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:first-child {\r\n              float: left;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:last-child {\r\n              float: right;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range {\r\n          position: relative;\r\n          margin: 30px 0 10px 0;\r\n          width: 240px;\r\n          height: 18px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5,\r\n          .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6 {\r\n            position: absolute;\r\n            top: 0;\r\n            width: 18px;\r\n            height: 18px;\r\n            border-radius: 100%;\r\n            background-color: rgba(0, 0, 0, 0.08);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5:hover,\r\n            .vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6:hover {\r\n              -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n                      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n              cursor: pointer;\r\n              background-color: rgba(0, 0, 0, 0.14);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5 {\r\n            left: 0;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5::before {\r\n              position: absolute;\r\n              content: '';\r\n              display: block;\r\n              left: 3px;\r\n              top: 8px;\r\n              width: 12px;\r\n              height: 2px;\r\n              background-color: #fff;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6 {\r\n            right: 0;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6::before {\r\n              position: absolute;\r\n              content: '';\r\n              display: block;\r\n              left: 3px;\r\n              top: 8px;\r\n              width: 12px;\r\n              height: 2px;\r\n              background-color: #fff;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6::after {\r\n              position: absolute;\r\n              content: '';\r\n              display: block;\r\n              top: 3px;\r\n              left: 8px;\r\n              width: 2px;\r\n              height: 12px;\r\n              background-color: #fff;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range] {\r\n            display: block;\r\n            padding-top: 5px;\r\n            margin: 0 auto;\r\n            width: 180px;\r\n            height: 8px;\r\n            vertical-align: top;\r\n            background: transparent;\r\n            -webkit-appearance: none;\r\n               -moz-appearance: none;\r\n                    appearance: none;\r\n            cursor: pointer;\r\n            /* 滑块\r\n\t\t\t\t\t\t\t ---------------------------------------------------------------*/\r\n            /* 轨道\r\n\t\t\t\t\t\t\t ---------------------------------------------------------------*/\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus {\r\n              outline: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-thumb {\r\n              -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n                      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n              -webkit-appearance: none;\r\n                      appearance: none;\r\n              margin-top: -3px;\r\n              width: 12px;\r\n              height: 12px;\r\n              background-color: #61c091;\r\n              border-radius: 100%;\r\n              border: none;\r\n              -webkit-transition: 0.2s;\r\n              transition: 0.2s;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-thumb {\r\n              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n              -moz-appearance: none;\r\n                   appearance: none;\r\n              width: 12px;\r\n              height: 12px;\r\n              background-color: #61c091;\r\n              border-radius: 100%;\r\n              border: none;\r\n              -webkit-transition: 0.2s;\r\n              transition: 0.2s;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-thumb {\r\n              box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.18);\r\n              appearance: none;\r\n              width: 12px;\r\n              height: 12px;\r\n              background-color: #61c091;\r\n              border: none;\r\n              border-radius: 100%;\r\n              -webkit-transition: 0.2s;\r\n              transition: 0.2s;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-moz-range-thumb {\r\n              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n              width: 14px;\r\n              height: 14px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-ms-thumb {\r\n              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n              width: 14px;\r\n              height: 14px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-webkit-slider-thumb {\r\n              -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n                      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.23);\r\n              margin-top: -4px;\r\n              width: 14px;\r\n              height: 14px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-runnable-track {\r\n              -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n                      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n              width: 100%;\r\n              height: 6px;\r\n              cursor: pointer;\r\n              border-radius: 2px;\r\n              border: none;\r\n              background-color: rgba(68, 170, 119, 0.3);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-track {\r\n              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n              width: 100%;\r\n              height: 6px;\r\n              cursor: pointer;\r\n              border-radius: 2px;\r\n              border: none;\r\n              background-color: rgba(68, 170, 119, 0.3);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-track {\r\n              box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);\r\n              width: 100%;\r\n              cursor: pointer;\r\n              background: transparent;\r\n              border-color: transparent;\r\n              color: transparent;\r\n              height: 6px;\r\n              border-radius: 2px;\r\n              border: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-lower {\r\n              background-color: rgba(68, 170, 119, 0.3);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-upper {\r\n              background-color: rgba(68, 170, 119, 0.15);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-webkit-slider-runnable-track {\r\n              background-color: rgba(68, 170, 119, 0.5);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-moz-range-track {\r\n              background-color: rgba(68, 170, 119, 0.5);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-lower {\r\n              background-color: rgba(68, 170, 119, 0.45);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-upper {\r\n              background-color: rgba(68, 170, 119, 0.25);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right {\r\n        float: right;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview {\r\n          height: 150px;\r\n          overflow: hidden;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item {\r\n            position: relative;\r\n            padding: 5px;\r\n            width: 100px;\r\n            height: 100px;\r\n            float: left;\r\n            margin-right: 16px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item span {\r\n              position: absolute;\r\n              bottom: -30px;\r\n              width: 100%;\r\n              font-size: 14px;\r\n              color: #bbb;\r\n              display: block;\r\n              text-align: center;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item img {\r\n              position: absolute;\r\n              display: block;\r\n              top: 0;\r\n              bottom: 0;\r\n              left: 0;\r\n              right: 0;\r\n              margin: auto;\r\n              padding: 3px;\r\n              background-color: #fff;\r\n              border: 1px solid rgba(0, 0, 0, 0.15);\r\n              overflow: hidden;\r\n              -webkit-user-select: none;\r\n                 -moz-user-select: none;\r\n                  -ms-user-select: none;\r\n                      user-select: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle {\r\n              margin-right: 0;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle img {\r\n                border-radius: 100%;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload {\r\n      position: relative;\r\n      -webkit-box-sizing: border-box;\r\n              box-sizing: border-box;\r\n      padding: 35px;\r\n      height: 170px;\r\n      background-color: rgba(0, 0, 0, 0.03);\r\n      text-align: center;\r\n      border: 1px dashed #ddd;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-loading {\r\n        display: block;\r\n        padding: 15px;\r\n        font-size: 16px;\r\n        color: #999;\r\n        line-height: 30px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap {\r\n        margin-top: 12px;\r\n        background-color: rgba(0, 0, 0, 0.08);\r\n        border-radius: 3px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress {\r\n          position: relative;\r\n          display: block;\r\n          height: 5px;\r\n          border-radius: 3px;\r\n          background-color: #4a7;\r\n          -webkit-box-shadow: 0 2px 6px 0 rgba(68, 170, 119, 0.3);\r\n                  box-shadow: 0 2px 6px 0 rgba(68, 170, 119, 0.3);\r\n          -webkit-transition: width 0.15s linear;\r\n          transition: width 0.15s linear;\r\n          background-image: linear-gradient(-45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent);\r\n          background-size: 40px 40px;\r\n          -webkit-animation: vicp_progress 0.5s linear infinite;\r\n                  animation: vicp_progress 0.5s linear infinite;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress::after {\r\n            content: '';\r\n            position: absolute;\r\n            display: block;\r\n            top: -3px;\r\n            right: -3px;\r\n            width: 9px;\r\n            height: 9px;\r\n            border: 1px solid rgba(245, 246, 247, 0.7);\r\n            -webkit-box-shadow: 0 1px 4px 0 rgba(68, 170, 119, 0.7);\r\n                    box-shadow: 0 1px 4px 0 rgba(68, 170, 119, 0.7);\r\n            border-radius: 100%;\r\n            background-color: #4a7;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-error,\r\n      .vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-success {\r\n        height: 100px;\r\n        line-height: 100px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-operate {\r\n      position: absolute;\r\n      right: 20px;\r\n      bottom: 20px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-operate a {\r\n        position: relative;\r\n        float: left;\r\n        display: block;\r\n        margin-left: 10px;\r\n        width: 100px;\r\n        height: 36px;\r\n        line-height: 36px;\r\n        text-align: center;\r\n        cursor: pointer;\r\n        font-size: 14px;\r\n        color: #4a7;\r\n        border-radius: 2px;\r\n        overflow: hidden;\r\n        -webkit-user-select: none;\r\n           -moz-user-select: none;\r\n            -ms-user-select: none;\r\n                user-select: none;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-operate a:hover {\r\n          background-color: rgba(0, 0, 0, 0.03);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-error,\r\n    .vue-image-crop-upload .vicp-wrap .vicp-success {\r\n      display: block;\r\n      font-size: 14px;\r\n      line-height: 24px;\r\n      height: 24px;\r\n      color: #d10;\r\n      text-align: center;\r\n      vertical-align: top;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-success {\r\n      color: #4a7;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-icon3 {\r\n      position: relative;\r\n      display: inline-block;\r\n      width: 20px;\r\n      height: 20px;\r\n      top: 4px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-icon3::after {\r\n        position: absolute;\r\n        top: 3px;\r\n        left: 6px;\r\n        width: 6px;\r\n        height: 10px;\r\n        border-width: 0 2px 2px 0;\r\n        border-color: #4a7;\r\n        border-style: solid;\r\n        -webkit-transform: rotate(45deg);\r\n                transform: rotate(45deg);\r\n        content: '';\n}\n.vue-image-crop-upload .vicp-wrap .vicp-icon2 {\r\n      position: relative;\r\n      display: inline-block;\r\n      width: 20px;\r\n      height: 20px;\r\n      top: 4px;\n}\n.vue-image-crop-upload .vicp-wrap .vicp-icon2::after, .vue-image-crop-upload .vicp-wrap .vicp-icon2::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 9px;\r\n        left: 4px;\r\n        width: 13px;\r\n        height: 2px;\r\n        background-color: #d10;\r\n        -webkit-transform: rotate(45deg);\r\n                transform: rotate(45deg);\n}\n.vue-image-crop-upload .vicp-wrap .vicp-icon2::after {\r\n        -webkit-transform: rotate(-45deg);\r\n                transform: rotate(-45deg);\n}\n.e-ripple {\r\n  position: absolute;\r\n  border-radius: 100%;\r\n  background-color: rgba(0, 0, 0, 0.15);\r\n  background-clip: padding-box;\r\n  pointer-events: none;\r\n  -webkit-user-select: none;\r\n     -moz-user-select: none;\r\n      -ms-user-select: none;\r\n          user-select: none;\r\n  -webkit-transform: scale(0);\r\n          transform: scale(0);\r\n  opacity: 1;\n}\n.e-ripple.z-active {\r\n    opacity: 0;\r\n    -webkit-transform: scale(2);\r\n            transform: scale(2);\r\n    -webkit-transition: opacity 1.2s ease-out, -webkit-transform 0.6s ease-out;\r\n    transition: opacity 1.2s ease-out, -webkit-transform 0.6s ease-out;\r\n    transition: opacity 1.2s ease-out, transform 0.6s ease-out;\r\n    transition: opacity 1.2s ease-out, transform 0.6s ease-out, -webkit-transform 0.6s ease-out;\n}\r\n\r\n", ""]);

// exports


/***/ }),

/***/ "Ep23":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Y/El");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0ba68fc1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cd69d6f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cd69d6f8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "F9zM":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#buttons[data-v-08019e22] {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n/* Page content */\n.content[data-v-08019e22] {\n  padding: 16px;\n}\n", ""]);

// exports


/***/ }),

/***/ "FBbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-ic_player",
  "use": "icon-ic_player-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_player\">\n<path d=\"M62.2,29.7c0,3.8-3.1,6.8-6.8,6.8c-3.8,0-6.8-3-6.8-6.8s3.1-6.8,6.8-6.8C59.1,22.9,62.1,26,62.2,29.7z\" />\n<path d=\"M60.4,52.8L57,50.4l0,0l-1.8-1.3l-6,10.9l0.1,0.1l0.3,0.1c-0.1,0-0.1,0-0.2,0L57,64l2,1c1.4,0.7,2.3,2.1,2.4,3.6l1.2,21.1\n\tc0.1,1.2-0.3,2.3-1.1,3.1c-0.8,0.9-1.8,1.4-3,1.4c-0.1,0-0.2,0-0.3,0c-2.3,0-4.2-1.8-4.3-4.1L53,71.6l-2.4-1.2l-5.8-2.9\n\tc-1.8-0.9-4-0.2-5,1.5L38,72.3l-1.9,3.5c-0.1,0.3-0.3,0.5-0.5,0.7L22,92.8c-1,1.2-2.6,1.7-4.1,1.5c-1.5-0.3-2.8-1.3-3.3-2.8\n\ts-0.2-3.1,0.8-4.3l13.4-15.8L30,69l4.8-8.8l0,0l1-2.5v-0.1l3.9-9.7l0,0L36.1,48L34,48.1L23.4,59.8c-1.2,1.3-3.1,1.3-4.4,0.2\n\ts-1.4-3.1-0.3-4.4L30,43.2c0.4-0.5,1-0.8,1.7-0.9l4.3-0.9l11.7-2.5c2.1,1.7,4.7,2.7,7.4,2.7l5.6,3.9l1.7,1.2l12.1-5.5\n\tc1-0.5,2.2-0.3,3.1,0.3s1.4,1.7,1.3,2.8s-0.8,2.1-1.8,2.5L63.4,53C62.4,53.5,61.3,53.4,60.4,52.8z\" />\n<circle cx=\"78.3\" cy=\"87\" r=\"7.4\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "FOHt":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.coach-uploader{\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.coach-uploader:hover {\n  border-color: #409EFF;\n}\n.coach-uploader-icon {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports


/***/ }),

/***/ "FQjR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wuZk");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("40fd3b03", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59060e58\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-59060e58\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "FUO8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Fa30":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FOHt");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("796bdb02", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f228cc0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f228cc0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "FnAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-lock",
  "use": "icon-lock-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-lock\"><path d=\"M119.88 49.674h-7.987V39.52C111.893 17.738 90.45.08 63.996.08 37.543.08 16.1 17.738 16.1 39.52v10.154H8.113c-4.408 0-7.987 2.94-7.987 6.577v65.13c0 3.637 3.57 6.577 7.987 6.577H119.88c4.407 0 7.987-2.94 7.987-6.577v-65.13c-.008-3.636-3.58-6.577-7.987-6.577zm-23.953 0H32.065V39.52c0-14.524 14.301-26.295 31.931-26.295 17.63 0 31.932 11.777 31.932 26.295v10.153z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "G0jH":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "G2aV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.wrap[data-v-26a19b9a] {\n    padding: 10%;\n}\n", ""]);

// exports


/***/ }),

/***/ "G2zY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-message\"><path d=\"M0 20.967v59.59c0 11.59 8.537 20.966 19.075 20.966h28.613l1 26.477L76.8 101.523h32.125c10.538 0 19.075-9.377 19.075-20.966v-59.59C128 9.377 119.463 0 108.925 0h-89.85C8.538 0 0 9.377 0 20.967zm82.325 33.1c0-5.524 4.013-9.935 9.037-9.935 5.026 0 9.038 4.41 9.038 9.934 0 5.524-4.025 9.934-9.038 9.934-5.024 0-9.037-4.41-9.037-9.934zm-27.613 0c0-5.524 4.013-9.935 9.038-9.935s9.037 4.41 9.037 9.934c0 5.524-4.025 9.934-9.037 9.934-5.025 0-9.038-4.41-9.038-9.934zm-27.1 0c0-5.524 4.013-9.935 9.038-9.935s9.038 4.41 9.038 9.934c0 5.524-4.026 9.934-9.05 9.934-5.013 0-9.025-4.41-9.025-9.934z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "G7YU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bqlW");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("09dbe89c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47d488f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-show.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47d488f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "GE6W":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("kuNs");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("355e6965", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a624cd0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6a624cd0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "GPe0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-people",
  "use": "icon-people-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-people\"><path d=\"M104.185 95.254c8.161 7.574 13.145 17.441 13.145 28.28 0 1.508-.098 2.998-.285 4.466h-10.784c.238-1.465.403-2.948.403-4.465 0-8.983-4.36-17.115-11.419-23.216C86 104.66 75.355 107.162 64 107.162c-11.344 0-21.98-2.495-31.22-6.83-7.064 6.099-11.444 14.218-11.444 23.203 0 1.517.165 3 .403 4.465H10.955a35.444 35.444 0 0 1-.285-4.465c0-10.838 4.974-20.713 13.127-28.291C9.294 85.42.003 70.417.003 53.58.003 23.99 28.656.001 64 .001s63.997 23.988 63.997 53.58c0 16.842-9.299 31.85-23.812 41.673zM64 36.867c-29.454 0-53.33-10.077-53.33 15.342 0 25.418 23.876 46.023 53.33 46.023 29.454 0 53.33-20.605 53.33-46.023 0-25.419-23.876-15.342-53.33-15.342zm24.888 25.644c-3.927 0-7.111-2.665-7.111-5.953 0-3.288 3.184-5.954 7.11-5.954 3.928 0 7.111 2.666 7.111 5.954s-3.183 5.953-7.11 5.953zm-3.556 16.372c0 4.11-9.55 7.442-21.332 7.442-11.781 0-21.332-3.332-21.332-7.442 0-1.06.656-2.064 1.8-2.976 3.295 2.626 10.79 4.465 19.532 4.465 8.743 0 16.237-1.84 19.531-4.465 1.145.912 1.801 1.916 1.801 2.976zm-46.22-16.372c-3.927 0-7.11-2.665-7.11-5.953 0-3.288 3.183-5.954 7.11-5.954 3.927 0 7.111 2.666 7.111 5.954s-3.184 5.953-7.11 5.953z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ga39":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.board-column[data-v-8f9406c6] {\n  margin: 1%;\n  min-width: 200px;\n  min-height: 100px;\n  height: auto;\n  overflow: hidden;\n  background: #f0f0f0;\n  border-radius: 3px;\n}\n.board-column .board-column-header[data-v-8f9406c6] {\n    height: 3o0px;\n    line-height: 50px;\n    overflow: hidden;\n    padding: 0 20px;\n    text-align: center;\n    background: #d5583a;\n    color: #fff;\n    border-radius: 3px 3px 0 0;\n}\n.board-column .board-column-content[data-v-8f9406c6] {\n    height: auto;\n    overflow: hidden;\n    border: 10px solid transparent;\n    min-height: 300px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n.board-column .board-column-content .board-item[data-v-8f9406c6] {\n      cursor: pointer;\n      width: 100%;\n      height: 44px;\n      margin: 5px 0;\n      background-color: #fff;\n      text-align: left;\n      line-height: 54px;\n      padding: 2px 6px;\n      -webkit-box-sizing: border-box;\n              box-sizing: border-box;\n      -webkit-box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.2);\n              box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.2);\n}\n", ""]);

// exports


/***/ }),

/***/ "GbHL":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Gres":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9Cl7");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("f6816796", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-036aaf64\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-036aaf64\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Gzgn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.team-manager-uploader{\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.team-manager-uploader:hover {\n  border-color: #409EFF;\n}\n.team-manager-uploader-icon {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports


/***/ }),

/***/ "HScZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cd9B");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("47496327", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2f8817f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2f8817f6\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Hg/M":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "I707":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vp8P");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1b33a77a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6f15dbb3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6f15dbb3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "J/Oh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Blf9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6706cca4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c8a5ef0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-import-csv.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c8a5ef0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-import-csv.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JEYi":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "JRRF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CJdp");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("e697994a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69e8774e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69e8774e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JWvb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("p7dQ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9bb670be", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47e8e629\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./main-layout.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-47e8e629\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./main-layout.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "JrO2":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Jysk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-tab",
  "use": "icon-tab-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-tab\"><path d=\"M78.921.052H49.08c-1.865 0-3.198 1.599-3.198 3.464v6.661c0 1.865 1.6 3.464 3.198 3.464h29.84c1.865 0 3.198-1.599 3.198-3.464V3.516C82.385 1.65 80.786.052 78.92.052zm45.563 0H94.642c-1.865 0-3.464 1.599-3.464 3.464v6.661c0 1.865 1.599 3.464 3.464 3.464h29.842c1.865-.266 3.464-1.599 3.464-3.464V3.516c0-1.865-1.599-3.464-3.464-3.464zm0 22.382H40.02c-1.866 0-3.464-1.599-3.464-3.464V3.516c0-1.865-1.599-3.464-3.464-3.464H3.516C1.65.052.052 1.651.052 3.516V124.75c0 1.598 1.599 3.197 3.464 3.197h120.968c1.865 0 3.464-1.599 3.464-3.464V25.898c0-1.865-1.599-3.464-3.464-3.464z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "KO/S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-clipboard",
  "use": "icon-clipboard-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-clipboard\"><path d=\"M54.857 118.857h64V73.143H89.143c-1.902 0-3.52-.668-4.855-2.002-1.335-1.335-2.002-2.954-2.002-4.855V36.57H54.857v82.286zM73.143 16v-4.571a2.2 2.2 0 0 0-.677-1.61 2.198 2.198 0 0 0-1.609-.676H20.571c-.621 0-1.158.225-1.609.676a2.198 2.198 0 0 0-.676 1.61V16a2.2 2.2 0 0 0 .676 1.61c.451.45.988.676 1.61.676h50.285c.622 0 1.158-.226 1.61-.677.45-.45.676-.987.676-1.609zm18.286 48h21.357L91.43 42.642V64zM128 73.143v48c0 1.902-.667 3.52-2.002 4.855-1.335 1.335-2.953 2.002-4.855 2.002H52.57c-1.901 0-3.52-.667-4.854-2.002-1.335-1.335-2.003-2.953-2.003-4.855v-11.429H6.857c-1.902 0-3.52-.667-4.855-2.002C.667 106.377 0 104.759 0 102.857v-96c0-1.902.667-3.52 2.002-4.855C3.337.667 4.955 0 6.857 0h77.714c1.902 0 3.52.667 4.855 2.002 1.335 1.335 2.003 2.953 2.003 4.855V30.29c1 .622 1.856 1.29 2.569 2.003l29.147 29.147c1.335 1.335 2.478 3.145 3.429 5.43.95 2.287 1.426 4.383 1.426 6.291v-.018z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "KgwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-link",
  "use": "icon-link-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-link\"><path d=\"M115.625 127.937H.063V12.375h57.781v12.374H12.438v90.813h90.813V70.156h12.374z\" /><path d=\"M116.426 2.821l8.753 8.753-56.734 56.734-8.753-8.745z\" /><path d=\"M127.893 37.982h-12.375V12.375H88.706V0h39.187z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "KjYH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("dME6");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7b4c507a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eb42eb8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6eb42eb8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "M8Oc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-pdf",
  "use": "icon-pdf-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pdf\"><path d=\"M869.073 277.307H657.111V65.344l211.962 211.963zm-238.232 26.27V65.344l-476.498-.054v416.957h714.73v-178.67H630.841zm-335.836 360.57c-5.07-3.064-10.944-5.133-17.61-6.201-6.67-1.064-13.603-1.6-20.81-1.6h-48.821v85.641h48.822c7.206 0 14.14-.532 20.81-1.6 6.665-1.065 12.54-3.133 17.609-6.202 5.064-3.063 9.134-7.406 12.208-13.007 3.065-5.602 4.6-12.937 4.6-22.011 0-9.07-1.535-16.408-4.6-22.01-3.074-5.603-7.144-9.94-12.208-13.01zM35.82 541.805v416.904h952.358V541.805H35.821zm331.421 191.179c-3.6 11.071-9.343 20.879-17.209 29.413-7.874 8.542-18.078 15.408-30.617 20.61-12.544 5.206-27.747 7.807-45.621 7.807h-66.036v102.45h-62.831V607.517h128.867c17.874 0 33.077 2.6 45.62 7.802 12.541 5.207 22.745 12.076 30.618 20.615 7.866 8.538 13.604 18.277 17.21 29.212 3.6 10.943 5.401 22.278 5.401 34.018 0 11.477-1.8 22.752-5.402 33.819zM644.9 806.417c-5.343 17.61-13.408 32.818-24.212 45.627-10.807 12.803-24.283 22.879-40.423 30.213-16.146 7.343-35.155 11.007-57.03 11.007h-123.26V607.518h123.26c18.41 0 35.552 2.941 51.428 8.808 15.873 5.869 29.618 14.671 41.22 26.412 11.608 11.744 20.674 26.411 27.217 44.02 6.535 17.61 9.803 38.288 9.803 62.035 0 20.81-2.67 40.02-8.003 57.624zm245.362-146.07h-138.07v66.03h119.66v48.829h-119.66v118.058h-62.83V607.518h200.9v52.829h-.001zm-318.2 25.611c-6.402-8.266-14.877-14.604-25.412-19.01-10.544-4.402-23.551-6.602-39.019-6.602h-44.825v180.088h56.029c9.07 0 17.872-1.463 26.415-4.401 8.535-2.932 16.14-7.802 22.812-14.609 6.665-6.8 12.007-15.667 16.007-26.61 4.003-10.94 6.003-24.275 6.003-40.021 0-14.408-1.4-27.416-4.202-39.019-2.8-11.607-7.406-21.542-13.808-29.816zm0 0\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "NF/t":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "NGwu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("yQyx");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b7b9639c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88dc4382\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./dashboard.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-88dc4382\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./dashboard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/firebase/dist/index.cjs.js
var index_cjs = __webpack_require__("kxiW");
var index_cjs_default = /*#__PURE__*/__webpack_require__.n(index_cjs);

// CONCATENATED MODULE: ./src/shared/firebase/firebase-init.js

// Required for side-effects
// require("firebase/functions");
var app = index_cjs_default.a.initializeApp({"apiKey":"AIzaSyDvUEiznUo4Wr0wyIE8aCbxfuxJ1B10WOQ","authDomain":"ite-dv7-dev.firebaseapp.com","databaseURL":"https://ite-dv7-dev.firebaseio.com","projectId":"ite-dv7-dev","storageBucket":"ite-dv7-dev.appspot.com","messagingSenderId":"417696187596"});
var firebase_init_db = app.database();
var storage = app.storage();
var functions = app.functions();
var auth = app.auth();
var firebase = index_cjs_default.a;

function firebaseInit() {
  app.auth();
}
// EXTERNAL MODULE: ./src/styles/main.scss
var main = __webpack_require__("67t3");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./src/styles/font-awesome.less
var font_awesome = __webpack_require__("3OZC");
var font_awesome_default = /*#__PURE__*/__webpack_require__.n(font_awesome);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/app.vue

//
//
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_bustCache_src_app = ({
  name: "app",

  created: function created() {
    this.$store.dispatch("auth/init");
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },


  methods: {
    handleResize: function handleResize() {
      this.$store.dispatch("shared/resize", {
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    initialized: "auth/initialized"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebb540f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/app.vue
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: !_vm.initialized,
          expression: "!initialized",
          modifiers: { fullscreen: true }
        }
      ],
      attrs: { id: "app" }
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_bustCache_src_app = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebb540f2", esExports)
  }
}
// CONCATENATED MODULE: ./src/app.vue
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("7EKC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebb540f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_bustCache_src_app,
  selectortype_template_index_0_bustCache_src_app,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/app.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ebb540f2", Component.options)
  } else {
    hotAPI.reload("data-v-ebb540f2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ var src_app = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/LangSelect/index.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LangSelect = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    language: 'shared/language'
  })),
  methods: {
    handleSetLanguage: function handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.dispatch('shared/setLanguage', lang);
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7068cc28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/LangSelect/index.vue
var LangSelect_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      attrs: { trigger: "click" },
      on: { command: _vm.handleSetLanguage }
    },
    [
      _c(
        "div",
        [
          _c("svg-icon", {
            attrs: {
              "class-name": "international-icon",
              "icon-class": "language"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "es", command: "es" } },
            [_vm._v("Español")]
          ),
          _vm._v(" "),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "en", command: "en" } },
            [_vm._v("English")]
          )
        ],
        1
      )
    ],
    1
  )
}
var LangSelect_staticRenderFns = []
LangSelect_render._withStripped = true
var LangSelect_esExports = { render: LangSelect_render, staticRenderFns: LangSelect_staticRenderFns }
/* harmony default export */ var components_LangSelect = (LangSelect_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7068cc28", LangSelect_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/LangSelect/index.vue
var LangSelect_disposed = false
var LangSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var LangSelect___vue_template_functional__ = false
/* styles */
var LangSelect___vue_styles__ = null
/* scopeId */
var LangSelect___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LangSelect___vue_module_identifier__ = null
var LangSelect_Component = LangSelect_normalizeComponent(
  LangSelect,
  components_LangSelect,
  LangSelect___vue_template_functional__,
  LangSelect___vue_styles__,
  LangSelect___vue_scopeId__,
  LangSelect___vue_module_identifier__
)
LangSelect_Component.options.__file = "src/components/LangSelect/index.vue"
if (LangSelect_Component.esModule && Object.keys(LangSelect_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7068cc28", LangSelect_Component.options)
  } else {
    hotAPI.reload("data-v-7068cc28", LangSelect_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    LangSelect_disposed = true
  })
})()}

/* harmony default export */ var src_components_LangSelect = (LangSelect_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/layout/header.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var layout_header = ({
  name: "app-header",
  components: {
    LangSelect: src_components_LangSelect
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    email: "auth/email",
    isMobile: "shared/isMobile"
  })),

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    toggleMenu: "shared/toggleMenu"
  }), {
    handleDropdownCommand: function handleDropdownCommand(command) {
      if (command === "goToActivity") {
        this.goToActivity();
      }

      if (command === "signout") {
        this.signout();
      }
    },
    goToActivity: function goToActivity() {
      this.$router.push({ name: "activity" });
    },
    signout: function signout() {
      return this.$store.dispatch("auth/signout");
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-825d0c1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/layout/header.vue
var header_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 16 } }, [
        _c(
          "h1",
          { staticClass: "logo" },
          [
            _c("i", {
              staticClass: "text-contrast raw-icon el-icon-fa-bars",
              staticStyle: { cursor: "pointer", "margin-right": "35px" },
              on: { click: _vm.toggleMenu }
            }),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("router-link", { attrs: { to: "/" } }, [_vm._v("ITE DV7 ")])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isMobile
        ? _c("el-col", { staticClass: "text-right", attrs: { span: 8 } }, [
            _c(
              "a",
              {
                staticClass: "signout-link",
                attrs: { href: "javascript:" },
                on: { click: _vm.signout }
              },
              [
                _c("i", {
                  staticClass: "el-icon-fa-sign-out",
                  attrs: { title: "Sign out" }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "text-right", attrs: { span: 2 } },
        [_c("lang-select", { staticClass: "set-language" })],
        1
      ),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "el-col",
            { staticClass: "text-right", attrs: { span: 6 } },
            [
              _c(
                "el-dropdown",
                { on: { command: _vm.handleDropdownCommand } },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _vm._v("\n       " + _vm._s(_vm.email) + "\n        "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "goToActivity" } },
                        [
                          _c("i", { staticClass: "el-icon-fa-eye" }),
                          _vm._v(" Activity Log\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "signout" } },
                        [
                          _c("i", { staticClass: "el-icon-fa-sign-out" }),
                          _vm._v(" Sign out\n        ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var header_staticRenderFns = []
header_render._withStripped = true
var header_esExports = { render: header_render, staticRenderFns: header_staticRenderFns }
/* harmony default export */ var shared_layout_header = (header_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-825d0c1c", header_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/layout/header.vue
var header_disposed = false
function header_injectStyle (ssrContext) {
  if (header_disposed) return
  __webpack_require__("whpb")
}
var header_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var header___vue_template_functional__ = false
/* styles */
var header___vue_styles__ = header_injectStyle
/* scopeId */
var header___vue_scopeId__ = "data-v-825d0c1c"
/* moduleIdentifier (server only) */
var header___vue_module_identifier__ = null
var header_Component = header_normalizeComponent(
  layout_header,
  shared_layout_header,
  header___vue_template_functional__,
  header___vue_styles__,
  header___vue_scopeId__,
  header___vue_module_identifier__
)
header_Component.options.__file = "src/shared/layout/header.vue"
if (header_Component.esModule && Object.keys(header_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-825d0c1c", header_Component.options)
  } else {
    hotAPI.reload("data-v-825d0c1c", header_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    header_disposed = true
  })
})()}

/* harmony default export */ var src_shared_layout_header = (header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/VersionApp/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ var VersionApp = ({
    name: "VersionApp",
    data: function data() {
        return {
            versionApp: "V0.9.9.1",
            centerDialogVisible: false,
            activeNames: [],
            versionList: [{
                title: "V0.1",
                changeList: ["Creación/edición de clubs, equipos y jugadores.", "Sistema de envío de invitaciones.", "Login en función del rol."]
            }, {
                title: "V0.2",
                changeList: ["Corrección creación de un equipo desde la vista del club (autoseleccion del club en el formulario del equipo).", "Corrección creación de un jugador desde la vista del equipo (autoseleccion del equipo en el formulario del jugador).", "Corrección del buscador de jugadores.", "Textos del correo mensaje de invitación al club manager (en español).", "Mejoras de diseño Iconos (Club, Team, Player).", "Corrección eliminación de (Club, Team, Player).", "Añadido en listado de clubs (número de equipos).", "Añadido en listado de equipo (número de jugadores).", "Traducción del 20% de la web."]
            }, {
                title: "V0.3",
                changeList: ["Traducción del 90% de la web al ingles.", "Formulario club manager (nombre, appellidos, telefono).", "Nueva version email de invitación club manager.", "Mejoras de usabilidad y diseño."]
            }, {
                title: "V0.4",
                changeList: ["Vista información del club, añadido información del manager.", "Vista información del jugador, añadido información del equipo.", "Listado de manager, añadido el club al que pertenece.", "Listado de jugadores, añadido el equipo al que pertenece.", "Al crear un jugador aparece la categoría con el equipo.", "Al crear un jugador aparece el nombre deportivo como obligatorio.", "Corregido el bug de la carga de fotos."]
            }, {
                title: "V0.5",
                changeList: ["Traducción del 95% de la web.", "Migración de datos.", "Mejoras de rendimiento."]
            }, {
                title: "V0.6",
                changeList: ["Listado de equipo, buscador mejorado, ya se puede buscar por categoria y club.", "Mejoras de rendimiento.", "Listado de equipo, Importación de jugadores."]
            }, {
                title: "V0.7",
                changeList: [" Listado de jugadores, ahora se muestra el formato de fecha DD-MM-AAAA ", " Detalles de un jugador, ahora se muestra el formato de fecha DD-MM-AAAA "]
            }, {
                title: "V0.7.1",
                changeList: [" Tracucción logín, posibilidad de cambiar de idioma en la esquina superior derecha. ", " Tracucción registro manager, posibilidad de cambiar de idioma en la esquina superior derecha. "]
            }, {
                title: "V0.7.2",
                changeList: [" FIX: Eliminación de un club. "]
            }, {
                title: "V0.8",
                changeList: [" Listado clubs, nueva columna con el numero de jugadores de todos los equipos del club. ", " Ordenación de las columnas del listado de jugadores. ", " Creación de jugadores: fecha de nacimiento dd/mm/yyyy. "]
            }, {
                title: "V0.8.1",
                changeList: [" Fix importación de jugadores, ahora se permite importar con columnas vacias. "]
            }, {
                title: "V0.9",
                changeList: [" Creación de delegados desde la vista de un equipo. ", " Creación de entrenadores desde la vista de un equipo. ", " Posibilidad de exportar un pdf del equipo. "]
            }, {
                title: "V0.9.1",
                changeList: [" Mejoras en la exportación de pdf. "]
            }, {
                title: "V0.9.2",
                changeList: [" Nuevo modulo documentos,todos los documentos se comparten con todos. ", " Mejora en el documento pdf, añadido el logo de la Oviedo cup. "]
            }, {
                title: "V0.9.3",
                changeList: [" Listado de clubs, posibilidad de buscar por status manager. "]
            }, {
                title: "V0.9.4",
                changeList: [" Listado de jugadores, añadida la columna del equipo y categoría del jugador. ", " Generación pdf del equipo, eliminado columna telefonos del entrenador y del delegado. "]
            }, {
                title: "V0.9.5",
                changeList: [" FIX: Listado de jugadores. "]
            }, {
                title: "V0.9.6",
                changeList: [" ADD: listado de entrenadores con buscador por equipo.  ", " ADD: listado de delegados de equipo con buscador por equipo. "]
            }, {
                title: "V0.9.7",
                changeList: [" ADD: listado de entrenadores y delegados de equipo, añadida la columna de la categoría.  ", " ADD: listado de entrenadores y delegados de equipo, añadida la funcionalidad para exportar como pdf.  ", " ADD: listado de clubs y de equipo, añadido el nº de entrenadores y delegados de equipo. "]
            }, {
                title: "V0.9.9",
                changeList: [" FIX: Listado de entrenadores  y delegados agrupado por equipo en el pdf exportado.  "]
            }, {
                title: "V0.9.9.1",
                changeList: [" FIX: Importación de jugadores desde un excel."]
            }]
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        hasRoleToCreateClubs: "entities/club/hasRoleToCreate"
    }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e1eccb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/VersionApp/index.vue
var VersionApp_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasRoleToCreateClubs
    ? _c(
        "div",
        { staticClass: "version" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  _vm.centerDialogVisible = true
                }
              }
            },
            [_vm._v(_vm._s(_vm.versionApp))]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "Versiones",
                visible: _vm.centerDialogVisible,
                width: "80%",
                center: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.centerDialogVisible = $event
                }
              }
            },
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames"
                  }
                },
                _vm._l(_vm.versionList, function(item, index) {
                  return _c(
                    "el-collapse-item",
                    {
                      key: item.title,
                      attrs: {
                        label: item.title,
                        name: index,
                        title: item.title
                      }
                    },
                    [
                      _c(
                        "ol",
                        _vm._l(item.changeList, function(item, index) {
                          return _c("li", { key: index }, [
                            _vm._v(" " + _vm._s(item))
                          ])
                        })
                      )
                    ]
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.centerDialogVisible = false
                        }
                      }
                    },
                    [_vm._v("Cerrar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var VersionApp_staticRenderFns = []
VersionApp_render._withStripped = true
var VersionApp_esExports = { render: VersionApp_render, staticRenderFns: VersionApp_staticRenderFns }
/* harmony default export */ var components_VersionApp = (VersionApp_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e1eccb", VersionApp_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/VersionApp/index.vue
var VersionApp_disposed = false
function VersionApp_injectStyle (ssrContext) {
  if (VersionApp_disposed) return
  __webpack_require__("jmxS")
}
var VersionApp_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var VersionApp___vue_template_functional__ = false
/* styles */
var VersionApp___vue_styles__ = VersionApp_injectStyle
/* scopeId */
var VersionApp___vue_scopeId__ = "data-v-13e1eccb"
/* moduleIdentifier (server only) */
var VersionApp___vue_module_identifier__ = null
var VersionApp_Component = VersionApp_normalizeComponent(
  VersionApp,
  components_VersionApp,
  VersionApp___vue_template_functional__,
  VersionApp___vue_styles__,
  VersionApp___vue_scopeId__,
  VersionApp___vue_module_identifier__
)
VersionApp_Component.options.__file = "src/components/VersionApp/index.vue"
if (VersionApp_Component.esModule && Object.keys(VersionApp_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13e1eccb", VersionApp_Component.options)
  } else {
    hotAPI.reload("data-v-13e1eccb", VersionApp_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    VersionApp_disposed = true
  })
})()}

/* harmony default export */ var src_components_VersionApp = (VersionApp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/layout/menu.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var menu = ({
    name: "app-menu",
    components: {
        VersionApp: src_components_VersionApp
    },
    data: function data() {
        return {
            labels: {
                users: "Usuarios",
                clubs: "Clubs",
                teams: "Equipos",
                categories: "Categorias",
                players: "Jugadores",
                managers: "Managers",
                positions: "Posiciones"
            }
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        hasRole: "auth/hasRole",
        collapsed: "shared/menuCollapsed",
        isMobile: "shared/isMobile",
        hasRoleToReadUsers: "user/hasRoleToRead",
        hasRoleToReadClubs: "entities/club/hasRoleToRead",
        hasRoleToReadTeams: "entities/team/hasRoleToRead",
        hasRoleToReadCategories: "entities/category/hasRoleToRead",
        hasRoleToReadPlayers: "entities/player/hasRoleToRead",
        hasRoleToReadManagers: "entities/manager/hasRoleToRead",
        hasRoleToReadPositions: "entities/position/hasRoleToRead",
        hasRoleToReadDocuments: "entities/document/hasRoleToRead",
        hasRoleToReadFieldManager: "entities/fieldManager/hasRoleToRead",
        hasRoleToReadReferee: "entities/referee/hasRoleToRead",
        hasRoleToReadTournament: "entities/tournament/hasRoleToRead",
        hasRoleToReadTeamManagers: "entities/team-manager/hasRoleToRead",
        hasRoleToReadCoaches: "entities/coach/hasRoleToRead"
    }), {
        asideWidth: function asideWidth() {
            if (!this.collapsed) {
                return "200px";
            }

            if (this.isMobile) {
                return "0px";
            }

            return "65px";
        }
    }),

    methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
        collapseMenu: "shared/collapseMenu"
    }), {
        collapseMenuIfMobile: function collapseMenuIfMobile() {
            if (this.isMobile) {
                this.collapseMenu();
            }
        },
        classFor: function classFor(path) {
            return {
                active: this.$route.path.startsWith(path)
            };
        }
    })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff739f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/layout/menu.vue
var menu_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-aside",
    { attrs: { width: _vm.asideWidth } },
    [
      _c(
        "el-menu",
        {
          class: { "el-menu-side-nav": true, collapsed: _vm.collapsed },
          attrs: {
            collapse: _vm.collapsed,
            "collapse-transition": false,
            router: true
          },
          on: {
            select: function($event) {
              _vm.collapseMenuIfMobile()
            }
          }
        },
        [
          _vm.hasRoleToReadClubs
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/club"),
                  attrs: {
                    index: "/entities/club",
                    route: { name: "clubList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_club"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.club.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadTeams
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/team"),
                  attrs: {
                    index: "/entities/team",
                    route: { name: "teamList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_team"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.team.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadCategories
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/category"),
                  attrs: {
                    index: "/entities/category",
                    route: { name: "categoryList", query: { v: +new Date() } }
                  }
                },
                [
                  _c(
                    "i",
                    [
                      _c("svg-icon", {
                        attrs: {
                          "class-name": "menu-icon",
                          "icon-class": "ic_category"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.category.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadPositions
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/position"),
                  attrs: {
                    index: "/entities/position",
                    route: { name: "positionList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-text" }, [_vm._v("P")]),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.position.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadDocuments
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/document"),
                  attrs: {
                    index: "/entities/document",
                    route: { name: "documentList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-document" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.document.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadTournament
            ? _c(
                "el-menu-item",
                {
                  class: _vm.classFor("/entities/tournament"),
                  attrs: {
                    index: "/entities/tournament",
                    route: { name: "tournamentList", query: { v: +new Date() } }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-text" }, [_vm._v("T")]),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.tournament.plural")))
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadPlayers ||
          _vm.hasRoleToReadManagers ||
          _vm.hasRoleToReadCoaches
            ? _c(
                "el-menu-item-group",
                { attrs: { title: _vm.$t("entities.user.plural") } },
                [
                  _vm.hasRoleToReadUsers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/user"),
                          attrs: {
                            index: "/user",
                            route: {
                              name: "userList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.user.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadPlayers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/player"),
                          attrs: {
                            index: "/entities/player",
                            route: {
                              name: "playerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c(
                            "i",
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "class-name": "menu-icon",
                                  "icon-class": "ic_player"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.player.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadManagers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/manager"),
                          attrs: {
                            index: "/entities/manager",
                            route: {
                              name: "managerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.manager.plural")))]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadTeamManagers
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/teamManager"),
                          attrs: {
                            index: "/entities/kteamManager",
                            route: {
                              name: "teamManagerList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("entities.teamManager.plural")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasRoleToReadCoaches
                    ? _c(
                        "el-menu-item",
                        {
                          class: _vm.classFor("/entities/coach"),
                          attrs: {
                            index: "/entities/coach",
                            route: {
                              name: "coachList",
                              query: { v: +new Date() }
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-fa-user" }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { attrs: { slot: "title" }, slot: "title" },
                            [_vm._v(_vm._s(_vm.$t("entities.coach.plural")))]
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("version-app")
        ],
        1
      )
    ],
    1
  )
}
var menu_staticRenderFns = []
menu_render._withStripped = true
var menu_esExports = { render: menu_render, staticRenderFns: menu_staticRenderFns }
/* harmony default export */ var layout_menu = (menu_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff739f8", menu_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/layout/menu.vue
var menu_disposed = false
function menu_injectStyle (ssrContext) {
  if (menu_disposed) return
  __webpack_require__("azsu")
}
var menu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var menu___vue_template_functional__ = false
/* styles */
var menu___vue_styles__ = menu_injectStyle
/* scopeId */
var menu___vue_scopeId__ = "data-v-3ff739f8"
/* moduleIdentifier (server only) */
var menu___vue_module_identifier__ = null
var menu_Component = menu_normalizeComponent(
  menu,
  layout_menu,
  menu___vue_template_functional__,
  menu___vue_styles__,
  menu___vue_scopeId__,
  menu___vue_module_identifier__
)
menu_Component.options.__file = "src/shared/layout/menu.vue"
if (menu_Component.esModule && Object.keys(menu_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ff739f8", menu_Component.options)
  } else {
    hotAPI.reload("data-v-3ff739f8", menu_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    menu_disposed = true
  })
})()}

/* harmony default export */ var shared_layout_menu = (menu_Component.exports);

// EXTERNAL MODULE: ./node_modules/filesize/lib/filesize.js
var filesize = __webpack_require__("H52G");
var filesize_default = /*#__PURE__*/__webpack_require__.n(filesize);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./src/shared/utils/string-utils.js
/* harmony default export */ var string_utils = ({
  camelize: function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  },
  capitalize: function capitalize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toUpperCase() : letter;
    }).replace(/\s+/g, '');
  },
  literalJoin: function literalJoin(arg, all, last) {
    var arr = arg.slice();
    var lastItem = arr.splice(-1);
    arr = arr.length ? [arr.join(all)] : [];
    arr.push(lastItem);
    return arr.join(last);
  }
});
// CONCATENATED MODULE: ./src/shared/file/file-validator.js




/* harmony default export */ var file_validator = ({
  validate: function validate(file, files, max, size, extensions) {
    if (max && files.length > max) {
      throw new Error('Limit of files is ' + max);
    }

    if (size) {
      if (file.size > size) {
        throw new Error('Size limit is ' + filesize_default()(size));
      }
    }

    if (extensions && extensions.length) {
      if (!extensions.includes(file_model.extension(file.name))) {
        throw new Error('This field allows only ' + string_utils.literalJoin(extensions, ', ', ' or '));
      }
    }
  }
});
// CONCATENATED MODULE: ./src/shared/file/file-model.js




/* harmony default export */ var file_model = ({
  toDatabase: function toDatabase(files) {
    if (!files) {
      return [];
    }

    return files.map(function (file) {
      return {
        name: file.name,
        size: file.size
      };
    });
  },
  toDatabaseFile: function toDatabaseFile(file) {
    return {
      name: file.name,
      size: file.size
    };
  },
  changeHandler: function changeHandler(file, files, max, size, types) {
    this.adjustLastAddedFileAsUnique(files);

    try {
      file_validator.validate(file, files, max, size, types);
      return true;
    } catch (error) {
      element_ui_common["Message"].error(error.message);
      files.splice(files.findIndex(function (f) {
        return f === file;
      }), 1);
      return false;
    }
  },
  extension: function extension(name) {
    return name.split('.').pop();
  },
  adjustLastAddedFileAsUnique: function adjustLastAddedFileAsUnique(files) {
    var names = files.map(function (f) {
      return f.name;
    });
    var name = names.pop();
    var nameExists = function nameExists(arg) {
      return names.find(function (n) {
        return n === arg;
      });
    };

    var index = 0;

    while (nameExists(name)) {
      name = this.appendIndex(name, index);
      index += 1;
    }

    assign_default()(files[files.length - 1], { name: name });
  },
  appendIndex: function appendIndex(name, index) {
    var nameWithoutExtension = name.substring(0, name.length - this.extension(name).length - 1);
    nameWithoutExtension = nameWithoutExtension.replace(/(\(\d+)\)+$/g, '');
    return nameWithoutExtension + '(' + index + ').' + this.extension(name);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/file/file-upload.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var file_upload = ({
  name: 'app-file-upload',

  props: {
    stored: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formats: Array,
    size: Number,
    max: Number
  },

  computed: {
    tip: function tip() {
      var hasFormats = this.formats && this.formats.length;
      var hasSize = this.size;

      if (!hasFormats && !hasSize) {
        return null;
      }

      if (!hasFormats && hasSize) {
        return 'files with a size less than ' + filesize_default()(this.size);
      }

      if (hasFormats && !hasSize) {
        return this.formats.join('/') + ' files';
      }

      return this.formats.join('/') + ' files with a size less than ' + filesize_default()(this.size);
    },
    data: function data() {
      return this.$refs.files.uploadFiles;
    }
  },

  methods: {
    download: function download(file) {
      window.open(file.url, '_blank');
    },
    fileChangeHandler: function fileChangeHandler(file, files) {
      return file_model.changeHandler(file, files, this.max, this.size, this.formats);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a92822f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/file-upload.vue
var file_upload_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "files",
      attrs: {
        drag: "",
        action: "",
        "file-list": _vm.stored,
        "auto-upload": false,
        "on-change": _vm.fileChangeHandler,
        "on-preview": _vm.download
      }
    },
    [
      _c("i", { staticClass: "el-icon-upload" }),
      _vm._v(" "),
      _c("div", { staticClass: "el-upload__text" }, [
        _vm._v("Drop file here or "),
        _c("em", [_vm._v("click to upload")])
      ]),
      _vm._v(" "),
      _vm.tip
        ? _c(
            "div",
            {
              staticClass: "el-upload__tip",
              attrs: { slot: "tip" },
              slot: "tip"
            },
            [_vm._v(_vm._s(_vm.tip))]
          )
        : _vm._e()
    ]
  )
}
var file_upload_staticRenderFns = []
file_upload_render._withStripped = true
var file_upload_esExports = { render: file_upload_render, staticRenderFns: file_upload_staticRenderFns }
/* harmony default export */ var file_file_upload = (file_upload_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a92822f", file_upload_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/file/file-upload.vue
var file_upload_disposed = false
function file_upload_injectStyle (ssrContext) {
  if (file_upload_disposed) return
  __webpack_require__("QBsE")
}
var file_upload_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var file_upload___vue_template_functional__ = false
/* styles */
var file_upload___vue_styles__ = file_upload_injectStyle
/* scopeId */
var file_upload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var file_upload___vue_module_identifier__ = null
var file_upload_Component = file_upload_normalizeComponent(
  file_upload,
  file_file_upload,
  file_upload___vue_template_functional__,
  file_upload___vue_styles__,
  file_upload___vue_scopeId__,
  file_upload___vue_module_identifier__
)
file_upload_Component.options.__file = "src/shared/file/file-upload.vue"
if (file_upload_Component.esModule && Object.keys(file_upload_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a92822f", file_upload_Component.options)
  } else {
    hotAPI.reload("data-v-1a92822f", file_upload_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    file_upload_disposed = true
  })
})()}

/* harmony default export */ var shared_file_file_upload = (file_upload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/file/file-link-list.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var file_link_list = ({
  name: 'app-file-link-list',

  props: {
    files: Array
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c7726d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/file-link-list.vue
var file_link_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.files && _vm.files.length
    ? _c(
        "div",
        _vm._l(_vm.files, function(file) {
          return _c("div", { key: file.name }, [
            _c(
              "a",
              { attrs: { href: file.url, target: "_blank", download: "" } },
              [_vm._v("\n      " + _vm._s(file.name) + "\n    ")]
            )
          ])
        })
      )
    : _vm._e()
}
var file_link_list_staticRenderFns = []
file_link_list_render._withStripped = true
var file_link_list_esExports = { render: file_link_list_render, staticRenderFns: file_link_list_staticRenderFns }
/* harmony default export */ var file_file_link_list = (file_link_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c7726d3", file_link_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/file/file-link-list.vue
var file_link_list_disposed = false
function file_link_list_injectStyle (ssrContext) {
  if (file_link_list_disposed) return
  __webpack_require__("y7ee")
}
var file_link_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var file_link_list___vue_template_functional__ = false
/* styles */
var file_link_list___vue_styles__ = file_link_list_injectStyle
/* scopeId */
var file_link_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var file_link_list___vue_module_identifier__ = null
var file_link_list_Component = file_link_list_normalizeComponent(
  file_link_list,
  file_file_link_list,
  file_link_list___vue_template_functional__,
  file_link_list___vue_styles__,
  file_link_list___vue_scopeId__,
  file_link_list___vue_module_identifier__
)
file_link_list_Component.options.__file = "src/shared/file/file-link-list.vue"
if (file_link_list_Component.esModule && Object.keys(file_link_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c7726d3", file_link_list_Component.options)
  } else {
    hotAPI.reload("data-v-4c7726d3", file_link_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    file_link_list_disposed = true
  })
})()}

/* harmony default export */ var shared_file_file_link_list = (file_link_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/file/image-upload.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var image_upload = ({
  name: 'app-image-upload',

  props: {
    stored: {
      type: Array,
      default: []
    },
    formats: {
      type: Array,
      default: function _default() {
        return ['gif', 'jpg', 'jpeg', 'png', 'svg'];
      }
    },
    size: Number,
    max: Number
  },

  computed: {
    data: function data() {
      return this.$refs.files.uploadFiles;
    }
  },

  methods: {
    download: function download(file) {
      window.open(file.url, '_blank');
    },
    fileChangeHandler: function fileChangeHandler(file, files) {
      return file_model.changeHandler(file, files, this.max, this.size, this.formats);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07d0a174","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/image-upload.vue
var image_upload_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-upload",
    {
      ref: "files",
      attrs: {
        action: "",
        "list-type": "picture-card",
        "file-list": _vm.stored,
        "on-change": _vm.fileChangeHandler,
        "auto-upload": false,
        "on-preview": _vm.download
      }
    },
    [_c("i", { staticClass: "el-icon-plus" })]
  )
}
var image_upload_staticRenderFns = []
image_upload_render._withStripped = true
var image_upload_esExports = { render: image_upload_render, staticRenderFns: image_upload_staticRenderFns }
/* harmony default export */ var file_image_upload = (image_upload_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07d0a174", image_upload_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/file/image-upload.vue
var image_upload_disposed = false
function image_upload_injectStyle (ssrContext) {
  if (image_upload_disposed) return
  __webpack_require__("Ta+H")
}
var image_upload_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var image_upload___vue_template_functional__ = false
/* styles */
var image_upload___vue_styles__ = image_upload_injectStyle
/* scopeId */
var image_upload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var image_upload___vue_module_identifier__ = null
var image_upload_Component = image_upload_normalizeComponent(
  image_upload,
  file_image_upload,
  image_upload___vue_template_functional__,
  image_upload___vue_styles__,
  image_upload___vue_scopeId__,
  image_upload___vue_module_identifier__
)
image_upload_Component.options.__file = "src/shared/file/image-upload.vue"
if (image_upload_Component.esModule && Object.keys(image_upload_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07d0a174", image_upload_Component.options)
  } else {
    hotAPI.reload("data-v-07d0a174", image_upload_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    image_upload_disposed = true
  })
})()}

/* harmony default export */ var shared_file_image_upload = (image_upload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/file/image-carousel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var image_carousel = ({
  name: 'app-image-carousel',

  props: {
    images: Array
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f0023e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/file/image-carousel.vue
var image_carousel_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.images && _vm.images.length
    ? _c(
        "el-carousel",
        {
          staticClass: "text-center",
          attrs: { trigger: "click", "indicator-position": "outside" }
        },
        _vm._l(_vm.images, function(image, index) {
          return _c("el-carousel-item", { key: index }, [
            _c("a", { attrs: { href: image.url, target: "_blank" } }, [
              _c("img", {
                attrs: { src: image.url, alt: image.name, height: "300px" }
              })
            ])
          ])
        })
      )
    : _vm._e()
}
var image_carousel_staticRenderFns = []
image_carousel_render._withStripped = true
var image_carousel_esExports = { render: image_carousel_render, staticRenderFns: image_carousel_staticRenderFns }
/* harmony default export */ var file_image_carousel = (image_carousel_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f0023e5", image_carousel_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/file/image-carousel.vue
var image_carousel_disposed = false
function image_carousel_injectStyle (ssrContext) {
  if (image_carousel_disposed) return
  __webpack_require__("dLIY")
}
var image_carousel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var image_carousel___vue_template_functional__ = false
/* styles */
var image_carousel___vue_styles__ = image_carousel_injectStyle
/* scopeId */
var image_carousel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var image_carousel___vue_module_identifier__ = null
var image_carousel_Component = image_carousel_normalizeComponent(
  image_carousel,
  file_image_carousel,
  image_carousel___vue_template_functional__,
  image_carousel___vue_styles__,
  image_carousel___vue_scopeId__,
  image_carousel___vue_module_identifier__
)
image_carousel_Component.options.__file = "src/shared/file/image-carousel.vue"
if (image_carousel_Component.esModule && Object.keys(image_carousel_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f0023e5", image_carousel_Component.options)
  } else {
    hotAPI.reload("data-v-5f0023e5", image_carousel_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    image_carousel_disposed = true
  })
})()}

/* harmony default export */ var shared_file_image_carousel = (image_carousel_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/shared/filters/format-date-filter.js


/* harmony default export */ var format_date_filter = ({
  name: 'formatDate',
  implementation: function implementation(value) {
    if (value) {
      return moment_default()(value).format('YYYY-MM-DD');
    }

    return null;
  }
});
// CONCATENATED MODULE: ./src/shared/filters/format-datetime-filter.js


/* harmony default export */ var format_datetime_filter = ({
  name: 'formatDatetime',
  implementation: function implementation(value) {
    if (value) {
      return moment_default()(value).format('YYYY-MM-DD HH:mm');
    }

    return null;
  }
});
// CONCATENATED MODULE: ./src/shared/mixins/autofocus-mixin.js
/* harmony default export */ var autofocus_mixin = ({
  mounted: function mounted() {
    if (this.$refs.focus) {
      this.$refs.focus.focus();
    }
  }
});
// CONCATENATED MODULE: ./src/shared/shared-store.js



/* harmony default export */ var shared_store = ({
  namespaced: true,

  state: {
    menuCollapsed: true,
    isMobile: false,
    language: js_cookie_default.a.get('language') || 'es'
  },

  getters: {
    menuCollapsed: function menuCollapsed(state) {
      return state.menuCollapsed;
    },
    isMobile: function isMobile(state) {
      return !!state.isMobile;
    },
    paginationLayout: function paginationLayout(state) {
      return state.isMobile ? 'total, prev, pager, next' : 'total, sizes, prev, pager, next';
    },
    labelPosition: function labelPosition(state) {
      return state.isMobile ? 'top' : undefined;
    },
    labelWidth: function labelWidth(state) {
      return state.isMobile ? undefined : '180px';
    },
    language: function language(state) {
      return state.language;
    }
  },

  mutations: {
    COLLAPSE_MENU: function COLLAPSE_MENU(state) {
      state.menuCollapsed = true;
    },
    TOGGLE_MENU: function TOGGLE_MENU(state) {
      state.menuCollapsed = !state.menuCollapsed;
    },
    RESIZE: function RESIZE(state, payload) {
      state.isMobile = payload.width < 576;
    },


    SET_LANGUAGE: function SET_LANGUAGE(state, language) {
      state.language = language;
      js_cookie_default.a.set('language', language);
    }
  },

  actions: {
    resize: function resize(_ref, payload) {
      var commit = _ref.commit;

      commit('RESIZE', payload);
    },
    toggleMenu: function toggleMenu(_ref2) {
      var commit = _ref2.commit;

      commit('TOGGLE_MENU');
    },
    collapseMenu: function collapseMenu(_ref3) {
      var commit = _ref3.commit;

      commit('COLLAPSE_MENU');
    },
    setLanguage: function setLanguage(_ref4, language) {
      var commit = _ref4.commit;

      commit('SET_LANGUAGE', language);
    },
    success: function success(context, payload) {
      Object(element_ui_common["Notification"])({
        showClose: true,
        message: payload,
        type: 'success',
        duration: 6000
      });
    },
    error: function error(context, payload) {
      var message = void 0;

      if (payload.response && payload.response.status === 400) {
        message = payload.response.data;
      } else {
        message = payload.message;
      }

      if (!message) {
        message = 'Ops, an error occurred';
      }
      // eslint-disable-next-line

      Object(element_ui_common["Notification"])({
        showClose: true,
        message: message,

        type: 'error',
        duration: 6000
      });
    }
  }
});
// CONCATENATED MODULE: ./src/shared/shared-module.js











/* harmony default export */ var shared_module = ({
  components: [src_shared_layout_header, shared_layout_menu, shared_file_file_upload, shared_file_image_upload, shared_file_file_link_list, shared_file_image_carousel],

  filters: [format_date_filter, format_datetime_filter],

  mixins: [autofocus_mixin],

  store: shared_store
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/en.js
var en = __webpack_require__("wUZ8");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/es.js
var es = __webpack_require__("JR9b");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// CONCATENATED MODULE: ./src/lang/en.js
/* harmony default export */ var lang_en = ({
  route: {
    home: 'Home',
    dashboard: 'Dashboard',
    users: 'Users',
    clubs: 'Clubs',
    teams: 'Teams',
    categories: 'Categories',
    players: 'Players',
    managers: 'Managers',
    positions: 'Positions',
    activity: 'Activity',
    coaches: 'Coaches',
    documents: 'Documents'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard'
  },

  auth: {
    login: {
      email: 'Email',
      password: 'Password',
      logIn: 'Log in',
      forgotPassword: 'Forgot password?'
    },

    passwordReset: {
      email: 'Email',
      sendPasswordReset: 'Send password reset email',
      cancel: 'Cancel'
    },

    emailUnverified: {
      pleaseConfirmYourEmailAt: 'Please confirm your email at',
      toContinue: ' to confinue.',
      resendEmailConfirmation: 'Resend email confirmation',
      signInWithAnotherAccount: 'Sign in with another account'
    },

    registerManager: {
      email: 'Email',
      password: 'Password',
      name: 'Name',
      lastName: 'Last name',
      phone: 'Phone number',
      createAccount: 'Create account',
      accept: 'Accept',
      termnsConditions: 'Terms and conditions',
      privacyPolicy: 'Privacy policy',
      cancel: 'Cancel'
    }
  },

  entities: {
    user: { singular: 'User', plural: 'Users' },
    club: {
      singular: 'Club', plural: 'Clubs',
      prop: {
        name: 'Name',
        emailManager: 'Email manager',
        statusManager: 'Status manager',
        logo: 'Logo'
      }
    },
    team: {
      singular: 'Team', plural: 'Teams', numberOfTeams: "Number of teams",
      exportTeamAsPdf: 'Export team pdf',
      prop: {
        name: 'Name',
        category: 'Category',
        locality: 'Locality',
        country: 'Country',
        web: 'Web'
      }
    },
    category: { singular: 'Category', plural: 'Categories' },
    player: {
      singular: 'Player', plural: 'Players',
      numberOfPlayers: "Number of players",
      importPlayers: 'Import players',
      exportPlayers: 'Export players',
      prop: {
        namePublic: 'Sporting name',
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        dorsal: 'Number',
        phone: 'Phone',
        position: 'Position',
        picture: 'Photo',
        birthdate: 'Birth date'
      }
    },
    coach: {
      singular: 'Coach', plural: 'Coaches',
      numberOfCoaches: "Nº coaches",
      importPlayers: 'Import coaches',
      exportCoachesAsPdf: 'Export pdf coaches',
      prop: {
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        birthdate: 'Birth date',
        phone: 'Phone',
        picture: 'Photo'
      }
    },
    teamManager: {
      singular: 'Team manager', plural: 'Team managers',
      numberOfTeamManager: "Nº manager's team",
      exportTeamManagerAsPdf: 'Export pdf team managers',
      prop: {
        name: 'Name',
        lastName: 'Last name',
        dni: 'Dni/Nie/Passport',
        email: 'Email',
        birthdate: 'Birth date',
        phone: 'Phone',
        picture: 'Photo'
      }
    },
    manager: {
      singular: 'Manager', plural: 'Managers',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },

    fieldManager: {
      singular: 'Field manager', plural: 'Field managers',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },

    referee: {
      singular: 'Referee', plural: 'Referees',
      prop: {
        name: 'Name',
        lastName: 'Lastname',
        email: 'Email',
        phone: 'Phone'
      }
    },
    position: { singular: 'Position', plural: 'Positions' },
    document: { singular: 'Document', plural: 'Documents', prop: { name: 'Name', document: 'Document' } },
    tournament: {
      singular: 'Tournament', plural: 'Tournaments',
      settingGroups: { title: 'Setting groups', description: 'Drag the team name to the corresponding group' },
      group: 'Group',
      prop: {
        name: 'Name',
        category: 'Category',
        locality: 'Locality',
        country: 'Country',
        web: 'Web'
      }
    }
  },

  notification: {
    savedSuccessfully: 'saved successfully!',
    deletedSuccessfully: 'deleted successfully!',
    invitationHasSendSuccessfully: 'Invitation sent successfully!'
  },

  confirm: {
    areYouSureCloseDialog: 'Are you sure to close this dialog?'
  },

  table: {
    search: 'Search',
    add: 'New',
    addProperty: 'Add property',
    setting: 'Setting',
    details: 'Details',
    edit: 'Edit',
    delete: 'Delete',
    sendInvitation: 'Send invitation',
    cancel: 'Cancel',
    export: 'Export',
    exportAsPdf: 'Export as Pdf',
    import: 'Import',
    history: 'History',
    actions: 'Actions',
    confirm: 'Confirm',
    areYouSure: 'Are you sure?',
    status: 'Status',
    yes: 'Yes',
    no: 'No'
  },

  status: {
    modifiedAt: 'Modified at',
    created: 'Created at'
  },

  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },

  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },

  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },

  validators: {
    isRequired: 'es obligatorio',
    lenghtMustBeLeast: 'length must be at least',
    lenghtMustBeMax: 'length must be a maximum of',
    valueShouldInteger: 'Value should be an integer',
    valueIsRequired: 'Value is required',
    mustBeEmail: 'must be at email',
    shouldBeNumber: 'should be a number',
    mustBeAtLeast: 'must be at least',
    mustBeAMaxOf: 'must be a maximum of',
    valueSize: 'Value size',
    size: 'size'
  }
});
// CONCATENATED MODULE: ./src/lang/es.js
/* harmony default export */ var lang_es = ({
  route: {
    home: 'Inicio',
    dashboard: 'Dashboard',
    users: 'Usuarios',
    clubs: 'Clubs',
    teams: 'Equipos',
    categories: 'Categorías',
    players: 'Jugadores',
    managers: 'Managers',
    positions: 'Posiciones',
    activity: 'Actividad',
    coaches: 'Entrenadores',
    documents: 'Documentos'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard'
  },

  auth: {
    login: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      logIn: 'Iniciar sesión',
      forgotPassword: '¿Has olvidado tu contraseña?'
    },

    passwordReset: {
      email: 'Correo electrónico',
      sendPasswordReset: 'Enviar correo electrónico para restablecer la contraseña',
      cancel: 'Cancelar'
    },

    emailUnverified: {
      pleaseConfirmYourEmailAt: 'Por favor, confirme su correo electrónico en',
      toContinue: ' para continuar.',
      resendEmailConfirmation: 'Reenviar correo electrónico de confirmación',
      signInWithAnotherAccount: 'Iniciar sesión con otra cuenta'
    },

    registerManager: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      name: 'Nombre',
      lastName: 'Apellidos',
      phone: 'Número de teléfono',
      createAccount: 'Crear cuenta',
      accept: 'Aceptar',
      termnsConditions: 'Terminos y condiciones de uso',
      privacyPolicy: 'Política de privacidad',
      cancel: 'Cancelar'
    }
  },

  entities: {
    user: { singular: 'Usuario', plural: 'Usuarios' },
    club: {
      singular: 'Club', plural: 'Clubs',
      prop: {
        name: 'Nombre',
        emailManager: 'Email manager',
        statusManager: 'Estado manager',
        logo: 'Logo'
      }
    },
    team: {
      singular: 'Equipo', plural: 'Equipos', numberOfTeams: "Número de equipos",
      exportTeamAsPdf: 'Exportar pdf de equipo ',
      prop: {
        name: 'Nombre',
        category: 'Categoría',
        locality: 'Localidad',
        logo: 'Logo',
        country: 'Ciudad',
        web: 'Web'
      }
    },
    category: { singular: 'Categoría', plural: 'Categorías' },
    player: {
      singular: 'Jugador', plural: 'Jugadores',
      numberOfPlayers: "Nº jugadores",
      importPlayers: 'Importar jugadores',
      exportPlayers: 'Expotar jugadores',
      prop: {
        namePublic: 'Nombre deportivo',
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        dorsal: 'Dorsal',
        phone: 'Teléfono',
        position: 'Posición',
        picture: 'Foto',
        birthdate: 'Fecha de nacimiento'
      }
    },
    coach: {
      singular: 'Entrenador', plural: 'Entrenadores',
      numberOfCoaches: "Nº entrenadores",
      importPlayers: 'Importar entrenador',
      exportCoachesAsPdf: 'Exportar pdf de entrenadores',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        birthdate: 'Fecha de nacimiento',
        phone: 'Teléfono',
        picture: 'Foto'
      }
    },
    teamManager: {
      singular: 'Delegado de equipo', plural: 'Delegados de equipo',
      numberOfTeamManager: "Nº delegados de equipo",
      exportTeamManagerAsPdf: 'Exportar pdf de delegados de equipo',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        dni: 'Dni/Nie/Pasaporte',
        email: 'Email',
        birthdate: 'Fecha de nacimiento',
        phone: 'Teléfono',
        picture: 'Foto'
      }
    },
    manager: {
      singular: 'Manager', plural: 'Managers',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },

    fieldManager: {
      singular: 'Delegado de campo', plural: 'Delegados de campo',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },

    referee: {
      singular: 'Arbitro', plural: 'Arbitros',
      prop: {
        name: 'Nombre',
        lastName: 'Apellidos',
        email: 'Email',
        phone: 'Teléfono'
      }
    },
    position: { singular: 'Posición', plural: 'Posiciones' },
    document: { singular: 'Documento', plural: 'Documentos', prop: { name: 'Nombre', document: 'Documento' } },
    tournament: {
      singular: 'Tournament', plural: 'Tournaments',
      settingGroups: { title: 'Configuración de grupos', description: 'Arrastra el nombre del equipo al grupo que le corresponde' },
      group: 'Grupo',
      prop: {
        name: 'Nombre',
        category: 'Categoría',
        locality: 'Localidad',
        logo: 'Logo',
        country: 'Ciudad',
        web: 'Web'
      }
    }
  },

  notification: {
    savedSuccessfully: 'guardado con éxito!',
    deletedSuccessfully: 'eliminado con éxito!',
    invitationHasSendSuccessfully: 'Invitación enviada con éxito!'
  },

  confirm: {
    areYouSureCloseDialog: '¿Estás seguro de que quieres cerrar?'
  },

  table: {
    search: 'Buscar',
    add: 'Crear',
    addProperty: 'Agregar property',
    setting: 'Configurar',
    details: 'Detalles',
    edit: 'Editar',
    delete: 'Eliminar',
    sendInvitation: 'Enviar invitación',
    cancel: 'Cancel',
    export: 'Exportar',
    exportAsPdf: 'Exportar como pdf',
    import: 'Importar',
    history: 'Historial',
    actions: 'Acciones',
    confirm: 'Confirmar',
    areYouSure: '¿Estás seguro?',
    status: 'Status',
    yes: 'Si',
    no: 'No'
  },

  status: {
    modifiedAt: 'Modificado',
    created: 'Creado'
  },

  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export selected items',
    placeholder: 'Please enter the file name(default excel-list)'
  },

  tagsView: {
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },

  register: {
    email: 'Email',
    password: 'Contraseña',
    name: 'Nombre',
    lastName: 'Apellidos',
    phone: 'Número de teléfono',
    createAccount: 'Crear cuenta',
    accept: 'Accept',
    termnsConditions: 'Términos y condiciones',
    privacyPolicy: 'Política de privacidad',
    cancel: 'Cancelar'
  },

  validators: {
    isRequired: 'es obligatorio',
    lenghtMustBeLeast: 'la longitud debe ser como mínimo de',
    lenghtMustBeMax: 'la longitud debe ser como máximo de',
    valueShouldInteger: 'Introduce un número entero',
    valueIsRequired: 'Campo obligatorio',
    mustBeEmail: 'introduce un email correcto',
    shouldBeNumber: 'debería ser un número',
    mustBeAtLeast: ' debe ser al menos',
    mustBeAMaxOf: 'debe ser de un máximo de',
    valueSize: 'Deber rellenar al menos ',
    size: 'Tamaño'
  }
});
// CONCATENATED MODULE: ./src/lang/index.js




 // element-ui lang
 // element-ui lang



vue_esm["default"].use(vue_i18n_esm["a" /* default */]);

var messages = {
  en: extends_default()({}, lang_en, en_default.a),
  es: extends_default()({}, lang_es, es_default.a)
};

var lang_i18n = new vue_i18n_esm["a" /* default */]({
  locale: js_cookie_default.a.get('language') || 'es', // set locale
  messages: messages // set locale messages
});

/* harmony default export */ var src_lang = (lang_i18n);
// CONCATENATED MODULE: ./src/shared/form/validators.js


 // Internationalization

/* eslint-disable */
function emailIsValid(email) {
  return (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  );
}

var validators_string = function string(_ref) {
  var label = _ref.label,
      required = _ref.required,
      min = _ref.min,
      max = _ref.max;

  var output = [];

  if (required) {
    output.push({ required: !!required, message: label + ' ' + src_lang.t('validators.isRequired') });
  }

  if (min || min === 0) {
    output.push({ min: min, message: label + ' ' + src_lang.t('validators.lenghtMustBeLeast') + ' ' + min });
  }

  if (max || max === 0) {
    output.push({ max: max, message: label + ' ' + src_lang.t('validators.lenghtMustBeMax') + ' ' + max });
  }

  return output;
};

var validators_email = function email(_ref2) {
  var label = _ref2.label,
      required = _ref2.required,
      min = _ref2.min,
      max = _ref2.max;

  var emailFn = function emailFn(rule, value, callback) {
    if (!value) {
      callback();
      return;
    }

    if (emailIsValid(value)) {
      callback();
      return;
    }

    callback(new Error(src_lang.t('validators.lenghtMustBeMax')));
  };

  var requiredFn = function requiredFn(rule, value, callback) {
    if (!value || !value.length) {
      callback(new Error(src_lang.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  var output = [];

  if (required) {
    output.push({ required: true, validator: requiredFn, message: label + ' ' + src_lang.t('validators.isRequired') });
  }

  output.push({ validator: emailFn, message: label + '  ' + src_lang.t('validators.mustBeEmail') + ' ' });

  return output;
};

var validators_decimal = function decimal(_ref3) {
  var label = _ref3.label,
      required = _ref3.required,
      min = _ref3.min,
      max = _ref3.max;

  var output = [{ type: 'number', message: label + ' ' + src_lang.t('validators.mustBeEmail') }];

  if (required) {
    output.push({ type: 'number', required: !!required, message: label + ' ' + src_lang.t('validators.isRequired') });
  }

  if (min || min === 0) {
    output.push({ type: 'number', min: min, message: label + ' ' + src_lang.t('validators.mustBeAtLeast') + ' ' + min });
  }

  if (max || max === 0) {
    output.push({ type: 'number', max: max, message: label + ' ' + src_lang.t('validators.mustBeAMaxOf') + ' ' + max });
  }

  return output;
};

var validators_integer = function integer(_ref4) {
  var label = _ref4.label,
      required = _ref4.required,
      min = _ref4.min,
      max = _ref4.max;

  var integerFn = function integerFn(rule, value, callback) {
    if (!value) {
      callback();
      return;
    }

    if (is_integer_default()(value)) {
      callback();
      return;
    }

    callback(new Error(src_lang.t('validators.valueShouldInteger')));
  };

  return [{ validator: integerFn, message: label + ' ' + src_lang.t('validators.valueShouldInteger') }].concat(toConsumableArray_default()(validators_decimal({ label: label, required: required, min: min, max: max })));
};

var validators_generic = function generic(_ref5) {
  var label = _ref5.label,
      required = _ref5.required;

  var output = [];

  if (required) {
    output.push({ required: true, message: label + ' ' + src_lang.t('validators.isRequired') });
  }

  return output;
};

var validators_hasOne = function hasOne(_ref6) {
  var label = _ref6.label,
      required = _ref6.required;

  var requiredFn = function requiredFn(rule, value, callback) {
    if (!value) {
      callback(new Error(src_lang.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  if (!required) {
    return [];
  }

  return [{ required: true, validator: requiredFn, message: label + ' ' + src_lang.t('validators.valueIsRequired') }];
};

var validators_hasMany = function hasMany(_ref7) {
  var label = _ref7.label,
      required = _ref7.required,
      min = _ref7.min,
      max = _ref7.max;

  var requiredFn = function requiredFn(rule, value, callback) {
    if (!value || !value.length) {
      callback(new Error(src_lang.t('validators.valueIsRequired')));
      return;
    }

    callback();
  };

  var minFn = function minFn(rule, value, callback) {
    if (!value || !value.length) {
      callback();
      return;
    }

    if (value.length < min) {
      callback(new Error(src_lang.t('validators.valueSize') + ' ' + src_lang.t('validators.mustBeAtLeast') + ' ' + min));
    }

    callback();
  };

  var maxFn = function maxFn(rule, value, callback) {
    if (!value || !value.length) {
      callback();
      return;
    }

    if (value.length > max) {
      callback(new Error(src_lang.t('validators.valueSize') + ' ' + src_lang.t('validators.mustBeAMaxOf') + ' ' + max));
    }

    callback();
  };

  var output = [];

  if (required) {
    output.push({ required: true, validator: requiredFn, message: label + ' ' + src_lang.t('validators.isRequired') });
  }

  if (min || min === 0) {
    output.push({ validator: minFn, message: label + ' ' + src_lang.t('validators.size') + ' ' + src_lang.t('validators.mustBeAtLeast') + '  ' + min });
  }

  if (max || max === 0) {
    output.push({ validator: maxFn, message: label + ' ' + src_lang.t('validators.size') + ' ' + src_lang.t('validators.mustBeAMaxOf') + max });
  }

  return output;
};

/* harmony default export */ var validators = ({
  string: validators_string,
  email: validators_email,
  integer: validators_integer,
  decimal: validators_decimal,
  generic: validators_generic,
  hasOne: validators_hasOne,
  hasMany: validators_hasMany
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/login/login.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var login = ({
    name: "app-login",
    components: { LangSelect: src_components_LangSelect },
    data: function data() {
        return {
            rules: {
                email: validators.string({
                    label: this.$t("auth.login.email"),
                    required: true
                }),
                password: validators.string({
                    label: this.$t("auth.login.password"),
                    required: true
                })
            },
            model: {}
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "auth/loading",
        isMobile: "shared/isMobile"
    })),

    methods: {
        submit: function submit() {
            var _this = this;

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                _this.$store.dispatch("auth/signin", {
                    email: _this.model.email,
                    password: _this.model.password
                }).then(function () {
                    // eslint-disable-next-line
                    console.log(" FINALICE");

                    _this.$router.push("/");
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47227766","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/login/login.vue
var login_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("lang-select", { staticClass: "set-language" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.model,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "0px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                  _vm.submit($event)
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      type: "text",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.login.email")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.login.password")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.password,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.submit }
                    },
                    [_vm._v(_vm._s(_vm.$t("auth.login.logIn")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "text-center" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "passwordReset" } } },
                    [_vm._v(_vm._s(_vm.$t("auth.login.forgotPassword")))]
                  ),
                  _vm._v(" "),
                  _c("br")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var login_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
login_render._withStripped = true
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var login_login = (login_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47227766", login_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/login/login.vue
var login_disposed = false
function login_injectStyle (ssrContext) {
  if (login_disposed) return
  __webpack_require__("D6Jq")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-47227766"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  login,
  login_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)
login_Component.options.__file = "src/auth/login/login.vue"
if (login_Component.esModule && Object.keys(login_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47227766", login_Component.options)
  } else {
    hotAPI.reload("data-v-47227766", login_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    login_disposed = true
  })
})()}

/* harmony default export */ var auth_login_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/registration/registration.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var registration = ({
    name: "app-registration",

    data: function data() {
        return {
            rules: {
                email: validators.string({
                    label: "Email",
                    required: true,
                    min: 1
                }),
                password: validators.string({
                    label: "Password",
                    required: true,
                    max: 255
                })
            },
            model: {}
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "auth/loading",
        isMobile: "shared/isMobile"
    }), {
        defaultEmail: function defaultEmail() {
            return this.$route.query.email || null;
        }
    }),

    created: function created() {
        if (this.defaultEmail) {
            this.model.email = this.defaultEmail;
        }
    },


    methods: {
        submit: function submit() {
            var _this = this;

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                _this.$store.dispatch("auth/register", {
                    email: _this.model.email,
                    password: _this.model.password
                }).then(function () {
                    _this.$router.push("/");
                });
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13831732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/registration/registration.vue
var registration_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper registration" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              class: {
                "login-container": !_vm.isMobile,
                "login-container-mobile": _vm.isMobile
              },
              attrs: {
                model: _vm.model,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "0px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      disabled: !!_vm.defaultEmail,
                      type: "text",
                      "auto-complete": "off",
                      placeholder: "Email"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "auto-complete": "off",
                      placeholder: "Password"
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.password,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.submit }
                    },
                    [_vm._v("Create account")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "text-center" },
                [
                  _c("router-link", { attrs: { to: { name: "login" } } }, [
                    _vm._v("Cancel")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var registration_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
registration_render._withStripped = true
var registration_esExports = { render: registration_render, staticRenderFns: registration_staticRenderFns }
/* harmony default export */ var registration_registration = (registration_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13831732", registration_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/registration/registration.vue
var registration_disposed = false
function registration_injectStyle (ssrContext) {
  if (registration_disposed) return
  __webpack_require__("vR5l")
}
var registration_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var registration___vue_template_functional__ = false
/* styles */
var registration___vue_styles__ = registration_injectStyle
/* scopeId */
var registration___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var registration___vue_module_identifier__ = null
var registration_Component = registration_normalizeComponent(
  registration,
  registration_registration,
  registration___vue_template_functional__,
  registration___vue_styles__,
  registration___vue_scopeId__,
  registration___vue_module_identifier__
)
registration_Component.options.__file = "src/auth/registration/registration.vue"
if (registration_Component.esModule && Object.keys(registration_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13831732", registration_Component.options)
  } else {
    hotAPI.reload("data-v-13831732", registration_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    registration_disposed = true
  })
})()}

/* harmony default export */ var auth_registration_registration = (registration_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/registration/registrationManager.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var registrationManager = ({
  name: "app-registration",
  components: {
    LangSelect: src_components_LangSelect
  },
  data: function data() {
    return {
      rules: {
        email: validators.string({ label: this.$t('auth.registerManager.email'), required: true, min: 1 }),
        password: validators.string({
          label: this.$t('auth.registerManager.password'),
          required: true,
          max: 255
        }),
        name: validators.string({
          label: this.$t('auth.registerManager.name'),
          required: true
        }),
        lastName: validators.string({
          label: this.$t('auth.registerManager.lastName'),
          required: true
        }),
        phone: validators.string({
          label: this.$t('auth.registerManager.phone'),
          required: true
        })
      },
      model: {},
      checked: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "auth/loading",
    isMobile: "shared/isMobile"
  }), {
    defaultEmail: function defaultEmail() {
      return this.$route.query.email || null;
    }
  }),

  created: function created() {
    if (this.defaultEmail) {
      this.model.email = this.defaultEmail;
    }
  },


  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this.$store.dispatch("auth/registerManager", _this.model).then(function () {
          _this.$router.push("/");
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53bfe5cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/registration/registrationManager.vue
var registrationManager_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper registration" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("lang-select", { staticClass: "set-language" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              class: {
                "login-container": !_vm.isMobile,
                "login-container-mobile": _vm.isMobile
              },
              attrs: {
                model: _vm.model,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "0px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      disabled: !!_vm.defaultEmail,
                      type: "text",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.registerManager.email")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.registerManager.password")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.password,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "password", $$v)
                      },
                      expression: "model.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: { placeholder: _vm.$t("auth.registerManager.name") },
                    model: {
                      value: _vm.model.name,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "lastName" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      placeholder: _vm.$t("auth.registerManager.lastName")
                    },
                    model: {
                      value: _vm.model.lastName,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "lastName", $$v)
                      },
                      expression: "model.lastName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "phone" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      placeholder: _vm.$t("auth.registerManager.phone")
                    },
                    model: {
                      value: _vm.model.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "phone", $$v)
                      },
                      expression: "model.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  [
                    _c(
                      "el-checkbox",
                      {
                        model: {
                          value: _vm.checked,
                          callback: function($$v) {
                            _vm.checked = $$v
                          },
                          expression: "checked"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("auth.registerManager.accept")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: { type: "text", to: { name: "privacyPolicy" } }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("auth.registerManager.privacyPolicy"))
                        )
                      ]
                    )
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        disabled: !_vm.checked
                      },
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("auth.registerManager.createAccount"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "text-center" },
                [
                  _c("router-link", { attrs: { to: { name: "login" } } }, [
                    _vm._v(_vm._s(_vm.$t("auth.registerManager.cancel")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var registrationManager_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
registrationManager_render._withStripped = true
var registrationManager_esExports = { render: registrationManager_render, staticRenderFns: registrationManager_staticRenderFns }
/* harmony default export */ var registration_registrationManager = (registrationManager_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53bfe5cb", registrationManager_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/registration/registrationManager.vue
var registrationManager_disposed = false
function registrationManager_injectStyle (ssrContext) {
  if (registrationManager_disposed) return
  __webpack_require__("xerS")
}
var registrationManager_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var registrationManager___vue_template_functional__ = false
/* styles */
var registrationManager___vue_styles__ = registrationManager_injectStyle
/* scopeId */
var registrationManager___vue_scopeId__ = "data-v-53bfe5cb"
/* moduleIdentifier (server only) */
var registrationManager___vue_module_identifier__ = null
var registrationManager_Component = registrationManager_normalizeComponent(
  registrationManager,
  registration_registrationManager,
  registrationManager___vue_template_functional__,
  registrationManager___vue_styles__,
  registrationManager___vue_scopeId__,
  registrationManager___vue_module_identifier__
)
registrationManager_Component.options.__file = "src/auth/registration/registrationManager.vue"
if (registrationManager_Component.esModule && Object.keys(registrationManager_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-53bfe5cb", registrationManager_Component.options)
  } else {
    hotAPI.reload("data-v-53bfe5cb", registrationManager_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    registrationManager_disposed = true
  })
})()}

/* harmony default export */ var auth_registration_registrationManager = (registrationManager_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/password-reset/password-reset.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var password_reset = ({
  name: "app-password-reset",

  components: { LangSelect: src_components_LangSelect },

  data: function data() {
    return {
      sent: false,
      rules: {
        email: validators.string({ label: "Email", required: true })
      },
      model: {}
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isMobile: "shared/isMobile"
  })),

  methods: {
    submit: function submit() {
      var _this = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this.sent = true;

        _this.$store.dispatch("auth/sendPasswordResetEmail", _this.model.email).then(function () {
          _this.$router.push({ name: "login" });
        }).catch(function () {
          _this.sent = false;
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34c287b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/password-reset/password-reset.vue
var password_reset_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper password-reset" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("lang-select", { staticClass: "set-language" }),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              class: {
                "login-container": !_vm.isMobile,
                "login-container-mobile": _vm.isMobile
              },
              attrs: {
                model: _vm.model,
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "0px"
              },
              nativeOn: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "email" } },
                [
                  _c("el-input", {
                    ref: "focus",
                    attrs: {
                      type: "text",
                      "auto-complete": "off",
                      placeholder: _vm.$t("auth.passwordReset.email")
                    },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !("button" in $event) &&
                          _vm._k($event.keyCode, "enter", 13, $event.key)
                        ) {
                          return null
                        }
                        _vm.submit($event)
                      }
                    },
                    model: {
                      value: _vm.model.email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary", disabled: _vm.sent },
                      on: { click: _vm.submit }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("auth.passwordReset.sendPasswordReset"))
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "text-center" },
                [
                  _c("router-link", { attrs: { to: { name: "login" } } }, [
                    _vm._v(_vm._s(_vm.$t("auth.passwordReset.cancel")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var password_reset_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
password_reset_render._withStripped = true
var password_reset_esExports = { render: password_reset_render, staticRenderFns: password_reset_staticRenderFns }
/* harmony default export */ var password_reset_password_reset = (password_reset_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34c287b2", password_reset_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/password-reset/password-reset.vue
var password_reset_disposed = false
function password_reset_injectStyle (ssrContext) {
  if (password_reset_disposed) return
  __webpack_require__("aLWN")
}
var password_reset_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var password_reset___vue_template_functional__ = false
/* styles */
var password_reset___vue_styles__ = password_reset_injectStyle
/* scopeId */
var password_reset___vue_scopeId__ = "data-v-34c287b2"
/* moduleIdentifier (server only) */
var password_reset___vue_module_identifier__ = null
var password_reset_Component = password_reset_normalizeComponent(
  password_reset,
  password_reset_password_reset,
  password_reset___vue_template_functional__,
  password_reset___vue_styles__,
  password_reset___vue_scopeId__,
  password_reset___vue_module_identifier__
)
password_reset_Component.options.__file = "src/auth/password-reset/password-reset.vue"
if (password_reset_Component.esModule && Object.keys(password_reset_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34c287b2", password_reset_Component.options)
  } else {
    hotAPI.reload("data-v-34c287b2", password_reset_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    password_reset_disposed = true
  })
})()}

/* harmony default export */ var auth_password_reset_password_reset = (password_reset_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/empty-permissions/empty-permissions.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var empty_permissions = ({
  name: "app-empty-permissions",

  methods: {
    signout: function signout() {
      return this.$store.dispatch("auth/signout");
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    isMobile: "shared/isMobile"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8e74dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/empty-permissions/empty-permissions.vue
var empty_permissions_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper empty-permissions" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c("div", { staticClass: "auth-wrapper__content" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "You have no permissions yet. Wait for the admin to add your privileges."
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mt-6 text-center" }, [
          _c(
            "a",
            { attrs: { href: "javascript:" }, on: { click: _vm.signout } },
            [_vm._v("Sign out")]
          )
        ])
      ])
    ])
  ])
}
var empty_permissions_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
empty_permissions_render._withStripped = true
var empty_permissions_esExports = { render: empty_permissions_render, staticRenderFns: empty_permissions_staticRenderFns }
/* harmony default export */ var empty_permissions_empty_permissions = (empty_permissions_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8e74dc", empty_permissions_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/empty-permissions/empty-permissions.vue
var empty_permissions_disposed = false
function empty_permissions_injectStyle (ssrContext) {
  if (empty_permissions_disposed) return
  __webpack_require__("7tkY")
}
var empty_permissions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var empty_permissions___vue_template_functional__ = false
/* styles */
var empty_permissions___vue_styles__ = empty_permissions_injectStyle
/* scopeId */
var empty_permissions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var empty_permissions___vue_module_identifier__ = null
var empty_permissions_Component = empty_permissions_normalizeComponent(
  empty_permissions,
  empty_permissions_empty_permissions,
  empty_permissions___vue_template_functional__,
  empty_permissions___vue_styles__,
  empty_permissions___vue_scopeId__,
  empty_permissions___vue_module_identifier__
)
empty_permissions_Component.options.__file = "src/auth/empty-permissions/empty-permissions.vue"
if (empty_permissions_Component.esModule && Object.keys(empty_permissions_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a8e74dc", empty_permissions_Component.options)
  } else {
    hotAPI.reload("data-v-6a8e74dc", empty_permissions_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    empty_permissions_disposed = true
  })
})()}

/* harmony default export */ var auth_empty_permissions_empty_permissions = (empty_permissions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/email-unverified/email-unverified.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var email_unverified = ({
  name: "app-email-unverified",

  data: function data() {
    return {
      sent: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    email: "auth/email",
    isMobile: "shared/isMobile"
  })),

  methods: {
    sendEmailVerification: function sendEmailVerification() {
      var _this = this;

      this.sent = true;
      this.$store.dispatch("auth/sendEmailVerification").catch(function () {
        _this.sent = false;
      });
    },
    signout: function signout() {
      return this.$store.dispatch("auth/signout");
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74017252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/email-unverified/email-unverified.vue
var email_unverified_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auth-wrapper email-unverified" }, [
    !_vm.isMobile
      ? _c("div", { staticClass: "auth-wrapper auth-wrapper-left" })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "auth-wrapper-rigth" }, [
      _c(
        "div",
        { staticClass: "auth-wrapper__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t("auth.emailUnverified.pleaseConfirmYourEmailAt")
                ) +
                "\n            "
            ),
            _c("strong", [_vm._v(_vm._s(_vm.email))]),
            _vm._v(
              "  \n            " +
                _vm._s(_vm.$t("auth.emailUnverified.toContinue")) +
                "\n          "
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "primary", disabled: _vm.sent },
              on: { click: _vm.sendEmailVerification }
            },
            [
              _vm._v(
                _vm._s(_vm.$t("auth.emailUnverified.resendEmailConfirmation"))
              )
            ]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [
            _c(
              "a",
              { attrs: { href: "javascript:" }, on: { click: _vm.signout } },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("auth.emailUnverified.signInWithAnotherAccount")
                  )
                )
              ]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var email_unverified_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "auth-wrapper__logo logo" }, [
      _c("figure", { staticClass: "figure-logo" }, [
        _c("img", {
          attrs: { src: "/static/logos/logo_dv7.png", alt: "40%", width: "80%" }
        })
      ])
    ])
  }
]
email_unverified_render._withStripped = true
var email_unverified_esExports = { render: email_unverified_render, staticRenderFns: email_unverified_staticRenderFns }
/* harmony default export */ var email_unverified_email_unverified = (email_unverified_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74017252", email_unverified_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/email-unverified/email-unverified.vue
var email_unverified_disposed = false
function email_unverified_injectStyle (ssrContext) {
  if (email_unverified_disposed) return
  __webpack_require__("PnGU")
}
var email_unverified_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var email_unverified___vue_template_functional__ = false
/* styles */
var email_unverified___vue_styles__ = email_unverified_injectStyle
/* scopeId */
var email_unverified___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var email_unverified___vue_module_identifier__ = null
var email_unverified_Component = email_unverified_normalizeComponent(
  email_unverified,
  email_unverified_email_unverified,
  email_unverified___vue_template_functional__,
  email_unverified___vue_styles__,
  email_unverified___vue_scopeId__,
  email_unverified___vue_module_identifier__
)
email_unverified_Component.options.__file = "src/auth/email-unverified/email-unverified.vue"
if (email_unverified_Component.esModule && Object.keys(email_unverified_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-74017252", email_unverified_Component.options)
  } else {
    hotAPI.reload("data-v-74017252", email_unverified_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    email_unverified_disposed = true
  })
})()}

/* harmony default export */ var auth_email_unverified_email_unverified = (email_unverified_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/docs/privacyPolicy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var privacyPolicy = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a19b9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/docs/privacyPolicy.vue
var privacyPolicy_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var privacyPolicy_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("title", [_vm._v(" Privacy policy")]),
      _vm._v(" "),
      _c("h1", [_vm._v("PRIVACY POLICY")]),
      _vm._v(" "),
      _c("h2", [_vm._v("1. Purposes of the processing")]),
      _vm._v(
        '\n\n        We inform that all personal data provided by the User through this \n    app (hereinafter, the "App") will be processed by OWQLO, S.L, as Data \n    Controller of the processing, (hereinafter, "OWQLO") for the following \n    purposes:\n\n        '
      ),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [
          _vm._v(
            "A.\tEnable the provision of requested services; The legal basis\n    for carrying out this data processing is the execution of the \n    contractual obligations assumed by the User and OWQLO in the App. The \n    personal data processed for this purpose will be kept as long as that \n    relationship is maintained and, once it is finalized, during the \n    conservation and prescription periods of the legal liabilities."
          )
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "B.\tKeep you informed, including by electronic means, about \n    news and events related to OWQLO, as well as OWQLO products and \n    services. The legal basis for carrying out this data processing is the \n    freely given consent of the User. Personal data processed for this \n    purpose will be kept until the User withdraws the given consent. The \n    User may indicate expressly whether or not it authorizes the processing \n    of their data at any time."
          )
        ])
      ]),
      _vm._v(" "),
      _c("h2", [
        _vm._v("2. Recipients, Data Processors and personal data transfers")
      ]),
      _vm._v(
        "\n\n        Personal data may be communicated to the following third-party \n    recipients: Public Administrations for compliance with legal \n    obligations; and to the following categories of Data Processors: \n    Providers of electronic communications; Suppliers of IT development and \n    online office automation, hosting, SaaS services such as CRM/ERP, \n    accounting, auditing and lawyers. OWQLO may also transfer the personal \n    data to Data Processors located in the United States of America who are \n    members of the Privacy Shield, which has a decision to adopt the \n    European Commission (Execution Decision (EU) 2016/1250 of the \n    Commission).\n\n    "
      ),
      _c("h2", [_vm._v("3. Rights of the Users")]),
      _vm._v(
        "\n\n        The interested party is, at any time, entitled to exercise the \n    rights of access, rectification, erasure, restriction of processing, \n    data portability and object by email addressed to support@owqlo.com or \n    by letter addressed to OWQLO, C/Fernando El Santo, nº 27, 4º A 28010 - \n    Madrid (Spain). The users have the right to withdraw consent at any \n    time, without affecting the lawfulness of processing based on consent \n    before its withdrawal. The users have, as well, the right to lodge a \n    complaint with a supervisory authority.\n\n    "
      ),
      _c("h2", [_vm._v("4. Display of User data by other Users")]),
      _vm._v(
        "\n\n    The User knows and accepts that when registering in the App, other Users will be able to visit and view their profile.\n\n    "
      ),
      _c("h2", [_vm._v("5. Under-age Users")]),
      _vm._v(
        "\n\n    When the User is under 14 years old, will be required the consent of\n    their respective legal guardians in order to get signed up in the App. \n    They will must enter their name, surname, email address and the number \n    of their national identity document at the time of registration in the \n    App. After, said legal guardian will have to verify it through the \n    e-mail address previously provided.\n\n    "
      ),
      _c("h2", [_vm._v("6. OWQLO as Data Processor")]),
      _vm._v(
        "\n\n    OWQLO will be the Data Processor of all those User?s personal data \n    that needs to be accessed for the correct provision of the requested \n    services, except those already treated in section 1 of this Privacy \n    Policy.\n\n    Said personal data may be classified into the following categories \nof data:    \n    "
      ),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [_vm._v("1.\tIdentification data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("2.\tPersonal characteristics data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("3.\tAcademic and professional data.")]),
        _vm._v(" "),
        _c("li", [_vm._v("4.\tData related to health.")])
      ]),
      _vm._v("\n\n\n\n\n    In this regard, OWQLO undertakes:\n    "),
      _c("ul", { staticStyle: { "list-style-type": "none" } }, [
        _c("li", [
          _vm._v(
            "a) Processing personal data only following documented \n    instructions from the User, including with regard to transfers of \n    personal data, unless required to do so by Union or Member State law; in\n    such case, the Processor will inform User of that legal requirement \n    before processing, unless that Law prohibits such information on \n    important grounds of public interests."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "b) Ensure that the persons authorised to process personal data\n    have committed themselves to confidentiality or are under an \n    appropriate statutory obligation of confidentiality. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "c) Take all measures required pursuant to Article 32 of the Regulation. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "d) When the Data Processor turns to another person in charge \n    to carry out certain treatment activities, he will impose on the other \n    person in charge, by contract, the same data protection obligations as \n    those stipulated in this Contract. e) Assist the User, taking into \n    account the nature of the processing, by appropriate technical and \n    organisational measures, insofar as this is possible, for the fulfilment\n    of the User?s obligation to respond to requests for exercising the data\n    subject?s rights. In this case, the Processor must communicate it by \n    email to the following address. The communication must be made \n    immediately."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "f) Assists the User in ensuring compliance with the \n    obligations pursuant to Articles 32 to 36 taking into account the nature\n    of processing and the information available to the Processor. g) At the\n    choice of the User, deletes or returns all the personal data to the \n    User after the end of the provision of services relating to processing, \n    and deletes existing copies unless Union or Member State law requires \n    storage of the personal data."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "h) Makes available to the User all information necessary to \n    demonstrate compliance with the obligations laid down in Article 28 of \n    the Regulation. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "i) Inform the User immediately if, in the opinion of the \n    Processor, when an instruction infringes the Regulation or other data \n    protection rule from the Union or Member State."
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "j) Comply with any other obligation set by the current data protection regulations. "
          )
        ]),
        _c("br"),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            " k) Notify to the User, without undue delay and where \n    feasible, through email, any personal data breach with all the relevant \n    information for the documentation, resolution and communication of the \n    incident."
          )
        ]),
        _c("br")
      ])
    ])
  }
]
privacyPolicy_render._withStripped = true
var privacyPolicy_esExports = { render: privacyPolicy_render, staticRenderFns: privacyPolicy_staticRenderFns }
/* harmony default export */ var docs_privacyPolicy = (privacyPolicy_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a19b9a", privacyPolicy_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/docs/privacyPolicy.vue
var privacyPolicy_disposed = false
function privacyPolicy_injectStyle (ssrContext) {
  if (privacyPolicy_disposed) return
  __webpack_require__("YkD6")
}
var privacyPolicy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var privacyPolicy___vue_template_functional__ = false
/* styles */
var privacyPolicy___vue_styles__ = privacyPolicy_injectStyle
/* scopeId */
var privacyPolicy___vue_scopeId__ = "data-v-26a19b9a"
/* moduleIdentifier (server only) */
var privacyPolicy___vue_module_identifier__ = null
var privacyPolicy_Component = privacyPolicy_normalizeComponent(
  privacyPolicy,
  docs_privacyPolicy,
  privacyPolicy___vue_template_functional__,
  privacyPolicy___vue_styles__,
  privacyPolicy___vue_scopeId__,
  privacyPolicy___vue_module_identifier__
)
privacyPolicy_Component.options.__file = "src/auth/docs/privacyPolicy.vue"
if (privacyPolicy_Component.esModule && Object.keys(privacyPolicy_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-26a19b9a", privacyPolicy_Component.options)
  } else {
    hotAPI.reload("data-v-26a19b9a", privacyPolicy_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    privacyPolicy_disposed = true
  })
})()}

/* harmony default export */ var auth_docs_privacyPolicy = (privacyPolicy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/auth/docs/termsConditions.vue
//
//
//
//
//
//

/* harmony default export */ var termsConditions = ({});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a14c38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/auth/docs/termsConditions.vue
var termsConditions_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_vm._v("\n    Terminos\n")])
}
var termsConditions_staticRenderFns = []
termsConditions_render._withStripped = true
var termsConditions_esExports = { render: termsConditions_render, staticRenderFns: termsConditions_staticRenderFns }
/* harmony default export */ var docs_termsConditions = (termsConditions_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33a14c38", termsConditions_esExports)
  }
}
// CONCATENATED MODULE: ./src/auth/docs/termsConditions.vue
var termsConditions_disposed = false
function termsConditions_injectStyle (ssrContext) {
  if (termsConditions_disposed) return
  __webpack_require__("iH+/")
}
var termsConditions_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var termsConditions___vue_template_functional__ = false
/* styles */
var termsConditions___vue_styles__ = termsConditions_injectStyle
/* scopeId */
var termsConditions___vue_scopeId__ = "data-v-33a14c38"
/* moduleIdentifier (server only) */
var termsConditions___vue_module_identifier__ = null
var termsConditions_Component = termsConditions_normalizeComponent(
  termsConditions,
  docs_termsConditions,
  termsConditions___vue_template_functional__,
  termsConditions___vue_styles__,
  termsConditions___vue_scopeId__,
  termsConditions___vue_module_identifier__
)
termsConditions_Component.options.__file = "src/auth/docs/termsConditions.vue"
if (termsConditions_Component.esModule && Object.keys(termsConditions_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-33a14c38", termsConditions_Component.options)
  } else {
    hotAPI.reload("data-v-33a14c38", termsConditions_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    termsConditions_disposed = true
  })
})()}

/* harmony default export */ var auth_docs_termsConditions = (termsConditions_Component.exports);

// CONCATENATED MODULE: ./src/auth/auth-routes.js









/* harmony default export */ var auth_routes = ([{
  name: 'login',
  path: '/auth/login',
  component: auth_login_login,
  meta: { unauth: true }
}, {
  name: 'passwordReset',
  path: '/auth/password-reset',
  component: auth_password_reset_password_reset,
  meta: { unauth: true }
}, {
  name: 'registrationManager',
  path: '/auth/registrationManager',
  component: auth_registration_registrationManager,
  meta: { unauth: true }
}, {
  name: 'registration',
  path: '/auth/registration',
  component: auth_registration_registration,
  meta: { unauth: true }
}, {
  name: 'emailUnverified',
  path: '/auth/email-unverified',
  component: auth_email_unverified_email_unverified,
  meta: { auth: true, emailAlreadyVerified: true }
}, {
  name: 'emptyPermissions',
  path: '/auth/empty-permissions',
  component: auth_empty_permissions_empty_permissions,
  meta: { auth: true, notEmptyPermissions: true }
}, {
  name: 'privacyPolicy',
  path: '/auth/privacyPolicy',
  component: auth_docs_privacyPolicy,
  meta: { unauth: true }
}, {
  name: 'termsConditions',
  path: '/auth/termsConditions',
  component: auth_docs_termsConditions,
  meta: { unauth: true }
}]);
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/set.js
var set = __webpack_require__("lHA8");
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/underscore/underscore.js
var underscore = __webpack_require__("rdLu");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// CONCATENATED MODULE: ./src/entities/manager/manager-model.js


/* harmony default export */ var manager_model = ({
  default: function _default() {
    return {};
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-model.js



/* harmony default export */ var club_model = ({
  default: function _default() {
    return {
      id: null,
      pictures: [],
      teams: [],
      logo: {
        name: "",
        size: 0,
        url: ""
      }
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      logo: data.logo ? file_model.toDatabaseFile(data.logo) : {
        name: "",
        size: 0,
        url: ""
      },
      name: data.name ? data.name : '',
      manager: data.manager ? data.manager : null
    };
  },
  forManager: function forManager(data) {
    return {
      id: data.id,
      name: data.name,
      logo: file_model.toDatabaseFile(data.logo),

      // manager: data.manager ? data.manager : null,
      teams: data.teams
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data, {
      // pictures: fileModel.toDatabase(data.pictures),
      logo: file_model.toDatabaseFile(data.logo)
    });
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data, {
      // pictures: fileModel.toDatabase(data.pictures),
      logo: file_model.toDatabaseFile(data.logo)
    });
  }
});
// CONCATENATED MODULE: ./src/shared/entity-logger.js

/* eslint-disable */
/* harmony default export */ var entity_logger = ({
  log: function log(data, operation, databasePath, entityName) {
    var modelLog = {
      data: data,
      entityPath: databasePath,
      entityName: entityName,
      operation: operation,
      modified: data.modified
    };

    firebase_init_db.ref('log').child('logs').child(databasePath).push(data);
    firebase_init_db.ref('userActivity').child(data.modifiedBy.id).push(modelLog);
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-service.js






/* eslint-disable */
var KEY_USERS_MANAGER = "usersManager";
var NAME_ENTITY = 'clubManager';

/* harmony default export */ var manager_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_USERS_MANAGER).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS_MANAGER).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy manager-model");
        }
        resolve(model);
      });
    });
  },
  findByEmail: function findByEmail(email) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS_MANAGER).orderByChild("email").equalTo(email).once('value').then(function (snapshot) {
        var model = {};
        snapshot.forEach(function (it) {
          model = it.val();
        });

        if (!model == null || underscore_default.a.isEmpty(model)) {
          reject("User manager no exist");
        }

        resolve(model);
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS_MANAGER).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- update");
    console.log(modelToUpdate);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS_MANAGER).child(modelToUpdate.id).set(manager_model.forUpdate(modelToUpdate), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToUpdate, "modified", KEY_USERS_MANAGER, NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  create: function create(model, loggedUser) {

    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_USERS_MANAGER).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- create");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS_MANAGER).child(modelToSave.id).set(manager_model.forCreate(modelToSave), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", KEY_USERS_MANAGER, NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_USERS_MANAGER).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./src/auth/roles.js




var roles_Roles = function () {
  function Roles() {
    classCallCheck_default()(this, Roles);
  }

  createClass_default()(Roles, null, [{
    key: 'labelOf',
    value: function labelOf(id) {
      if (!this.exists(id)) {
        return id;
      }

      return this.values[id].label;
    }
  }, {
    key: 'exists',
    value: function exists(role) {
      return !!this.values[role];
    }
  }, {
    key: 'values',
    get: function get() {
      return {
        owner: {
          id: 'owner',
          label: 'Owner',
          description: 'Access to all resources'
        },
        activityViewer: {
          id: 'activityViewer',
          label: 'Activity Viewer',
          description: 'Access to view all activities'
        },
        securityReviewer: {
          id: 'securityReviewer',
          label: 'Security Reviewer',
          description: 'Full access to manage user\'s roles'
        },
        entityEditor: {
          id: 'entityEditor',
          label: 'Entity Editor',
          description: 'Edit access to all entities'
        },
        entityViewer: {
          id: 'entityViewer',
          label: 'Entity Viewer',
          description: 'View access to all entities'
        },
        clubEditor: {
          id: 'clubEditor',
          label: 'Club Editor',
          description: 'Edit access to clubs'
        },
        clubViewer: {
          id: 'clubViewer',
          label: 'Club Viewer',
          description: 'View access to clubs'
        },
        teamEditor: {
          id: 'teamEditor',
          label: 'Team Editor',
          description: 'Edit access to teams'
        },
        teamViewer: {
          id: 'teamViewer',
          label: 'Team Viewer',
          description: 'View access to teams'
        },
        teamManagerEditor: {
          id: 'teamManagerEditor',
          label: 'Team manager Editor',
          description: 'Edit access to team managers'
        },
        teamManagerViewer: {
          id: 'teamManagerViewer',
          label: 'Team manager Viewer',
          description: 'View access to team managers'
        },
        categoryEditor: {
          id: 'categoryEditor',
          label: 'Category Editor',
          description: 'Edit access to categories'
        },
        categoryViewer: {
          id: 'categoryViewer',
          label: 'Category Viewer',
          description: 'View access to categories'
        },
        playerEditor: {
          id: 'playerEditor',
          label: 'Player Editor',
          description: 'Edit access to players'
        },
        playerViewer: {
          id: 'playerViewer',
          label: 'Player Viewer',
          description: 'View access to players'
        },
        coachEditor: {
          id: 'coachEditor',
          label: 'Coach Editor',
          description: 'Edit access to coaches'
        },
        coachViewer: {
          id: 'coachViewer',
          label: 'Coach Viewer',
          description: 'View access to coaches'
        },
        managerEditor: {
          id: 'managerEditor',
          label: 'Manager Editor',
          description: 'Edit access to managers'
        },
        managerViewer: {
          id: 'managerViewer',
          label: 'Manager Viewer',
          description: 'View access to managers'
        },
        positionEditor: {
          id: 'positionEditor',
          label: 'Position Editor',
          description: 'Edit access to positions'
        },
        positionViewer: {
          id: 'positionViewer',
          label: 'Position Viewer',
          description: 'View access to positions'
        },
        documentEditor: {
          id: 'documentEditor',
          label: 'Document Editor',
          description: 'Edit access to documents'
        },
        documentViewer: {
          id: 'documentViewer',
          label: 'Document Viewer',
          description: 'View access to documents'
        },
        fieldManagerEditor: {
          id: 'fieldManagerEditor',
          label: 'Field manager Editor',
          description: 'Edit access to fieldManagers'
        },
        fieldManagerViewer: {
          id: 'fieldManagerViewer',
          label: 'Field manager Viewer',
          description: 'View access to fieldManagers'
        },
        refereeEditor: {
          id: 'refereeEditor',
          label: 'Referee Editor',
          description: 'Edit access to referees'
        },
        refereeViewer: {
          id: 'refereeViewer',
          label: 'Referee Viewer',
          description: 'View access to referees'
        },
        tournamentEditor: {
          id: 'tournamentEditor',
          label: 'Tournament Editor',
          description: 'Edit access to tournaments'
        },
        tournamentViewer: {
          id: 'tournamentViewer',
          label: 'Tournament Viewer',
          description: 'View access to tournaments'
        },

        // NEW!!
        clubManager: {
          id: 'clubManager',
          label: 'Club manager',
          description: 'View access to edit ( teams, players ) of club'
        }
      };
    }
  }, {
    key: 'asArray',
    get: function get() {
      var _this = this;

      return keys_default()(this.values).map(function (roleId) {
        return _this.values[roleId];
      });
    }
  }]);

  return Roles;
}();

/* harmony default export */ var auth_roles = (roles_Roles);
// CONCATENATED MODULE: ./src/user/user-service.js




/* eslint-disable */
// import firebaseAxios from '@/shared/firebase/firebase-axios';






var KEY_USERS = 'users';
var KEY_TEAMS = 'teams';
var KEY_CLUBS = 'clubs';
var KEY_PROPERTIES = 'properties';
var KEY_USERS_NO_VERIFIED = 'userNoVerified';

/* harmony default export */ var user_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_USERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {

      firebase_init_db.ref(KEY_USERS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy user");
        }

        resolve(model);
      });
    });
  },
  findByEmail: function findByEmail(email) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS).orderByChild("email").equalTo(email).once('value').then(function (snapshot) {
        var model = {};
        snapshot.forEach(function (it) {
          model = it.val();
        });

        if (!model == null || underscore_default.a.isEmpty(model)) {
          reject("User no exist");
        }

        resolve(model);
      });
    });
  },
  findUserNoVerifiedByEmail: function findUserNoVerifiedByEmail(email) {
    return new promise_default.a(function (resolve, reject) {
      var ref = firebase.database().ref(KEY_USERS_NO_VERIFIED);

      ref.orderByChild("email").equalTo(email).once('value', function (snapshot) {
        var model = {};
        snapshot.forEach(function (it) {
          model = it.val();
        });

        if (!model == null || underscore_default.a.isEmpty(model)) {
          reject("User no exist");
        }

        resolve(model);
      });
    });
  },
  update: function update(user) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS).child(user.id).set(user, function (error) {

        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  addAllUsersProperty: function addAllUsersProperty(property, loggedUser) {
    console.log(" ADD ALL USERS ", property);

    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_USERS).once('value').then(function (snapshot) {
        var list = [];
        var updates = {};

        snapshot.forEach(function (childSnapshot) {
          var user = childSnapshot.val();
          list.push(childSnapshot.val());
          updates['/' + KEY_USERS + '/' + user.id + '/' + KEY_PROPERTIES + '/' + property] = true;
        });

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            reject(error);
          } else {
            resolve();
          }
        });
        resolve(list);
      });
    });
  },


  // 1. findByEmail
  // 2. if NotExist create user
  // 3. else exception userExist
  createAll: function createAll(model, loggedUser) {
    var _this = this;

    var emails = model.emails;
    var roles = model.roles;

    return new promise_default.a(function (resolve, reject) {
      if (!emails || !emails.length) {
        reject('emails are required');
      }

      if (!roles || !roles.length) {
        reject('roles are required');
      }

      // For each
      emails.forEach(function (email) {

        // 1. find by email
        _this.findByEmail(email).then(function (user) {

          model.roles = [].concat(toConsumableArray_default()(new set_default.a(roles.concat(user.roles))));
          // 2. update user
          _this.update(model).then(function () {
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {

          //create auth user
          var modelToSave = {
            id: firebase_init_db.ref("userNoVerified").push().key,
            email: email,
            roles: roles

            // 1. Guardar usuario en lista no verificados
          };firebase_init_db.ref("userNoVerified").child(modelToSave.id).set(modelToSave).then(function (e) {
            var sendEmailRegistrationUser = functions.httpsCallable('sendEmailRegistrationUser');

            // 2. Enviar el email con enlace para que se registren como manager
            sendEmailRegistrationUser(email).then(function (result) {
              if (result.data != null && result.data.errorInfo) {
                // Error
                reject(result.data.errorInfo.message);
              } else {
                // Success
                resolve();
              }
            });
          }).catch(function (error) {
            reject(error);
          });
        });
      });
    });
  },
  create: function create(data, loggedUser) {
    var modelToSave = extends_default()({}, data, {
      id: data.id || firebase_init_db.ref(KEY_USERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_USERS).child(modelToSave.id).set(modelToSave, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  createUserNoVerifiedAndSendEmailManager: function createUserNoVerifiedAndSendEmailManager(model) {
    var _this2 = this;

    return new promise_default.a(function (resolve, reject) {

      // 1. Guardar usuario en lista no verificados
      firebase_init_db.ref("userNoVerified").child(model.id).set(model).then(function () {
        var sendEmailRegistrationManager = functions.httpsCallable('sendEmailRegistrationManager');

        // 2. Enviar el email con enlace para que se registren como manager
        sendEmailRegistrationManager(model.email).then(function (result) {

          if (result.data != null && result.data.errorInfo) {

            //Error creating user
            _this2.dismissibleAlertText = result.data.errorInfo.message;
            reject(result.data.errorInfo.message);
          } else {
            // 3. Avisar a los clubs que se le ha enviado el correo al manager (statusManager="invited")
            underscore_default.a.each(model.clubs, function (value, key, obj) {
              firebase_init_db.ref('clubs').child(key).child('statusManager').set("invited");
            });

            resolve();
          }
        }).catch(function (error) {
          reject(error);
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },

  /**
   * Función que crea un usuario manager asignandole el club con el rol de clubManager
   * 
   * @param {*} club 
   */
  createUserManagerSendEmail: function createUserManagerSendEmail(club, loggedUser) {
    var _this3 = this;

    return new promise_default.a(function (resolve, reject) {
      console.log("<---- CREATE USER MANAGER ");
      console.log(club);

      var clubs = {}; // create an empty array
      var roles = ['clubManager']; // create an empty array

      clubs[club.id] = club_model.forManager(club);

      var modelToSave = {
        email: club.emailManager.trim(),
        roles: roles,
        clubs: clubs,
        typeManager: 'clubManager'

        // 1. Buscamos si el manager tiene usuario, es decir, que ya se ha registrado
      };manager_service.findByEmail(modelToSave.email).then(function (manager) {
        console.log("<---- 1 Registrado");
        console.log(manager);

        //manager.roles = [...new Set(roles.concat('clubManager'))];

        if (manager.clubs) {
          manager.clubs[club.id] = club_model.forManager(club);
        } else {
          manager.clubs = clubs;
        }

        // 2. update manager
        manager_service.update(manager, loggedUser).then(function () {
          var updates = {};
          updates['/' + KEY_CLUBS + '/' + club.id + '/' + 'statusManager'] = "verified";
          updates['/' + KEY_CLUBS + '/' + club.id + '/' + 'manager'] = manager_model.forSimple(manager);

          firebase_init_db.ref().update(updates, function (error) {
            if (error) {
              reject(error);
            } else {
              resolve();
            }
          });

          resolve();
        }).catch(function (error) {
          reject(error);
        });
      }).catch(function (error) {

        // 2. Si no tiene usuario
        // 2.1 Buscamos si el emailManager, tiene invitaciones, es decir, esta en la tabla de usuariosNo
        _this3.findUserNoVerifiedByEmail(modelToSave.email).then(function (userNoVerified) {
          // updadte roles
          modelToSave.roles = underscore_default.a.union(roles, userNoVerified.roles);
          // update clubs
          modelToSave.clubs = userNoVerified.clubs;
          modelToSave.clubs[club.id] = club_model.forManager(club);
          modelToSave.id = userNoVerified.id;

          // 2.2 Modificamos el usuario no verificado
          _this3.createUserNoVerifiedAndSendEmailManager(modelToSave).then(function () {
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {

          // Si no tiene ninguna invitación le asignamos un id nuevo
          modelToSave.id = firebase_init_db.ref("userNoVerified").push().key;
          _this3.createUserNoVerifiedAndSendEmailManager(modelToSave).then(function () {
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        });
      });
    });
  },
  findMe: function findMe(firebaseUser) {
    var _this4 = this;

    return new promise_default.a(function (resolve, reject) {
      _this4.find(firebaseUser.uid).then(function (user) {
        var userRoles = user.roles;
        var roles = auth_roles.values;

        console.log(roles.clubManager.id);

        if (underscore_default.a.contains(userRoles, roles.clubManager.id)) {
          manager_service.find(user.id).then(function (manager) {

            var userToAuth = extends_default()({}, user, {
              clubs: manager.clubs
            });

            resolve(userToAuth);
          }).catch(function (error) {
            reject(error);
          });
        } else {
          resolve(user);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/auth/auth-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */








/* harmony default export */ var auth_service = ({
  onAuthStateChanged: function onAuthStateChanged(callbackSuccess, callbackError) {
    index_cjs["auth"]().onAuthStateChanged(callbackSuccess, callbackError);
  },
  sendEmailVerification: function sendEmailVerification(firebaseUser) {
    return firebaseUser.sendEmailVerification();
  },
  sendPasswordResetEmail: function sendPasswordResetEmail(email) {
    return promise_default.a.resolve().then(function () {
      return index_cjs["auth"]().sendPasswordResetEmail(email);
    });
  },
  registerManager: function registerManager(model) {
    return new promise_default.a(function (resolve, reject) {
      index_cjs["auth"]().createUserWithEmailAndPassword(model.email, model.password).then(function (firebaseUser) {
        user_service.findUserNoVerifiedByEmail(model.email).then(function (userNoVerified) {
          console.log("<--- userNoVerified finded");
          console.log(userNoVerified);

          console.log("<--- userNoVerified firebase");
          console.log(firebaseUser);

          if (userNoVerified.roles === undefined) {
            reject("Link invalid");
          }

          var modelUserToSave = {
            id: firebaseUser.user.uid,
            roles: userNoVerified.roles,
            email: model.email.trim()
          };

          var modelManagertoSave = {
            id: firebaseUser.user.uid,
            email: model.email,
            name: model.name,
            lastName: model.lastName,
            phone: model.phone,
            clubs: userNoVerified.clubs
          };

          var loggerUser = {
            id: firebaseUser.user.uid,
            email: model.email
          };

          console.log("<--- userNoVerified modelUserToSave");
          console.log(modelUserToSave);
          console.log("<--- userNoVerified modelManagertoSave");
          console.log(modelManagertoSave);

          manager_service.save(manager_model.forCreate(modelManagertoSave), loggerUser).then(function () {
            console.log("<--- manager save");

            user_service.create(modelUserToSave, loggerUser).then(function () {
              console.log("<--- user save");
              index_cjs["auth"]().currentUser.sendEmailVerification().then(function () {

                // 5. Eliminamos el usuario de los usuarios no verificados
                firebase_init_db.ref('userNoVerified').child(userNoVerified.id).set(null);

                // 6. Actualizamos el (statusManager=verified) de los clubs del usuario
                underscore_default.a.each(userNoVerified.clubs, function (value, key, obj) {
                  console.log("key club");
                  console.log(key);

                  firebase_init_db.ref('clubs').child(key).child('statusManager').set("verified");
                  firebase_init_db.ref('clubs').child(key).child('manager').set(manager_model.forSimple(modelManagertoSave));
                });

                resolve();
              }).catch(function (error) {
                reject(error);
              });
            }).catch(function (error) {
              reject(error);
            });
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {
          reject(error);
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  register: function register(email, password) {
    return new promise_default.a(function (resolve, reject) {
      index_cjs["auth"]().createUserWithEmailAndPassword(email, password).then(function (firebaseUser) {
        user_service.findUserNoVerifiedByEmail(email).then(function (user) {
          console.log("<--- user finded");
          console.log(user);

          console.log("<--- user firebase");
          console.log(firebaseUser);

          if (user.roles === undefined) {
            reject("Link invalid");
          }

          var modelToSave = {
            id: firebaseUser.user.uid,
            roles: user.roles,
            email: email
          };

          var loggerUser = {
            id: firebaseUser.user.uid,
            email: email
          };

          console.log("<--- user modelToSave");
          console.log(modelToSave);

          user_service.create(modelToSave, loggerUser).then(function () {
            console.log("<--- user save");
            index_cjs["auth"]().currentUser.sendEmailVerification().then(function () {

              // 5. Eliminamos el usuario de los usuarios no verificados
              firebase_init_db.ref('userNoVerified').child(user.id).set(null);
              // 6. Actualizamos el (statusManager=verified) de los clubs del usuario
              underscore_default.a.each(user.clubs, function (value, key, obj) {
                console.log("key club");
                console.log(key);

                firebase_init_db.ref('clubs').child(key).child('statusManager').set("verified");
                firebase_init_db.ref('clubs').child(key).child('statusManager').set("verified");
              });

              resolve();
            }).catch(function (error) {
              reject(error);
            });
          }).catch(function (error) {
            reject(error);
          });
        }).catch(function (error) {
          reject(error);
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  signin: function signin(email, password) {
    return promise_default.a.resolve().then(function () {
      return index_cjs["auth"]().signInWithEmailAndPassword(email, password);
    });
  },
  signout: function signout() {
    return index_cjs["auth"]().signOut();
  }
});
// CONCATENATED MODULE: ./src/auth/role-matcher.js



var role_matcher_RoleMatcher = function () {
  /* eslint-disable */
  function RoleMatcher(currentUserRoles) {
    classCallCheck_default()(this, RoleMatcher);

    this.currentUserRoles = currentUserRoles;
  }

  createClass_default()(RoleMatcher, [{
    key: "has",
    value: function has(arg) {

      if (!this.currentUserRoles || !this.currentUserRoles.length) {
        return false;
      }

      if (!arg) {
        return true;
      }

      var rolesToCompare = Array.isArray(arg) ? arg : [arg];

      return this.currentUserRoles.some(function (role) {
        return rolesToCompare.some(function (allowedRole) {
          return allowedRole === role;
        });
      });
    }
  }]);

  return RoleMatcher;
}();

/* harmony default export */ var role_matcher = (role_matcher_RoleMatcher);
// CONCATENATED MODULE: ./src/auth/auth-store.js





/* eslint-disable */
/* harmony default export */ var auth_store = ({
  namespaced: true,

  state: {
    loading: false,
    initialized: false,
    storageInitialized: false,
    firebaseUser: null,
    user: null
  },

  getters: {
    initialized: function initialized(state) {
      return state.initialized;
    },
    storageInitialized: function storageInitialized(state) {
      return state.storageInitialized;
    },
    user: function user(state) {
      return state.user;
    },
    authenticated: function authenticated(state) {
      return !!state.user && !!state.user.id;
    },
    email: function email(state) {
      return state.firebaseUser ? state.firebaseUser.email : null;
    },
    emailVerified: function emailVerified(state) {
      return state.firebaseUser && state.firebaseUser.emailVerified;
    },
    loading: function loading(state) {
      return state.loading;
    },
    hasRole: function hasRole(state) {
      return function (arg) {
        return new role_matcher(state.user.roles).has(arg);
      };
    }

  },

  mutations: {
    INITIALIZED: function INITIALIZED(state, payload) {
      state.initialized = !!payload;
    },
    STORAGE_INITIALIZED: function STORAGE_INITIALIZED(state, payload) {
      state.storageInitialized = !!payload;
    },
    USER: function USER(state, payload) {
      state.user = payload;
    },
    FIREBASE_USER: function FIREBASE_USER(state, payload) {
      state.firebaseUser = payload;
    },
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    }
  },

  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      auth_service.onAuthStateChanged(function (firebaseUser) {
        dispatch('setupForFirebaseUser', firebaseUser);
      }, function (error) {
        dispatch('shared/error', error, { root: true });
        commit('USER', null);
        commit('INITIALIZED', true);
      });
    },
    waitUntilInit: function waitUntilInit(_ref2) {
      var getters = _ref2.getters;

      if (getters.initialized) {
        return promise_default.a.resolve();
      }

      return new promise_default.a(function (resolve) {
        var waitUntilInitInterval = setInterval(function () {
          if (getters.initialized) {
            clearInterval(waitUntilInitInterval);
            resolve();
          }
        }, 500);
      });
    },
    waitUntilStorageInit: function waitUntilStorageInit(_ref3) {
      var getters = _ref3.getters;

      if (getters.storageInitialized) {
        return promise_default.a.resolve();
      }

      return new promise_default.a(function (resolve) {
        var waitUntilStorageInitInterval = setInterval(function () {
          if (getters.storageInitialized) {
            clearInterval(waitUntilStorageInitInterval);
            resolve();
          }
        }, 500);
      });
    },
    setupForFirebaseUser: function setupForFirebaseUser(_ref4, firebaseUser) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit('FIREBASE_USER', firebaseUser);

      if (!firebaseUser) {
        commit('USER', null);
        commit('INITIALIZED', true);
        return promise_default.a.resolve();
      }
      console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<");

      return user_service.findMe(firebaseUser).then(function (user) {
        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<< USER");

        console.log(user);
        commit('USER', user);
        commit('INITIALIZED', true);
      });
      // .catch((error) => {
      //     return dispatch('signout')
      // })
    },


    // reauthenticateWithStorageToken({ dispatch, commit }) {
    //   return service
    //     .reauthenticateWithStorageToken()
    //     .then(() => {
    //       commit('STORAGE_INITIALIZED', true);
    //     })
    //     .catch((error) => {
    //       commit('STORAGE_INITIALIZED', true);
    //       dispatch('shared/error', error, { root: true });
    //       return dispatch('signout');
    //     });
    // },

    sendEmailVerification: function sendEmailVerification(_ref5) {
      var state = _ref5.state,
          getters = _ref5.getters,
          dispatch = _ref5.dispatch;

      if (!getters.authenticated) {
        throw new Error('User not authenticated!');
      }

      return auth_service.sendEmailVerification(state.firebaseUser).then(function () {
        dispatch('shared/success', 'The confirmation email was sent to ' + getters.email + '.', { root: true });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
      });
    },
    sendPasswordResetEmail: function sendPasswordResetEmail(_ref6, email) {
      var dispatch = _ref6.dispatch;

      return auth_service.sendPasswordResetEmail(email).then(function () {
        dispatch('shared/success', 'The password reset instructions was sent to ' + email + '.', { root: true });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
      });
    },
    signin: function signin(_ref7, _ref8) {
      var dispatch = _ref7.dispatch,
          commit = _ref7.commit;
      var email = _ref8.email,
          password = _ref8.password;

      commit('LOADING', true);

      return auth_service.signin(email, password).then(function (firebaseUser) {
        return dispatch('setupForFirebaseUser', firebaseUser.user);
      }).then(function () {
        return commit('LOADING', false);
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        commit('LOADING', false);
      });
    },
    register: function register(_ref9, _ref10) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;
      var email = _ref10.email,
          password = _ref10.password;

      commit('LOADING', true);

      return auth_service.register(email, password).then(function () {
        return dispatch('signin', { email: email, password: password });
      }).then(function () {
        return commit('LOADING', false);
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        commit('LOADING', false);
        return promise_default.a.reject(error);
      });
    },
    registerManager: function registerManager(_ref11, model) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit;

      commit('LOADING', true);

      return auth_service.registerManager(model).then(function () {
        return dispatch('signin', { email: model.email, password: model.password });
      }).then(function () {
        return commit('LOADING', false);
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        commit('LOADING', false);
        return promise_default.a.reject(error);
      });
    },
    signout: function signout() {
      return auth_service.signout().then(function () {
        return app_module.routerAsync().push({ name: 'login' });
      });
    }
  }
});
// CONCATENATED MODULE: ./src/auth/guards/auth-guard-mixin.js


/* harmony default export */ var auth_guard_mixin = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.auth) {
      next();
      return;
    }

    var store = app_module.storeAsync();

    store.dispatch('auth/waitUntilInit').then(function () {
      if (store.getters['auth/authenticated']) {
        if (to.name !== 'emailUnverified' && !store.getters['auth/emailVerified']) {
          next({ name: 'emailUnverified' });
          return;
        }

        if (to.name !== 'emptyPermissions' && store.getters['auth/emailVerified'] && !store.getters['auth/hasRole']()) {
          next({ name: 'emptyPermissions' });
          return;
        }

        next();
      } else {
        next({ name: 'login' });
      }
    });
  }
});
// CONCATENATED MODULE: ./src/auth/guards/unauth-guard-mixin.js


/* harmony default export */ var unauth_guard_mixin = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.unauth) {
      next();
      return;
    }

    app_module.storeAsync().dispatch('auth/waitUntilInit').then(function () {
      if (app_module.storeAsync().getters['auth/authenticated']) {
        next('/');
      } else {
        next();
      }
    });
  }
});
// CONCATENATED MODULE: ./src/auth/guards/email-already-verified-guard-mixin.js


/* harmony default export */ var email_already_verified_guard_mixin = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.emailAlreadyVerified) {
      next();
      return;
    }

    var store = app_module.storeAsync();

    store.dispatch('auth/waitUntilInit').then(function () {
      if (store.getters['auth/authenticated'] && store.getters['auth/emailVerified']) {
        next('/');
      } else {
        next();
      }
    });
  }
});
// CONCATENATED MODULE: ./src/auth/guards/not-empty-permissions-guard-mixin.js


/* harmony default export */ var not_empty_permissions_guard_mixin = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.notEmptyPermissions) {
      next();
      return;
    }

    var store = app_module.storeAsync();

    store.dispatch('auth/waitUntilInit').then(function () {
      if (store.getters['auth/authenticated'] && store.getters['auth/hasRole']()) {
        next('/');
      } else {
        next();
      }
    });
  }
});
// CONCATENATED MODULE: ./src/auth/guards/role-guard-mixin.js


/* harmony default export */ var role_guard_mixin = ({
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    if (!to.meta || !to.meta.roles) {
      next();
      return;
    }

    if (!to.meta.roles || Array.isArray(to.meta.roles) && !to.meta.roles.length) {
      throw new Error('Invalid roles for roles guard!');
    }

    app_module.storeAsync().dispatch('auth/waitUntilInit').then(function () {
      if (app_module.storeAsync().getters['auth/hasRole'](to.meta.roles)) {
        next();
      } else {
        next('/');
      }
    });
  }
});
// CONCATENATED MODULE: ./src/auth/auth-module.js








var auth_module_mixins = [auth_guard_mixin, unauth_guard_mixin, email_already_verified_guard_mixin, not_empty_permissions_guard_mixin, role_guard_mixin];

/* harmony default export */ var auth_module = ({
  routes: auth_routes,
  store: auth_store,
  mixins: auth_module_mixins
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/shared/layout/main-layout.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var main_layout = ({
  name: "app-main-layout"
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47e8e629","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/layout/main-layout.vue
var main_layout_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        [
          _c("el-header", [_c("app-header")], 1),
          _vm._v(" "),
          _c(
            "el-container",
            [
              _c("app-menu"),
              _vm._v(" "),
              _c("el-main", [_c("router-view")], 1)
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var main_layout_staticRenderFns = []
main_layout_render._withStripped = true
var main_layout_esExports = { render: main_layout_render, staticRenderFns: main_layout_staticRenderFns }
/* harmony default export */ var layout_main_layout = (main_layout_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47e8e629", main_layout_esExports)
  }
}
// CONCATENATED MODULE: ./src/shared/layout/main-layout.vue
var main_layout_disposed = false
function main_layout_injectStyle (ssrContext) {
  if (main_layout_disposed) return
  __webpack_require__("JWvb")
}
var main_layout_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var main_layout___vue_template_functional__ = false
/* styles */
var main_layout___vue_styles__ = main_layout_injectStyle
/* scopeId */
var main_layout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var main_layout___vue_module_identifier__ = null
var main_layout_Component = main_layout_normalizeComponent(
  main_layout,
  layout_main_layout,
  main_layout___vue_template_functional__,
  main_layout___vue_styles__,
  main_layout___vue_scopeId__,
  main_layout___vue_module_identifier__
)
main_layout_Component.options.__file = "src/shared/layout/main-layout.vue"
if (main_layout_Component.esModule && Object.keys(main_layout_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47e8e629", main_layout_Component.options)
  } else {
    hotAPI.reload("data-v-47e8e629", main_layout_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    main_layout_disposed = true
  })
})()}

/* harmony default export */ var shared_layout_main_layout = (main_layout_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/dashboard/dashboard.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var dashboard = ({
  name: "app-dashboard",
  created: function created() {
    this.$router.push({
      name: "clubList"
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88dc4382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/dashboard/dashboard.vue
var dashboard_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var dashboard_staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "column",
          "justify-content": "center",
          "align-items": "center",
          height: "calc(100vh - 64px - 48px)",
          overflow: "hidden"
        }
      },
      [
        _c("h1", { staticStyle: { "text-align": "center", color: "#666" } }, [
          _c("br"),
          _vm._v("This is your Home Page\n    "),
          _c("br"),
          _vm._v("You can edit this page at\n    "),
          _c("br"),
          _vm._v("frontend/src/dashboard/dashboard.vue\n  ")
        ])
      ]
    )
  }
]
dashboard_render._withStripped = true
var dashboard_esExports = { render: dashboard_render, staticRenderFns: dashboard_staticRenderFns }
/* harmony default export */ var dashboard_dashboard = (dashboard_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88dc4382", dashboard_esExports)
  }
}
// CONCATENATED MODULE: ./src/dashboard/dashboard.vue
var dashboard_disposed = false
function dashboard_injectStyle (ssrContext) {
  if (dashboard_disposed) return
  __webpack_require__("NGwu")
}
var dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var dashboard___vue_template_functional__ = false
/* styles */
var dashboard___vue_styles__ = dashboard_injectStyle
/* scopeId */
var dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var dashboard___vue_module_identifier__ = null
var dashboard_Component = dashboard_normalizeComponent(
  dashboard,
  dashboard_dashboard,
  dashboard___vue_template_functional__,
  dashboard___vue_styles__,
  dashboard___vue_scopeId__,
  dashboard___vue_module_identifier__
)
dashboard_Component.options.__file = "src/dashboard/dashboard.vue"
if (dashboard_Component.esModule && Object.keys(dashboard_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88dc4382", dashboard_Component.options)
  } else {
    hotAPI.reload("data-v-88dc4382", dashboard_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    dashboard_disposed = true
  })
})()}

/* harmony default export */ var src_dashboard_dashboard = (dashboard_Component.exports);

// CONCATENATED MODULE: ./src/dashboard/dashboard-module.js



var routes = [{
  path: '/dashboard',
  component: shared_layout_main_layout,
  meta: { auth: true },
  children: [{
    name: 'dashboard',
    path: '',
    component: src_dashboard_dashboard,
    meta: { auth: true }
  }]
}];

/* harmony default export */ var dashboard_module = ({
  routes: routes
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/activity/activity-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable */
/* harmony default export */ var activity_list = ({
  name: "app-activity-list",

  props: {
    user: Object
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "activity/loading",
    list: "activity/list",
    last: "activity/last",
    hasRoleToFullHistory: "activity/hasRoleToFullHistory"
  })),

  created: function created() {
    this.$store.dispatch("activity/setup", this.user);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("activity/clear");
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: "activity/fetch"
  }), {
    getDescription: function getDescription(activity) {
      console.log(activity);

      return string_utils.capitalize(activity.operation) + " " + activity.entityPath + " " + activity.data.name + " by (" + activity.data.modifiedBy.email + ")";
    },
    open: function open(activity) {
      this.$router.push({
        name: activity.entityName + "HistorySingle",
        params: { id: activity.data.id }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e19fa7b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/activity/activity-list.vue
var activity_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "empty-text": "There are no activities yet",
            border: ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "modified", label: "Date", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("i", { staticClass: "el-icon-time" }),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified))
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "operation", label: "Operation" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getDescription(scope.row)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              label: "Operations",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Details", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            icon: "el-icon-fa-search",
                            size: "small",
                            type: "text"
                          },
                          on: {
                            click: function($event) {
                              _vm.open(scope.row)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.last
        ? _c(
            "el-button",
            {
              staticClass: "mt-3 w-100",
              attrs: { type: "infor", icon: "el-icon-fa-plus" },
              on: {
                click: function($event) {
                  _vm.fetch()
                }
              }
            },
            [_vm._v("Load more...")]
          )
        : _vm._e()
    ],
    1
  )
}
var activity_list_staticRenderFns = []
activity_list_render._withStripped = true
var activity_list_esExports = { render: activity_list_render, staticRenderFns: activity_list_staticRenderFns }
/* harmony default export */ var activity_activity_list = (activity_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e19fa7b4", activity_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/activity/activity-list.vue
var activity_list_disposed = false
function activity_list_injectStyle (ssrContext) {
  if (activity_list_disposed) return
  __webpack_require__("8e8P")
}
var activity_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var activity_list___vue_template_functional__ = false
/* styles */
var activity_list___vue_styles__ = activity_list_injectStyle
/* scopeId */
var activity_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var activity_list___vue_module_identifier__ = null
var activity_list_Component = activity_list_normalizeComponent(
  activity_list,
  activity_activity_list,
  activity_list___vue_template_functional__,
  activity_list___vue_styles__,
  activity_list___vue_scopeId__,
  activity_list___vue_module_identifier__
)
activity_list_Component.options.__file = "src/activity/activity-list.vue"
if (activity_list_Component.esModule && Object.keys(activity_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e19fa7b4", activity_list_Component.options)
  } else {
    hotAPI.reload("data-v-e19fa7b4", activity_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    activity_list_disposed = true
  })
})()}

/* harmony default export */ var src_activity_activity_list = (activity_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/activity/activity.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var activity_activity = ({
  name: 'app-activity',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    user: 'auth/user'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8f68016","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/activity/activity.vue
var activity_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v("Activity Log")])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("route.activity")) + " \n  ")
      ]),
      _vm._v(" "),
      _c("app-activity-list", { attrs: { user: _vm.user } })
    ],
    1
  )
}
var activity_staticRenderFns = []
activity_render._withStripped = true
var activity_esExports = { render: activity_render, staticRenderFns: activity_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_bustCache_src_activity_activity = (activity_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d8f68016", activity_esExports)
  }
}
// CONCATENATED MODULE: ./src/activity/activity.vue
var activity_disposed = false
function activity_injectStyle (ssrContext) {
  if (activity_disposed) return
  __webpack_require__("O26P")
}
var activity_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var activity___vue_template_functional__ = false
/* styles */
var activity___vue_styles__ = activity_injectStyle
/* scopeId */
var activity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var activity___vue_module_identifier__ = null
var activity_Component = activity_normalizeComponent(
  activity_activity,
  selectortype_template_index_0_bustCache_src_activity_activity,
  activity___vue_template_functional__,
  activity___vue_styles__,
  activity___vue_scopeId__,
  activity___vue_module_identifier__
)
activity_Component.options.__file = "src/activity/activity.vue"
if (activity_Component.esModule && Object.keys(activity_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d8f68016", activity_Component.options)
  } else {
    hotAPI.reload("data-v-d8f68016", activity_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    activity_disposed = true
  })
})()}

/* harmony default export */ var src_activity_activity = (activity_Component.exports);

// CONCATENATED MODULE: ./src/activity/activity-routes.js



/* harmony default export */ var activity_routes = ([{
  path: '/activity',
  component: shared_layout_main_layout,
  meta: { auth: true },
  children: [{
    name: 'activity',
    path: '',
    component: src_activity_activity,
    meta: { auth: true }
  }]
}]);
// CONCATENATED MODULE: ./src/activity/activity-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var KEY_ACTIVITIES = 'userActivity';
var SIZE = 10;

/* harmony default export */ var activity_service = ({
  size: 10,

  fetch: function fetch(userId, lastmodified) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_ACTIVITIES).child(userId).orderByChild("modified").endAt(lastmodified - 1).limitToLast(SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/activity/activity-store.js



/* harmony default export */ var activity_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true,
    user: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    },
    user: function user(state) {
      return state.user;
    },
    hasRoleToFullHistory: function hasRoleToFullHistory(state, getters, rootState, rootGetters) {
      return function (activity) {
        if (!activity.entityPath) {
          return false;
        }

        var roles = auth_roles.values;

        return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
      };
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    USER: function USER(state, payload) {
      state.user = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
    }
  },

  actions: {
    setup: function setup(_ref, user) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      commit('USER', user);
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters,
          dispatch = _ref2.dispatch;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return activity_service.fetch(getters.user.id, lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/activity/activity-module.js




var activity_module_components = [src_activity_activity_list];

/* harmony default export */ var activity_module = ({
  routes: activity_routes,
  components: activity_module_components,
  store: activity_store
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-full/club-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var club_history_full_service_SIZE = 10;

/* harmony default export */ var club_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      console.log(lastmodified);

      firebase_init_db.ref("log").child("logs").child("clubs").orderByChild("modified").endAt(lastmodified - 1).limitToLast(club_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < club_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-full/club-history-full-store.js


/* harmony default export */ var club_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return club_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// EXTERNAL MODULE: ./node_modules/match-sorter/dist/match-sorter.esm.js
var match_sorter_esm = __webpack_require__("sQiz");

// EXTERNAL MODULE: ./node_modules/lodash.sortby/index.js
var lodash_sortby = __webpack_require__("oASp");
var lodash_sortby_default = /*#__PURE__*/__webpack_require__.n(lodash_sortby);

// EXTERNAL MODULE: ./node_modules/json2csv/lib/json2csv.js
var json2csv = __webpack_require__("sVpU");
var json2csv_default = /*#__PURE__*/__webpack_require__.n(json2csv);

// EXTERNAL MODULE: ./node_modules/file-saver/FileSaver.js
var FileSaver = __webpack_require__("lDdF");
var FileSaver_default = /*#__PURE__*/__webpack_require__.n(FileSaver);

// CONCATENATED MODULE: ./src/shared/pager/csv-exporter.js



/* harmony default export */ var csv_exporter = ({
  download: function download(fields, data) {
    var output = json2csv_default()({
      data: data,
      fields: fields
    });

    var blob = new Blob([output], {
      type: 'text/csv;charset=utf-8'
    });

    FileSaver_default.a.saveAs(blob, 'data.csv');
  },
  extractValueOf: function extractValueOf(item) {
    var result = item;
    var keys = this.value.split('.');

    keys.forEach(function (key, i) {
      if (result) {
        result = result[keys[i]];
      }
    });

    return result;
  }
});
// CONCATENATED MODULE: ./src/shared/pager/pager.js






var pager_Pager = function () {
  function Pager(keysToSearch, exportDefinitions) {
    classCallCheck_default()(this, Pager);

    this.keysToSearch = [];
    this.search = '';
    this.sortData = null;
    this.pageSize = 10;
    this.currentPage = 1;

    this.keysToSearch = keysToSearch;
    this.exportDefinitions = exportDefinitions;
  }

  createClass_default()(Pager, [{
    key: 'filter',
    value: function filter(list) {
      if (!this.search || !this.keysToSearch || !this.keysToSearch.length) {
        return list;
      }

      return Object(match_sorter_esm["a" /* default */])(list, this.search, {
        keys: this.keysToSearch,
        threshold: match_sorter_esm["a" /* default */].rankings.CONTAINS
      });
    }
  }, {
    key: 'sortChange',
    value: function sortChange(sortData) {
      this.sortData = sortData || null;
    }
  }, {
    key: 'pageSizeChange',
    value: function pageSizeChange(pageSizeData) {
      this.pageSize = pageSizeData || 10;
    }
  }, {
    key: 'slice',
    value: function slice(list) {
      var currentPageToSlice = this.currentPage - 1;
      return list.slice(currentPageToSlice * this.pageSize, (currentPageToSlice + 1) * this.pageSize);
    }
  }, {
    key: 'sort',
    value: function sort(list) {
      if (!this.sortData || !this.sortData.prop || !this.sortData.order) {
        return list;
      }

      if (this.sortData.order === 'descending') {
        return lodash_sortby_default()(list, [this.sortData.prop]).reverse();
      }

      return lodash_sortby_default()(list, [this.sortData.prop]);
    }
  }, {
    key: 'exportToCsv',
    value: function exportToCsv(fullList) {
      if (!this.hasDataToExport(fullList)) {
        throw new Error('No config/data to CSV export!');
      }

      return csv_exporter.download(this.exportDefinitions, this.filteredAndSortedList(fullList));
    }
  }, {
    key: 'hasDataToExport',
    value: function hasDataToExport(fullList) {
      if (!this.exportDefinitions || !this.exportDefinitions.length) {
        return false;
      }

      return !!this.filteredAndSortedList(fullList).length;
    }
  }, {
    key: 'filteredAndSortedList',
    value: function filteredAndSortedList(fullList) {
      return this.sort(this.filter(fullList));
    }
  }, {
    key: 'paginate',
    value: function paginate(fullList) {
      return this.slice(this.filteredAndSortedList(fullList));
    }
  }]);

  return Pager;
}();

/* harmony default export */ var pager = (pager_Pager);
// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-single/club-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


/* harmony default export */ var club_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child("clubs").orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-single/club-history-single-store.js



/* harmony default export */ var club_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return club_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-model.js

// import fileModel from '@/shared/file/file-model';

/* harmony default export */ var team_model = ({
  default: function _default() {
    return {
      id: null,
      players: []
      // pictures: [],
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    };
  },
  forClub: function forClub(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      players: data.players ? data.players : [],
      teamManagers: data.teamManagers ? data.teamManagers : [],
      coaches: data.coaches ? data.coaches : []
    };
  },
  forGame: function forGame(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club,
      score: 0
    };
  },
  forPlayer: function forPlayer(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-pager.js


/* harmony default export */ var team_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'category.label', 'club.name'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'category.label', label: 'Category' }, { value: 'club.name', label: 'Club' }, { value: 'locality', label: 'Locality' }, { value: 'country', label: 'Country' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/shared/file/file-service.js



/* eslint-disable */
/* harmony default export */ var file_service = ({
  uploadAll: function uploadAll(entityPath, entity, properties) {
    var _this = this;

    var promises = [];

    properties.forEach(function (property) {
      if (!entity[property]) {
        return;
      }

      entity[property].filter(function (f) {
        return !!f.raw;
      }).forEach(function (f) {
        promises.push(_this.upload(entityPath, entity.id, property, f));
      });
    });

    return promise_default.a.all(promises).then(function () {
      return entity;
    });
  },
  deleteAll: function deleteAll(entityPath, entity, properties) {
    var _this2 = this;

    var promises = [];

    properties.forEach(function (property) {
      if (!entity[property]) {
        return;
      }

      entity[property].forEach(function (f) {
        promises.push(_this2.delete(entityPath, entity.id, property, f));
      });
    });

    return promise_default.a.all(promises).then(function () {
      return entity;
    });
  },
  fillDownloadURLs: function fillDownloadURLs(entityPath, entity, properties) {
    var _this3 = this;

    var promises = [];

    properties.forEach(function (property) {
      if (!entity[property]) {
        return;
      }

      entity[property].forEach(function (fileItem) {
        promises.push(_this3.fillDownloadURL(entityPath, entity.id, property, fileItem));
      });
    });

    return promise_default.a.all(promises).then(function () {
      return entity;
    });
  },
  upload: function upload(entityPath, id, property, file) {
    return new promise_default.a(function (resolve, reject) {
      var uploadTask = index_cjs["storage"]().ref(entityPath + '/' + id + '/' + property + '/' + file.name).put(file.raw);

      uploadTask.on(index_cjs["storage"].TaskEvent.STATE_CHANGED, function () {}, function (error) {
        reject(error);
      }, function () {
        resolve();
      });
    });
  },
  uploadB64Img: function uploadB64Img(entityPath, id, property, file) {

    console.log("<-- uploadB64Img");
    console.log(entityPath + '/' + id + '/' + property + '/' + index_cjs["database"].ServerValue.TIMESTAMP);

    return new promise_default.a(function (resolve, reject) {

      if (file === undefined || file.data === undefined || file.size === 0) {
        resolve();
      }

      var uploadTask = index_cjs["storage"]().ref(entityPath + '/' + id + '/' + property + '/' + file.name).putString(file.dataB64, 'base64', { contentType: 'image/png' });

      uploadTask.on(index_cjs["storage"].TaskEvent.STATE_CHANGED, function () {
        resolve();
      }, function (error) {
        reject(error);
      }, function () {
        resolve();
      });
    });
  },
  delete: function _delete(entityPath, id, property, file) {
    return new promise_default.a(function (resolve, reject) {
      console.log("<---- delete file");
      console.log(file);

      if (file.size === 0 || file.name === "") {
        resolve();
        return;
      }

      index_cjs["storage"]().ref(entityPath + '/' + id + '/' + property + '/' + file.name).delete().then(function () {
        // File deleted successfully
        resolve();
      }).catch(function (error) {
        // Uh-oh, an error occurred!
        reject(error);
      });
    });
  },
  fillDownloadURL: function fillDownloadURL(entityPath, id, property, file) {

    if (!entityPath) {
      return promise_default.a.reject(new Error('Entity path is null!'));
    }

    if (!id) {
      return promise_default.a.reject(new Error('Id is null!'));
    }

    if (!property) {
      return promise_default.a.reject(new Error('Property is null!'));
    }

    if (!file) {
      return promise_default.a.reject(new Error('File is null!'));
    }

    if (file && file.size === 0) {
      return promise_default.a.reject(new Error('File size is 0!'));
    }

    return index_cjs["storage"]().ref(entityPath + '/' + id + '/' + property + '/' + file.name).getDownloadURL().then(function (url) {
      assign_default()(file, {
        url: url
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-team-list/club-team-list-service.js






var club_team_list_service_KEY_TEAMS = 'teams';
var club_team_list_service_KEY_CLUBS = 'clubs';

/* harmony default export */ var club_team_list_service = ({
  list: function list(clubId) {
    return new promise_default.a(function (resolve) {
      // eslint-disable-next-line
      firebase_init_db.ref(club_team_list_service_KEY_CLUBS).child(clubId).child(club_team_list_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      // eslint-disable-next-line
      firebase_init_db.ref(club_team_list_service_KEY_TEAMS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        file_service.fillDownloadURLs(club_team_list_service_KEY_TEAMS, model, ['pictures']).then(function (modelR) {
          resolve(modelR);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(club_team_list_service_KEY_TEAMS).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model) {
    return new promise_default.a(function (resolve, reject) {
      file_service.uploadAll(club_team_list_service_KEY_TEAMS, model, ['pictures']).then(function () {
        firebase_init_db.ref(club_team_list_service_KEY_TEAMS).child(model.id).set(team_model.forUpdate(model), function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(club_team_list_service_KEY_TEAMS).push().key
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadAll(club_team_list_service_KEY_TEAMS, modelToSave, ['pictures']).then(function () {
        firebase_init_db.ref(club_team_list_service_KEY_CLUBS).child(model.club.id).child(club_team_list_service_KEY_TEAMS).child(modelToSave.id).set(team_model.forCreate(modelToSave), function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(club_team_list_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;

          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-model.js


/* harmony default export */ var category_model = ({
  default: function _default() {
    return {};
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-service.js





var KEY_CATEGORIES = 'categories';

/* harmony default export */ var category_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_CATEGORIES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_CATEGORIES).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy category");
        }
        resolve(model);
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_CATEGORIES).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_CATEGORIES).child(model.id).set(category_model.forUpdate(model), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  create: function create(model) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_CATEGORIES).push().key
    });

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_CATEGORIES).child(modelToSave.id).set(category_model.forCreate(modelToSave), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_CATEGORIES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-service.js


/* eslint-disable */






var club_service_KEY_TEAMS = 'teams';
var club_service_KEY_CLUBS = 'clubs';
var KEY_CLUB = 'club';
var club_service_NAME_ENTITY = 'club';
var KEY_USER_MANAGER = 'usersManager';

/* harmony default export */ var club_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(club_service_KEY_CLUBS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {

          var modelToShow = extends_default()({}, childSnapshot.val());

          if (modelToShow.statusManager === "verified") {
            modelToShow.statusManagerEs = "Registrado";
          } else if (modelToShow.statusManager === "unverified") {
            modelToShow.statusManagerEs = "Sin invitación";
          } else if (modelToShow.statusManager === "invited") {
            modelToShow.statusManagerEs = "Invitado";
          }

          list.push(modelToShow);
        });

        resolve(list.reverse());
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(club_service_KEY_CLUBS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        if (model.logo.name === "") {
          resolve(model);
        }

        file_service.fillDownloadURL(club_service_KEY_CLUBS, model.id, 'logo', model.logo).then(function () {
          resolve(model);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },


  /**
   * Elimina un club, solo en el caso de que el club no tenga equipos
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {

      // 1. Comprobamos si el club tiene equipos 
      if (underscore_default.a.size(model.teams) > 0) {
        reject(new Error("El club tiene equipos asignados."));
        return;
      }

      var updates = {};
      updates['/' + club_service_KEY_CLUBS + '/' + model.id] = null;

      // Si tiene manager, modificamos el club del manager
      if (model.manager) {
        updates['/' + KEY_USER_MANAGER + '/' + model.manager.id + '/' + club_service_KEY_CLUBS + '/' + model.id] = null;
      }

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {

          // Data deleted successfully!
          file_service.delete(club_service_KEY_CLUBS, model.id, 'logo', model.logo).then(function () {
            entity_logger.log(modelToDestroy, "deleted", club_service_KEY_CLUBS, club_service_NAME_ENTITY);
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },
  update: function update(model, loggedUser) {

    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadB64Img(club_service_KEY_CLUBS, modelToUpdate.id, 'logo', modelToUpdate.logo).then(function () {

        var updates = {};
        updates['/' + club_service_KEY_CLUBS + '/' + modelToUpdate.id] = club_model.forUpdate(modelToUpdate);

        // Si el club tiene equipos, modificamos la información de cada uno de los equipos
        // TODO: modificar el club del manager

        // Si tiene equipos, modificamos los clubs de cada equipo
        if (model.teams) {
          underscore_default.a.each(model.teams, function (value, key, obj) {
            updates['/' + club_service_KEY_TEAMS + '/' + key + '/' + KEY_CLUB] = club_model.forSimple(modelToUpdate);
          });
        }

        // Si tiene manager, modificamos el club del manager
        if (model.manager) {
          updates['/' + KEY_USER_MANAGER + '/' + model.manager.id + '/' + club_service_KEY_CLUBS + '/' + modelToUpdate.id] = club_model.forManager(modelToUpdate);
        }

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Logs
            entity_logger.log(modelToUpdate, "modified", club_service_KEY_CLUBS, club_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model, loggedUser) {
    var modelToSave = extends_default()({}, model, {
      statusManager: "unverified",
      id: firebase_init_db.ref(club_service_KEY_CLUBS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadB64Img(club_service_KEY_CLUBS, modelToSave.id, 'logo', modelToSave.logo).then(function () {
        firebase_init_db.ref(club_service_KEY_CLUBS).child(modelToSave.id).set(club_model.forCreate(modelToSave), function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            entity_logger.log(modelToSave, "created", club_service_KEY_CLUBS, club_service_NAME_ENTITY);
            resolve(modelToSave);
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(club_service_KEY_CLUBS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.name = childSnapshot.val().name;
          modelOption.logo = childSnapshot.val().logo;
          modelOption.teams = childSnapshot.val().teams;
          modelOption.manager = childSnapshot.val().manager;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-model.js



/* harmony default export */ var player_model = ({
  default: function _default() {
    return {
      id: null,
      dorsal: "-",
      picture: {
        name: "",
        size: 0,
        url: ""
      }
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : ''
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  },
  forTeam: function forTeam(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : '',
      picture: data.picture ? file_model.toDatabaseFile(data.picture) : {
        name: "",
        size: 0,
        url: ""
      },
      birthdate: data.birthdate ? data.birthdate : '',
      dorsal: data.dorsal ? data.dorsal : '',
      phone: data.phone ? data.phone : '',
      namePublic: data.namePublic ? data.namePublic : '',
      email: data.email ? data.email : '',
      dni: data.dni ? data.dni : '',
      position: data.position ? data.position : ''
    };
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-service.js


/* eslint-disable */





var KEY_PLAYERS = 'players';
var player_service_KEY_TEAMS = 'teams';
var player_service_NAME_ENTITY = 'player';
var player_service_KEY_CLUBS = 'clubs';

/* harmony default export */ var player_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_PLAYERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByTeamId: function listByTeamId(teamId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(player_service_KEY_TEAMS).child(teamId).child(KEY_PLAYERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      // eslint-disable-next-line
      firebase_init_db.ref(KEY_PLAYERS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        // Si no tiene picture
        if (model.picture.name === "") {
          resolve(model);
        }

        file_service.fillDownloadURL(KEY_PLAYERS, model.id, 'picture', model.picture).then(function () {
          resolve(model);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + model.id] = null;
      updates['/' + KEY_PLAYERS + '/' + model.id] = null;
      updates['/' + player_service_KEY_CLUBS + '/' + model.team.club.id + '/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + model.id] = null;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data deleted successfully!
          file_service.delete(KEY_PLAYERS, model.id, 'picture', model.picture).then(function () {
            // Logs 
            entity_logger.log(modelToDestroy, "deleted", KEY_PLAYERS, player_service_NAME_ENTITY);
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadB64Img(KEY_PLAYERS, modelToUpdate.id, 'picture', modelToUpdate.picture).then(function () {
        var updates = {};
        updates['/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + model.id] = player_model.forTeam(modelToUpdate);
        updates['/' + KEY_PLAYERS + '/' + model.id] = player_model.forUpdate(modelToUpdate);
        updates['/' + player_service_KEY_CLUBS + '/' + model.team.club.id + '/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + model.id] = player_model.forTeam(modelToUpdate);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToUpdate, "modified", KEY_PLAYERS, player_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model, loggedUser) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_PLAYERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });
    console.log("<--- CREATE PLAYER");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {

      file_service.uploadB64Img(KEY_PLAYERS, modelToSave.id, 'picture', modelToSave.picture).then(function () {
        var updates = {};
        updates['/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + modelToSave.id] = player_model.forTeam(modelToSave);
        updates['/' + KEY_PLAYERS + '/' + modelToSave.id] = player_model.forCreate(modelToSave);
        updates['/' + player_service_KEY_CLUBS + '/' + model.team.club.id + '/' + player_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_PLAYERS + '/' + modelToSave.id] = player_model.forTeam(modelToSave);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToSave, "created", KEY_PLAYERS, player_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_PLAYERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;

          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-team-list/club-team-list-store.js











/* eslint-disable */
/* harmony default export */ var club_team_list_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    club: club_model.default(),
    pager: team_pager.build(),
    model: team_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    club: function club(state, getters, rootState, rootGetters) {
      return rootState.entities.club.model;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id, roles.clubManager.id] // NEW!!
      );
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.teamViewer.id, roles.teamEditor.id, roles.clubManager.id] // NEW!!

      );
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || team_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = team_pager.build();
      state.model = team_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return club_team_list_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return club_team_list_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return club_team_list_service.save(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', 'Team saved successfully!', { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return club_team_list_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', 'Team deleted successfully!', { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var getters = _ref6.getters,
          commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      console.log("<------- ROOT STATE");

      var clubId = getters.club.id;
      return club_team_list_service.list(clubId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      category_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'categories', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      club_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'clubs', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      player_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'players', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-pager.js


/* harmony default export */ var club_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'emailManager', 'statusManager', 'statusManagerEs'];

    var exportDefinitions = [
    // { value: 'id', label: 'id' },
    { value: 'name', label: 'name' }, { value: 'emailManager', label: 'emailManager' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// EXTERNAL MODULE: ./node_modules/jspdf/dist/jspdf.min.js
var jspdf_min = __webpack_require__("l9mu");
var jspdf_min_default = /*#__PURE__*/__webpack_require__.n(jspdf_min);

// EXTERNAL MODULE: ./node_modules/jspdf-autotable/dist/jspdf.plugin.autotable.js
var jspdf_plugin_autotable = __webpack_require__("+2xD");
var jspdf_plugin_autotable_default = /*#__PURE__*/__webpack_require__.n(jspdf_plugin_autotable);

// CONCATENATED MODULE: ./src/entities/team/team-service.js


/* eslint-disable */





 // birthdate





//  import teamModel from './team-model';
var team_service_NAME_ENTITY = 'team';
var team_service_KEY_TEAMS = 'teams';
var KEY_TEAM = 'team';
var team_service_KEY_CLUBS = 'clubs';
var team_service_KEY_CLUB = 'club';
var team_service_KEY_USER_MANAGER = 'usersManager';
var team_service_KEY_PLAYERS = 'players';

/* harmony default export */ var team_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      // eslint-disable-next-line
      firebase_init_db.ref(team_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByClubId: function listByClubId(clubId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_service_KEY_CLUBS).child(clubId).child(team_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByCategoryId: function listByCategoryId(categoryId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];

        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByCategoryWithoutGroup: function listByCategoryWithoutGroup() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];

        var teamListByCategory = {};

        snapshot.forEach(function (childSnapshot) {
          var listTeam = teamListByCategory[childSnapshot.val().category.id];

          if (childSnapshot.val().hasGroup !== true) {
            list.push(childSnapshot.val());

            // Si es vacio, 
            if (underscore_default.a.isEmpty(listTeam)) {
              listTeam = [];
            }

            listTeam.push(childSnapshot.val());

            teamListByCategory[childSnapshot.val().category.id] = listTeam;
          }
        });
        resolve(teamListByCategory);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(team_service_KEY_TEAMS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }
        resolve(model);
      });
    });
  },


  /**
   * Elimina un equipo, solo en el caso de que el club no tenga jugadores
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {

      // 1. Comprobamos si el club tiene equipos 
      if (underscore_default.a.size(model.players) > 0) {
        reject(new Error("El equipo tiene jugadores asignados."));
      } else {
        var updates = {};
        updates['/' + team_service_KEY_CLUBS + '/' + model.club.id + '/' + team_service_KEY_TEAMS + '/' + model.id] = null;
        updates['/' + team_service_KEY_TEAMS + '/' + model.id] = null;

        if (modelToDestroy.club.manager) {
          updates['/' + team_service_KEY_USER_MANAGER + '/' + modelToDestroy.club.manager.id + '/' + team_service_KEY_CLUBS + '/' + modelToDestroy.club.id + '/' + team_service_KEY_TEAMS + '/' + modelToDestroy.id] = null;
        }

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            entity_logger.log(modelToDestroy, "deleted", team_service_KEY_TEAMS, team_service_NAME_ENTITY);
            resolve();
          }
        });
      }
    });
  },
  update: function update(model, loggedUser) {
    return new promise_default.a(function (resolve, reject) {

      var modelToUpdate = extends_default()({}, model, {
        modified: firebase.database.ServerValue.TIMESTAMP,
        modifiedBy: { id: loggedUser.id, email: loggedUser.email }
      });

      var updates = {};
      updates['/' + team_service_KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + team_service_KEY_TEAMS + '/' + modelToUpdate.id] = team_model.forClub(modelToUpdate);;
      updates['/' + team_service_KEY_TEAMS + '/' + modelToUpdate.id] = modelToUpdate;

      // Si tiene club manager modificamos el equipo al manager
      if (modelToUpdate.club.manager) {
        updates['/' + team_service_KEY_USER_MANAGER + '/' + modelToUpdate.club.manager.id + '/' + team_service_KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + team_service_KEY_TEAMS + '/' + modelToUpdate.id] = team_model.forClub(modelToUpdate);
      }

      // Si tiene jugadores, modificamos los jugadores de ese equipo
      if (model.players) {
        underscore_default.a.each(model.players, function (value, key, obj) {
          updates['/' + team_service_KEY_PLAYERS + '/' + key + '/' + KEY_TEAM] = team_model.forSimple(modelToUpdate);
        });
      }

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          // Logs
          entity_logger.log(modelToUpdate, "modified", team_service_KEY_TEAMS, team_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  create: function create(model, loggedUser) {

    console.log("<------ CREATE TEAM");
    console.log(model);

    var club = model.club;
    var clubSimple = club_model.forSimple(club);
    model.club = clubSimple;

    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(team_service_KEY_TEAMS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- ");
    console.log(modelToSave);
    console.log("<--- CLUBS ");
    console.log(club.teams);

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + team_service_KEY_CLUBS + '/' + modelToSave.club.id + '/' + team_service_KEY_TEAMS + '/' + modelToSave.id] = team_model.forClub(modelToSave);;
      updates['/' + team_service_KEY_TEAMS + '/' + modelToSave.id] = modelToSave;

      // Si tiene club manager creamos los equipos al manager
      if (modelToSave.club.manager) {
        updates['/' + team_service_KEY_USER_MANAGER + '/' + modelToSave.club.manager.id + '/' + team_service_KEY_CLUBS + '/' + modelToSave.club.id + '/' + team_service_KEY_TEAMS + '/' + modelToSave.id] = team_model.forClub(modelToSave);
      }

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", team_service_KEY_TEAMS, team_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  exportAsPDF: function exportAsPDF(team) {
    return new promise_default.a(function (resolve, reject) {
      console.log(team);

      /**
       * PLAYERS PARSING
       */

      var playerDataList = [];
      var playerHeaderList = [['Nombre deportivo', 'Nombre', 'Apellidos', 'Dni', 'Fecha de nacim.', 'Dorsal']];

      // Players
      underscore_default.a.each(team.players, function (player, key, list) {
        var birthdate = moment_default()(player.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(js_cookie_default.a.get('language') || 'es').format('L');
        var values = [player.namePublic, player.name, player.lastName, player.dni, birthdate, player.dorsal];
        playerDataList.push(values);
      });

      /**
       * COACHES PARSING
       */

      var coachDataList = [];
      var coachHeaderList = [['Nombre', 'Apellidos', 'Dni']];

      // Coaches
      underscore_default.a.each(team.coaches, function (coach, key, list) {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name, coach.lastName, coach.dni];
        coachDataList.push(values);
      });

      /**
       * TEAM MANAGERS PARSING
       */

      var teamManagerDataList = [];
      var teamManagerHeaderList = [['Nombre', 'Apellidos', 'Dni']];

      // Managers
      underscore_default.a.each(team.teamManagers, function (tm, key, list) {
        // var birthdate =  moment( tm.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [tm.name, tm.lastName, tm.dni];
        teamManagerDataList.push(values);
      });

      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jspdf_min();
      var docName = team.name + '_' + team.category.label + '_' + moment_default()().format('DD-MM-YYYY') + '.pdf';
      var docTitle = "Datos del equipo";

      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function () {
        // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 155, 12, 40, 20);

      // Team data
      //  Labels
      doc.text("Nombre:", 14, 35);
      doc.text("Categoría:", 14, 40);
      doc.text("Club:", 14, 45);

      doc.text(team.name, 40, 35);
      doc.text(team.category.label, 40, 40);
      doc.text(team.club.name, 40, 45);

      // Team information

      // Coaches
      doc.setFontSize(14);
      doc.text("Entrenadores", 14, 60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList, startY: 65, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      var finalYCoach = doc.previousAutoTable.finalY;

      // Team Managers
      doc.setFontSize(14);
      doc.text("Delegados", 14, finalYCoach + 15);
      doc.autoTable({ head: teamManagerHeaderList, body: teamManagerDataList, startY: finalYCoach + 20, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      var finalYTeamManager = doc.previousAutoTable.finalY;

      // Players
      doc.setFontSize(14);
      doc.text("Jugadores", 14, finalYTeamManager + 15);
      doc.autoTable({ head: playerHeaderList, body: playerDataList, startY: finalYTeamManager + 20, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });

      doc.save(docName);
      resolve();
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_service_KEY_TEAMS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          console.log("<-------");

          console.log(childSnapshot.key);

          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.name = childSnapshot.val().name, modelOption.label = childSnapshot.val().name + ' · ' + childSnapshot.val().category.label;
          modelOption.club = childSnapshot.val().club;
          modelOption.category = childSnapshot.val().category;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/club/club-store.js





 // Internationalization









/* eslint-disable */

/* harmony default export */ var club_store = ({
  namespaced: true,

  modules: {
    "historyFull": club_history_full_store,
    "historySingle": club_history_single_store,
    "clubTeamList": club_team_list_store
  },

  state: {
    loading: false,
    list: [],
    pager: club_pager.build(),
    model: club_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.clubEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.clubEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.clubViewer.id, roles.clubEditor.id, roles.clubManager.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.clubEditor.id]);
    },
    isClubManager: function isClubManager(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.clubManager.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || club_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = club_pager.build();
      state.model = club_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return club_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return club_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4, club) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      // eslint-disable-next-line 
      var modelToSave = getters.model;

      if (club !== null) {
        modelToSave = club;
      }

      return club_service.save(modelToSave, rootGetters['auth/user']).then(function (modelSaved) {
        dispatch('shared/success', src_lang.t('entities.club.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
        return promise_default.a.resolve(modelSaved);
      });
    },
    createManagerSendEmail: function createManagerSendEmail(_ref5, data) {
      var commit = _ref5.commit,
          rootGetters = _ref5.rootGetters,
          dispatch = _ref5.dispatch;

      commit('LOADING', true);
      // eslint-disable-next-line
      console.log("<---- CREATE MANAGER AND SEND EMAIL");

      console.log(data);
      console.log(underscore_default.a.isArray(data.teams));
      // Si no hay equipos no se puede enviar la invitacion
      if (!underscore_default.a.isObject(data.teams)) {
        commit('LOADING', false);
        var error = new Error('Debe haber al menos un equipo en el club para enviar la invitación.');
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      } else {
        return user_service.createUserManagerSendEmail(data, rootGetters['auth/user']).then(function (model) {

          dispatch('shared/success', '' + src_lang.t('notification.invitationHasSendSuccessfully'), { root: true });

          commit('MODEL', model);
          commit('LOADING', false);
          return promise_default.a.resolve();
        }).catch(function (error) {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return promise_default.a.reject(error);
        });
      }
    },
    destroy: function destroy(_ref6, club) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          rootGetters = _ref6.rootGetters;

      commit('LOADING', true);

      return club_service.destroy(club, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.club.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch,
          rootGetters = _ref7.rootGetters;

      commit('LIST', []);
      commit('LOADING', true);

      return club_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listClubManager: function listClubManager(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootGetters = _ref8.rootGetters;


      var user = rootGetters['auth/user'];
      var clubs = underscore_default.a.map(user.clubs, function (value, key, list) {
        return value;
      });
      console.log("<--- LIST CLUB MANAGER");
      console.log(clubs);

      commit('LIST', clubs);
      return promise_default.a.resolve();
    },
    clear: function clear(_ref9) {
      var commit = _ref9.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref10) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      team_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'teams', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      manager_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'managers', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/vue-image-crop-upload/utils/language.js
var utils_language = __webpack_require__("74/Y");

// EXTERNAL MODULE: ./node_modules/vue-image-crop-upload/utils/mimes.js
var mimes = __webpack_require__("Bb9R");

// EXTERNAL MODULE: ./node_modules/vue-image-crop-upload/utils/data2blob.js
var data2blob = __webpack_require__("g3c9");

// EXTERNAL MODULE: ./node_modules/vue-image-crop-upload/utils/effectRipple.js
var effectRipple = __webpack_require__("eyka");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./node_modules/vue-image-crop-upload/upload-2.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var upload_2 = ({
	props: {
		// 域，上传文件name，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		field: {
			type: String,
			'default': 'avatar'
		},
		// 原名key，类似于id，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		ki: {
			'default': 0
		},
		// 显示该控件与否
		value: {
			'default': true
		},
		// 上传地址
		url: {
			type: String,
			'default': ''
		},
		// 其他要上传文件附带的数据，对象格式
		params: {
			type: Object,
			'default': null
		},
		//Add custom headers
		headers: {
			type: Object,
			'default': null
		},
		// 剪裁图片的宽
		width: {
			type: Number,
			default: 200
		},
		// 剪裁图片的高
		height: {
			type: Number,
			default: 200
		},
		// 不显示旋转功能
		noRotate: {
			type: Boolean,
			default: true
		},
		// 不预览圆形图片
		noCircle: {
			type: Boolean,
			default: false
		},
		// 不预览方形图片
		noSquare: {
			type: Boolean,
			default: false
		},
		// 单文件大小限制
		maxSize: {
			type: Number,
			'default': 10240
		},
		// 语言类型
		langType: {
			type: String,
			'default': 'zh'
		},
		// 语言包
		langExt: {
			type: Object,
			'default': null
		},
		// 图片上传格式
		imgFormat: {
			type: String,
			'default': 'png'
		},
		// 图片背景 jpg情况下生效
		imgBgc: {
			type: String,
			'default': '#fff'
		},
		// 是否支持跨域
		withCredentials: {
			type: Boolean,
			'default': false
		},
		method: {
			type: String,
			'default': 'POST'
		}
	},
	data: function data() {
		var that = this,
		    imgFormat = that.imgFormat,
		    langType = that.langType,
		    langExt = that.langExt,
		    width = that.width,
		    height = that.height,
		    isSupported = true,
		    allowImgFormat = ['jpg', 'png'],
		    tempImgFormat = allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat,
		    lang = utils_language["a" /* default */][langType] ? utils_language["a" /* default */][langType] : utils_language["a" /* default */]['en'],
		    mime = mimes["a" /* default */][tempImgFormat];
		// 规范图片格式
		that.imgFormat = tempImgFormat;

		if (langExt) {
			assign_default()(lang, langExt);
		}
		if (typeof FormData != 'function') {
			isSupported = false;
		}
		return {
			// 图片的mime
			mime: mime,

			// 语言包
			lang: lang,

			// 浏览器是否支持该控件
			isSupported: isSupported,
			// 浏览器是否支持触屏事件
			isSupportTouch: document.hasOwnProperty("ontouchstart"),

			// 步骤
			step: 1, //1选择文件 2剪裁 3上传

			// 上传状态及进度
			loading: 0, //0未开始 1正在 2成功 3错误
			progress: 0,

			// 是否有错误及错误信息
			hasError: false,
			errorMsg: '',

			// 需求图宽高比
			ratio: width / height,

			// 原图地址、生成图片地址
			sourceImg: null,
			sourceImgUrl: '',
			createImgUrl: '',

			// 原图片拖动事件初始值
			sourceImgMouseDown: {
				on: false,
				mX: 0, //鼠标按下的坐标
				mY: 0,
				x: 0, //scale原图坐标
				y: 0
			},

			// 生成图片预览的容器大小
			previewContainer: {
				width: 100,
				height: 100
			},

			// 原图容器宽高
			sourceImgContainer: { // sic
				width: 240,
				height: 184 // 如果生成图比例与此一致会出现bug，先改成特殊的格式吧，哈哈哈
			},

			// 原图展示属性
			scale: {
				zoomAddOn: false, //按钮缩放事件开启
				zoomSubOn: false, //按钮缩放事件开启
				range: 1, //最大100

				x: 0,
				y: 0,
				width: 0,
				height: 0,
				maxWidth: 0,
				maxHeight: 0,
				minWidth: 0, //最宽
				minHeight: 0,
				naturalWidth: 0, //原宽
				naturalHeight: 0
			}
		};
	},

	computed: {
		// 进度条样式
		progressStyle: function progressStyle() {
			var progress = this.progress;

			return {
				width: progress + '%'
			};
		},

		// 原图样式
		sourceImgStyle: function sourceImgStyle() {
			var scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    top = scale.y + sourceImgMasking.y + 'px',
			    left = scale.x + sourceImgMasking.x + 'px';

			return {
				top: top,
				left: left,
				width: scale.width + 'px',
				height: scale.height + 'px' // 兼容 Opera
			};
		},

		// 原图蒙版属性
		sourceImgMasking: function sourceImgMasking() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sicRatio = sic.width / sic.height,
			    x = 0,
			    y = 0,
			    w = sic.width,
			    h = sic.height,
			    scale = 1;

			if (ratio < sicRatio) {
				scale = sic.height / height;
				w = sic.height * ratio;
				x = (sic.width - w) / 2;
			}
			if (ratio > sicRatio) {
				scale = sic.width / width;
				h = sic.width / ratio;
				y = (sic.height - h) / 2;
			}
			return {
				scale: scale, // 蒙版相对需求宽高的缩放
				x: x,
				y: y,
				width: w,
				height: h
			};
		},

		// 原图遮罩样式
		sourceImgShadeStyle: function sourceImgShadeStyle() {
			var sourceImgMasking = this.sourceImgMasking,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sim = sourceImgMasking,
			    w = sim.width == sic.width ? sim.width : (sic.width - sim.width) / 2,
			    h = sim.height == sic.height ? sim.height : (sic.height - sim.height) / 2;

			return {
				width: w + 'px',
				height: h + 'px'
			};
		},
		previewStyle: function previewStyle() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    previewContainer = this.previewContainer,
			    pc = previewContainer,
			    w = pc.width,
			    h = pc.height,
			    pcRatio = w / h;

			if (ratio < pcRatio) {
				w = pc.height * ratio;
			}
			if (ratio > pcRatio) {
				h = pc.width / ratio;
			}
			return {
				width: w + 'px',
				height: h + 'px'
			};
		}
	},
	watch: {
		value: function value(newValue) {
			if (newValue && this.loading != 1) {
				this.reset();
			}
		}
	},
	methods: {
		// 点击波纹效果
		ripple: function ripple(e) {
			Object(effectRipple["a" /* default */])(e);
		},

		// 关闭控件
		off: function off() {
			var _this = this;

			setTimeout(function () {
				_this.$emit('input', false);
				if (_this.step == 3 && _this.loading == 2) {
					_this.setStep(1);
				}
			}, 200);
		},

		// 设置步骤
		setStep: function setStep(no) {
			var _this2 = this;

			// 延时是为了显示动画效果呢，哈哈哈
			setTimeout(function () {
				_this2.step = no;
			}, 200);
		},


		/* 图片选择区域函数绑定
   ---------------------------------------------------------------*/
		preventDefault: function preventDefault(e) {
			e.preventDefault();
			return false;
		},
		handleClick: function handleClick(e) {
			if (this.loading !== 1) {
				if (e.target !== this.$refs.fileinput) {
					e.preventDefault();
					if (document.activeElement !== this.$refs) {
						this.$refs.fileinput.click();
					}
				}
			}
		},
		handleChange: function handleChange(e) {
			e.preventDefault();
			if (this.loading !== 1) {
				var files = e.target.files || e.dataTransfer.files;
				this.reset();
				if (this.checkFile(files[0])) {
					this.setSourceImg(files[0]);
				}
			}
		},

		/* ---------------------------------------------------------------*/

		// 检测选择的文件是否合适
		checkFile: function checkFile(file) {
			var that = this,
			    lang = that.lang,
			    maxSize = that.maxSize;
			// 仅限图片
			if (file.type.indexOf('image') === -1) {
				that.hasError = true;
				that.errorMsg = lang.error.onlyImg;
				return false;
			}

			// 超出大小
			if (file.size / 1024 > maxSize) {
				that.hasError = true;
				that.errorMsg = lang.error.outOfSize + maxSize + 'kb';
				return false;
			}
			return true;
		},

		// 重置控件
		reset: function reset() {
			var that = this;
			that.loading = 0;
			that.hasError = false;
			that.errorMsg = '';
			that.progress = 0;
		},

		// 设置图片源
		setSourceImg: function setSourceImg(file) {
			this.$emit('src-file-set', file.name, file.type, file.size);
			var that = this,
			    fr = new FileReader();
			fr.onload = function (e) {
				that.sourceImgUrl = fr.result;
				that.startCrop();
			};
			fr.readAsDataURL(file);
		},

		// 剪裁前准备工作
		startCrop: function startCrop() {
			var that = this,
			    width = that.width,
			    height = that.height,
			    ratio = that.ratio,
			    scale = that.scale,
			    sourceImgUrl = that.sourceImgUrl,
			    sourceImgMasking = that.sourceImgMasking,
			    lang = that.lang,
			    sim = sourceImgMasking,
			    img = new Image();

			img.src = sourceImgUrl;
			img.onload = function () {
				var nWidth = img.naturalWidth,
				    nHeight = img.naturalHeight,
				    nRatio = nWidth / nHeight,
				    w = sim.width,
				    h = sim.height,
				    x = 0,
				    y = 0;
				// 图片像素不达标
				if (nWidth < width || nHeight < height) {
					that.hasError = true;
					that.errorMsg = lang.error.lowestPx + width + '*' + height;
					return false;
				}
				if (ratio > nRatio) {
					h = w / nRatio;
					y = (sim.height - h) / 2;
				}
				if (ratio < nRatio) {
					w = h * nRatio;
					x = (sim.width - w) / 2;
				}
				scale.range = 0;
				scale.x = x;
				scale.y = y;
				scale.width = w;
				scale.height = h;
				scale.minWidth = w;
				scale.minHeight = h;
				scale.maxWidth = nWidth * sim.scale;
				scale.maxHeight = nHeight * sim.scale;
				scale.naturalWidth = nWidth;
				scale.naturalHeight = nHeight;
				that.sourceImg = img;
				that.createImg();
				that.setStep(2);
			};
		},

		// 鼠标按下图片准备移动
		imgStartMove: function imgStartMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    simd = sourceImgMouseDown;

			simd.mX = et.screenX;
			simd.mY = et.screenY;
			simd.x = scale.x;
			simd.y = scale.y;
			simd.on = true;
		},

		// 鼠标按下状态下移动，图片移动
		imgMove: function imgMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    _sourceImgMouseDown = this.sourceImgMouseDown,
			    on = _sourceImgMouseDown.on,
			    mX = _sourceImgMouseDown.mX,
			    mY = _sourceImgMouseDown.mY,
			    x = _sourceImgMouseDown.x,
			    y = _sourceImgMouseDown.y,
			    scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    sim = sourceImgMasking,
			    nX = et.screenX,
			    nY = et.screenY,
			    dX = nX - mX,
			    dY = nY - mY,
			    rX = x + dX,
			    rY = y + dY;

			if (!on) return;
			if (rX > 0) {
				rX = 0;
			}
			if (rY > 0) {
				rY = 0;
			}
			if (rX < sim.width - scale.width) {
				rX = sim.width - scale.width;
			}
			if (rY < sim.height - scale.height) {
				rY = sim.height - scale.height;
			}
			scale.x = rX;
			scale.y = rY;
		},

		// 顺时针旋转图片
		rotateImg: function rotateImg(e) {
			var sourceImg = this.sourceImg,
			    _scale = this.scale,
			    naturalWidth = _scale.naturalWidth,
			    naturalHeight = _scale.naturalHeight,
			    width = naturalHeight,
			    height = naturalWidth,
			    canvas = this.$refs.canvas,
			    ctx = canvas.getContext('2d');

			canvas.width = width;
			canvas.height = height;
			ctx.clearRect(0, 0, width, height);

			ctx.fillStyle = 'rgba(0,0,0,0)';
			ctx.fillRect(0, 0, width, height);

			ctx.translate(width, 0);
			ctx.rotate(Math.PI * 90 / 180);

			ctx.drawImage(sourceImg, 0, 0, naturalWidth, naturalHeight);
			var imgUrl = canvas.toDataURL(mimes["a" /* default */]['png']);

			this.sourceImgUrl = imgUrl;
			this.startCrop();
		},


		// 按钮按下开始放大
		startZoomAdd: function startZoomAdd(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomAddOn = true;

			function zoom() {
				if (scale.zoomAddOn) {
					var range = scale.range >= 100 ? 100 : ++scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消放大
		endZoomAdd: function endZoomAdd(e) {
			this.scale.zoomAddOn = false;
		},

		// 按钮按下开始缩小
		startZoomSub: function startZoomSub(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomSubOn = true;

			function zoom() {
				if (scale.zoomSubOn) {
					var range = scale.range <= 0 ? 0 : --scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消缩小
		endZoomSub: function endZoomSub(e) {
			var scale = this.scale;

			scale.zoomSubOn = false;
		},
		zoomChange: function zoomChange(e) {
			this.zoomImg(e.target.value);
		},

		// 缩放原图
		zoomImg: function zoomImg(newRange) {
			var that = this,
			    sourceImgMasking = this.sourceImgMasking,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    maxWidth = scale.maxWidth,
			    maxHeight = scale.maxHeight,
			    minWidth = scale.minWidth,
			    minHeight = scale.minHeight,
			    width = scale.width,
			    height = scale.height,
			    x = scale.x,
			    y = scale.y,
			    range = scale.range,
			    sim = sourceImgMasking,
			    sWidth = sim.width,
			    sHeight = sim.height,
			    nWidth = minWidth + (maxWidth - minWidth) * newRange / 100,
			    nHeight = minHeight + (maxHeight - minHeight) * newRange / 100,
			    nX = sWidth / 2 - nWidth / width * (sWidth / 2 - x),
			    nY = sHeight / 2 - nHeight / height * (sHeight / 2 - y);

			// 判断新坐标是否超过蒙版限制
			if (nX > 0) {
				nX = 0;
			}
			if (nY > 0) {
				nY = 0;
			}
			if (nX < sWidth - nWidth) {
				nX = sWidth - nWidth;
			}
			if (nY < sHeight - nHeight) {
				nY = sHeight - nHeight;
			}

			// 赋值处理
			scale.x = nX;
			scale.y = nY;
			scale.width = nWidth;
			scale.height = nHeight;
			scale.range = newRange;
			setTimeout(function () {
				if (scale.range == newRange) {
					that.createImg();
				}
			}, 300);
		},

		// 生成需求图片
		createImg: function createImg(e) {
			var that = this,
			    imgFormat = that.imgFormat,
			    imgBgc = that.imgBgc,
			    mime = that.mime,
			    sourceImg = that.sourceImg,
			    _that$scale = that.scale,
			    x = _that$scale.x,
			    y = _that$scale.y,
			    width = _that$scale.width,
			    height = _that$scale.height,
			    scale = that.sourceImgMasking.scale,
			    canvas = that.$refs.canvas,
			    ctx = canvas.getContext('2d');

			if (e) {
				// 取消鼠标按下移动状态
				that.sourceImgMouseDown.on = false;
			}
			canvas.width = that.width;
			canvas.height = that.height;
			ctx.clearRect(0, 0, that.width, that.height);

			if (imgFormat == 'png') {
				ctx.fillStyle = 'rgba(0,0,0,0)';
			} else {
				// 如果jpg 为透明区域设置背景，默认白色
				ctx.fillStyle = imgBgc;
			}
			ctx.fillRect(0, 0, that.width, that.height);

			ctx.drawImage(sourceImg, x / scale, y / scale, width / scale, height / scale);
			that.createImgUrl = canvas.toDataURL(mime);
		},
		prepareUpload: function prepareUpload() {
			var url = this.url,
			    createImgUrl = this.createImgUrl,
			    field = this.field,
			    ki = this.ki;

			this.$emit('crop-success', createImgUrl, field, ki);
			if (typeof url == 'string' && url) {
				this.upload();
			} else {
				this.off();
			}
		},

		// 上传图片
		upload: function upload() {
			var that = this,
			    lang = this.lang,
			    imgFormat = this.imgFormat,
			    mime = this.mime,
			    url = this.url,
			    params = this.params,
			    headers = this.headers,
			    field = this.field,
			    ki = this.ki,
			    createImgUrl = this.createImgUrl,
			    withCredentials = this.withCredentials,
			    method = this.method,
			    fmData = new FormData();

			fmData.append(field, Object(data2blob["a" /* default */])(createImgUrl, mime), field + '.' + imgFormat);

			// 添加其他参数
			if ((typeof params === 'undefined' ? 'undefined' : typeof_default()(params)) == 'object' && params) {
				keys_default()(params).forEach(function (k) {
					fmData.append(k, params[k]);
				});
			}

			// 监听进度回调
			var uploadProgress = function uploadProgress(event) {
				if (event.lengthComputable) {
					that.progress = 100 * Math.round(event.loaded) / event.total;
				}
			};

			// 上传文件
			that.reset();
			that.loading = 1;
			that.setStep(3);
			new promise_default.a(function (resolve, reject) {
				var client = new XMLHttpRequest();
				client.open(method, url, true);
				client.withCredentials = withCredentials;
				client.onreadystatechange = function () {
					if (this.readyState !== 4) {
						return;
					}
					if (this.status === 200 || this.status === 201) {
						resolve(JSON.parse(this.responseText));
					} else {
						reject(this.status);
					}
				};
				client.upload.addEventListener("progress", uploadProgress, false); //监听进度
				// 设置header
				if ((typeof headers === 'undefined' ? 'undefined' : typeof_default()(headers)) == 'object' && headers) {
					keys_default()(headers).forEach(function (k) {
						client.setRequestHeader(k, headers[k]);
					});
				}
				client.send(fmData);
			}).then(
			// 上传成功
			function (resData) {
				if (that.value) {
					that.loading = 2;
					that.$emit('crop-upload-success', resData, field, ki);
				}
			},
			// 上传失败
			function (sts) {
				if (that.value) {
					that.loading = 3;
					that.hasError = true;
					that.errorMsg = lang.fail;
					that.$emit('crop-upload-fail', sts, field, ki);
				}
			});
		}
	},
	created: function created() {
		var _this3 = this;

		// 绑定按键esc隐藏此插件事件
		document.addEventListener('keyup', function (e) {
			if (_this3.value && (e.key == 'Escape' || e.keyCode == 27)) {
				_this3.off();
			}
		});
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ef6ccc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/vue-image-crop-upload/upload-2.vue
var upload_2_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.value,
          expression: "value"
        }
      ],
      staticClass: "vue-image-crop-upload"
    },
    [
      _c("div", { staticClass: "vicp-wrap" }, [
        _c("div", { staticClass: "vicp-close", on: { click: _vm.off } }, [
          _c("i", { staticClass: "vicp-icon4" })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.step == 1,
                expression: "step == 1"
              }
            ],
            staticClass: "vicp-step1"
          },
          [
            _c(
              "div",
              {
                staticClass: "vicp-drop-area",
                on: {
                  dragleave: _vm.preventDefault,
                  dragover: _vm.preventDefault,
                  dragenter: _vm.preventDefault,
                  click: _vm.handleClick,
                  drop: _vm.handleChange
                }
              },
              [
                _c(
                  "i",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading != 1,
                        expression: "loading != 1"
                      }
                    ],
                    staticClass: "vicp-icon1"
                  },
                  [
                    _c("i", { staticClass: "vicp-icon1-arrow" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "vicp-icon1-body" }),
                    _vm._v(" "),
                    _c("i", { staticClass: "vicp-icon1-bottom" })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading !== 1,
                        expression: "loading !== 1"
                      }
                    ],
                    staticClass: "vicp-hint"
                  },
                  [_vm._v(_vm._s(_vm.lang.hint))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isSupported,
                        expression: "!isSupported"
                      }
                    ],
                    staticClass: "vicp-no-supported-hint"
                  },
                  [_vm._v(_vm._s(_vm.lang.noSupported))]
                ),
                _vm._v(" "),
                _vm.step == 1
                  ? _c("input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      ref: "fileinput",
                      attrs: { type: "file" },
                      on: { change: _vm.handleChange }
                    })
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasError,
                    expression: "hasError"
                  }
                ],
                staticClass: "vicp-error"
              },
              [
                _c("i", { staticClass: "vicp-icon2" }),
                _vm._v(" " + _vm._s(_vm.errorMsg) + "\r\n\t\t\t")
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "vicp-operate" }, [
              _c("a", { on: { click: _vm.off, mousedown: _vm.ripple } }, [
                _vm._v(_vm._s(_vm.lang.btn.off))
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _vm.step == 2
          ? _c("div", { staticClass: "vicp-step2" }, [
              _c("div", { staticClass: "vicp-crop" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: true,
                        expression: "true"
                      }
                    ],
                    staticClass: "vicp-crop-left"
                  },
                  [
                    _c("div", { staticClass: "vicp-img-container" }, [
                      _c("img", {
                        ref: "img",
                        staticClass: "vicp-img",
                        style: _vm.sourceImgStyle,
                        attrs: { src: _vm.sourceImgUrl, draggable: "false" },
                        on: {
                          drag: _vm.preventDefault,
                          dragstart: _vm.preventDefault,
                          dragend: _vm.preventDefault,
                          dragleave: _vm.preventDefault,
                          dragover: _vm.preventDefault,
                          dragenter: _vm.preventDefault,
                          drop: _vm.preventDefault,
                          touchstart: _vm.imgStartMove,
                          touchmove: _vm.imgMove,
                          touchend: _vm.createImg,
                          touchcancel: _vm.createImg,
                          mousedown: _vm.imgStartMove,
                          mousemove: _vm.imgMove,
                          mouseup: _vm.createImg,
                          mouseout: _vm.createImg
                        }
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "vicp-img-shade vicp-img-shade-1",
                        style: _vm.sourceImgShadeStyle
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "vicp-img-shade vicp-img-shade-2",
                        style: _vm.sourceImgShadeStyle
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vicp-range" }, [
                      _c("input", {
                        attrs: {
                          type: "range",
                          step: "1",
                          min: "0",
                          max: "100"
                        },
                        domProps: { value: _vm.scale.range },
                        on: { mousemove: _vm.zoomChange }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "vicp-icon5",
                        on: {
                          mousedown: _vm.startZoomSub,
                          mouseout: _vm.endZoomSub,
                          mouseup: _vm.endZoomSub
                        }
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "vicp-icon6",
                        on: {
                          mousedown: _vm.startZoomAdd,
                          mouseout: _vm.endZoomAdd,
                          mouseup: _vm.endZoomAdd
                        }
                      })
                    ]),
                    _vm._v(" "),
                    !_vm.noRotate
                      ? _c("div", { staticClass: "vicp-rotate" }, [
                          _c("i", { on: { click: _vm.rotateImg } }, [
                            _vm._v("↻")
                          ])
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: true,
                        expression: "true"
                      }
                    ],
                    staticClass: "vicp-crop-right"
                  },
                  [
                    _c("div", { staticClass: "vicp-preview" }, [
                      !_vm.noSquare
                        ? _c("div", { staticClass: "vicp-preview-item" }, [
                            _c("img", {
                              style: _vm.previewStyle,
                              attrs: { src: _vm.createImgUrl }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(_vm.lang.preview))])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.noCircle
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "vicp-preview-item vicp-preview-item-circle"
                            },
                            [
                              _c("img", {
                                style: _vm.previewStyle,
                                attrs: { src: _vm.createImgUrl }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.lang.preview))])
                            ]
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vicp-operate" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.setStep(1)
                      },
                      mousedown: _vm.ripple
                    }
                  },
                  [_vm._v(_vm._s(_vm.lang.btn.back))]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "vicp-operate-btn",
                    on: { click: _vm.prepareUpload, mousedown: _vm.ripple }
                  },
                  [_vm._v(_vm._s(_vm.lang.btn.save))]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.step == 3
          ? _c("div", { staticClass: "vicp-step3" }, [
              _c("div", { staticClass: "vicp-upload" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading === 1,
                        expression: "loading === 1"
                      }
                    ],
                    staticClass: "vicp-loading"
                  },
                  [_vm._v(_vm._s(_vm.lang.loading))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vicp-progress-wrap" }, [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading === 1,
                        expression: "loading === 1"
                      }
                    ],
                    staticClass: "vicp-progress",
                    style: _vm.progressStyle
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasError,
                        expression: "hasError"
                      }
                    ],
                    staticClass: "vicp-error"
                  },
                  [
                    _c("i", { staticClass: "vicp-icon2" }),
                    _vm._v(" " + _vm._s(_vm.errorMsg) + "\r\n\t\t\t\t")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.loading === 2,
                        expression: "loading === 2"
                      }
                    ],
                    staticClass: "vicp-success"
                  },
                  [
                    _c("i", { staticClass: "vicp-icon3" }),
                    _vm._v(" " + _vm._s(_vm.lang.success) + "\r\n\t\t\t\t")
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vicp-operate" }, [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        _vm.setStep(2)
                      },
                      mousedown: _vm.ripple
                    }
                  },
                  [_vm._v(_vm._s(_vm.lang.btn.back))]
                ),
                _vm._v(" "),
                _c("a", { on: { click: _vm.off, mousedown: _vm.ripple } }, [
                  _vm._v(_vm._s(_vm.lang.btn.close))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("canvas", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false"
            }
          ],
          ref: "canvas",
          attrs: { width: _vm.width, height: _vm.height }
        })
      ])
    ]
  )
}
var upload_2_staticRenderFns = []
upload_2_render._withStripped = true
var upload_2_esExports = { render: upload_2_render, staticRenderFns: upload_2_staticRenderFns }
/* harmony default export */ var vue_image_crop_upload_upload_2 = (upload_2_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ef6ccc6", upload_2_esExports)
  }
}
// CONCATENATED MODULE: ./node_modules/vue-image-crop-upload/upload-2.vue
var upload_2_disposed = false
function upload_2_injectStyle (ssrContext) {
  if (upload_2_disposed) return
  __webpack_require__("hugX")
}
var upload_2_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var upload_2___vue_template_functional__ = false
/* styles */
var upload_2___vue_styles__ = upload_2_injectStyle
/* scopeId */
var upload_2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var upload_2___vue_module_identifier__ = null
var upload_2_Component = upload_2_normalizeComponent(
  upload_2,
  vue_image_crop_upload_upload_2,
  upload_2___vue_template_functional__,
  upload_2___vue_styles__,
  upload_2___vue_scopeId__,
  upload_2___vue_module_identifier__
)
upload_2_Component.options.__file = "node_modules/vue-image-crop-upload/upload-2.vue"
if (upload_2_Component.esModule && Object.keys(upload_2_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ef6ccc6", upload_2_Component.options)
  } else {
    hotAPI.reload("data-v-5ef6ccc6", upload_2_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    upload_2_disposed = true
  })
})()}

/* harmony default export */ var node_modules_vue_image_crop_upload_upload_2 = (upload_2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from "underscore"
/* eslint-disable */
/* harmony default export */ var club_form = ({
    name: "app-club-form",
    components: {
        'my-upload': node_modules_vue_image_crop_upload_upload_2
    },
    props: {
        id: String,
        previous: String
    },

    data: function data() {
        return {
            show: false,

            rules: {
                name: validators.string({
                    label: "Name",
                    required: true
                }),
                emailManager: validators.email({
                    label: "Email Manager",
                    required: true
                })
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/club/loadOptions");
        if (this.id) {
            this.$store.dispatch("entities/club/edit", this.id).catch(function () {
                return _this.$router.push({ name: "clubList" });
            });
        } else {
            this.$store.dispatch("entities/club/new");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/club/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/club/model",
        loading: "entities/club/loading",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        options: "entities/club/options"
    }), {

        editing: function editing(state) {
            return !!state.id;
        }
    }),

    methods: {
        save: function save() {
            var _this2 = this;

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                // this.attachFilesToModel();

                _this2.$store.dispatch("entities/club/save", _this2.model).then(function (model) {
                    console.log("Modle saved");

                    console.log(model);

                    _this2.back();
                });
            });
        },
        back: function back() {
            if (this.previous === "show") {
                this.$router.push({
                    name: "clubShow",
                    params: { id: this.id }
                });
                return;
            }

            this.$router.push({ name: "clubList" });
        },
        attachFilesToModel: function attachFilesToModel() {
            this.model.pictures = this.$refs.pictures.data || [];
        },
        toggleShow: function toggleShow() {
            this.show = !this.show;
        },

        /**
         * crop success
         *
         * [param] imgDataUrl
         * [param] field
         */
        cropSuccess: function cropSuccess(imgDataUrl, field) {
            console.log('-------- crop success --------');
            var data = imgDataUrl.slice(22, imgDataUrl.length);
            var logo = {
                name: "logo.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            };
            this.model.logo = logo;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c959c754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-form.vue
var club_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "clubList" } } },
                    [_vm._v("$t('entities.club.plural')")]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "clubShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.club.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.club.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Email Manager",
                            prop: "emailManager"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                attrs: {
                                  disabled:
                                    _vm.model.statusManager == "verified"
                                },
                                model: {
                                  value: _vm.model.emailManager,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "emailManager", $$v)
                                  },
                                  expression: "model.emailManager"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Escudo" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "club-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.logo.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.logo.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus team-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.cropSuccess },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var club_form_staticRenderFns = []
club_form_render._withStripped = true
var club_form_esExports = { render: club_form_render, staticRenderFns: club_form_staticRenderFns }
/* harmony default export */ var club_club_form = (club_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c959c754", club_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-form.vue
var club_form_disposed = false
function club_form_injectStyle (ssrContext) {
  if (club_form_disposed) return
  __webpack_require__("2jyU")
}
var club_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_form___vue_template_functional__ = false
/* styles */
var club_form___vue_styles__ = club_form_injectStyle
/* scopeId */
var club_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_form___vue_module_identifier__ = null
var club_form_Component = club_form_normalizeComponent(
  club_form,
  club_club_form,
  club_form___vue_template_functional__,
  club_form___vue_styles__,
  club_form___vue_scopeId__,
  club_form___vue_module_identifier__
)
club_form_Component.options.__file = "src/entities/club/club-form.vue"
if (club_form_Component.esModule && Object.keys(club_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c959c754", club_form_Component.options)
  } else {
    hotAPI.reload("data-v-c959c754", club_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_form_disposed = true
  })
})()}

/* harmony default export */ var entities_club_club_form = (club_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ var club_list = ({
    name: "app-club-import",

    data: function data() {
        return {
            statusManagerList: [{ text: "No invitado", value: "unverified" }, { text: "Invitado", value: "invited" }, { text: "Registrado", value: "verified" }]
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/club/loading",
        list: "entities/club/list",
        pager: "entities/club/pager",
        hasRoleToDelete: "entities/club/hasRoleToDelete",
        hasRoleToUpdate: "entities/club/hasRoleToUpdate",
        hasRoleToRead: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/club/hasRoleToReadLogs",
        hasRoleToCreate: "entities/club/hasRoleToCreate",
        isClubManager: "entities/club/isClubManager",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created: function created() {
        if (this.isClubManager) {
            this.$store.dispatch("entities/club/listClubManager");
        } else {
            this.$store.dispatch("entities/club/list");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.name !== "clubImportCsv") {
            this.$store.dispatch("entities/club/clear");
        }
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        if (to.name !== "clubImportCsv") {
            if (this.isClubManager) {
                this.$store.dispatch("entities/club/listClubManager");
            } else {
                this.$store.dispatch("entities/club/list");
            }
        }
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "clubNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "clubShow",
                    params: { id: row.id }
                });
            }
        },
        sendInvitation: function sendInvitation(club) {
            var _this = this;

            this.$store.dispatch("entities/club/createManagerSendEmail", club).then(function () {
                if (_this.isClubManager) {
                    _this.$store.dispatch("entities/club/listClubManager");
                } else {
                    _this.$store.dispatch("entities/club/list");
                }
            });
        },
        show: function show(id) {
            this.$router.push({
                name: "clubShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "clubEdit",
                params: { id: id }
            });
        },
        importCsv: function importCsv() {
            this.$router.push({
                name: "clubImportCsv"
            });
        },
        destroy: function destroy(model) {
            var _this2 = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this2.$store.dispatch("entities/club/destroy", model);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "clubHistoryFull" });
        },
        filterByStatusManager: function filterByStatusManager(value, row) {
            return row.statusManager === value;
        },


        // Aux UI functions
        getSyleStatusManager: function getSyleStatusManager(statusManager) {
            if (statusManager == "unverified") {
                return "danger";
            } else if (statusManager == "invited") {
                return "warning";
            } else if (statusManager == "verified") {
                return "success";
            }
        },
        getLabelStatusManager: function getLabelStatusManager(statusManager) {
            if (statusManager == "unverified") {
                return "No invitado";
            } else if (statusManager == "invited") {
                return "Invitado";
            } else if (statusManager == "verified") {
                return "Registrado";
            }
        },
        getNumTeams: function getNumTeams(teams) {
            return underscore_default.a.size(teams);
        },
        getNumPlayers: function getNumPlayers(teams) {
            var num = 0;

            underscore_default.a.forEach(teams, function (team) {
                num += underscore_default.a.size(team.players);
            });

            return num;
        },
        getNumCoaches: function getNumCoaches(teams) {
            var num = 0;

            underscore_default.a.forEach(teams, function (team) {
                num += underscore_default.a.size(team.coaches);
            });

            return num;
        },
        getNumTeamManagers: function getNumTeamManagers(teams) {
            var num = 0;

            underscore_default.a.forEach(teams, function (team) {
                num += underscore_default.a.size(team.teamManagers);
            });

            return num;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-616779a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-list.vue
var club_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(_vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.$t("entities.club.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.club.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToCreate && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.importCsv()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.import")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "primary",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { attrs: { name: "clubImport" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no clubs yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.club.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _vm.hasRoleToUpdate
            ? _c("el-table-column", {
                attrs: {
                  prop: "emailManager",
                  label: _vm.$t("entities.club.prop.emailManager"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "modified",
                  label: _vm.$t("status.modifiedAt"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.modified))
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "created",
                  label: _vm.$t("status.created"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.created))
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToUpdate
            ? _c("el-table-column", {
                attrs: {
                  prop: "statusManager",
                  label: _vm.$t("entities.club.prop.statusManager"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getSyleStatusManager(
                                scope.row.statusManager
                              ),
                              "disable-transitions": ""
                            }
                          },
                          [_vm._v(_vm._s(scope.row.statusManagerEs))]
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizeTeams",
              label: _vm.$t("entities.team.numberOfTeams"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getNumTeams(scope.row.teams)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.player.numberOfPlayers"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getNumPlayers(scope.row.teams)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.coach.numberOfCoaches"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getNumCoaches(scope.row.teams)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.teamManager.numberOfTeamManager"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm.getNumTeamManagers(scope.row.teams)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToUpdate && scope.row.statusManager != "verified"
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.sendInvitation"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-bell",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.sendInvitation(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToRead
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var club_list_staticRenderFns = []
club_list_render._withStripped = true
var club_list_esExports = { render: club_list_render, staticRenderFns: club_list_staticRenderFns }
/* harmony default export */ var club_club_list = (club_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-616779a0", club_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-list.vue
var club_list_disposed = false
function club_list_injectStyle (ssrContext) {
  if (club_list_disposed) return
  __webpack_require__("R6TZ")
}
var club_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_list___vue_template_functional__ = false
/* styles */
var club_list___vue_styles__ = club_list_injectStyle
/* scopeId */
var club_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_list___vue_module_identifier__ = null
var club_list_Component = club_list_normalizeComponent(
  club_list,
  club_club_list,
  club_list___vue_template_functional__,
  club_list___vue_styles__,
  club_list___vue_scopeId__,
  club_list___vue_module_identifier__
)
club_list_Component.options.__file = "src/entities/club/club-list.vue"
if (club_list_Component.esModule && Object.keys(club_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-616779a0", club_list_Component.options)
  } else {
    hotAPI.reload("data-v-616779a0", club_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_list_disposed = true
  })
})()}

/* harmony default export */ var entities_club_club_list = (club_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-history/club-history-full/club-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var club_history_full = ({
  name: 'app-club-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/club/historyFull/loading',
    list: 'entities/club/historyFull/list',
    last: 'entities/club/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/club/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/club/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/club/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a5f2a12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-history/club-history-full/club-history-full.vue
var club_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "clubList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.club.plural")) + " ")
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.club.plural")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var club_history_full_staticRenderFns = []
club_history_full_render._withStripped = true
var club_history_full_esExports = { render: club_history_full_render, staticRenderFns: club_history_full_staticRenderFns }
/* harmony default export */ var club_history_full_club_history_full = (club_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a5f2a12", club_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-full/club-history-full.vue
var club_history_full_disposed = false
function club_history_full_injectStyle (ssrContext) {
  if (club_history_full_disposed) return
  __webpack_require__("bhRE")
}
var club_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_history_full___vue_template_functional__ = false
/* styles */
var club_history_full___vue_styles__ = club_history_full_injectStyle
/* scopeId */
var club_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_history_full___vue_module_identifier__ = null
var club_history_full_Component = club_history_full_normalizeComponent(
  club_history_full,
  club_history_full_club_history_full,
  club_history_full___vue_template_functional__,
  club_history_full___vue_styles__,
  club_history_full___vue_scopeId__,
  club_history_full___vue_module_identifier__
)
club_history_full_Component.options.__file = "src/entities/club/club-history/club-history-full/club-history-full.vue"
if (club_history_full_Component.esModule && Object.keys(club_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a5f2a12", club_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-1a5f2a12", club_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_history_full_disposed = true
  })
})()}

/* harmony default export */ var club_history_club_history_full_club_history_full = (club_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-history/club-history-single/club-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var club_history_single = ({
  name: 'app-club-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/club/historySingle/loading',
    list: 'entities/club/historySingle/list',
    pager: 'entities/club/historySingle/pager',
    model: 'entities/club/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/club/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/club/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd69d6f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-history/club-history-single/club-history-single.vue
var club_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "clubList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.player.plural")) + " ")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "clubShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.player.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var club_history_single_staticRenderFns = []
club_history_single_render._withStripped = true
var club_history_single_esExports = { render: club_history_single_render, staticRenderFns: club_history_single_staticRenderFns }
/* harmony default export */ var club_history_single_club_history_single = (club_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cd69d6f8", club_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-history/club-history-single/club-history-single.vue
var club_history_single_disposed = false
function club_history_single_injectStyle (ssrContext) {
  if (club_history_single_disposed) return
  __webpack_require__("Ep23")
}
var club_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_history_single___vue_template_functional__ = false
/* styles */
var club_history_single___vue_styles__ = club_history_single_injectStyle
/* scopeId */
var club_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_history_single___vue_module_identifier__ = null
var club_history_single_Component = club_history_single_normalizeComponent(
  club_history_single,
  club_history_single_club_history_single,
  club_history_single___vue_template_functional__,
  club_history_single___vue_styles__,
  club_history_single___vue_scopeId__,
  club_history_single___vue_module_identifier__
)
club_history_single_Component.options.__file = "src/entities/club/club-history/club-history-single/club-history-single.vue"
if (club_history_single_Component.esModule && Object.keys(club_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cd69d6f8", club_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-cd69d6f8", club_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_history_single_disposed = true
  })
})()}

/* harmony default export */ var club_history_club_history_single_club_history_single = (club_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team/team-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable */
/* harmony default export */ var team_list = ({
    name: "app-team-list",

    props: {
        clubId: String
    },

    data: function data() {
        return {
            title: "Equipos",
            labels: {
                name: "Nombre",
                category: "Categoría"
            },
            breadcrumbLabels: {
                home: "Inicio",
                teams: "Equipos",
                edit: "Editar",
                new: "Nuevo"
            },
            emptyText: "There are no teams yet"
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/team/loading",
        list: "entities/team/list",
        pager: "entities/team/pager",
        hasRoleToDelete: "entities/team/hasRoleToDelete",
        hasRoleToUpdate: "entities/team/hasRoleToUpdate",
        hasRoleToRead: "entities/team/hasRoleToRead",
        hasRoleToReadClub: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/team/hasRoleToReadLogs",
        hasRoleToCreate: "entities/team/hasRoleToCreate",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    created: function created() {
        if (this.clubId) {
            this.$store.dispatch("entities/team/listByClubId", this.clubId);
        } else {
            this.$store.dispatch("entities/team/list");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        this.$store.dispatch("entities/team/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/team/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "teamNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "teamShow",
                    params: { id: row.id }
                });
            }
        },
        importPlayers: function importPlayers(team) {
            var _this = this;

            this.$store.dispatch("entities/team/importPlayersSetup", team).then(function (teamSetup) {
                _this.$store.dispatch('entities/player/import/setup', teamSetup);
                _this.$router.push({
                    name: "playerImportCsv"
                });
            });
        },
        exportTeamAsPdf: function exportTeamAsPdf(team) {
            this.$store.dispatch("entities/team/exportAsPDF", team);
        },
        show: function show(id) {
            console.log("*******");
            console.log(id);

            this.$router.push({
                name: "teamShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "teamEdit",
                params: { id: id }
            });
        },
        destroy: function destroy(model) {
            var _this2 = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this2.$store.dispatch("entities/team/destroy", model).then(function () {
                    if (_this2.clubId) {
                        _this2.$store.dispatch("entities/team/listByClubId", _this2.clubId);
                    } else {
                        _this2.$store.dispatch("entities/team/list");
                    }
                });
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "teamHistoryFull" });
        },


        // Auz functions

        getSize: function getSize(obj) {
            return underscore_default.a.size(obj);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63813ed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team/team-list.vue
var team_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRoleToReadLogs
        ? _c(
            "el-breadcrumb",
            {
              staticStyle: { float: "right" },
              attrs: { "separator-class": "el-icon-arrow-right" }
            },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v(_vm._s(_vm.$t("route.home")))
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("route.teams")))])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.team.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { attrs: { name: "playerImport" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": _vm.emptyText,
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.team.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "category",
              label: _vm.$t("entities.team.prop.category"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.category ? scope.row.category.label : "")
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "locality",
                  label: _vm.$t("entities.team.prop.locality"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "country",
                  label: _vm.$t("entities.team.prop.country"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "web",
                  label: _vm.$t("entities.team.prop.web"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.player.numberOfPlayers"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getSize(scope.row.players)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.coach.numberOfCoaches"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getSize(scope.row.coaches)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "sizePlayers",
              label: _vm.$t("entities.teamManager.numberOfTeamManager"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_vm._v(_vm._s(_vm.getSize(scope.row.teamManagers)))]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("entities.team.exportTeamAsPdf"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-download",
                                size: "medium",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.exportTeamAsPdf(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("entities.player.importPlayers"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-upload2",
                                size: "medium",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.importPlayers(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToRead || _vm.hasRoleToReadClub
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var team_list_staticRenderFns = []
team_list_render._withStripped = true
var team_list_esExports = { render: team_list_render, staticRenderFns: team_list_staticRenderFns }
/* harmony default export */ var team_team_list = (team_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63813ed0", team_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team/team-list.vue
var team_list_disposed = false
function team_list_injectStyle (ssrContext) {
  if (team_list_disposed) return
  __webpack_require__("7KqF")
}
var team_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_list___vue_template_functional__ = false
/* styles */
var team_list___vue_styles__ = team_list_injectStyle
/* scopeId */
var team_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_list___vue_module_identifier__ = null
var team_list_Component = team_list_normalizeComponent(
  team_list,
  team_team_list,
  team_list___vue_template_functional__,
  team_list___vue_styles__,
  team_list___vue_scopeId__,
  team_list___vue_module_identifier__
)
team_list_Component.options.__file = "src/entities/team/team-list.vue"
if (team_list_Component.esModule && Object.keys(team_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63813ed0", team_list_Component.options)
  } else {
    hotAPI.reload("data-v-63813ed0", team_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_list_disposed = true
  })
})()}

/* harmony default export */ var entities_team_team_list = (team_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */

/* harmony default export */ var club_show = ({
    name: "app-club-show",

    components: {
        teamList: entities_team_team_list
    },

    props: {
        id: String
    },

    data: function data() {
        return {
            title: "Información del club",
            labels: {
                name: "Nombre club",
                emailManager: "Email de contacto",
                picture: "Escudo"
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/club/detail", this.id).catch(function () {
            return _this.$router.push({ name: "clubList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        /**
         * Si no estamos en detalles de club y no creamos un equipo, reseteamos el estado del club
         */
        if (from.name === "clubShow" && to.name === "teamNew") {
            next();
        } else {
            this.$store.dispatch("entities/club/clear");
            next();
        }
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/team/list");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/club/model",
        loading: "entities/club/loading",
        hasRoleToDelete: "entities/club/hasRoleToDelete",
        hasRoleToUpdate: "entities/club/hasRoleToUpdate",
        hasRoleToRead: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/club/hasRoleToReadLogs",
        hasRoleToCreate: "entities/club/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "clubEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy(model) {
            var _this2 = this;

            //eslint-disable-next-line
            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this2.$store.dispatch("entities/club/destroy", model);
            }).then(function () {
                return _this2.$router.push({ name: "clubList" });
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "clubHistorySingle",
                params: { id: this.id }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae5260f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-show.vue
var club_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(_vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "clubList" } } },
                    [_vm._v(" " + _vm._s(_vm.$t("entities.club.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(" " + _vm._s(_vm.$t("entities.club.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.club.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.club.prop.emailManager")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.emailManager))]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "entities.club.prop.statusManager"
                                    )
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.statusManager))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.club.prop.logo")
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.model.logo.url,
                                  width: "10%",
                                  height: "10%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("status.created") } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("status.modifiedAt") }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy(_vm.model)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.model.manager
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("div", { staticClass: "grid-content bg-purple" }),
                          _vm._v(" "),
                          _c("h3", { staticClass: "page-title" }, [
                            _vm._v(_vm._s(_vm.$t("entities.manager.singular")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              class: {
                                show: true,
                                "show-mobile": _vm.isMobile
                              },
                              attrs: {
                                "label-position": _vm.labelPosition,
                                "label-width": _vm.labelWidth
                              },
                              nativeOn: {
                                submit: function($event) {
                                  $event.preventDefault()
                                }
                              }
                            },
                            [
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-form-item",
                                    { attrs: { label: "Id" } },
                                    [_vm._v(_vm._s(_vm.model.manager.id))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.manager.prop.name")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.manager.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "entities.manager.prop.lastName"
                                    )
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.manager.lastName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.manager.prop.email")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.manager.email))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.manager.prop.phone")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.manager.phone))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("team-list", { attrs: { clubId: _vm.model.id } })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var club_show_staticRenderFns = []
club_show_render._withStripped = true
var club_show_esExports = { render: club_show_render, staticRenderFns: club_show_staticRenderFns }
/* harmony default export */ var club_club_show = (club_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ae5260f", club_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-show.vue
var club_show_disposed = false
function club_show_injectStyle (ssrContext) {
  if (club_show_disposed) return
  __webpack_require__("9nNw")
}
var club_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_show___vue_template_functional__ = false
/* styles */
var club_show___vue_styles__ = club_show_injectStyle
/* scopeId */
var club_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_show___vue_module_identifier__ = null
var club_show_Component = club_show_normalizeComponent(
  club_show,
  club_club_show,
  club_show___vue_template_functional__,
  club_show___vue_styles__,
  club_show___vue_scopeId__,
  club_show___vue_module_identifier__
)
club_show_Component.options.__file = "src/entities/club/club-show.vue"
if (club_show_Component.esModule && Object.keys(club_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ae5260f", club_show_Component.options)
  } else {
    hotAPI.reload("data-v-6ae5260f", club_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_show_disposed = true
  })
})()}

/* harmony default export */ var entities_club_club_show = (club_show_Component.exports);

// EXTERNAL MODULE: ./node_modules/xlsx/xlsx.js
var xlsx = __webpack_require__("uXZL");
var xlsx_default = /*#__PURE__*/__webpack_require__.n(xlsx);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/UploadExcel/index.vue

//
//
//
//
//
//
//
//
//
//


/* eslint-disable */
/* harmony default export */ var UploadExcel = ({
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function // eslint-disable-line
  },
  data: function data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null
      }
    };
  },

  methods: {
    generateData: function generateData(_ref) {
      var header = _ref.header,
          results = _ref.results;

      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },
    handleDrop: function handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      var files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error('Only support uploading one file!');
        return;
      }
      var rawFile = files[0]; // only use files[0]

      if (!this.isExcel(rawFile)) {
        this.$message.error('Only supports upload .xlsx, .xls, .csv suffix files');
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover: function handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
    },
    handleUpload: function handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick: function handleClick(e) {
      var files = e.target.files;
      var rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.upload(rawFile);
    },
    upload: function upload(rawFile) {
      this.$refs['excel-upload-input'].value = null; // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }
      var before = this.beforeUpload(rawFile);
      if (before) {
        this.readerData(rawFile);
      }
    },
    readerData: function readerData(rawFile) {
      var _this = this;

      this.loading = true;
      return new promise_default.a(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (e) {
          var data = e.target.result;
          var workbook = xlsx_default.a.read(data, { type: 'array', cellDates: true });
          var firstSheetName = workbook.SheetNames[0];
          var worksheet = workbook.Sheets[firstSheetName];
          var header = _this.getHeaderRow(worksheet);
          var results = xlsx_default.a.utils.sheet_to_json(worksheet);
          _this.generateData({ header: header, results: results });
          _this.loading = false;
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    getHeaderRow: function getHeaderRow(sheet) {
      var headers = [];
      var range = xlsx_default.a.utils.decode_range(sheet['!ref']);
      var C = void 0;
      var R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        var cell = sheet[xlsx_default.a.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = xlsx_default.a.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel: function isExcel(file) {
      return (/\.(xlsx|xls|csv)$/.test(file.name)
      );
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ff25a2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/UploadExcel/index.vue
var UploadExcel_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      ref: "excel-upload-input",
      staticClass: "excel-upload-input",
      attrs: { type: "file", accept: ".xlsx, .xls, .csv" },
      on: { change: _vm.handleClick }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "drop",
        on: {
          drop: _vm.handleDrop,
          dragover: _vm.handleDragover,
          dragenter: _vm.handleDragover
        }
      },
      [
        _vm._v("\n    Arrastrar fichero excel ó \n    "),
        _c(
          "el-button",
          {
            staticStyle: { "margin-left": "16px" },
            attrs: { loading: _vm.loading, size: "mini", type: "primary" },
            on: { click: _vm.handleUpload }
          },
          [_vm._v("Seleccionar fichero")]
        )
      ],
      1
    )
  ])
}
var UploadExcel_staticRenderFns = []
UploadExcel_render._withStripped = true
var UploadExcel_esExports = { render: UploadExcel_render, staticRenderFns: UploadExcel_staticRenderFns }
/* harmony default export */ var components_UploadExcel = (UploadExcel_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff25a2c", UploadExcel_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/UploadExcel/index.vue
var UploadExcel_disposed = false
function UploadExcel_injectStyle (ssrContext) {
  if (UploadExcel_disposed) return
  __webpack_require__("UWrJ")
}
var UploadExcel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var UploadExcel___vue_template_functional__ = false
/* styles */
var UploadExcel___vue_styles__ = UploadExcel_injectStyle
/* scopeId */
var UploadExcel___vue_scopeId__ = "data-v-3ff25a2c"
/* moduleIdentifier (server only) */
var UploadExcel___vue_module_identifier__ = null
var UploadExcel_Component = UploadExcel_normalizeComponent(
  UploadExcel,
  components_UploadExcel,
  UploadExcel___vue_template_functional__,
  UploadExcel___vue_styles__,
  UploadExcel___vue_scopeId__,
  UploadExcel___vue_module_identifier__
)
UploadExcel_Component.options.__file = "src/components/UploadExcel/index.vue"
if (UploadExcel_Component.esModule && Object.keys(UploadExcel_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ff25a2c", UploadExcel_Component.options)
  } else {
    hotAPI.reload("data-v-3ff25a2c", UploadExcel_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    UploadExcel_disposed = true
  })
})()}

/* harmony default export */ var src_components_UploadExcel = (UploadExcel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/club/club-import-csv.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* eslint-disable */
/* harmony default export */ var club_import_csv = ({
    name: "app-club-list",
    components: { UploadExcelComponent: src_components_UploadExcel },
    data: function data() {
        return {
            dialogTableVisible: true,
            tableData: [],
            tableHeader: ['category', 'clubName', 'team', 'emailManager'],

            file: null,
            parse_header: [],
            parse_csv: [],
            multipleSelection: [],
            sortOrders: {},
            sortKey: ""
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/club/loading"
    })),

    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created: function created() {
        console.log("<--- created import");

        this.dialogTableVisible = true;
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log(to, from);

        next();
    },


    methods: {
        sortBy: function sortBy(key) {
            var vm = this;
            vm.sortKey = key;
            vm.sortOrders[key] = vm.sortOrders[key] * -1;
        },

        csvJSON: function csvJSON(csv) {
            var vm = this;
            var lines = csv.split("\n");
            var result = [];
            var headers = lines[0].split(",");
            vm.parse_header = lines[0].split(",");
            lines[0].split(",").forEach(function (key) {
                vm.sortOrders[key] = 1;
            });
            lines.map(function (line, indexLine) {
                if (indexLine < 1) return; // Jump header line
                var currentline = line.split(",");

                // Data
                var categoryId = "";
                var categoryName = "";
                var clubName = "";
                var managerEmail = "";

                headers.map(function (header, indexHeader) {
                    console.log(header);

                    // categoryId
                    if (header.trim() === "categoryId") {
                        categoryId = currentline[indexHeader].trim();
                    } else if (header.trim() === "\"categoryId\"") {
                        categoryId = currentline[indexHeader].trim().substring(1);
                        categoryId = categoryId.trim().substring(0, categoryId.length - 1);
                    }

                    // categoryName
                    if (header.trim() === "categoryName") {
                        categoryName = currentline[indexHeader].trim();
                    } else if (header.trim() === "\"categoryName\"") {
                        categoryName = currentline[indexHeader].trim().substring(1);
                        categoryName = categoryName.trim().substring(0, categoryName.length - 1);
                    }
                    // clubName
                    if (header.trim() === "clubName") {
                        clubName = currentline[indexHeader].trim();
                    } else if (header.trim() === "\"clubName\"") {
                        clubName = currentline[indexHeader].trim().substring(1);
                        clubName = clubName.trim().substring(0, clubName.length - 1);
                    }

                    // managerEmail
                    if (header.trim() === "managerEmail") {
                        managerEmail = currentline[indexHeader].trim();
                    } else if (header.trim() === "\"managerEmail\"") {
                        managerEmail = currentline[indexHeader].trim().substring(1);
                        managerEmail = managerEmail.trim().substring(0, managerEmail.length - 1);
                    }
                });

                var obj = {
                    categoryId: categoryId,
                    categoryName: categoryName,
                    clubName: clubName,
                    managerEmail: managerEmail
                };
                result.push(obj);
            });
            return result; // JavaScript object
        },
        loadCSV: function loadCSV(e) {
            var vm = this;
            var reader = new FileReader();
            reader.readAsText(e.file);
            // Handle errors load
            reader.onload = function (event) {
                var csv = event.target.result;
                vm.parse_csv = vm.csvJSON(csv);
            };
            reader.onerror = function (evt) {
                if (evt.target.error.name == "NotReadableError") {
                    alert("Canno't read file !");
                }
            };
        },
        toggleSelection: function toggleSelection(rows) {
            var _this = this;

            if (rows) {
                rows.forEach(function (row) {
                    _this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        save: function save() {
            var _this2 = this;

            var indeByClub = underscore_default.a.indexBy(this.multipleSelection, "clubName");
            var groupByClub = underscore_default.a.groupBy(this.multipleSelection, "clubName");

            // Clubs uniques
            underscore_default.a.forEach(indeByClub, function (value, index, array) {
                var clubToSave = {
                    name: value.clubName,
                    emailManager: value.managerEmail.trim(),
                    logo: {
                        name: "",
                        data: "",
                        size: 0
                    }
                };
                console.log("###### club to save");
                console.log(clubToSave);

                // Save club
                _this2.$store.dispatch("entities/club/save", clubToSave).then(function (club) {
                    var teams = groupByClub[index];

                    underscore_default.a.forEach(teams, function (value, index, array) {
                        var teamToSave = {
                            category: {
                                id: value.categoryId,
                                label: value.categoryName
                            },
                            club: {
                                id: club.id,
                                name: club.name
                            },
                            name: value.teamName
                        };
                        _this2.$store.dispatch("entities/team/save", teamToSave).then(function () {});
                        console.log("###### TEAM");
                        console.log(teamToSave);
                    });
                });
            });
            console.log("NUM");

            console.log(underscore_default.a.size(groupByClub));

            //   this.multipleSelection.forEach((it, index, array) => {
            //        this.$store.dispatch("entities/club/save", it).then(() => {
            //         console.log(index);
            //         console.log(it);
            //         if (index == array.length - 1 ) {
            //           this.file = null
            //           this.parse_csv = []
            //           this.multipleSelection = []
            //           this.dialogTableVisible = false
            //           this.$router.go(-1)
            //         }
            //       });
            //   })
        },
        handleClose: function handleClose(done) {
            var _this3 = this;

            this.$confirm("Are you sure to close this dialog?").then(function (_) {
                done();
                _this3.$router.go(-1);
            }).catch(function (_) {});
        },

        // Functions upload excel
        beforeUpload: function beforeUpload(file) {
            var isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess: function handleSuccess(_ref) {
            var results = _ref.results,
                header = _ref.header;

            this.tableData = results;
            this.tableHeader = header;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c8a5ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/club/club-import-csv.vue
var club_import_csv_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ],
          attrs: {
            title: "Import from CSV",
            visible: _vm.dialogTableVisible,
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c("upload-excel-component", {
            attrs: {
              "on-success": _vm.handleSuccess,
              "before-upload": _vm.beforeUpload
            }
          }),
          _vm._v(" "),
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "highlight-current-row": ""
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._v(" "),
                _vm._l(_vm.tableHeader, function(item) {
                  return _c("el-table-column", {
                    key: item,
                    attrs: { prop: item, label: item }
                  })
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      type: "primary",
                      icon: "el-icon-fa-floppy-o"
                    },
                    on: {
                      click: function($event) {
                        _vm.save()
                      }
                    }
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggleSelection()
                      }
                    }
                  },
                  [_vm._v("Clear selection")]
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var club_import_csv_staticRenderFns = []
club_import_csv_render._withStripped = true
var club_import_csv_esExports = { render: club_import_csv_render, staticRenderFns: club_import_csv_staticRenderFns }
/* harmony default export */ var club_club_import_csv = (club_import_csv_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c8a5ef0", club_import_csv_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/club/club-import-csv.vue
var club_import_csv_disposed = false
function club_import_csv_injectStyle (ssrContext) {
  if (club_import_csv_disposed) return
  __webpack_require__("J/Oh")
}
var club_import_csv_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var club_import_csv___vue_template_functional__ = false
/* styles */
var club_import_csv___vue_styles__ = club_import_csv_injectStyle
/* scopeId */
var club_import_csv___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var club_import_csv___vue_module_identifier__ = null
var club_import_csv_Component = club_import_csv_normalizeComponent(
  club_import_csv,
  club_club_import_csv,
  club_import_csv___vue_template_functional__,
  club_import_csv___vue_styles__,
  club_import_csv___vue_scopeId__,
  club_import_csv___vue_module_identifier__
)
club_import_csv_Component.options.__file = "src/entities/club/club-import-csv.vue"
if (club_import_csv_Component.esModule && Object.keys(club_import_csv_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c8a5ef0", club_import_csv_Component.options)
  } else {
    hotAPI.reload("data-v-4c8a5ef0", club_import_csv_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    club_import_csv_disposed = true
  })
})()}

/* harmony default export */ var entities_club_club_import_csv = (club_import_csv_Component.exports);

// CONCATENATED MODULE: ./src/entities/club/club-routes.js








var club_routes_roles = auth_roles.values;

/* harmony default export */ var club_routes = ([{
  name: 'clubList',
  path: 'club',
  component: entities_club_club_list,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.activityViewer.id, club_routes_roles.entityViewer.id, club_routes_roles.entityEditor.id, club_routes_roles.clubViewer.id, club_routes_roles.clubEditor.id, club_routes_roles.clubManager.id]
  },
  children: [{
    name: 'clubImportCsv',
    path: 'importCsv',
    components: {
      clubImport: entities_club_club_import_csv
    }
  }]
}, {
  name: 'clubNew',
  path: 'club/new',
  component: entities_club_club_form,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.entityEditor.id, club_routes_roles.clubEditor.id]
  }
}, {
  name: 'clubEdit',
  path: 'club/:id/edit',
  component: entities_club_club_form,
  props: true,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.entityEditor.id, club_routes_roles.clubEditor.id]
  }
}, {
  name: 'clubHistorySingle',
  path: 'club/:id/history',
  component: club_history_club_history_single_club_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.activityViewer.id]
  }
}, {
  name: 'clubHistoryFull',
  path: 'club/history',
  component: club_history_club_history_full_club_history_full,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.activityViewer.id]
  }
}, {
  name: 'clubShow',
  path: 'club/:id',
  component: entities_club_club_show,
  props: true,
  meta: {
    auth: true,
    roles: [club_routes_roles.owner.id, club_routes_roles.activityViewer.id, club_routes_roles.entityViewer.id, club_routes_roles.entityEditor.id, club_routes_roles.clubViewer.id, club_routes_roles.clubEditor.id, club_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/club/club-module.js



var club_module_components = [];
var club_module_mixins = [];
var filters = [];
var club_module_directives = [];

/* harmony default export */ var club_module = ({
  components: club_module_components,
  mixins: club_module_mixins,
  filters: filters,
  directives: club_module_directives,
  routes: club_routes,
  store: club_store
});
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-full/team-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


var team_history_full_service_SIZE = 10;

/* harmony default export */ var team_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child("teams").orderByChild("modified").endAt(lastmodified - 1).limitToLast(team_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < team_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-full/team-history-full-store.js


/* harmony default export */ var team_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return team_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-single/team-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


/* harmony default export */ var team_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child("teams").orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-single/team-history-single-store.js



/* harmony default export */ var team_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'locality', 'country', 'web']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'locality', 'country', 'web']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return team_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/team/team-store.js





 // Internationalization








// import playerService from '../player/player-service';
/* eslint-disable */
/* harmony default export */ var team_store = ({
  namespaced: true,

  modules: {
    historyFull: team_history_full_store,
    historySingle: team_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: team_pager.build(),
    model: team_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.teamViewer.id, roles.teamEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || team_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = team_pager.build();
      state.model = team_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return team_service.find(id).then(function (model) {

        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters;

      var club = rootGetters['entities/club/model'];

      var model = { club: club };

      commit('MODEL', model);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return team_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4, team) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      var modelToSave = getters.model;

      if (team !== null) {
        modelToSave = team;
      }
      return team_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.team.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref5, model) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      var club = rootGetters['entities/club/model'];
      var modelToDestroy = model;
      if (club.id !== null) {
        modelToDestroy = extends_default()({}, model, { club: club_model.forSimple(club) });
      }

      return team_service.destroy(modelToDestroy, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.team.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return team_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    importPlayersSetup: function importPlayersSetup(_ref7, team) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch,
          rootGetters = _ref7.rootGetters;

      var club = rootGetters['entities/club/model'];
      var modelToSetup = team;

      if (club.id !== null) {
        modelToSetup = extends_default()({}, team, { club: club_model.forSimple(club) });
      }

      return promise_default.a.resolve(modelToSetup);
    },
    exportAsPDF: function exportAsPDF(_ref8, team) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootGetters = _ref8.rootGetters;

      commit('LOADING', true);

      var club = rootGetters['entities/club/model'];
      var modelToExport = team;

      if (club.id !== null) {
        modelToExport = extends_default()({}, team, { club: club_model.forSimple(club) });
      }

      return team_service.exportAsPDF(modelToExport).then(function () {
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByClubId: function listByClubId(_ref9, clubId) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return team_service.listByClubId(clubId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref10) {
      var commit = _ref10.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref11) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      category_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'categories', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      club_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'clubs', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      // playerService.listOptions().then((options) => {
      //   commit('ADD_OPTIONS', { key: 'players', options });
      // }).catch((error) => {
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team/team-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ var team_form = ({
  name: 'app-team-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        }),
        category: validators.hasOne({
          label: 'Category',
          required: true
        }),
        club: validators.hasOne({
          label: 'Club',
          required: true
        }),
        locality: validators.string({
          label: 'Locality',
          required: false
        }),
        players: validators.hasMany({
          label: 'Players',
          required: false
        }),
        country: validators.string({
          label: 'Country',
          required: false
        }),
        web: validators.string({
          label: 'Web',
          required: false
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/team/loadOptions');

    if (this.id) {
      this.$store.dispatch('entities/team/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'teamList' });
      });
    } else {

      this.$store.dispatch('entities/team/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team/clear');
    this.$store.dispatch('entities/club/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    club: 'entities/club/model',
    model: 'entities/team/model',
    loading: 'entities/team/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth",
    options: 'entities/team/options'
  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/team/save', _this2.model).then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8817f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team/team-form.vue
var team_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "teamList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.team.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "teamShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.team.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.team.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Category", prop: "category" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.categories == null,
                                      expression: "options.categories == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.category,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "category", $$v)
                                    },
                                    expression: "model.category"
                                  }
                                },
                                [
                                  _vm.options.categories
                                    ? _vm._l(_vm.options.categories, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Club", prop: "club" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.clubs == null,
                                      expression: "options.clubs == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.club,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "club", $$v)
                                    },
                                    expression: "model.club"
                                  }
                                },
                                [
                                  _vm.options.clubs
                                    ? _vm._l(_vm.options.clubs, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.name,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Locality", prop: "locality" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.locality,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "locality", $$v)
                                  },
                                  expression: "model.locality"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Country", prop: "country" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "country", $$v)
                                  },
                                  expression: "model.country"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Web", prop: "web" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.web,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "web", $$v)
                                  },
                                  expression: "model.web"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var team_form_staticRenderFns = []
team_form_render._withStripped = true
var team_form_esExports = { render: team_form_render, staticRenderFns: team_form_staticRenderFns }
/* harmony default export */ var team_team_form = (team_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f8817f6", team_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team/team-form.vue
var team_form_disposed = false
function team_form_injectStyle (ssrContext) {
  if (team_form_disposed) return
  __webpack_require__("HScZ")
}
var team_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_form___vue_template_functional__ = false
/* styles */
var team_form___vue_styles__ = team_form_injectStyle
/* scopeId */
var team_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_form___vue_module_identifier__ = null
var team_form_Component = team_form_normalizeComponent(
  team_form,
  team_team_form,
  team_form___vue_template_functional__,
  team_form___vue_styles__,
  team_form___vue_scopeId__,
  team_form___vue_module_identifier__
)
team_form_Component.options.__file = "src/entities/team/team-form.vue"
if (team_form_Component.esModule && Object.keys(team_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2f8817f6", team_form_Component.options)
  } else {
    hotAPI.reload("data-v-2f8817f6", team_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_form_disposed = true
  })
})()}

/* harmony default export */ var entities_team_team_form = (team_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team/team-history/team-history-full/team-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var team_history_full = ({
  name: 'app-team-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team/historyFull/loading',
    list: 'entities/team/historyFull/list',
    last: 'entities/team/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/team/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/team/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb42eb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team/team-history/team-history-full/team-history-full.vue
var team_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "teamList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.team.plural")) + " ")
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.player.plural")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "category", label: "Category" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.category ? scope.row.category.label : ""
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "club", label: "Club" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.club ? scope.row.club.name : "") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "locality", label: "Locality" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "country", label: "Country" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "web", label: "Web" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var team_history_full_staticRenderFns = []
team_history_full_render._withStripped = true
var team_history_full_esExports = { render: team_history_full_render, staticRenderFns: team_history_full_staticRenderFns }
/* harmony default export */ var team_history_full_team_history_full = (team_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eb42eb8", team_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-full/team-history-full.vue
var team_history_full_disposed = false
function team_history_full_injectStyle (ssrContext) {
  if (team_history_full_disposed) return
  __webpack_require__("KjYH")
}
var team_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_history_full___vue_template_functional__ = false
/* styles */
var team_history_full___vue_styles__ = team_history_full_injectStyle
/* scopeId */
var team_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_history_full___vue_module_identifier__ = null
var team_history_full_Component = team_history_full_normalizeComponent(
  team_history_full,
  team_history_full_team_history_full,
  team_history_full___vue_template_functional__,
  team_history_full___vue_styles__,
  team_history_full___vue_scopeId__,
  team_history_full___vue_module_identifier__
)
team_history_full_Component.options.__file = "src/entities/team/team-history/team-history-full/team-history-full.vue"
if (team_history_full_Component.esModule && Object.keys(team_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6eb42eb8", team_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-6eb42eb8", team_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_history_full_disposed = true
  })
})()}

/* harmony default export */ var team_history_team_history_full_team_history_full = (team_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team/team-history/team-history-single/team-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var team_history_single = ({
  name: 'app-team-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team/historySingle/loading',
    list: 'entities/team/historySingle/list',
    pager: 'entities/team/historySingle/pager',
    model: 'entities/team/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/team/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eab1d754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team/team-history/team-history-single/team-history-single.vue
var team_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "teamList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.team.plural")))
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "teamShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.team.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "category", label: "Category" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.category ? scope.row.category.label : ""
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.club ? scope.row.club.name : "") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "locality", label: "Locality", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "country", label: "Country", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "web", label: "Web", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var team_history_single_staticRenderFns = []
team_history_single_render._withStripped = true
var team_history_single_esExports = { render: team_history_single_render, staticRenderFns: team_history_single_staticRenderFns }
/* harmony default export */ var team_history_single_team_history_single = (team_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eab1d754", team_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team/team-history/team-history-single/team-history-single.vue
var team_history_single_disposed = false
function team_history_single_injectStyle (ssrContext) {
  if (team_history_single_disposed) return
  __webpack_require__("6ZCx")
}
var team_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_history_single___vue_template_functional__ = false
/* styles */
var team_history_single___vue_styles__ = team_history_single_injectStyle
/* scopeId */
var team_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_history_single___vue_module_identifier__ = null
var team_history_single_Component = team_history_single_normalizeComponent(
  team_history_single,
  team_history_single_team_history_single,
  team_history_single___vue_template_functional__,
  team_history_single___vue_styles__,
  team_history_single___vue_scopeId__,
  team_history_single___vue_module_identifier__
)
team_history_single_Component.options.__file = "src/entities/team/team-history/team-history-single/team-history-single.vue"
if (team_history_single_Component.esModule && Object.keys(team_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-eab1d754", team_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-eab1d754", team_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_history_single_disposed = true
  })
})()}

/* harmony default export */ var team_history_team_history_single_team_history_single = (team_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // birthdate
 // birthdate

/* eslint-disable */

/* harmony default export */ var player_list = ({
    name: "app-player-list",
    components: { UploadExcelComponent: src_components_UploadExcel },

    props: {
        teamId: String
    },
    data: function data() {
        return {
            tableData: [],
            tableHeader: []
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/player/loading",
        list: "entities/player/list",
        pager: "entities/player/pager",
        hasRoleToCreate: "entities/player/hasRoleToCreate",
        hasRoleToRead: "entities/player/hasRoleToRead",
        hasRoleToUpdate: "entities/player/hasRoleToUpdate",
        hasRoleToDelete: "entities/player/hasRoleToDelete",
        hasRoleToReadClub: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/player/hasRoleToReadLogs",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    created: function created() {
        if (this.teamId) {
            this.$store.dispatch("entities/player/listByTeamId", this.teamId);
        } else {
            this.$store.dispatch("entities/player/list");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/player/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "playerNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "playerShow",
                    params: { id: row.id }
                });
            }
        },
        show: function show(id) {
            this.$router.push({
                name: "playerShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "playerEdit",
                params: { id: id }
            });
        },
        destroy: function destroy(model) {
            var _this = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this.$store.dispatch("entities/player/destroy", model);
            }).then(function () {
                if (_this.teamId) {
                    _this.$store.dispatch("entities/player/listByTeamId", _this.teamId);
                } else {
                    _this.$store.dispatch("entities/player/list");
                }
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "playerHistoryFull" });
        },


        // Functions upload excel
        beforeUpload: function beforeUpload(file) {
            var isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess: function handleSuccess(_ref) {
            var results = _ref.results,
                header = _ref.header;

            this.tableData = results;
            this.tableHeader = header;
        },

        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment_default()(dateString, ["YYYY-MM-DD"]).locale(js_cookie_default.a.get("language") || "es").format("L");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ef7c60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-list.vue
var player_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRoleToReadLogs
        ? _c(
            "el-breadcrumb",
            {
              staticStyle: { float: "right" },
              attrs: { "separator-class": "el-icon-arrow-right" }
            },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v(_vm._s(_vm.$t("route.home")))
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [
                _vm._v(_vm._s(_vm.$t("entities.player.plural")))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.player.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "id",
              order: "ascending"
            },
            "empty-text": "There are no players yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.player.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lastName",
              label: _vm.$t("entities.player.prop.lastName"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "dni",
              label: _vm.$t("entities.player.prop.dni"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "birthdate",
              label: _vm.$t("entities.player.prop.birthdate"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm.getDateFormat(scope.row.birthdate)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  prop: "team",
                  label: _vm.$t("entities.team.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(scope.row.team ? scope.row.team.name : " ") +
                            "\n                "
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  rop: "category",
                  label: _vm.$t("entities.category.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.team ? scope.row.team.category.label : " "
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "dorsal",
                  label: _vm.$t("entities.player.prop.dorsal"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "position",
                  label: _vm.$t("entities.player.prop.position")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.position ? scope.row.position.label : ""
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead || _vm.hasRoleToReadClub
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var player_list_staticRenderFns = []
player_list_render._withStripped = true
var player_list_esExports = { render: player_list_render, staticRenderFns: player_list_staticRenderFns }
/* harmony default export */ var player_player_list = (player_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9ef7c60", player_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-list.vue
var player_list_disposed = false
function player_list_injectStyle (ssrContext) {
  if (player_list_disposed) return
  __webpack_require__("ZQtL")
}
var player_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_list___vue_template_functional__ = false
/* styles */
var player_list___vue_styles__ = player_list_injectStyle
/* scopeId */
var player_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_list___vue_module_identifier__ = null
var player_list_Component = player_list_normalizeComponent(
  player_list,
  player_player_list,
  player_list___vue_template_functional__,
  player_list___vue_styles__,
  player_list___vue_scopeId__,
  player_list___vue_module_identifier__
)
player_list_Component.options.__file = "src/entities/player/player-list.vue"
if (player_list_Component.esModule && Object.keys(player_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c9ef7c60", player_list_Component.options)
  } else {
    hotAPI.reload("data-v-c9ef7c60", player_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_list_disposed = true
  })
})()}

/* harmony default export */ var entities_player_player_list = (player_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/coach/coach-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // birthdate
 // birthdate

/* eslint-disable */

/* harmony default export */ var coach_list = ({
    name: "app-coach-list",
    components: { UploadExcelComponent: src_components_UploadExcel },

    props: {
        teamId: String
    },
    data: function data() {
        return {
            tableData: [],
            tableHeader: []
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/coach/loading",
        list: "entities/coach/list",
        pager: "entities/coach/pager",
        hasRoleToCreate: "entities/coach/hasRoleToCreate",
        hasRoleToRead: "entities/coach/hasRoleToRead",
        hasRoleToUpdate: "entities/coach/hasRoleToUpdate",
        hasRoleToDelete: "entities/coach/hasRoleToDelete",
        hasRoleToReadClub: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/coach/hasRoleToReadLogs",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    created: function created() {
        if (this.teamId) {
            this.$store.dispatch("entities/coach/listByTeam");
        } else {
            this.$store.dispatch("entities/coach/list");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/coach/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/coach/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "coachNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "coachShow",
                    params: { id: row.id }
                });
            }
        },
        show: function show(id) {
            this.$router.push({
                name: "coachShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "coachEdit",
                params: { id: id }
            });
        },
        destroy: function destroy(model) {
            var _this = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this.$store.dispatch("entities/coach/destroy", model);
            }).then(function () {
                if (_this.teamId) {
                    _this.$store.dispatch("entities/coach/listByTeamId", _this.teamId);
                } else {
                    _this.$store.dispatch("entities/coach/list");
                }
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "coachHistoryFull" });
        },
        exportAsPdf: function exportAsPdf() {
            this.$store.dispatch("entities/coach/exportAsPDF");
        },

        // Functions upload excel
        beforeUpload: function beforeUpload(file) {
            var isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess: function handleSuccess(_ref) {
            var results = _ref.results,
                header = _ref.header;

            this.tableData = results;
            this.tableHeader = header;
        },


        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment_default()(dateString, ["YYYY-MM-DD"]).locale(js_cookie_default.a.get("language") || "es").format("L");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2467e07a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-list.vue
var coach_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.coach.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToCreate && !_vm.teamId
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-download", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportAsPdf()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.exportAsPdf")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "id",
              order: "ascending"
            },
            "empty-text": "There are no coaches yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.coach.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lastName",
              label: _vm.$t("entities.coach.prop.lastName"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _vm.hasRoleToCreate
            ? _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: _vm.$t("entities.coach.prop.email"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: _vm.$t("entities.coach.prop.phone"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "dni",
                  label: _vm.$t("entities.coach.prop.dni"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "birthdate",
                  label: _vm.$t("entities.coach.prop.birthdate"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.getDateFormat(scope.row.birthdate)))
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  prop: "team",
                  label: _vm.$t("entities.team.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.team ? scope.row.team.name : " ")
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  rop: "category",
                  label: _vm.$t("entities.category.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.team ? scope.row.team.category.label : " "
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead || _vm.hasRoleToReadClub
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var coach_list_staticRenderFns = []
coach_list_render._withStripped = true
var coach_list_esExports = { render: coach_list_render, staticRenderFns: coach_list_staticRenderFns }
/* harmony default export */ var coach_coach_list = (coach_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2467e07a", coach_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/coach/coach-list.vue
var coach_list_disposed = false
function coach_list_injectStyle (ssrContext) {
  if (coach_list_disposed) return
  __webpack_require__("9GeN")
}
var coach_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var coach_list___vue_template_functional__ = false
/* styles */
var coach_list___vue_styles__ = coach_list_injectStyle
/* scopeId */
var coach_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var coach_list___vue_module_identifier__ = null
var coach_list_Component = coach_list_normalizeComponent(
  coach_list,
  coach_coach_list,
  coach_list___vue_template_functional__,
  coach_list___vue_styles__,
  coach_list___vue_scopeId__,
  coach_list___vue_module_identifier__
)
coach_list_Component.options.__file = "src/entities/coach/coach-list.vue"
if (coach_list_Component.esModule && Object.keys(coach_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2467e07a", coach_list_Component.options)
  } else {
    hotAPI.reload("data-v-2467e07a", coach_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    coach_list_disposed = true
  })
})()}

/* harmony default export */ var entities_coach_coach_list = (coach_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team-manager/team-manager-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // birthdate
 // birthdate

/* eslint-disable */

/* harmony default export */ var team_manager_list = ({
    name: "app-team-manager-list",
    components: { UploadExcelComponent: src_components_UploadExcel },

    props: {
        teamId: String
    },
    data: function data() {
        return {
            tableData: [],
            tableHeader: []
        };
    },

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/team-manager/loading",
        list: "entities/team-manager/list",
        pager: "entities/team-manager/pager",
        hasRoleToCreate: "entities/team-manager/hasRoleToCreate",
        hasRoleToRead: "entities/team-manager/hasRoleToRead",
        hasRoleToUpdate: "entities/team-manager/hasRoleToUpdate",
        hasRoleToDelete: "entities/team-manager/hasRoleToDelete",
        hasRoleToReadClub: "entities/club/hasRoleToRead",
        hasRoleToReadLogs: "entities/team-manager/hasRoleToReadLogs",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    created: function created() {
        if (this.teamId) {
            this.$store.dispatch("entities/team-manager/listByTeamId", this.teamId);
        } else {
            this.$store.dispatch("entities/team-manager/list");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/team-manager/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/team-manager/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "teamManagerNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "teamManagerShow",
                    params: { id: row.id }
                });
            }
        },
        show: function show(id) {
            this.$router.push({
                name: "teamManagerShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "teamManagerEdit",
                params: { id: id }
            });
        },
        destroy: function destroy(model) {
            var _this = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this.$store.dispatch("entities/team-manager/destroy", model);
            }).then(function () {
                if (_this.teamId) {
                    _this.$store.dispatch("entities/team-manager/listByTeamId", _this.teamId);
                } else {
                    _this.$store.dispatch("entities/team-manager/list");
                }
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "teamManagerHistoryFull" });
        },
        exportAsPdf: function exportAsPdf() {
            this.$store.dispatch("entities/team-manager/exportAsPDF");
        },

        // Functions upload excel
        beforeUpload: function beforeUpload(file) {
            var isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess: function handleSuccess(_ref) {
            var results = _ref.results,
                header = _ref.header;

            this.tableData = results;
            this.tableHeader = header;
        },

        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment_default()(dateString, ["YYYY-MM-DD"]).locale(js_cookie_default.a.get("language") || "es").format("L");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a624cd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team-manager/team-manager-list.vue
var team_manager_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.teamManager.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToCreate && !_vm.teamId
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-download", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.exportAsPdf()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.exportAsPdf")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "id",
              order: "ascending"
            },
            "empty-text": "There are no teamManageres yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.teamManager.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "lastName",
              label: _vm.$t("entities.teamManager.prop.lastName"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _vm.hasRoleToCreate
            ? _c("el-table-column", {
                attrs: {
                  prop: "email",
                  label: _vm.$t("entities.teamManager.prop.email"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: _vm.$t("entities.coach.prop.phone"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "dni",
                  label: _vm.$t("entities.teamManager.prop.dni"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "birthdate",
                  label: _vm.$t("entities.teamManager.prop.birthdate"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.getDateFormat(scope.row.birthdate)))
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  prop: "team",
                  label: _vm.$t("entities.team.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(scope.row.team ? scope.row.team.name : " ")
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.teamId
            ? _c("el-table-column", {
                attrs: {
                  prop: "category",
                  label: _vm.$t("entities.category.singular"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            scope.row.team ? scope.row.team.category.label : " "
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead || _vm.hasRoleToReadClub
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var team_manager_list_staticRenderFns = []
team_manager_list_render._withStripped = true
var team_manager_list_esExports = { render: team_manager_list_render, staticRenderFns: team_manager_list_staticRenderFns }
/* harmony default export */ var team_manager_team_manager_list = (team_manager_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a624cd0", team_manager_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-list.vue
var team_manager_list_disposed = false
function team_manager_list_injectStyle (ssrContext) {
  if (team_manager_list_disposed) return
  __webpack_require__("GE6W")
}
var team_manager_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_manager_list___vue_template_functional__ = false
/* styles */
var team_manager_list___vue_styles__ = team_manager_list_injectStyle
/* scopeId */
var team_manager_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_manager_list___vue_module_identifier__ = null
var team_manager_list_Component = team_manager_list_normalizeComponent(
  team_manager_list,
  team_manager_team_manager_list,
  team_manager_list___vue_template_functional__,
  team_manager_list___vue_styles__,
  team_manager_list___vue_scopeId__,
  team_manager_list___vue_module_identifier__
)
team_manager_list_Component.options.__file = "src/entities/team-manager/team-manager-list.vue"
if (team_manager_list_Component.esModule && Object.keys(team_manager_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a624cd0", team_manager_list_Component.options)
  } else {
    hotAPI.reload("data-v-6a624cd0", team_manager_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_manager_list_disposed = true
  })
})()}

/* harmony default export */ var entities_team_manager_team_manager_list = (team_manager_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team/team-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var team_show = ({
    name: "app-team-show",

    components: {
        playerList: entities_player_player_list,
        coachList: entities_coach_coach_list,
        teamManagerList: entities_team_manager_team_manager_list
    },

    props: {
        id: String
    },

    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/team/detail", this.id).catch(function () {
            return _this.$router.push({ name: "teamList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        /**
         * Si no estamos en detalles de equipo y no creamos un equipo, reseteamos el estado del equipo
         */
        if (from.name === "teamShow" && (to.name === "playerNew" || to.name === "coachNew" || to.name === "teamManagerNew")) {
            // En otras palabras, si vamos a crear un jugador, coach o delegado desde el detalle de un equipo, entonces no borramos el estado del equipo (ya que lo necesitaremos)
            next();
        } else {
            this.$store.dispatch("entities/team/clear");
            next();
        }
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/team/model",
        loading: "entities/team/loading",
        hasRoleToDelete: "entities/team/hasRoleToDelete",
        hasRoleToUpdate: "entities/team/hasRoleToUpdate",
        hasRoleToRead: "entities/team/hasRoleToRead",
        hasRoleToReadLogs: "entities/team/hasRoleToReadLogs",
        hasRoleToCreate: "entities/team/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "teamEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this2 = this;

            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            }).then(function () {
                return _this2.$store.dispatch("entities/team/destroy", _this2.model);
            }).then(function () {
                return _this2.$router.go(-1);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "teamHistorySingle",
                params: { id: this.id }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01cbbca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team/team-show.vue
var team_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "teamList" } } },
                        [_vm._v("{$t('entities.team.plural')}}")]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.team.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.category")
                              }
                            },
                            [
                              _c("app-entity-link", {
                                attrs: {
                                  entityName: "category",
                                  property: _vm.model.category
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("entities.club.singular") }
                            },
                            [_vm._v(_vm._s(_vm.model.club.name))]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.team.prop.locality")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.locality))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.team.prop.country")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.country))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("entities.team.prop.web")
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.web))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("status.created") } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("status.modifiedAt") }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [_c("coach-list", { attrs: { teamId: _vm.model.id } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("team-manager-list", {
                        attrs: { teamId: _vm.model.id }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("player-list", { attrs: { teamId: _vm.model.id } })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var team_show_staticRenderFns = []
team_show_render._withStripped = true
var team_show_esExports = { render: team_show_render, staticRenderFns: team_show_staticRenderFns }
/* harmony default export */ var team_team_show = (team_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01cbbca2", team_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team/team-show.vue
var team_show_disposed = false
function team_show_injectStyle (ssrContext) {
  if (team_show_disposed) return
  __webpack_require__("0uoj")
}
var team_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_show___vue_template_functional__ = false
/* styles */
var team_show___vue_styles__ = team_show_injectStyle
/* scopeId */
var team_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_show___vue_module_identifier__ = null
var team_show_Component = team_show_normalizeComponent(
  team_show,
  team_team_show,
  team_show___vue_template_functional__,
  team_show___vue_styles__,
  team_show___vue_scopeId__,
  team_show___vue_module_identifier__
)
team_show_Component.options.__file = "src/entities/team/team-show.vue"
if (team_show_Component.esModule && Object.keys(team_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-01cbbca2", team_show_Component.options)
  } else {
    hotAPI.reload("data-v-01cbbca2", team_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_show_disposed = true
  })
})()}

/* harmony default export */ var entities_team_team_show = (team_show_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-import/player-import.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // birthdate

/* eslint-disable */
 // birthdate

/* harmony default export */ var player_import = ({
    name: "app-club-list",
    components: { UploadExcelComponent: src_components_UploadExcel },

    data: function data() {
        return {
            dialogTableVisible: true,
            tableData: [],
            tableHeader: [],
            playersSelected: []
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/player/import/loading",
        list: "entities/player/import/list",
        team: "entities/player/import/team",
        isMobile: "shared/isMobile"
    })),

    // created() {
    //     this.$store.dispatch(
    //     'entities/club/historyFull/setup'
    //     );
    // },

    // beforeRouteLeave(to, from, next) {
    //     this.$store.dispatch(
    //     'entities/club/historyFull/clear',
    //     );
    //     next();
    // },

    created: function created() {
        this.dialogTableVisible = true;
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/import/clear");
        next();
    },

    methods: {
        toggleSelection: function toggleSelection(rows) {
            var _this = this;

            if (rows) {
                rows.forEach(function (row) {
                    _this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.playersSelected = val;
        },
        save: function save() {
            var _this2 = this;

            // players
            var playerLsit = [];

            underscore_default.a.forEach(this.playersSelected, function (value, index, array) {
                var playerToSave = {
                    namePublic: value.namePublic,
                    name: value.name,
                    lastName: value.lastName,
                    dni: value.dni,
                    birthdate: moment_default()(value.birthdate).format("YYYY-MM-DD"),
                    dorsal: value.dorsal,
                    email: value.email,
                    team: _this2.team,
                    picture: {
                        name: "",
                        size: 0
                    }
                };

                playerLsit.push(playerToSave);
            });
            console.log("<---- SAVE ");

            console.log(playerLsit);

            this.$store.dispatch("entities/player/import/createAllPlayers", playerLsit).then(function () {
                _this2.$router.go(-1);
            });
        },
        handleClose: function handleClose(done) {
            var _this3 = this;

            this.$confirm(this.$t("confirm.areYouSureCloseDialog"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function (_) {
                done();
                _this3.$router.go(-1);
            }).catch(function (_) {});
        },

        // Functions upload excel
        beforeUpload: function beforeUpload(file) {
            var isLt1M = file.size / 1024 / 1024 < 1;

            if (isLt1M) {
                return true;
            }

            this.$message({
                message: "Please do not upload files larger than 1m in size.",
                type: "warning"
            });
            return false;
        },
        handleSuccess: function handleSuccess(_ref) {
            var _this4 = this;

            var results = _ref.results,
                header = _ref.header;

            this.tableData = [];
            results.forEach(function (value) {
                var model = {
                    namePublic: value.namePublic ? value.namePublic : "",
                    name: value.name ? value.name : "",
                    lastName: value.lastName ? value.lastName : "",
                    dni: value.dni ? value.dni : "",
                    birthdate: value.birthdate ? moment_default()(value.birthdate).format("YYYY-MM-DD") : "",
                    dorsal: value.dorsal ? value.dorsal : "",
                    email: value.email ? value.email : ""
                };

                var name = "";
                var lastName = "";
                var namePublic = "";
                var stringList;
                var nameLastName = value.nameLastName ? value.nameLastName : "";

                stringList = nameLastName.split(",");
                console.log("VALUE");
                console.log(stringList.length);

                if (stringList.length >= 1) {
                    if (stringList.length == 1) {
                        model.name = nameLastName;
                    } else {
                        model.name = stringList[0];
                        model.lastName = stringList[1];
                    }
                    model.namePublic = model.name;
                }

                _this4.tableData.push(model);
            });
            this.tableHeader = header;
        },
        getDateFormat: function getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment_default()(dateString, ["YYYY-MM-DD"]).locale(js_cookie_default.a.get("language") || "es").format("L");
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ccd7d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-import/player-import.vue
var player_import_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ],
          attrs: {
            title: _vm.$t("entities.player.importPlayers"),
            visible: _vm.dialogTableVisible,
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("div", { staticClass: "grid-content bg-purple" }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "page-title" }, [
                    _vm._v(_vm._s(_vm.$t("entities.team.singular")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form",
                    {
                      class: { show: true, "show-mobile": _vm.isMobile },
                      nativeOn: {
                        submit: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("entities.team.prop.name") } },
                        [_vm._v(_vm._s(_vm.team.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.team.prop.category")
                          }
                        },
                        [_vm._v(_vm._s(_vm.team.category.label))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("upload-excel-component", {
                    attrs: {
                      "on-success": _vm.handleSuccess,
                      "before-upload": _vm.beforeUpload
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%", "margin-top": "20px" },
                attrs: {
                  data: _vm.tableData,
                  border: "",
                  "highlight-current-row": ""
                },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "name",
                    label: _vm.$t("entities.player.prop.name"),
                    sortable: "custom"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "lastName",
                    label: _vm.$t("entities.player.prop.lastName"),
                    sortable: "custom"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "dni",
                    label: _vm.$t("entities.player.prop.dni"),
                    sortable: "custom"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "birthdate",
                    label: _vm.$t("entities.player.prop.birthdate"),
                    sortable: "custom"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm._v(_vm._s(_vm.getDateFormat(scope.row.birthdate)))
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "dorsal",
                    label: _vm.$t("entities.player.prop.dorsal"),
                    sortable: "custom"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading || _vm.playersSelected.length === 0,
                      type: "primary",
                      icon: "el-icon-fa-floppy-o"
                    },
                    on: {
                      click: function($event) {
                        _vm.save()
                      }
                    }
                  },
                  [_vm._v("Guardar")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggleSelection()
                      }
                    }
                  },
                  [_vm._v("Clear selection")]
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var player_import_staticRenderFns = []
player_import_render._withStripped = true
var player_import_esExports = { render: player_import_render, staticRenderFns: player_import_staticRenderFns }
/* harmony default export */ var player_import_player_import = (player_import_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64ccd7d9", player_import_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-import/player-import.vue
var player_import_disposed = false
function player_import_injectStyle (ssrContext) {
  if (player_import_disposed) return
  __webpack_require__("DFbB")
}
var player_import_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_import___vue_template_functional__ = false
/* styles */
var player_import___vue_styles__ = player_import_injectStyle
/* scopeId */
var player_import___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_import___vue_module_identifier__ = null
var player_import_Component = player_import_normalizeComponent(
  player_import,
  player_import_player_import,
  player_import___vue_template_functional__,
  player_import___vue_styles__,
  player_import___vue_scopeId__,
  player_import___vue_module_identifier__
)
player_import_Component.options.__file = "src/entities/player/player-import/player-import.vue"
if (player_import_Component.esModule && Object.keys(player_import_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-64ccd7d9", player_import_Component.options)
  } else {
    hotAPI.reload("data-v-64ccd7d9", player_import_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_import_disposed = true
  })
})()}

/* harmony default export */ var player_player_import_player_import = (player_import_Component.exports);

// CONCATENATED MODULE: ./src/entities/team/team-routes.js








var team_routes_roles = auth_roles.values;

/* harmony default export */ var team_routes = ([{
  name: 'teamList',
  path: 'team',
  component: entities_team_team_list,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.activityViewer.id, team_routes_roles.entityViewer.id, team_routes_roles.entityEditor.id, team_routes_roles.teamViewer.id, team_routes_roles.teamEditor.id]
  },
  children: [{
    name: 'playerImportCsv',
    path: 'team/importCsv',
    components: {
      playerImport: player_player_import_player_import
    }
  }]
}, {
  name: 'teamNew',
  path: 'team/new',
  component: entities_team_team_form,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.entityEditor.id, team_routes_roles.teamEditor.id, team_routes_roles.clubManager.id]
  }
}, {
  name: 'teamEdit',
  path: 'team/:id/edit',
  component: entities_team_team_form,
  props: true,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.entityEditor.id, team_routes_roles.teamEditor.id]
  }
}, {
  name: 'teamHistorySingle',
  path: 'team/:id/history',
  component: team_history_team_history_single_team_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.activityViewer.id]
  }
}, {
  name: 'teamHistoryFull',
  path: 'team/history',
  component: team_history_team_history_full_team_history_full,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.activityViewer.id]
  }
}, {
  name: 'teamShow',
  path: 'team/:id',
  component: entities_team_team_show,
  props: true,
  meta: {
    auth: true,
    roles: [team_routes_roles.owner.id, team_routes_roles.activityViewer.id, team_routes_roles.entityViewer.id, team_routes_roles.entityEditor.id, team_routes_roles.teamViewer.id, team_routes_roles.teamEditor.id, team_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/team/team-module.js



var team_module_components = [];
var team_module_mixins = [];
var team_module_filters = [];
var team_module_directives = [];

/* harmony default export */ var team_module = ({
  components: team_module_components,
  mixins: team_module_mixins,
  filters: team_module_filters,
  directives: team_module_directives,
  routes: team_routes,
  store: team_store
});
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-full/category-history-full-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
/* harmony default export */ var category_history_full_service = ({
  fetch: function fetch(lastmodified) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/categories/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-full/category-history-full-store.js


/* harmony default export */ var category_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : null;

      return category_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-single/category-history-single-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
/* harmony default export */ var category_history_single_service = ({
  list: function list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/categories/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-single/category-history-single-store.js



/* harmony default export */ var category_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return category_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-pager.js


/* harmony default export */ var category_pager = ({
  build: function build() {
    var keysToSearch = ['name'];

    var exportDefinitions = [{ value: 'id', label: 'id' }, { value: 'name', label: 'name'
      // { value: 'created', label: 'Created at' },
      // { value: 'modified', label: 'Updated at' }
    }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/category/category-store.js


 // Internationalization





/* eslint-disable */
/* harmony default export */ var category_store = ({
  namespaced: true,

  modules: {
    historyFull: category_history_full_store,
    historySingle: category_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: category_pager.build(),
    model: category_model.default()
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.categoryEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.categoryEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.categoryViewer.id, roles.categoryEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.categoryEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || category_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = category_pager.build();
      state.model = category_model.default();
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return category_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return category_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    save: function save(_ref4, model) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      var modelToSave = getters.model;

      if (model !== null) {
        modelToSave = model;
      }

      return category_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.category.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return category_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.category.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return category_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var category_form = ({
  name: 'app-category-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.id) {
      this.$store.dispatch('entities/category/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'categoryList' });
      });
    } else {
      this.$store.dispatch('entities/category/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/category/model',
    loading: 'entities/category/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"

  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/category/save', _this2.model).then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'categoryShow',
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: 'categoryList' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0494c3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-form.vue
var category_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "categoryList" } } },
                    [_vm._v("{{$t('entities.category.plural')}")]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "categoryShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.category.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.category.singular")
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var category_form_staticRenderFns = []
category_form_render._withStripped = true
var category_form_esExports = { render: category_form_render, staticRenderFns: category_form_staticRenderFns }
/* harmony default export */ var category_category_form = (category_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0494c3d6", category_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-form.vue
var category_form_disposed = false
function category_form_injectStyle (ssrContext) {
  if (category_form_disposed) return
  __webpack_require__("3nTM")
}
var category_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_form___vue_template_functional__ = false
/* styles */
var category_form___vue_styles__ = category_form_injectStyle
/* scopeId */
var category_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_form___vue_module_identifier__ = null
var category_form_Component = category_form_normalizeComponent(
  category_form,
  category_category_form,
  category_form___vue_template_functional__,
  category_form___vue_styles__,
  category_form___vue_scopeId__,
  category_form___vue_module_identifier__
)
category_form_Component.options.__file = "src/entities/category/category-form.vue"
if (category_form_Component.esModule && Object.keys(category_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0494c3d6", category_form_Component.options)
  } else {
    hotAPI.reload("data-v-0494c3d6", category_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_form_disposed = true
  })
})()}

/* harmony default export */ var entities_category_category_form = (category_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var category_list = ({
  name: 'app-category-list',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/category/loading',
    list: 'entities/category/list',
    pager: 'entities/category/pager',
    hasRoleToDelete: "entities/category/hasRoleToDelete",
    hasRoleToUpdate: "entities/category/hasRoleToUpdate",
    hasRoleToRead: "entities/category/hasRoleToRead",
    hasRoleToReadLogs: "entities/category/hasRoleToReadLogs",
    hasRoleToCreate: "entities/category/hasRoleToCreate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/category/list');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/clear');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/category/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: 'categoryNew'
      });
    },
    show: function show(id) {
      this.$router.push({
        name: 'categoryShow',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'categoryEdit',
        params: { id: id }
      });
    },
    destroy: function destroy(id) {
      var _this = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this.$store.dispatch('entities/category/destroy', id);
      }).catch(function () {});
    },
    importCsv: function importCsv() {
      this.$router.push({
        name: "categoryImportCsv"
      });
    },
    history: function history() {
      this.$router.push({ name: 'categoryHistoryFull' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-388deab0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-list.vue
var category_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.$t("entities.category.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.category.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.importCsv()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.import")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list)
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "primary",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { attrs: { name: "categoryImport" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no categories yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: "Operations",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var category_list_staticRenderFns = []
category_list_render._withStripped = true
var category_list_esExports = { render: category_list_render, staticRenderFns: category_list_staticRenderFns }
/* harmony default export */ var category_category_list = (category_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-388deab0", category_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-list.vue
var category_list_disposed = false
function category_list_injectStyle (ssrContext) {
  if (category_list_disposed) return
  __webpack_require__("vmNq")
}
var category_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_list___vue_template_functional__ = false
/* styles */
var category_list___vue_styles__ = category_list_injectStyle
/* scopeId */
var category_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_list___vue_module_identifier__ = null
var category_list_Component = category_list_normalizeComponent(
  category_list,
  category_category_list,
  category_list___vue_template_functional__,
  category_list___vue_styles__,
  category_list___vue_scopeId__,
  category_list___vue_module_identifier__
)
category_list_Component.options.__file = "src/entities/category/category-list.vue"
if (category_list_Component.esModule && Object.keys(category_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-388deab0", category_list_Component.options)
  } else {
    hotAPI.reload("data-v-388deab0", category_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_list_disposed = true
  })
})()}

/* harmony default export */ var entities_category_category_list = (category_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-history/category-history-full/category-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var category_history_full = ({
  name: 'app-category-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/category/historyFull/loading',
    list: 'entities/category/historyFull/list',
    last: 'entities/category/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/category/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/category/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24da51fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-history/category-history-full/category-history-full.vue
var category_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { name: "categoryList" } } },
            [_vm._v(_vm._s(_vm.$t("entities.category.plural")))]
          ),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.category.plural")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var category_history_full_staticRenderFns = []
category_history_full_render._withStripped = true
var category_history_full_esExports = { render: category_history_full_render, staticRenderFns: category_history_full_staticRenderFns }
/* harmony default export */ var category_history_full_category_history_full = (category_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24da51fc", category_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-full/category-history-full.vue
var category_history_full_disposed = false
function category_history_full_injectStyle (ssrContext) {
  if (category_history_full_disposed) return
  __webpack_require__("qssz")
}
var category_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_history_full___vue_template_functional__ = false
/* styles */
var category_history_full___vue_styles__ = category_history_full_injectStyle
/* scopeId */
var category_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_history_full___vue_module_identifier__ = null
var category_history_full_Component = category_history_full_normalizeComponent(
  category_history_full,
  category_history_full_category_history_full,
  category_history_full___vue_template_functional__,
  category_history_full___vue_styles__,
  category_history_full___vue_scopeId__,
  category_history_full___vue_module_identifier__
)
category_history_full_Component.options.__file = "src/entities/category/category-history/category-history-full/category-history-full.vue"
if (category_history_full_Component.esModule && Object.keys(category_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24da51fc", category_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-24da51fc", category_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_history_full_disposed = true
  })
})()}

/* harmony default export */ var category_history_category_history_full_category_history_full = (category_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-history/category-history-single/category-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var category_history_single = ({
  name: 'app-category-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/category/historySingle/loading',
    list: 'entities/category/historySingle/list',
    pager: 'entities/category/historySingle/pager',
    model: 'entities/category/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/category/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dac92f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-history/category-history-single/category-history-single.vue
var category_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { name: "categoryList" } } },
            [_vm._v(" " + _vm._s(_vm.$t("entities.player.plural")) + " ")]
          ),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "categoryShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.player.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var category_history_single_staticRenderFns = []
category_history_single_render._withStripped = true
var category_history_single_esExports = { render: category_history_single_render, staticRenderFns: category_history_single_staticRenderFns }
/* harmony default export */ var category_history_single_category_history_single = (category_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5dac92f4", category_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-history/category-history-single/category-history-single.vue
var category_history_single_disposed = false
function category_history_single_injectStyle (ssrContext) {
  if (category_history_single_disposed) return
  __webpack_require__("geVL")
}
var category_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_history_single___vue_template_functional__ = false
/* styles */
var category_history_single___vue_styles__ = category_history_single_injectStyle
/* scopeId */
var category_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_history_single___vue_module_identifier__ = null
var category_history_single_Component = category_history_single_normalizeComponent(
  category_history_single,
  category_history_single_category_history_single,
  category_history_single___vue_template_functional__,
  category_history_single___vue_styles__,
  category_history_single___vue_scopeId__,
  category_history_single___vue_module_identifier__
)
category_history_single_Component.options.__file = "src/entities/category/category-history/category-history-single/category-history-single.vue"
if (category_history_single_Component.esModule && Object.keys(category_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5dac92f4", category_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-5dac92f4", category_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_history_single_disposed = true
  })
})()}

/* harmony default export */ var category_history_category_history_single_category_history_single = (category_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var category_show = ({
  name: 'app-category-show',

  props: {
    id: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/category/detail', this.id).catch(function () {
      return _this.$router.push({ name: 'categoryList' });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/category/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/category/model',
    loading: 'entities/category/loading',
    hasRoleToDelete: "entities/category/hasRoleToDelete",
    hasRoleToUpdate: "entities/category/hasRoleToUpdate",
    hasRoleToRead: "entities/category/hasRoleToRead",
    hasRoleToReadLogs: "entities/category/hasRoleToReadLogs",
    hasRoleToCreate: "entities/category/hasRoleToCreate",
    isMobile: "shared/isMobile",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  })),

  methods: {
    edit: function edit() {
      this.$router.push({
        name: 'categoryEdit',
        params: { id: this.id, previous: 'show' }
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this2.$store.dispatch('entities/category/destroy', _this2.id);
      }).then(function () {
        return _this2.$router.push({ name: 'categoryList' });
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({
        name: 'categoryHistorySingle',
        params: { id: this.id }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57b264e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-show.vue
var category_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "categoryList" } } },
                    [_vm._v(" " + _vm._s(_vm.$t("entities.category.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n       " +
                    _vm._s(_vm.$t("entities.category.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var category_show_staticRenderFns = []
category_show_render._withStripped = true
var category_show_esExports = { render: category_show_render, staticRenderFns: category_show_staticRenderFns }
/* harmony default export */ var category_category_show = (category_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-57b264e2", category_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-show.vue
var category_show_disposed = false
function category_show_injectStyle (ssrContext) {
  if (category_show_disposed) return
  __webpack_require__("bLmq")
}
var category_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_show___vue_template_functional__ = false
/* styles */
var category_show___vue_styles__ = category_show_injectStyle
/* scopeId */
var category_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_show___vue_module_identifier__ = null
var category_show_Component = category_show_normalizeComponent(
  category_show,
  category_category_show,
  category_show___vue_template_functional__,
  category_show___vue_styles__,
  category_show___vue_scopeId__,
  category_show___vue_module_identifier__
)
category_show_Component.options.__file = "src/entities/category/category-show.vue"
if (category_show_Component.esModule && Object.keys(category_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57b264e2", category_show_Component.options)
  } else {
    hotAPI.reload("data-v-57b264e2", category_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_show_disposed = true
  })
})()}

/* harmony default export */ var entities_category_category_show = (category_show_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/category/category-import-csv.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable */
/* harmony default export */ var category_import_csv = ({
    name: "app-club-import",
    data: function data() {
        return {
            dialogTableVisible: true,
            file: null,
            parse_header: [],
            parse_csv: [],
            multipleSelection: [],
            sortOrders: {},
            sortKey: ""
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/category/loading"
    })),

    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created: function created() {
        console.log("<--- created import");

        this.dialogTableVisible = true;
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log(to, from);

        next();
    },


    methods: {
        sortBy: function sortBy(key) {
            var vm = this;
            vm.sortKey = key;
            vm.sortOrders[key] = vm.sortOrders[key] * -1;
        },

        csvJSON: function csvJSON(csv) {
            var vm = this;
            var lines = csv.split("\n");
            var result = [];
            var headers = lines[0].split(",");
            vm.parse_header = lines[0].split(",");
            lines[0].split(",").forEach(function (key) {
                vm.sortOrders[key] = 1;
            });
            lines.map(function (line, indexLine) {
                if (indexLine < 1) return; // Jump header line
                var currentline = line.split(",");
                var name = "";

                headers.map(function (header, indexHeader) {
                    if (header === "name") {
                        name = currentline[indexHeader].trim();
                    } else if (header === "\"name\"") {
                        name = currentline[indexHeader].trim().substring(1);
                        name = name.trim().substring(0, name.length - 1);
                    }
                });

                var obj = {
                    name: name
                };

                result.push(obj);
            });
            return result; // JavaScript object
        },
        loadCSV: function loadCSV(e) {
            var vm = this;
            var reader = new FileReader();
            reader.readAsText(e.file);
            // Handle errors load
            reader.onload = function (event) {
                var csv = event.target.result;
                vm.parse_csv = vm.csvJSON(csv);
            };
            reader.onerror = function (evt) {
                if (evt.target.error.name == "NotReadableError") {
                    alert("Canno't read file !");
                }
            };
        },
        toggleSelection: function toggleSelection(rows) {
            var _this = this;

            if (rows) {
                rows.forEach(function (row) {
                    _this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange: function handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        save: function save() {
            var _this2 = this;

            this.multipleSelection.forEach(function (it, index, array) {

                _this2.$store.dispatch("entities/category/save", it).then(function () {
                    if (index == array.length - 1) {
                        _this2.file = null;
                        _this2.parse_csv = [];
                        _this2.multipleSelection = [];
                        _this2.dialogTableVisible = false;
                        _this2.$router.go(-1);
                    }
                });
            });
        },
        handleClose: function handleClose(done) {
            var _this3 = this;

            this.$confirm('Are you sure to close this dialog?').then(function (_) {
                done();
                _this3.$router.go(-1);
            }).catch(function (_) {});
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b65f3320","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/category/category-import-csv.vue
var category_import_csv_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen",
              value: _vm.loading,
              expression: "loading",
              modifiers: { fullscreen: true }
            }
          ],
          attrs: {
            title: "Import from CSV",
            visible: _vm.dialogTableVisible,
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-demo",
              attrs: {
                drag: "",
                stored: _vm.file,
                accept: ".xls, .xlsx, .csv, .ods",
                action: "",
                "http-request": _vm.loadCSV
              }
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("Suelta tu archivo aquí o\n                "),
                _c("em", [_vm._v("haz clic para cargar")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip"
                },
                [_vm._v("Solo archivos .xls, .xlsx, .csv menor de 500kb")]
              )
            ]
          ),
          _vm._v(" "),
          [
            _c(
              "el-table",
              {
                ref: "multipleTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.parse_csv },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "Name category", width: "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [_vm._v(_vm._s(scope.row.name))]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "20px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.loading,
                      type: "primary",
                      icon: "el-icon-fa-floppy-o"
                    },
                    on: {
                      click: function($event) {
                        _vm.save()
                      }
                    }
                  },
                  [_vm._v("Save")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.toggleSelection()
                      }
                    }
                  },
                  [_vm._v("Clear selection")]
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var category_import_csv_staticRenderFns = []
category_import_csv_render._withStripped = true
var category_import_csv_esExports = { render: category_import_csv_render, staticRenderFns: category_import_csv_staticRenderFns }
/* harmony default export */ var category_category_import_csv = (category_import_csv_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b65f3320", category_import_csv_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/category/category-import-csv.vue
var category_import_csv_disposed = false
function category_import_csv_injectStyle (ssrContext) {
  if (category_import_csv_disposed) return
  __webpack_require__("VGLB")
}
var category_import_csv_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var category_import_csv___vue_template_functional__ = false
/* styles */
var category_import_csv___vue_styles__ = category_import_csv_injectStyle
/* scopeId */
var category_import_csv___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var category_import_csv___vue_module_identifier__ = null
var category_import_csv_Component = category_import_csv_normalizeComponent(
  category_import_csv,
  category_category_import_csv,
  category_import_csv___vue_template_functional__,
  category_import_csv___vue_styles__,
  category_import_csv___vue_scopeId__,
  category_import_csv___vue_module_identifier__
)
category_import_csv_Component.options.__file = "src/entities/category/category-import-csv.vue"
if (category_import_csv_Component.esModule && Object.keys(category_import_csv_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b65f3320", category_import_csv_Component.options)
  } else {
    hotAPI.reload("data-v-b65f3320", category_import_csv_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    category_import_csv_disposed = true
  })
})()}

/* harmony default export */ var entities_category_category_import_csv = (category_import_csv_Component.exports);

// CONCATENATED MODULE: ./src/entities/category/category-routes.js








var category_routes_roles = auth_roles.values;

/* harmony default export */ var category_routes = ([{
  name: 'categoryList',
  path: 'category',
  component: entities_category_category_list,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.activityViewer.id, category_routes_roles.entityViewer.id, category_routes_roles.entityEditor.id, category_routes_roles.categoryViewer.id, category_routes_roles.categoryEditor.id]
  },
  children: [{
    name: 'categoryImportCsv',
    path: 'importCsv',
    components: {
      categoryImport: entities_category_category_import_csv
    }
  }]
}, {
  name: 'categoryNew',
  path: 'category/new',
  component: entities_category_category_form,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.entityEditor.id, category_routes_roles.categoryEditor.id]
  }
}, {
  name: 'categoryEdit',
  path: 'category/:id/edit',
  component: entities_category_category_form,
  props: true,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.entityEditor.id, category_routes_roles.categoryEditor.id]
  }
}, {
  name: 'categoryHistorySingle',
  path: 'category/:id/history',
  component: category_history_category_history_single_category_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.activityViewer.id]
  }
}, {
  name: 'categoryHistoryFull',
  path: 'category/history',
  component: category_history_category_history_full_category_history_full,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.activityViewer.id]
  }
}, {
  name: 'categoryShow',
  path: 'category/:id',
  component: entities_category_category_show,
  props: true,
  meta: {
    auth: true,
    roles: [category_routes_roles.owner.id, category_routes_roles.activityViewer.id, category_routes_roles.entityViewer.id, category_routes_roles.entityEditor.id, category_routes_roles.categoryViewer.id, category_routes_roles.categoryEditor.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/category/category-module.js



var category_module_components = [];
var category_module_mixins = [];
var category_module_filters = [];
var category_module_directives = [];

/* harmony default export */ var category_module = ({
  components: category_module_components,
  mixins: category_module_mixins,
  filters: category_module_filters,
  directives: category_module_directives,
  routes: category_routes,
  store: category_store
});
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-full/player-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var player_history_full_service_SIZE = 10;

/* harmony default export */ var player_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      console.log(lastmodified);

      firebase_init_db.ref("log").child("logs").child("players").orderByChild("modified").endAt(lastmodified - 1).limitToLast(player_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < player_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-full/player-history-full-store.js


/* harmony default export */ var player_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return player_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-single/player-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


/* harmony default export */ var player_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child("players").orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-single/player-history-single-store.js



/* harmony default export */ var player_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return player_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-import/player-import-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */



/* harmony default export */ var player_import_service = ({
  createAllPlayers: function createAllPlayers(playerList, loggedUser) {

    return new promise_default.a(function (resolve, reject) {

      var count = 0;
      playerList.forEach(function (player) {

        player_service.save(player, loggedUser).then(function () {
          if (count == playerList.length - 1) {
            resolve();
          }
          count = count + 1;
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-import/player-import-store.js

/* eslint-disable */

 // Internationalization

/* harmony default export */ var player_import_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    team: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    team: function team(state) {
      return state.team;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    TEAM: function TEAM(state, payload) {
      state.team = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.team = null;
    }
  },

  actions: {
    setup: function setup(_ref, modelTeam) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      console.log("<--- SETUP PLAYER IMPORT");
      console.log(modelTeam);

      if (modelTeam !== null) {
        commit('LOADING', false);
        commit('TEAM', modelTeam);
        return promise_default.a.resolve();
      } else {
        commit('LOADING', false);
        var error = new Error('Equipo no existe.');
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      }
    },
    createAllPlayers: function createAllPlayers(_ref2, playerList) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters;

      //commit('LOADING', true);
      console.log("<-- CREATE ALL PLAYERS");
      console.log(playerList);

      player_import_service.createAllPlayers(playerList, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.player.plural') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
      // .catch((error) => {
      //   commit('LOADING', false);
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-pager.js


/* harmony default export */ var player_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'lastName', 'namePublic', 'team.name', 'team.category.label'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'dni', label: 'DNI/NIE/PASAPORTE' }, { value: 'email', label: 'Email' }, { value: 'dorsal', label: 'Dorsal' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-model.js


/* harmony default export */ var position_model = ({
  default: function _default() {
    return {};
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-service.js





var KEY_POSITIONS = 'positions';

/* harmony default export */ var position_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_POSITIONS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_POSITIONS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy category");
        }
        resolve(model);
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_POSITIONS).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_POSITIONS).child(model.id).set(position_model.forUpdate(model), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  create: function create(model) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_POSITIONS).push().key
    });

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_POSITIONS).child(modelToSave.id).set(position_model.forCreate(modelToSave), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_POSITIONS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/player/player-store.js




/* eslint-disable */

 // Internationalization


 // NEW!!







/* harmony default export */ var player_store = ({
  namespaced: true,

  modules: {
    historyFull: player_history_full_store,
    historySingle: player_history_single_store,
    import: player_import_store // NEW!!
  },

  state: {
    loading: false,
    list: [],
    pager: player_pager.build(),
    model: player_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.playerEditor.id, roles.clubManager.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.playerEditor.id, roles.clubManager.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.playerViewer.id, roles.playerEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.playerEditor.id, roles.clubManager.id]);
    },
    isClubManager: function isClubManager(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.clubManager.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || player_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = player_pager.build();
      state.model = player_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return player_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters;

      var team = rootGetters['entities/team/model'];
      var model = { team: team_model.forSimple(team), dorsal: "", picture: { name: "", size: 0, url: "" } };
      commit('MODEL', model);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return player_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      var team = rootGetters['entities/team/model'];
      var model = getters.model;
      var modelToSave = model;

      if (team.id !== null) {
        modelToSave = extends_default()({}, model, { team: team_model.forSimple(team) });
      }

      return player_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.player.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref5, model) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);
      console.log("<---- STORE DESTROY PLAYER");

      var team = rootGetters['entities/team/model'];
      console.log("<---- STORE MODEL TEAM");
      console.log(team);
      console.log("<---- STORE MODEL PLAYER");
      console.log(model);

      var modelToDestroy = model;
      if (team.id !== null) {
        modelToDestroy = extends_default()({}, model, { team: team });
      }

      return player_service.destroy(modelToDestroy, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.player.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return player_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByTeamId: function listByTeamId(_ref7, teamId) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return player_service.listByTeamId(teamId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref8) {
      var commit = _ref8.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref9) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      position_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'positions', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      team_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'teams', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // birthdate

/* harmony default export */ var player_form = ({
    name: "app-player-form",

    components: {
        'my-upload': node_modules_vue_image_crop_upload_upload_2
    },

    props: {
        id: String,
        previous: String
    },

    data: function data() {
        return {
            title: "Jugadores",
            titleEditPlayer: "Editar jugador",
            titleNewPlayer: "Nuevo jugador",
            breadcrumbLabels: {
                home: "Inicio",
                players: "Jugadores",
                edit: "Editar",
                new: "Nuevo"
            },
            show: false,
            imgDataUrl: '', // the datebase64 url of created image
            labels: {
                name: "Nombre",
                lastName: "Apellidos",
                picture: "Foto",
                dni: "Dni/Nie/Pasaporte",
                email: "Email de contacto",
                dorsal: "Dorsal",
                phone: "Teléfono",
                position: "Posición",
                namePublic: "Nombre deportivo"
            },

            buttonLabels: {
                save: "Guardar",
                cancel: "Cancelar"
            },

            rules: {
                name: validators.string({
                    label: "Nombre",
                    required: true
                }),
                lastName: validators.string({
                    label: "Apellidos",
                    required: false
                }),
                dni: validators.string({
                    label: "Dni/Nie/Passaporte",
                    required: false
                }),
                team: validators.hasOne({
                    label: 'Team',
                    required: true
                }),
                email: validators.string({
                    label: "Email de contacto",
                    required: false
                }),
                dorsal: validators.integer({
                    label: "Dorsal",
                    required: false
                }),
                phone: validators.string({
                    label: "Teléfono",
                    required: false
                }),
                position: validators.hasOne({
                    label: "Posición",
                    required: false
                }),
                namePublic: validators.string({
                    label: "Nombre deportivo",
                    required: false
                })
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/player/loadOptions");
        if (this.id) {
            this.$store.dispatch("entities/player/edit", this.id).catch(function () {
                return _this.$router.push({ name: "playerList" });
            });
        } else {
            this.$store.dispatch("entities/player/new");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/clear");
        this.$store.dispatch("entities/team/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/player/model",
        loading: "entities/player/loading",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        isClubManager: "entities/player/isClubManager",
        options: "entities/player/options"
    }), {

        editing: function editing(state) {
            return !!state.id;
        }
    }),

    methods: {
        save: function save() {
            var _this2 = this;

            this.model.birthdate = moment_default()(this.model.birthdate).format('YYYY-MM-DD');

            this.model.namePublic = this.model.name;
            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                _this2.$store.dispatch("entities/player/save").then(function () {
                    _this2.back();
                });
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        toggleShow: function toggleShow() {
            this.show = !this.show;
        },
        attachFileToModel: function attachFileToModel(imgDataUrl) {
            var data = imgDataUrl.slice(22, imgDataUrl.length);
            var picture = {
                name: "picture.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            };
            this.model.picture = picture;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670f1af6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-form.vue
var player_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(_vm._s(_vm.breadcrumbLabels.home))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "playerList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.player.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "playerShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.id))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.player.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.player.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.name"),
                            prop: "name"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.lastName"),
                            prop: "lastName"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.team.singular"),
                            prop: "team"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.teams == null,
                                      expression: "options.teams == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing || _vm.isClubManager,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.team,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "team", $$v)
                                    },
                                    expression: "model.team"
                                  }
                                },
                                [
                                  _vm.options.teams
                                    ? _vm._l(_vm.options.teams, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.picture")
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "player-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.picture.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.picture.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus player-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.attachFileToModel },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.dni"),
                            prop: "dni"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.dni,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dni", $$v)
                                  },
                                  expression: "model.dni"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.birthdate"),
                            prop: "birthdate"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  format: "dd-MM-yyyy",
                                  type: "date",
                                  placeholder: "Pick a day"
                                },
                                model: {
                                  value: _vm.model.birthdate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "birthdate", $$v)
                                  },
                                  expression: "model.birthdate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.dorsal"),
                            prop: "dorsal"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  "controls-position": "right",
                                  step: 1
                                },
                                model: {
                                  value: _vm.model.dorsal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dorsal", _vm._n($$v))
                                  },
                                  expression: "model.dorsal"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.player.prop.position"),
                            prop: "position"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.positions == null,
                                      expression: "options.positions == null"
                                    }
                                  ],
                                  attrs: { filterable: "", "value-key": "id" },
                                  model: {
                                    value: _vm.model.position,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "position", $$v)
                                    },
                                    expression: "model.position"
                                  }
                                },
                                [
                                  _vm.options.positions
                                    ? _vm._l(_vm.options.positions, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.save))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.cancel))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var player_form_staticRenderFns = []
player_form_render._withStripped = true
var player_form_esExports = { render: player_form_render, staticRenderFns: player_form_staticRenderFns }
/* harmony default export */ var player_player_form = (player_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670f1af6", player_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-form.vue
var player_form_disposed = false
function player_form_injectStyle (ssrContext) {
  if (player_form_disposed) return
  __webpack_require__("+tsz")
}
var player_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_form___vue_template_functional__ = false
/* styles */
var player_form___vue_styles__ = player_form_injectStyle
/* scopeId */
var player_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_form___vue_module_identifier__ = null
var player_form_Component = player_form_normalizeComponent(
  player_form,
  player_player_form,
  player_form___vue_template_functional__,
  player_form___vue_styles__,
  player_form___vue_scopeId__,
  player_form___vue_module_identifier__
)
player_form_Component.options.__file = "src/entities/player/player-form.vue"
if (player_form_Component.esModule && Object.keys(player_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-670f1af6", player_form_Component.options)
  } else {
    hotAPI.reload("data-v-670f1af6", player_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_form_disposed = true
  })
})()}

/* harmony default export */ var entities_player_player_form = (player_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-history/player-history-full/player-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var player_history_full = ({
  name: 'app-player-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/player/historyFull/loading',
    list: 'entities/player/historyFull/list',
    last: 'entities/player/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/player/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/player/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/player/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06ef5848","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-history/player-history-full/player-history-full.vue
var player_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "playerList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.player.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.player.singular")) + " history ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dni", label: "DNI/NIE/PASAPORTE" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dorsal", label: "Dorsal" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "Phone" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "position", label: "Position" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.position ? scope.row.position.label : ""
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "namePublic", label: "Nombre deportivo" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var player_history_full_staticRenderFns = []
player_history_full_render._withStripped = true
var player_history_full_esExports = { render: player_history_full_render, staticRenderFns: player_history_full_staticRenderFns }
/* harmony default export */ var player_history_full_player_history_full = (player_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06ef5848", player_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-full/player-history-full.vue
var player_history_full_disposed = false
function player_history_full_injectStyle (ssrContext) {
  if (player_history_full_disposed) return
  __webpack_require__("2+48")
}
var player_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_history_full___vue_template_functional__ = false
/* styles */
var player_history_full___vue_styles__ = player_history_full_injectStyle
/* scopeId */
var player_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_history_full___vue_module_identifier__ = null
var player_history_full_Component = player_history_full_normalizeComponent(
  player_history_full,
  player_history_full_player_history_full,
  player_history_full___vue_template_functional__,
  player_history_full___vue_styles__,
  player_history_full___vue_scopeId__,
  player_history_full___vue_module_identifier__
)
player_history_full_Component.options.__file = "src/entities/player/player-history/player-history-full/player-history-full.vue"
if (player_history_full_Component.esModule && Object.keys(player_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-06ef5848", player_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-06ef5848", player_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_history_full_disposed = true
  })
})()}

/* harmony default export */ var player_history_player_history_full_player_history_full = (player_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-history/player-history-single/player-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var player_history_single = ({
  name: 'app-player-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/player/historySingle/loading',
    list: 'entities/player/historySingle/list',
    pager: 'entities/player/historySingle/pager',
    model: 'entities/player/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/player/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/player/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036aaf64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-history/player-history-single/player-history-single.vue
var player_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "playerList" } } }, [
            _vm._v("Players")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "playerShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.id))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n    Player " + _vm._s(_vm.$t("table.history")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "dni",
              label: "DNI/NIE/PASAPORTE",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "dorsal", label: "Dorsal", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "position", label: "Position" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.position ? scope.row.position.label : ""
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "namePublic",
              label: "Nombre deportivo",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var player_history_single_staticRenderFns = []
player_history_single_render._withStripped = true
var player_history_single_esExports = { render: player_history_single_render, staticRenderFns: player_history_single_staticRenderFns }
/* harmony default export */ var player_history_single_player_history_single = (player_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-036aaf64", player_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-history/player-history-single/player-history-single.vue
var player_history_single_disposed = false
function player_history_single_injectStyle (ssrContext) {
  if (player_history_single_disposed) return
  __webpack_require__("Gres")
}
var player_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_history_single___vue_template_functional__ = false
/* styles */
var player_history_single___vue_styles__ = player_history_single_injectStyle
/* scopeId */
var player_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_history_single___vue_module_identifier__ = null
var player_history_single_Component = player_history_single_normalizeComponent(
  player_history_single,
  player_history_single_player_history_single,
  player_history_single___vue_template_functional__,
  player_history_single___vue_styles__,
  player_history_single___vue_scopeId__,
  player_history_single___vue_module_identifier__
)
player_history_single_Component.options.__file = "src/entities/player/player-history/player-history-single/player-history-single.vue"
if (player_history_single_Component.esModule && Object.keys(player_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-036aaf64", player_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-036aaf64", player_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_history_single_disposed = true
  })
})()}

/* harmony default export */ var player_history_player_history_single_player_history_single = (player_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/player/player-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // birthdate
 // birthdate
/* eslint-disable */

/* harmony default export */ var player_show = ({
    name: "app-player-show",

    props: {
        id: String
    },

    data: function data() {
        return {
            labels: {
                name: "Nombre",
                lastName: "Apellidos",
                picture: "Foto",
                dni: "Dni/Nie/Pasaporte",
                email: "Email de contacto",
                dorsal: "Dorsal",
                phone: "Teléfono",
                position: "Posición",
                namePublic: "Nombre deportivo"
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/player/detail", this.id).catch(function () {
            return _this.$router.push({ name: "playerList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/player/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/player/model",
        loading: "entities/player/loading",
        hasRoleToDelete: "entities/player/hasRoleToDelete",
        hasRoleToUpdate: "entities/player/hasRoleToUpdate",
        hasRoleToRead: "entities/player/hasRoleToRead",
        hasRoleToReadLogs: "entities/player/hasRoleToReadLogs",
        hasRoleToCreate: "entities/player/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "playerEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this2 = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this2.$store.dispatch("entities/player/destroy", _this2.model);
            }).then(function () {
                return _this2.$router.go(-1);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "playerHistorySingle",
                params: { id: this.id }
            });
        },


        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            console.log("<---- GET DATE FORMAT");
            console.log(dateString);
            console.log(new Date(dateString));

            return moment_default()(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(js_cookie_default.a.get('language') || 'es').format('L');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a124af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/player/player-show.vue
var player_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "playerList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.player.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.id))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.player.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.lastName")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.lastName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.dni")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dni))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.birthdate")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getDateFormat(_vm.model.birthdate))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.dorsal")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dorsal))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.position")
                              }
                            },
                            [
                              _c("app-entity-link", {
                                attrs: {
                                  entityName: "position",
                                  property: _vm.model.position
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.player.prop.picture")
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.model.picture.url,
                                  width: "10%",
                                  height: "10%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Created at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Updated at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "page-title" }, [
                        _vm._v(_vm._s(_vm.$t("entities.team.singular")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.team.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.category")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.category.label))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var player_show_staticRenderFns = []
player_show_render._withStripped = true
var player_show_esExports = { render: player_show_render, staticRenderFns: player_show_staticRenderFns }
/* harmony default export */ var player_player_show = (player_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36a124af", player_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/player/player-show.vue
var player_show_disposed = false
function player_show_injectStyle (ssrContext) {
  if (player_show_disposed) return
  __webpack_require__("Pv/A")
}
var player_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var player_show___vue_template_functional__ = false
/* styles */
var player_show___vue_styles__ = player_show_injectStyle
/* scopeId */
var player_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var player_show___vue_module_identifier__ = null
var player_show_Component = player_show_normalizeComponent(
  player_show,
  player_player_show,
  player_show___vue_template_functional__,
  player_show___vue_styles__,
  player_show___vue_scopeId__,
  player_show___vue_module_identifier__
)
player_show_Component.options.__file = "src/entities/player/player-show.vue"
if (player_show_Component.esModule && Object.keys(player_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-36a124af", player_show_Component.options)
  } else {
    hotAPI.reload("data-v-36a124af", player_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    player_show_disposed = true
  })
})()}

/* harmony default export */ var entities_player_player_show = (player_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/player/player-routes.js







var player_routes_roles = auth_roles.values;

/* harmony default export */ var player_routes = ([{
  name: 'playerList',
  path: 'player',
  component: entities_player_player_list,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.activityViewer.id, player_routes_roles.entityViewer.id, player_routes_roles.entityEditor.id, player_routes_roles.playerViewer.id, player_routes_roles.playerEditor.id]
  }
}, {
  name: 'playerNew',
  path: 'player/new',
  component: entities_player_player_form,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.entityEditor.id, player_routes_roles.playerEditor.id, player_routes_roles.clubManager.id]
  }
}, {
  name: 'playerEdit',
  path: 'player/:id/edit',
  component: entities_player_player_form,
  props: true,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.entityEditor.id, player_routes_roles.playerEditor.id, player_routes_roles.clubManager.id]
  }
}, {
  name: 'playerHistorySingle',
  path: 'player/:id/history',
  component: player_history_player_history_single_player_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.activityViewer.id]
  }
}, {
  name: 'playerHistoryFull',
  path: 'player/history',
  component: player_history_player_history_full_player_history_full,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.activityViewer.id]
  }
}, {
  name: 'playerShow',
  path: 'player/:id',
  component: entities_player_player_show,
  props: true,
  meta: {
    auth: true,
    roles: [player_routes_roles.owner.id, player_routes_roles.activityViewer.id, player_routes_roles.entityViewer.id, player_routes_roles.entityEditor.id, player_routes_roles.playerViewer.id, player_routes_roles.playerEditor.id, player_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/player/player-module.js



var player_module_components = [];
var player_module_mixins = [];
var player_module_filters = [];
var player_module_directives = [];

/* harmony default export */ var player_module = ({
  components: player_module_components,
  mixins: player_module_mixins,
  filters: player_module_filters,
  directives: player_module_directives,
  routes: player_routes,
  store: player_store
});
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-full/manager-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var manager_history_full_service_SIZE = 10;

var manager_history_full_service_KEY_USERS_MANAGER = "usersManager";

/* harmony default export */ var manager_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      console.log(lastmodified);

      firebase_init_db.ref("log").child("logs").child(manager_history_full_service_KEY_USERS_MANAGER).orderByChild("modified").endAt(lastmodified - 1).limitToLast(manager_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < manager_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-full/manager-history-full-store.js


/* harmony default export */ var manager_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return manager_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-single/manager-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
var manager_history_single_service_KEY_USERS_MANAGER = "usersManager";

/* harmony default export */ var manager_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      db.ref("log").child("logs").child(manager_history_single_service_KEY_USERS_MANAGER).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-single/manager-history-single-store.js



/* harmony default export */ var manager_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return manager_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-pager.js


/* harmony default export */ var manager_pager = ({
  build: function build() {
    var keysToSearch = ['name'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'email', label: 'Email' }, { value: 'phone', label: 'Phone' }, { value: 'club.name', label: 'Club' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/manager/manager-store.js




 // Internationalization







/* harmony default export */ var manager_store = ({
  namespaced: true,

  modules: {
    historyFull: manager_history_full_store,
    historySingle: manager_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: manager_pager.build(),
    model: manager_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.managerEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.managerEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.managerViewer.id, roles.managerEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.managerEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || manager_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = manager_pager.build();
      state.model = manager_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return manager_service.save(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.manager.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return manager_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.manager.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return manager_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      club_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'clubs', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/manager/manager-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var manager_form = ({
  name: 'app-manager-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: false
        }),
        lastName: validators.string({
          label: 'LastName',
          required: false
        }),
        email: validators.string({
          label: 'Email',
          required: true
        }),
        phone: validators.string({
          label: 'Phone',
          required: false
        }),
        club: validators.hasOne({
          label: 'Club',
          required: false
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/manager/loadOptions');

    if (this.id) {
      this.$store.dispatch('entities/manager/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'managerList' });
      });
    } else {
      this.$store.dispatch('entities/manager/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/manager/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/manager/model',
    loading: 'entities/manager/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth",

    options: 'entities/manager/options'
  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/manager/save').then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'managerShow',
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: 'managerList' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0f85c0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-form.vue
var manager_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "managerList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.manager.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "managerShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.manager.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.manager.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "LastName", prop: "lastName" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Phone", prop: "phone" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var manager_form_staticRenderFns = []
manager_form_render._withStripped = true
var manager_form_esExports = { render: manager_form_render, staticRenderFns: manager_form_staticRenderFns }
/* harmony default export */ var manager_manager_form = (manager_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0f85c0c", manager_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/manager/manager-form.vue
var manager_form_disposed = false
function manager_form_injectStyle (ssrContext) {
  if (manager_form_disposed) return
  __webpack_require__("agpV")
}
var manager_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var manager_form___vue_template_functional__ = false
/* styles */
var manager_form___vue_styles__ = manager_form_injectStyle
/* scopeId */
var manager_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var manager_form___vue_module_identifier__ = null
var manager_form_Component = manager_form_normalizeComponent(
  manager_form,
  manager_manager_form,
  manager_form___vue_template_functional__,
  manager_form___vue_styles__,
  manager_form___vue_scopeId__,
  manager_form___vue_module_identifier__
)
manager_form_Component.options.__file = "src/entities/manager/manager-form.vue"
if (manager_form_Component.esModule && Object.keys(manager_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0f85c0c", manager_form_Component.options)
  } else {
    hotAPI.reload("data-v-c0f85c0c", manager_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    manager_form_disposed = true
  })
})()}

/* harmony default export */ var entities_manager_manager_form = (manager_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/manager/manager-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable */

/* harmony default export */ var manager_list = ({
  name: 'app-manager-list',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/manager/loading',
    list: 'entities/manager/list',
    pager: 'entities/manager/pager',
    hasRoleToDelete: "entities/manager/hasRoleToDelete",
    hasRoleToUpdate: "entities/manager/hasRoleToUpdate",
    hasRoleToRead: "entities/manager/hasRoleToRead",
    hasRoleToReadLogs: "entities/manager/hasRoleToReadLogs",
    hasRoleToCreate: "entities/manager/hasRoleToCreate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/manager/list');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/manager/clear');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/manager/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: 'managerNew'
      });
    },
    rowClick: function rowClick(row, column, cell, event) {
      if (cell.label !== this.$t("table.actions")) {
        this.$router.push({
          name: "managerShow",
          params: { id: row.id }
        });
      }
    },
    show: function show(id) {
      this.$router.push({
        name: 'managerShow',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'managerEdit',
        params: { id: id }
      });
    },
    destroy: function destroy(id) {
      var _this = this;

      this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
        confirmButtonText: this.$t("table.yes"),
        cancelButtonText: this.$t("table.no"),
        type: 'warning'
      }).then(function () {
        return _this.$store.dispatch('entities/manager/destroy', id);
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({ name: 'managerHistoryFull' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59060e58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-list.vue
var manager_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.$t("entities.manager.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.manager.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no managers yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.clubs, function(clubs) {
                    return _c("div", { key: clubs.id }, [
                      _vm._v("\n          " + _vm._s(clubs.name) + "\n        ")
                    ])
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { size: "small", round: "" }
                          },
                          [_c("i", { staticClass: "el-icon-more" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-search",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.show(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.details")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToUpdate
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-pencil-square-o",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.edit(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.edit")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToDelete
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-trash",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.destroy(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.delete")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var manager_list_staticRenderFns = []
manager_list_render._withStripped = true
var manager_list_esExports = { render: manager_list_render, staticRenderFns: manager_list_staticRenderFns }
/* harmony default export */ var manager_manager_list = (manager_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59060e58", manager_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/manager/manager-list.vue
var manager_list_disposed = false
function manager_list_injectStyle (ssrContext) {
  if (manager_list_disposed) return
  __webpack_require__("FQjR")
}
var manager_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var manager_list___vue_template_functional__ = false
/* styles */
var manager_list___vue_styles__ = manager_list_injectStyle
/* scopeId */
var manager_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var manager_list___vue_module_identifier__ = null
var manager_list_Component = manager_list_normalizeComponent(
  manager_list,
  manager_manager_list,
  manager_list___vue_template_functional__,
  manager_list___vue_styles__,
  manager_list___vue_scopeId__,
  manager_list___vue_module_identifier__
)
manager_list_Component.options.__file = "src/entities/manager/manager-list.vue"
if (manager_list_Component.esModule && Object.keys(manager_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59060e58", manager_list_Component.options)
  } else {
    hotAPI.reload("data-v-59060e58", manager_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    manager_list_disposed = true
  })
})()}

/* harmony default export */ var entities_manager_manager_list = (manager_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/manager/manager-history/manager-history-full/manager-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var manager_history_full = ({
  name: 'app-manager-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/manager/historyFull/loading',
    list: 'entities/manager/historyFull/list',
    last: 'entities/manager/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/manager/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/manager/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/manager/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3004e8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-history/manager-history-full/manager-history-full.vue
var manager_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "managerList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.manager.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(" " + _vm._s(_vm.$t("table.history")) + " ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.manager.plural")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "Phone" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "club", label: "Club" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.club ? scope.row.club.name : "") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var manager_history_full_staticRenderFns = []
manager_history_full_render._withStripped = true
var manager_history_full_esExports = { render: manager_history_full_render, staticRenderFns: manager_history_full_staticRenderFns }
/* harmony default export */ var manager_history_full_manager_history_full = (manager_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3004e8ae", manager_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-full/manager-history-full.vue
var manager_history_full_disposed = false
function manager_history_full_injectStyle (ssrContext) {
  if (manager_history_full_disposed) return
  __webpack_require__("Xgqo")
}
var manager_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var manager_history_full___vue_template_functional__ = false
/* styles */
var manager_history_full___vue_styles__ = manager_history_full_injectStyle
/* scopeId */
var manager_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var manager_history_full___vue_module_identifier__ = null
var manager_history_full_Component = manager_history_full_normalizeComponent(
  manager_history_full,
  manager_history_full_manager_history_full,
  manager_history_full___vue_template_functional__,
  manager_history_full___vue_styles__,
  manager_history_full___vue_scopeId__,
  manager_history_full___vue_module_identifier__
)
manager_history_full_Component.options.__file = "src/entities/manager/manager-history/manager-history-full/manager-history-full.vue"
if (manager_history_full_Component.esModule && Object.keys(manager_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3004e8ae", manager_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-3004e8ae", manager_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    manager_history_full_disposed = true
  })
})()}

/* harmony default export */ var manager_history_manager_history_full_manager_history_full = (manager_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/manager/manager-history/manager-history-single/manager-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var manager_history_single = ({
  name: 'app-manager-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/manager/historySingle/loading',
    list: 'entities/manager/historySingle/list',
    pager: 'entities/manager/historySingle/pager',
    model: 'entities/manager/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/manager/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/manager/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e8774e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-history/manager-history-single/manager-history-single.vue
var manager_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "managerList" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("entities.manager.plural")) + " ")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "managerShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.manager.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.club ? scope.row.club.name : "") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var manager_history_single_staticRenderFns = []
manager_history_single_render._withStripped = true
var manager_history_single_esExports = { render: manager_history_single_render, staticRenderFns: manager_history_single_staticRenderFns }
/* harmony default export */ var manager_history_single_manager_history_single = (manager_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69e8774e", manager_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/manager/manager-history/manager-history-single/manager-history-single.vue
var manager_history_single_disposed = false
function manager_history_single_injectStyle (ssrContext) {
  if (manager_history_single_disposed) return
  __webpack_require__("JRRF")
}
var manager_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var manager_history_single___vue_template_functional__ = false
/* styles */
var manager_history_single___vue_styles__ = manager_history_single_injectStyle
/* scopeId */
var manager_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var manager_history_single___vue_module_identifier__ = null
var manager_history_single_Component = manager_history_single_normalizeComponent(
  manager_history_single,
  manager_history_single_manager_history_single,
  manager_history_single___vue_template_functional__,
  manager_history_single___vue_styles__,
  manager_history_single___vue_scopeId__,
  manager_history_single___vue_module_identifier__
)
manager_history_single_Component.options.__file = "src/entities/manager/manager-history/manager-history-single/manager-history-single.vue"
if (manager_history_single_Component.esModule && Object.keys(manager_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69e8774e", manager_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-69e8774e", manager_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    manager_history_single_disposed = true
  })
})()}

/* harmony default export */ var manager_history_manager_history_single_manager_history_single = (manager_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/manager/manager-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var manager_show = ({
  name: 'app-manager-show',

  props: {
    id: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/manager/detail', this.id).catch(function () {
      return _this.$router.push({ name: 'managerList' });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/manager/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/manager/model',
    loading: 'entities/manager/loading',
    hasRoleToDelete: "entities/manager/hasRoleToDelete",
    hasRoleToUpdate: "entities/manager/hasRoleToUpdate",
    hasRoleToRead: "entities/manager/hasRoleToRead",
    hasRoleToReadLogs: "entities/manager/hasRoleToReadLogs",
    hasRoleToCreate: "entities/manager/hasRoleToCreate",
    isMobile: "shared/isMobile",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  })),

  methods: {
    edit: function edit() {
      this.$router.push({
        name: 'managerEdit',
        params: { id: this.id, previous: 'show' }
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this2.$store.dispatch('entities/manager/destroy', _this2.id);
      }).then(function () {
        return _this2.$router.push({ name: 'managerList' });
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({
        name: 'managerHistorySingle',
        params: { id: this.id }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f15dbb3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/manager/manager-show.vue
var manager_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "managerList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.manager.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("entities.manager.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "LastName" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.model.lastName) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Email" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.email) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Phone" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.phone) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Clubs" } },
                    [
                      _vm._l(_vm.model.clubs, function(club) {
                        return _c("div", { key: club.id }, [
                          _vm._v(
                            "\n          " + _vm._s(club.name) + "\n        "
                          )
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var manager_show_staticRenderFns = []
manager_show_render._withStripped = true
var manager_show_esExports = { render: manager_show_render, staticRenderFns: manager_show_staticRenderFns }
/* harmony default export */ var manager_manager_show = (manager_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f15dbb3", manager_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/manager/manager-show.vue
var manager_show_disposed = false
function manager_show_injectStyle (ssrContext) {
  if (manager_show_disposed) return
  __webpack_require__("I707")
}
var manager_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var manager_show___vue_template_functional__ = false
/* styles */
var manager_show___vue_styles__ = manager_show_injectStyle
/* scopeId */
var manager_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var manager_show___vue_module_identifier__ = null
var manager_show_Component = manager_show_normalizeComponent(
  manager_show,
  manager_manager_show,
  manager_show___vue_template_functional__,
  manager_show___vue_styles__,
  manager_show___vue_scopeId__,
  manager_show___vue_module_identifier__
)
manager_show_Component.options.__file = "src/entities/manager/manager-show.vue"
if (manager_show_Component.esModule && Object.keys(manager_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6f15dbb3", manager_show_Component.options)
  } else {
    hotAPI.reload("data-v-6f15dbb3", manager_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    manager_show_disposed = true
  })
})()}

/* harmony default export */ var entities_manager_manager_show = (manager_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/manager/manager-routes.js







var manager_routes_roles = auth_roles.values;

/* harmony default export */ var manager_routes = ([{
  name: 'managerList',
  path: 'manager',
  component: entities_manager_manager_list,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.activityViewer.id, manager_routes_roles.entityViewer.id, manager_routes_roles.entityEditor.id, manager_routes_roles.managerViewer.id, manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'managerNew',
  path: 'manager/new',
  component: entities_manager_manager_form,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.entityEditor.id, manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'managerEdit',
  path: 'manager/:id/edit',
  component: entities_manager_manager_form,
  props: true,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.entityEditor.id, manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'managerHistorySingle',
  path: 'manager/:id/history',
  component: manager_history_manager_history_single_manager_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'managerHistoryFull',
  path: 'manager/history',
  component: manager_history_manager_history_full_manager_history_full,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'managerShow',
  path: 'manager/:id',
  component: entities_manager_manager_show,
  props: true,
  meta: {
    auth: true,
    roles: [manager_routes_roles.owner.id, manager_routes_roles.activityViewer.id, manager_routes_roles.entityViewer.id, manager_routes_roles.entityEditor.id, manager_routes_roles.managerViewer.id, manager_routes_roles.managerEditor.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/manager/manager-module.js



var manager_module_components = [];
var manager_module_mixins = [];
var manager_module_filters = [];
var manager_module_directives = [];

/* harmony default export */ var manager_module = ({
  components: manager_module_components,
  mixins: manager_module_mixins,
  filters: manager_module_filters,
  directives: manager_module_directives,
  routes: manager_routes,
  store: manager_store
});
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-full/position-history-full-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
/* harmony default export */ var position_history_full_service = ({
  fetch: function fetch(lastmodified) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/positions/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-full/position-history-full-store.js


/* harmony default export */ var position_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : null;

      return position_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-single/position-history-single-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
/* harmony default export */ var position_history_single_service = ({
  list: function list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/positions/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-single/position-history-single-store.js



/* harmony default export */ var position_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return position_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-pager.js


/* harmony default export */ var position_pager = ({
  build: function build() {
    var keysToSearch = ['name'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/position/position-store.js


 // Internationalization






/* harmony default export */ var position_store = ({
  namespaced: true,

  modules: {
    historyFull: position_history_full_store,
    historySingle: position_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: position_pager.build(),
    model: position_model.default()
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.positionEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.positionEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.positionViewer.id, roles.positionEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.positionEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || position_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = position_pager.build();
      state.model = position_model.default();
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return position_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return position_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return position_service.save(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.position.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return position_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.position.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return position_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/position/position-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var position_form = ({
  name: 'app-position-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.id) {
      this.$store.dispatch('entities/position/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'positionList' });
      });
    } else {
      this.$store.dispatch('entities/position/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/position/model',
    loading: 'entities/position/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"

  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/position/save').then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'positionShow',
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: 'positionList' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-663ca114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/position/position-form.vue
var position_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "positionList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.position.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "positionShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.position.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.position.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var position_form_staticRenderFns = []
position_form_render._withStripped = true
var position_form_esExports = { render: position_form_render, staticRenderFns: position_form_staticRenderFns }
/* harmony default export */ var position_position_form = (position_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-663ca114", position_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/position/position-form.vue
var position_form_disposed = false
function position_form_injectStyle (ssrContext) {
  if (position_form_disposed) return
  __webpack_require__("XGA4")
}
var position_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var position_form___vue_template_functional__ = false
/* styles */
var position_form___vue_styles__ = position_form_injectStyle
/* scopeId */
var position_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var position_form___vue_module_identifier__ = null
var position_form_Component = position_form_normalizeComponent(
  position_form,
  position_position_form,
  position_form___vue_template_functional__,
  position_form___vue_styles__,
  position_form___vue_scopeId__,
  position_form___vue_module_identifier__
)
position_form_Component.options.__file = "src/entities/position/position-form.vue"
if (position_form_Component.esModule && Object.keys(position_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-663ca114", position_form_Component.options)
  } else {
    hotAPI.reload("data-v-663ca114", position_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    position_form_disposed = true
  })
})()}

/* harmony default export */ var entities_position_position_form = (position_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/position/position-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var position_list = ({
  name: 'app-position-list',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/position/loading',
    list: 'entities/position/list',
    pager: 'entities/position/pager',
    hasRoleToDelete: "entities/position/hasRoleToDelete",
    hasRoleToUpdate: "entities/position/hasRoleToUpdate",
    hasRoleToRead: "entities/position/hasRoleToRead",
    hasRoleToReadLogs: "entities/position/hasRoleToReadLogs",
    hasRoleToCreate: "entities/position/hasRoleToCreate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/position/list');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/clear');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/position/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: 'positionNew'
      });
    },
    show: function show(id) {
      this.$router.push({
        name: 'positionShow',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'positionEdit',
        params: { id: id }
      });
    },
    destroy: function destroy(id) {
      var _this = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this.$store.dispatch('entities/position/destroy', id);
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({ name: 'positionHistoryFull' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00dad650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/position/position-list.vue
var position_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.$t("entities.position.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.position.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list)
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no positions yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: "Operations",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var position_list_staticRenderFns = []
position_list_render._withStripped = true
var position_list_esExports = { render: position_list_render, staticRenderFns: position_list_staticRenderFns }
/* harmony default export */ var position_position_list = (position_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00dad650", position_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/position/position-list.vue
var position_list_disposed = false
function position_list_injectStyle (ssrContext) {
  if (position_list_disposed) return
  __webpack_require__("68AW")
}
var position_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var position_list___vue_template_functional__ = false
/* styles */
var position_list___vue_styles__ = position_list_injectStyle
/* scopeId */
var position_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var position_list___vue_module_identifier__ = null
var position_list_Component = position_list_normalizeComponent(
  position_list,
  position_position_list,
  position_list___vue_template_functional__,
  position_list___vue_styles__,
  position_list___vue_scopeId__,
  position_list___vue_module_identifier__
)
position_list_Component.options.__file = "src/entities/position/position-list.vue"
if (position_list_Component.esModule && Object.keys(position_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-00dad650", position_list_Component.options)
  } else {
    hotAPI.reload("data-v-00dad650", position_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    position_list_disposed = true
  })
})()}

/* harmony default export */ var entities_position_position_list = (position_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/position/position-history/position-history-full/position-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var position_history_full = ({
  name: 'app-position-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/position/historyFull/loading',
    list: 'entities/position/historyFull/list',
    last: 'entities/position/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/position/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/position/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c27f1fe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/position/position-history/position-history-full/position-history-full.vue
var position_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { name: "positionList" } } },
            [_vm._v("Positions")]
          ),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n    Positions " + _vm._s(_vm.$t("table.history")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var position_history_full_staticRenderFns = []
position_history_full_render._withStripped = true
var position_history_full_esExports = { render: position_history_full_render, staticRenderFns: position_history_full_staticRenderFns }
/* harmony default export */ var position_history_full_position_history_full = (position_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c27f1fe8", position_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-full/position-history-full.vue
var position_history_full_disposed = false
function position_history_full_injectStyle (ssrContext) {
  if (position_history_full_disposed) return
  __webpack_require__("jYcp")
}
var position_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var position_history_full___vue_template_functional__ = false
/* styles */
var position_history_full___vue_styles__ = position_history_full_injectStyle
/* scopeId */
var position_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var position_history_full___vue_module_identifier__ = null
var position_history_full_Component = position_history_full_normalizeComponent(
  position_history_full,
  position_history_full_position_history_full,
  position_history_full___vue_template_functional__,
  position_history_full___vue_styles__,
  position_history_full___vue_scopeId__,
  position_history_full___vue_module_identifier__
)
position_history_full_Component.options.__file = "src/entities/position/position-history/position-history-full/position-history-full.vue"
if (position_history_full_Component.esModule && Object.keys(position_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c27f1fe8", position_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-c27f1fe8", position_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    position_history_full_disposed = true
  })
})()}

/* harmony default export */ var position_history_position_history_full_position_history_full = (position_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/position/position-history/position-history-single/position-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var position_history_single = ({
  name: 'app-position-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/position/historySingle/loading',
    list: 'entities/position/historySingle/list',
    pager: 'entities/position/historySingle/pager',
    model: 'entities/position/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/position/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56777f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/position/position-history/position-history-single/position-history-single.vue
var position_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { name: "positionList" } } },
            [_vm._v("Positions")]
          ),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "positionShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n    Position " + _vm._s(_vm.$t("table.history")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var position_history_single_staticRenderFns = []
position_history_single_render._withStripped = true
var position_history_single_esExports = { render: position_history_single_render, staticRenderFns: position_history_single_staticRenderFns }
/* harmony default export */ var position_history_single_position_history_single = (position_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56777f84", position_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/position/position-history/position-history-single/position-history-single.vue
var position_history_single_disposed = false
function position_history_single_injectStyle (ssrContext) {
  if (position_history_single_disposed) return
  __webpack_require__("RMpR")
}
var position_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var position_history_single___vue_template_functional__ = false
/* styles */
var position_history_single___vue_styles__ = position_history_single_injectStyle
/* scopeId */
var position_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var position_history_single___vue_module_identifier__ = null
var position_history_single_Component = position_history_single_normalizeComponent(
  position_history_single,
  position_history_single_position_history_single,
  position_history_single___vue_template_functional__,
  position_history_single___vue_styles__,
  position_history_single___vue_scopeId__,
  position_history_single___vue_module_identifier__
)
position_history_single_Component.options.__file = "src/entities/position/position-history/position-history-single/position-history-single.vue"
if (position_history_single_Component.esModule && Object.keys(position_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56777f84", position_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-56777f84", position_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    position_history_single_disposed = true
  })
})()}

/* harmony default export */ var position_history_position_history_single_position_history_single = (position_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/position/position-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var position_show = ({
  name: 'app-position-show',

  props: {
    id: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/position/detail', this.id).catch(function () {
      return _this.$router.push({ name: 'positionList' });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/position/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/position/model',
    loading: 'entities/position/loading',
    hasRoleToDelete: "entities/position/hasRoleToDelete",
    hasRoleToUpdate: "entities/position/hasRoleToUpdate",
    hasRoleToRead: "entities/position/hasRoleToRead",
    hasRoleToReadLogs: "entities/position/hasRoleToReadLogs",
    hasRoleToCreate: "entities/position/hasRoleToCreate",
    isMobile: "shared/isMobile",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  })),

  methods: {
    edit: function edit() {
      this.$router.push({
        name: 'positionEdit',
        params: { id: this.id, previous: 'show' }
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this2.$store.dispatch('entities/position/destroy', _this2.id);
      }).then(function () {
        return _this2.$router.push({ name: 'positionList' });
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({
        name: 'positionHistorySingle',
        params: { id: this.id }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7188da2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/position/position-show.vue
var position_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "positionList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.position.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("entities.position.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var position_show_staticRenderFns = []
position_show_render._withStripped = true
var position_show_esExports = { render: position_show_render, staticRenderFns: position_show_staticRenderFns }
/* harmony default export */ var position_position_show = (position_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7188da2", position_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/position/position-show.vue
var position_show_disposed = false
function position_show_injectStyle (ssrContext) {
  if (position_show_disposed) return
  __webpack_require__("4S/0")
}
var position_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var position_show___vue_template_functional__ = false
/* styles */
var position_show___vue_styles__ = position_show_injectStyle
/* scopeId */
var position_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var position_show___vue_module_identifier__ = null
var position_show_Component = position_show_normalizeComponent(
  position_show,
  position_position_show,
  position_show___vue_template_functional__,
  position_show___vue_styles__,
  position_show___vue_scopeId__,
  position_show___vue_module_identifier__
)
position_show_Component.options.__file = "src/entities/position/position-show.vue"
if (position_show_Component.esModule && Object.keys(position_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c7188da2", position_show_Component.options)
  } else {
    hotAPI.reload("data-v-c7188da2", position_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    position_show_disposed = true
  })
})()}

/* harmony default export */ var entities_position_position_show = (position_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/position/position-routes.js







var position_routes_roles = auth_roles.values;

/* harmony default export */ var position_routes = ([{
  name: 'positionList',
  path: 'position',
  component: entities_position_position_list,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.activityViewer.id, position_routes_roles.entityViewer.id, position_routes_roles.entityEditor.id, position_routes_roles.positionViewer.id, position_routes_roles.positionEditor.id]
  }
}, {
  name: 'positionNew',
  path: 'position/new',
  component: entities_position_position_form,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.entityEditor.id, position_routes_roles.positionEditor.id]
  }
}, {
  name: 'positionEdit',
  path: 'position/:id/edit',
  component: entities_position_position_form,
  props: true,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.entityEditor.id, position_routes_roles.positionEditor.id]
  }
}, {
  name: 'positionHistorySingle',
  path: 'position/:id/history',
  component: position_history_position_history_single_position_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.activityViewer.id]
  }
}, {
  name: 'positionHistoryFull',
  path: 'position/history',
  component: position_history_position_history_full_position_history_full,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.activityViewer.id]
  }
}, {
  name: 'positionShow',
  path: 'position/:id',
  component: entities_position_position_show,
  props: true,
  meta: {
    auth: true,
    roles: [position_routes_roles.owner.id, position_routes_roles.activityViewer.id, position_routes_roles.entityViewer.id, position_routes_roles.entityEditor.id, position_routes_roles.positionViewer.id, position_routes_roles.positionEditor.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/position/position-module.js



var position_module_components = [];
var position_module_mixins = [];
var position_module_filters = [];
var position_module_directives = [];

/* harmony default export */ var position_module = ({
  components: position_module_components,
  mixins: position_module_mixins,
  filters: position_module_filters,
  directives: position_module_directives,
  routes: position_routes,
  store: position_store
});
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-full/coach-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var coach_history_full_service_SIZE = 10;

var KEY_COACH = 'coaches';
/* harmony default export */ var coach_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      console.log(lastmodified);

      firebase_init_db.ref("log").child("logs").child(KEY_COACH).orderByChild("modified").endAt(lastmodified - 1).limitToLast(coach_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < coach_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-full/coach-history-full-store.js


/* harmony default export */ var coach_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return coach_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-single/coach-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var coach_history_single_service_KEY_COACH = 'coaches';

/* harmony default export */ var coach_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(coach_history_single_service_KEY_COACH).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-single/coach-history-single-store.js



/* harmony default export */ var coach_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return coach_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-model.js



/* harmony default export */ var coach_model = ({
  default: function _default() {
    return {
      id: null,
      picture: {
        name: "",
        size: 0,
        url: ""
      }
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : ''
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  },
  forTeam: function forTeam(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : '',
      birthdate: data.birthdate ? data.birthdate : '',
      email: data.email ? data.email : '',
      picture: data.picture ? file_model.toDatabaseFile(data.picture) : {
        name: "",
        size: 0,
        url: ""
      },
      dni: data.dni ? data.dni : '',
      phone: data.phone ? data.phone : ''
    };
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-service.js


/* eslint-disable */




 // birthdate
 // export pdf
 // export pdf
 // export pdf

var coach_service_KEY_COACH = 'coaches';
var KEY_COACHES = 'coaches';
var coach_service_KEY_TEAMS = 'teams';
var coach_service_NAME_ENTITY = 'coach';
var coach_service_KEY_CLUBS = 'clubs';

/* harmony default export */ var coach_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_COACHES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByTeamId: function listByTeamId(teamId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(coach_service_KEY_TEAMS).child(teamId).child(KEY_COACHES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByTeam: function listByTeam(modelTeam) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(coach_service_KEY_TEAMS).child(modelTeam.id).child(KEY_COACHES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelCoach = extends_default()({}, childSnapshot.val(), {
            team: modelTeam
          });
          list.push(modelCoach);
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      // eslint-disable-next-line
      firebase_init_db.ref(KEY_COACHES).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        // Si no tiene picture
        if (model.picture.name === "") {
          resolve(model);
        }

        file_service.fillDownloadURL(KEY_COACHES, model.id, 'picture', model.picture).then(function () {
          resolve(model);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + model.id] = null;
      updates['/' + KEY_COACHES + '/' + model.id] = null;
      updates['/' + coach_service_KEY_CLUBS + '/' + model.team.club.id + '/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + model.id] = null;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data deleted successfully!
          file_service.delete(KEY_COACHES, model.id, 'picture', model.picture).then(function () {
            // Logs 
            entity_logger.log(modelToDestroy, "deleted", KEY_COACHES, coach_service_NAME_ENTITY);
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadB64Img(KEY_COACHES, modelToUpdate.id, 'picture', modelToUpdate.picture).then(function () {
        var updates = {};
        updates['/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + model.id] = coach_model.forTeam(modelToUpdate);
        updates['/' + KEY_COACHES + '/' + model.id] = coach_model.forUpdate(modelToUpdate);
        updates['/' + coach_service_KEY_CLUBS + '/' + model.team.club.id + '/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + model.id] = coach_model.forTeam(modelToUpdate);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToUpdate, "modified", KEY_COACHES, coach_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model, loggedUser) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_COACHES).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });
    console.log("<--- CREATE PLAYER");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {

      file_service.uploadB64Img(KEY_COACHES, modelToSave.id, 'picture', modelToSave.picture).then(function () {
        var updates = {};
        updates['/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + modelToSave.id] = coach_model.forTeam(modelToSave);
        updates['/' + KEY_COACHES + '/' + modelToSave.id] = coach_model.forCreate(modelToSave);
        updates['/' + coach_service_KEY_CLUBS + '/' + model.team.club.id + '/' + coach_service_KEY_TEAMS + '/' + model.team.id + '/' + KEY_COACHES + '/' + modelToSave.id] = coach_model.forTeam(modelToSave);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToSave, "created", KEY_COACHES, coach_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  exportAsPDF: function exportAsPDF(list) {
    return new promise_default.a(function (resolve, reject) {
      /**
       * COACHES PARSING
       */

      var coachDataList = [];
      var coachHeaderList = [['Nombre', 'Apellidos', 'Teléfono', 'Equipo', 'Categoría']];

      // Coaches
      var listMapped = underscore_default.a.map(list, function (item) {
        return extends_default()({}, item, { teamName: item.team.name });
      });

      // Oredenar por nombre del equipo
      underscore_default.a.each(underscore_default.a.sortBy(listMapped, 'teamName'), function (coach, key, list) {

        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name, coach.lastName, coach.phone, coach.team.name, coach.team.category.label];
        coachDataList.push(values);
      });

      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jspdf_min();
      var docName = 'Entrenadores_' + moment_default()().format('DD-MM-YYYY') + '.pdf';
      var docTitle = "Entrenadores ";

      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function () {
        // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 155, 12, 40, 20);

      // Coaches data
      //  Labels
      doc.text("Fecha:", 14, 35);
      doc.text("Nº de entrenadores:", 14, 40);

      doc.text(moment_default()().format('DD/MM/YYYY'), 60, 35);
      doc.text('' + underscore_default.a.size(list), 60, 40);

      // Coaches
      doc.setFontSize(14);
      // doc.text("Entrenadores", 14,  60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList, startY: 65, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });

      doc.save(docName);
      resolve();
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_COACHES).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;

          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-import/coach-import-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */



/* harmony default export */ var coach_import_service = ({
  createAllPlayers: function createAllPlayers(playerList, loggedUser) {

    return new promise_default.a(function (resolve, reject) {

      var count = 0;
      playerList.forEach(function (player) {

        coach_service.save(player, loggedUser).then(function () {
          if (count == playerList.length - 1) {
            resolve();
          }
          count = count + 1;
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-import/coach-import-store.js

/* eslint-disable */

 // Internationalization

/* harmony default export */ var coach_import_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    team: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    team: function team(state) {
      return state.team;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    TEAM: function TEAM(state, payload) {
      state.team = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.team = null;
    }
  },

  actions: {
    setup: function setup(_ref, modelTeam) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      console.log("<--- SETUP PLAYER IMPORT");
      console.log(modelTeam);

      if (modelTeam !== null) {
        commit('LOADING', false);
        commit('TEAM', modelTeam);
        return promise_default.a.resolve();
      } else {
        commit('LOADING', false);
        var error = new Error('Equipo no existe.');
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      }
    },
    createAllPlayers: function createAllPlayers(_ref2, playerList) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters;

      //commit('LOADING', true);
      console.log("<-- CREATE ALL PLAYERS");
      console.log(playerList);

      coach_import_service.createAllPlayers(playerList, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.player.plural') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
      // .catch((error) => {
      //   commit('LOADING', false);
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-pager.js


/* harmony default export */ var coach_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'lastName', 'namePublic', 'team.name', 'team.category.label'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'dni', label: 'DNI/NIE/PASAPORTE' }, { value: 'email', label: 'Email' }, { value: 'dorsal', label: 'Dorsal' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/coach/coach-store.js




/* eslint-disable */

 // Internationalization


 // NEW!!







/* harmony default export */ var coach_store = ({
  namespaced: true,

  modules: {
    historyFull: coach_history_full_store,
    historySingle: coach_history_single_store,
    import: coach_import_store // NEW!!
  },

  state: {
    loading: false,
    list: [],
    pager: coach_pager.build(),
    model: coach_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.coachEditor.id, roles.clubManager.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.coachEditor.id, roles.clubManager.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.coachViewer.id, roles.coachEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.coachEditor.id, roles.clubManager.id]);
    },
    isClubManager: function isClubManager(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.clubManager.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || coach_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = coach_pager.build();
      state.model = coach_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return coach_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters;

      var team = rootGetters['entities/team/model'];
      var model = { team: team_model.forSimple(team), dorsal: "", picture: { name: "", size: 0, url: "" } };
      commit('MODEL', model);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return coach_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      var team = rootGetters['entities/team/model'];
      var model = getters.model;
      var modelToSave = model;

      if (team.id !== null) {
        modelToSave = extends_default()({}, model, { team: team_model.forSimple(team) });
      }

      return coach_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.coach.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref5, model) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);
      console.log("<---- STORE DESTROY PLAYER");

      var team = rootGetters['entities/team/model'];
      console.log("<---- STORE MODEL TEAM");
      console.log(team);
      console.log("<---- STORE MODEL PLAYER");
      console.log(model);

      var modelToDestroy = model;
      if (team.id !== null) {
        modelToDestroy = extends_default()({}, model, { team: team });
      }

      return coach_service.destroy(modelToDestroy, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.coach.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return coach_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByTeamId: function listByTeamId(_ref7, teamId) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return coach_service.listByTeamId(teamId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByTeam: function listByTeam(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootGetters = _ref8.rootGetters;

      commit('LIST', []);
      commit('LOADING', true);

      var team = rootGetters['entities/team/model'];
      var model = team_model.forSimple(team);

      if (team.id === null) {
        return promise_default.a.reject(new Error('Team not found'));
      }

      return coach_service.listByTeam(model).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    exportAsPDF: function exportAsPDF(_ref9) {
      var getters = _ref9.getters,
          commit = _ref9.commit,
          dispatch = _ref9.dispatch,
          rootGetters = _ref9.rootGetters;

      commit('LOADING', true);

      return coach_service.exportAsPDF(getters.list).then(function () {
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref10) {
      var commit = _ref10.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref11) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      position_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'positions', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      team_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'teams', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/coach/coach-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // birthdate

/* harmony default export */ var coach_form = ({
    name: "app-coach-form",

    components: {
        'my-upload': node_modules_vue_image_crop_upload_upload_2
    },

    props: {
        id: String,
        previous: String
    },

    data: function data() {
        return {
            title: "Entrenadores",
            titleEditCoach: "Editar entrenador",
            titleNewCoach: "Nuevo entrenador",
            breadcrumbLabels: {
                home: "Inicio",
                players: "Jugadores",
                edit: "Editar",
                new: "Nuevo"
            },
            show: false,
            imgDataUrl: '', // the datebase64 url of created image
            buttonLabels: {
                save: "Guardar",
                cancel: "Cancelar"
            },

            rules: {
                name: validators.string({
                    label: "Nombre",
                    required: true
                }),
                lastName: validators.string({
                    label: "Apellidos",
                    required: true
                }),
                dni: validators.string({
                    label: "Dni/Nie/Passaporte",
                    required: false
                }),
                team: validators.hasOne({
                    label: 'Team',
                    required: true
                }),
                email: validators.string({
                    label: "Email de contacto",
                    required: false
                }),
                phone: validators.string({
                    label: "Teléfono",
                    required: false
                })
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/coach/loadOptions");
        if (this.id) {
            this.$store.dispatch("entities/coach/edit", this.id).catch(function () {
                return _this.$router.push({ name: "coachList" });
            });
        } else {
            this.$store.dispatch("entities/coach/new");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/coach/clear");
        this.$store.dispatch("entities/team/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/coach/model",
        loading: "entities/coach/loading",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        isClubManager: "entities/coach/isClubManager",
        options: "entities/coach/options"
    }), {

        editing: function editing(state) {
            return !!state.id;
        }
    }),

    methods: {
        save: function save() {
            var _this2 = this;

            this.model.birthdate = moment_default()(this.model.birthdate).format('YYYY-MM-DD');

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                _this2.$store.dispatch("entities/coach/save").then(function () {
                    _this2.back();
                });
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        toggleShow: function toggleShow() {
            this.show = !this.show;
        },
        attachFileToModel: function attachFileToModel(imgDataUrl) {
            var data = imgDataUrl.slice(22, imgDataUrl.length);
            var picture = {
                name: "picture.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            };
            this.model.picture = picture;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f228cc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-form.vue
var coach_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.coach.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.coach.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.name"),
                            prop: "name"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.lastName"),
                            prop: "lastName"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.team.singular"),
                            prop: "team"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.teams == null,
                                      expression: "options.teams == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing || _vm.isClubManager,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.team,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "team", $$v)
                                    },
                                    expression: "model.team"
                                  }
                                },
                                [
                                  _vm.options.teams
                                    ? _vm._l(_vm.options.teams, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.picture")
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "coach-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.picture.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.picture.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus coach-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.attachFileToModel },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.dni"),
                            prop: "dni"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.dni,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dni", $$v)
                                  },
                                  expression: "model.dni"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.birthdate"),
                            prop: "birthdate"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  format: "dd-MM-yyyy",
                                  type: "date",
                                  placeholder: "Pick a day"
                                },
                                model: {
                                  value: _vm.model.birthdate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "birthdate", $$v)
                                  },
                                  expression: "model.birthdate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.email"),
                            prop: "email"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.coach.prop.phone"),
                            prop: "phone"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.save))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.cancel))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var coach_form_staticRenderFns = []
coach_form_render._withStripped = true
var coach_form_esExports = { render: coach_form_render, staticRenderFns: coach_form_staticRenderFns }
/* harmony default export */ var coach_coach_form = (coach_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f228cc0", coach_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/coach/coach-form.vue
var coach_form_disposed = false
function coach_form_injectStyle (ssrContext) {
  if (coach_form_disposed) return
  __webpack_require__("Fa30")
}
var coach_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var coach_form___vue_template_functional__ = false
/* styles */
var coach_form___vue_styles__ = coach_form_injectStyle
/* scopeId */
var coach_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var coach_form___vue_module_identifier__ = null
var coach_form_Component = coach_form_normalizeComponent(
  coach_form,
  coach_coach_form,
  coach_form___vue_template_functional__,
  coach_form___vue_styles__,
  coach_form___vue_scopeId__,
  coach_form___vue_module_identifier__
)
coach_form_Component.options.__file = "src/entities/coach/coach-form.vue"
if (coach_form_Component.esModule && Object.keys(coach_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f228cc0", coach_form_Component.options)
  } else {
    hotAPI.reload("data-v-1f228cc0", coach_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    coach_form_disposed = true
  })
})()}

/* harmony default export */ var entities_coach_coach_form = (coach_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/coach/coach-history/coach-history-full/coach-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var coach_history_full = ({
  name: 'app-coach-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/coach/historyFull/loading',
    list: 'entities/coach/historyFull/list',
    last: 'entities/coach/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/coach/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/coach/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/coach/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76d25228","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-history/coach-history-full/coach-history-full.vue
var coach_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "coachList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.coach.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.coach.plural")) + " history ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dni", label: "DNI/NIE/PASAPORTE" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var coach_history_full_staticRenderFns = []
coach_history_full_render._withStripped = true
var coach_history_full_esExports = { render: coach_history_full_render, staticRenderFns: coach_history_full_staticRenderFns }
/* harmony default export */ var coach_history_full_coach_history_full = (coach_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76d25228", coach_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-full/coach-history-full.vue
var coach_history_full_disposed = false
function coach_history_full_injectStyle (ssrContext) {
  if (coach_history_full_disposed) return
  __webpack_require__("o0ps")
}
var coach_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var coach_history_full___vue_template_functional__ = false
/* styles */
var coach_history_full___vue_styles__ = coach_history_full_injectStyle
/* scopeId */
var coach_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var coach_history_full___vue_module_identifier__ = null
var coach_history_full_Component = coach_history_full_normalizeComponent(
  coach_history_full,
  coach_history_full_coach_history_full,
  coach_history_full___vue_template_functional__,
  coach_history_full___vue_styles__,
  coach_history_full___vue_scopeId__,
  coach_history_full___vue_module_identifier__
)
coach_history_full_Component.options.__file = "src/entities/coach/coach-history/coach-history-full/coach-history-full.vue"
if (coach_history_full_Component.esModule && Object.keys(coach_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-76d25228", coach_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-76d25228", coach_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    coach_history_full_disposed = true
  })
})()}

/* harmony default export */ var coach_history_coach_history_full_coach_history_full = (coach_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/coach/coach-history/coach-history-single/coach-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var coach_history_single = ({
  name: 'app-coach-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/coach/historySingle/loading',
    list: 'entities/coach/historySingle/list',
    pager: 'entities/coach/historySingle/pager',
    model: 'entities/coach/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/coach/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/coach/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07187b70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-history/coach-history-single/coach-history-single.vue
var coach_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "coachList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.coach.plural")))
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "playerShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.id))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.coach.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "dni",
              label: "DNI/NIE/PASAPORTE",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "dorsal", label: "Dorsal", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "position", label: "Position" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.position ? scope.row.position.label : ""
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "namePublic",
              label: "Nombre deportivo",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var coach_history_single_staticRenderFns = []
coach_history_single_render._withStripped = true
var coach_history_single_esExports = { render: coach_history_single_render, staticRenderFns: coach_history_single_staticRenderFns }
/* harmony default export */ var coach_history_single_coach_history_single = (coach_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07187b70", coach_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/coach/coach-history/coach-history-single/coach-history-single.vue
var coach_history_single_disposed = false
function coach_history_single_injectStyle (ssrContext) {
  if (coach_history_single_disposed) return
  __webpack_require__("wYKH")
}
var coach_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var coach_history_single___vue_template_functional__ = false
/* styles */
var coach_history_single___vue_styles__ = coach_history_single_injectStyle
/* scopeId */
var coach_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var coach_history_single___vue_module_identifier__ = null
var coach_history_single_Component = coach_history_single_normalizeComponent(
  coach_history_single,
  coach_history_single_coach_history_single,
  coach_history_single___vue_template_functional__,
  coach_history_single___vue_styles__,
  coach_history_single___vue_scopeId__,
  coach_history_single___vue_module_identifier__
)
coach_history_single_Component.options.__file = "src/entities/coach/coach-history/coach-history-single/coach-history-single.vue"
if (coach_history_single_Component.esModule && Object.keys(coach_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-07187b70", coach_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-07187b70", coach_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    coach_history_single_disposed = true
  })
})()}

/* harmony default export */ var coach_history_coach_history_single_coach_history_single = (coach_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/coach/coach-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // birthdate
 // birthdate
/* eslint-disable */

/* harmony default export */ var coach_show = ({
    name: "app-coach-show",

    props: {
        id: String
    },

    data: function data() {
        return {
            labels: {
                name: "Nombre",
                lastName: "Apellidos",
                picture: "Foto",
                dni: "Dni/Nie/Pasaporte",
                email: "Email de contacto",
                dorsal: "Dorsal",
                phone: "Teléfono",
                position: "Posición",
                namePublic: "Nombre deportivo"
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/coach/detail", this.id).catch(function () {
            return _this.$router.push({ name: "coachList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/coach/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/coach/model",
        loading: "entities/coach/loading",
        hasRoleToDelete: "entities/coach/hasRoleToDelete",
        hasRoleToUpdate: "entities/coach/hasRoleToUpdate",
        hasRoleToRead: "entities/coach/hasRoleToRead",
        hasRoleToReadLogs: "entities/coach/hasRoleToReadLogs",
        hasRoleToCreate: "entities/coach/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "coachEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this2 = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this2.$store.dispatch("entities/coach/destroy", _this2.model);
            }).then(function () {
                return _this2.$router.go(-1);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "coachHistorySingle",
                params: { id: this.id }
            });
        },


        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            return moment_default()(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(js_cookie_default.a.get('language') || 'es').format('L');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ffe794e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/coach/coach-show.vue
var coach_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "coachList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.coach.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.id))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.coach.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.lastName")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.lastName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.dni")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dni))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.birthdate")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getDateFormat(_vm.model.birthdate))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.email")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.email))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.phone")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.phone))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.coach.prop.picture")
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.model.picture.url,
                                  width: "10%",
                                  height: "10%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Created at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Updated at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "page-title" }, [
                        _vm._v(_vm._s(_vm.$t("entities.team.singular")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.team.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.category")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.category.label))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var coach_show_staticRenderFns = []
coach_show_render._withStripped = true
var coach_show_esExports = { render: coach_show_render, staticRenderFns: coach_show_staticRenderFns }
/* harmony default export */ var coach_coach_show = (coach_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ffe794e", coach_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/coach/coach-show.vue
var coach_show_disposed = false
function coach_show_injectStyle (ssrContext) {
  if (coach_show_disposed) return
  __webpack_require__("6wlc")
}
var coach_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var coach_show___vue_template_functional__ = false
/* styles */
var coach_show___vue_styles__ = coach_show_injectStyle
/* scopeId */
var coach_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var coach_show___vue_module_identifier__ = null
var coach_show_Component = coach_show_normalizeComponent(
  coach_show,
  coach_coach_show,
  coach_show___vue_template_functional__,
  coach_show___vue_styles__,
  coach_show___vue_scopeId__,
  coach_show___vue_module_identifier__
)
coach_show_Component.options.__file = "src/entities/coach/coach-show.vue"
if (coach_show_Component.esModule && Object.keys(coach_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ffe794e", coach_show_Component.options)
  } else {
    hotAPI.reload("data-v-7ffe794e", coach_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    coach_show_disposed = true
  })
})()}

/* harmony default export */ var entities_coach_coach_show = (coach_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/coach/coach-routes.js







var coach_routes_roles = auth_roles.values;

/* harmony default export */ var coach_routes = ([{
  name: 'coachList',
  path: 'coach',
  component: entities_coach_coach_list,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.activityViewer.id, coach_routes_roles.entityViewer.id, coach_routes_roles.entityEditor.id, coach_routes_roles.coachViewer.id, coach_routes_roles.coachEditor.id]
  }
}, {
  name: 'coachNew',
  path: 'coach/new',
  component: entities_coach_coach_form,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.entityEditor.id, coach_routes_roles.coachEditor.id, coach_routes_roles.clubManager.id]
  }
}, {
  name: 'coachEdit',
  path: 'coach/:id/edit',
  component: entities_coach_coach_form,
  props: true,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.entityEditor.id, coach_routes_roles.coachEditor.id, coach_routes_roles.clubManager.id]
  }
}, {
  name: 'coachHistorySingle',
  path: 'coach/:id/history',
  component: coach_history_coach_history_single_coach_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.activityViewer.id]
  }
}, {
  name: 'coachHistoryFull',
  path: 'coach/history',
  component: coach_history_coach_history_full_coach_history_full,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.activityViewer.id]
  }
}, {
  name: 'coachShow',
  path: 'coach/:id',
  component: entities_coach_coach_show,
  props: true,
  meta: {
    auth: true,
    roles: [coach_routes_roles.owner.id, coach_routes_roles.activityViewer.id, coach_routes_roles.entityViewer.id, coach_routes_roles.entityEditor.id, coach_routes_roles.coachViewer.id, coach_routes_roles.coachEditor.id, coach_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/coach/coach-module.js



var coach_module_components = [];
var coach_module_mixins = [];
var coach_module_filters = [];
var coach_module_directives = [];

/* harmony default export */ var coach_module = ({
  components: coach_module_components,
  mixins: coach_module_mixins,
  filters: coach_module_filters,
  directives: coach_module_directives,
  routes: coach_routes,
  store: coach_store
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var team_manager_history_full_service_SIZE = 10;

var KEY_TEAM_MANAGERS = 'teamManagers';

/* harmony default export */ var team_manager_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      console.log(lastmodified);

      firebase_init_db.ref("log").child("logs").child(KEY_TEAM_MANAGERS).orderByChild("modified").endAt(lastmodified - 1).limitToLast(team_manager_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < team_manager_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full-store.js


/* harmony default export */ var team_manager_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return team_manager_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var KEY_TEAM_MANAGER = 'teamManagers';

/* harmony default export */ var team_manager_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(KEY_TEAM_MANAGER).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single-store.js



/* harmony default export */ var team_manager_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'dni', 'email', 'dorsal', 'phone', 'namePublic']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return team_manager_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-model.js



/* harmony default export */ var team_manager_model = ({
  default: function _default() {
    return {
      id: null,
      picture: {
        name: "",
        size: 0,
        url: ""
      }
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : ''
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  },
  forTeam: function forTeam(data) {
    return {
      id: data.id,
      name: data.name ? data.name : '',
      lastName: data.lastName ? data.lastName : '',
      birthdate: data.birthdate ? data.birthdate : '',
      email: data.email ? data.email : '',
      picture: data.picture ? file_model.toDatabaseFile(data.picture) : {
        name: "",
        size: 0,
        url: ""
      },
      dni: data.dni ? data.dni : '',
      phone: data.phone ? data.phone : ''
    };
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data, {
      picture: file_model.toDatabaseFile(data.picture)
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-pager.js


/* harmony default export */ var team_manager_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'lastName', 'team.name', 'team.category.label'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'dni', label: 'DNI/NIE/PASAPORTE' }, { value: 'email', label: 'Email' }, { value: 'dorsal', label: 'Dorsal' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-service.js


/* eslint-disable */




 // birthdate
 // export pdf
 // export pdf
 // export pdf

var team_manager_service_KEY_TEAM_MANAGERS = 'teamManagers';
var team_manager_service_KEY_TEAMS = 'teams';
var team_manager_service_NAME_ENTITY = 'team-manager';
var team_manager_service_KEY_CLUBS = 'clubs';

/* harmony default export */ var team_manager_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_manager_service_KEY_TEAM_MANAGERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  listByTeamId: function listByTeamId(teamId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_manager_service_KEY_TEAMS).child(teamId).child(team_manager_service_KEY_TEAM_MANAGERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      // eslint-disable-next-line
      firebase_init_db.ref(team_manager_service_KEY_TEAM_MANAGERS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        // Si no tiene picture
        if (model.picture.name === "") {
          resolve(model);
        }

        file_service.fillDownloadURL(team_manager_service_KEY_TEAM_MANAGERS, model.id, 'picture', model.picture).then(function () {
          resolve(model);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = null;
      updates['/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = null;
      updates['/' + team_manager_service_KEY_CLUBS + '/' + model.team.club.id + '/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = null;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data deleted successfully!
          file_service.delete(team_manager_service_KEY_TEAM_MANAGERS, model.id, 'picture', model.picture).then(function () {
            // Logs 
            entity_logger.log(modelToDestroy, "deleted", team_manager_service_KEY_TEAM_MANAGERS, team_manager_service_NAME_ENTITY);
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadB64Img(team_manager_service_KEY_TEAM_MANAGERS, modelToUpdate.id, 'picture', modelToUpdate.picture).then(function () {
        var updates = {};
        updates['/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = team_manager_model.forTeam(modelToUpdate);
        updates['/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = team_manager_model.forUpdate(modelToUpdate);
        updates['/' + team_manager_service_KEY_CLUBS + '/' + model.team.club.id + '/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + model.id] = team_manager_model.forTeam(modelToUpdate);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToUpdate, "modified", team_manager_service_KEY_TEAM_MANAGERS, team_manager_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model, loggedUser) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(team_manager_service_KEY_TEAM_MANAGERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });
    console.log("<--- CREATE PLAYER");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {

      file_service.uploadB64Img(team_manager_service_KEY_TEAM_MANAGERS, modelToSave.id, 'picture', modelToSave.picture).then(function () {
        var updates = {};
        updates['/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + modelToSave.id] = team_manager_model.forTeam(modelToSave);
        updates['/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + modelToSave.id] = team_manager_model.forCreate(modelToSave);
        updates['/' + team_manager_service_KEY_CLUBS + '/' + model.team.club.id + '/' + team_manager_service_KEY_TEAMS + '/' + model.team.id + '/' + team_manager_service_KEY_TEAM_MANAGERS + '/' + modelToSave.id] = team_manager_model.forTeam(modelToSave);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            // Logs
            entity_logger.log(modelToSave, "created", team_manager_service_KEY_TEAM_MANAGERS, team_manager_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  exportAsPDF: function exportAsPDF(list) {
    return new promise_default.a(function (resolve, reject) {
      /**
       * COACHES PARSING
       */

      var coachDataList = [];
      var coachHeaderList = [['Nombre', 'Apellidos', 'Teléfono', 'Equipo', 'Categoría']];

      // Coaches
      var listMapped = underscore_default.a.map(list, function (item) {
        return extends_default()({}, item, { teamName: item.team.name });
      });

      // Oredenar por nombre del equipo
      underscore_default.a.each(underscore_default.a.sortBy(listMapped, 'teamName'), function (coach, key, list) {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name, coach.lastName, coach.phone, coach.team.name, coach.team.category.label];
        coachDataList.push(values);
      });

      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jspdf_min();
      var docName = 'Delegadore_De_Equipo_' + moment_default()().format('DD-MM-YYYY') + '.pdf';
      var docTitle = "Delegados de equipo ";

      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function () {
        // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 155, 12, 40, 20);

      // Coaches data
      //  Labels
      doc.text("Fecha:", 14, 35);
      doc.text("Nº de delegados:", 14, 40);

      doc.text(moment_default()().format('DD/MM/YYYY'), 60, 35);
      doc.text('' + underscore_default.a.size(list), 60, 40);

      // Coaches
      doc.setFontSize(14);
      // doc.text("Entrenadores", 14,  60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList, startY: 65, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });

      doc.save(docName);
      resolve();
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(team_manager_service_KEY_TEAM_MANAGERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;

          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-store.js




/* eslint-disable */

 // Internationalization









/* harmony default export */ var team_manager_store = ({
  namespaced: true,

  modules: {
    historyFull: team_manager_history_full_store,
    historySingle: team_manager_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: team_manager_pager.build(),
    model: team_manager_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamManagerEditor.id, roles.clubManager.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamManagerEditor.id, roles.clubManager.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.teamManagerViewer.id, roles.teamManagerEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.teamManagerEditor.id, roles.clubManager.id]);
    },
    isClubManager: function isClubManager(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.clubManager.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || team_manager_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = team_manager_pager.build();
      state.model = team_manager_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return team_manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          rootGetters = _ref2.rootGetters;

      var team = rootGetters['entities/team/model'];
      var model = { team: team_model.forSimple(team), dorsal: "", picture: { name: "", size: 0, url: "" } };
      commit('MODEL', model);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return team_manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      var team = rootGetters['entities/team/model'];
      var model = getters.model;
      var modelToSave = model;

      if (team.id !== null) {
        modelToSave = extends_default()({}, model, { team: team_model.forSimple(team) });
      }

      return team_manager_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.teamManager.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref5, model) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);
      console.log("<---- STORE DESTROY PLAYER");

      var team = rootGetters['entities/team/model'];
      console.log("<---- STORE MODEL TEAM");
      console.log(team);
      console.log("<---- STORE MODEL PLAYER");
      console.log(model);

      var modelToDestroy = model;
      if (team.id !== null) {
        modelToDestroy = extends_default()({}, model, { team: team });
      }

      return team_manager_service.destroy(modelToDestroy, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.teamManager.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return team_manager_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByTeamId: function listByTeamId(_ref7, teamId) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return team_manager_service.listByTeamId(teamId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    exportAsPDF: function exportAsPDF(_ref8) {
      var getters = _ref8.getters,
          commit = _ref8.commit,
          dispatch = _ref8.dispatch,
          rootGetters = _ref8.rootGetters;

      commit('LOADING', true);

      return team_manager_service.exportAsPDF(getters.list).then(function () {
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref9) {
      var commit = _ref9.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref10) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      position_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'positions', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      team_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'teams', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team-manager/team-manager-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // birthdate

/* harmony default export */ var team_manager_form = ({
    name: "app-team-manager-form",

    components: {
        'my-upload': node_modules_vue_image_crop_upload_upload_2
    },

    props: {
        id: String,
        previous: String
    },

    data: function data() {
        return {
            title: "Delegados",
            titleEditCoach: "Editar delegados",
            titleNewCoach: "Nuevo delegado",
            breadcrumbLabels: {
                home: "Inicio",
                players: "Jugadores",
                edit: "Editar",
                new: "Nuevo"
            },
            show: false,
            imgDataUrl: '', // the datebase64 url of created image
            buttonLabels: {
                save: "Guardar",
                cancel: "Cancelar"
            },

            rules: {
                name: validators.string({
                    label: "Nombre",
                    required: true
                }),
                lastName: validators.string({
                    label: "Apellidos",
                    required: true
                }),
                dni: validators.string({
                    label: "Dni/Nie/Passaporte",
                    required: false
                }),
                team: validators.hasOne({
                    label: 'Team',
                    required: true
                }),
                email: validators.string({
                    label: "Email de contacto",
                    required: false
                }),
                phone: validators.string({
                    label: "Teléfono",
                    required: false
                })
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/team-manager/loadOptions");
        if (this.id) {
            this.$store.dispatch("entities/team-manager/edit", this.id).catch(function () {
                return _this.$router.push({ name: "coachList" });
            });
        } else {
            this.$store.dispatch("entities/team-manager/new");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/team-manager/clear");
        this.$store.dispatch("entities/team/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/team-manager/model",
        loading: "entities/team-manager/loading",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        isClubManager: "entities/team-manager/isClubManager",
        options: "entities/team-manager/options"
    }), {

        editing: function editing(state) {
            return !!state.id;
        }
    }),

    methods: {
        save: function save() {
            var _this2 = this;

            this.model.birthdate = moment_default()(this.model.birthdate).format('YYYY-MM-DD');

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                _this2.$store.dispatch("entities/team-manager/save").then(function () {
                    _this2.back();
                });
            });
        },
        back: function back() {
            this.$router.go(-1);
        },
        toggleShow: function toggleShow() {
            this.show = !this.show;
        },
        attachFileToModel: function attachFileToModel(imgDataUrl) {
            var data = imgDataUrl.slice(22, imgDataUrl.length);
            var picture = {
                name: "picture.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            };
            this.model.picture = picture;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-366925f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team-manager/team-manager-form.vue
var team_manager_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.teamManager.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.teamManager.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.name"),
                            prop: "name"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.lastName"),
                            prop: "lastName"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.team.singular"),
                            prop: "team"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.options.teams == null,
                                      expression: "options.teams == null"
                                    }
                                  ],
                                  attrs: {
                                    filterable: "",
                                    disabled: _vm.editing || _vm.isClubManager,
                                    "value-key": "id"
                                  },
                                  model: {
                                    value: _vm.model.team,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "team", $$v)
                                    },
                                    expression: "model.team"
                                  }
                                },
                                [
                                  _vm.options.teams
                                    ? _vm._l(_vm.options.teams, function(
                                        option
                                      ) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.picture")
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "team-manager-uploader",
                                  on: { click: _vm.toggleShow }
                                },
                                [
                                  _vm.model.picture.url
                                    ? _c("img", {
                                        staticClass: "avatar",
                                        attrs: { src: _vm.model.picture.url }
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus team-manager-uploader-icon"
                                      })
                                ]
                              ),
                              _vm._v(" "),
                              _c("my-upload", {
                                attrs: {
                                  field: "img",
                                  width: 300,
                                  height: 300,
                                  langType: "es-MX",
                                  "img-format": "png"
                                },
                                on: { "crop-success": _vm.attachFileToModel },
                                model: {
                                  value: _vm.show,
                                  callback: function($$v) {
                                    _vm.show = $$v
                                  },
                                  expression: "show"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.dni"),
                            prop: "dni"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.dni,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "dni", $$v)
                                  },
                                  expression: "model.dni"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "entities.teamManager.prop.birthdate"
                            ),
                            prop: "birthdate"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  format: "dd-MM-yyyy",
                                  type: "date",
                                  placeholder: "Pick a day"
                                },
                                model: {
                                  value: _vm.model.birthdate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "birthdate", $$v)
                                  },
                                  expression: "model.birthdate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.email"),
                            prop: "email"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("entities.teamManager.prop.phone"),
                            prop: "phone"
                          }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.save))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonLabels.cancel))]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var team_manager_form_staticRenderFns = []
team_manager_form_render._withStripped = true
var team_manager_form_esExports = { render: team_manager_form_render, staticRenderFns: team_manager_form_staticRenderFns }
/* harmony default export */ var team_manager_team_manager_form = (team_manager_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-366925f6", team_manager_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-form.vue
var team_manager_form_disposed = false
function team_manager_form_injectStyle (ssrContext) {
  if (team_manager_form_disposed) return
  __webpack_require__("0PeL")
}
var team_manager_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_manager_form___vue_template_functional__ = false
/* styles */
var team_manager_form___vue_styles__ = team_manager_form_injectStyle
/* scopeId */
var team_manager_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_manager_form___vue_module_identifier__ = null
var team_manager_form_Component = team_manager_form_normalizeComponent(
  team_manager_form,
  team_manager_team_manager_form,
  team_manager_form___vue_template_functional__,
  team_manager_form___vue_styles__,
  team_manager_form___vue_scopeId__,
  team_manager_form___vue_module_identifier__
)
team_manager_form_Component.options.__file = "src/entities/team-manager/team-manager-form.vue"
if (team_manager_form_Component.esModule && Object.keys(team_manager_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-366925f6", team_manager_form_Component.options)
  } else {
    hotAPI.reload("data-v-366925f6", team_manager_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_manager_form_disposed = true
  })
})()}

/* harmony default export */ var entities_team_manager_team_manager_form = (team_manager_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var team_manager_history_full = ({
  name: 'app-team-manager-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team-manager/historyFull/loading',
    list: 'entities/team-manager/historyFull/list',
    last: 'entities/team-manager/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/team-manager/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team-manager/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/team-manager/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0fae038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full.vue
var team_manager_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "coachList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.teamManager.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.teamManager.plural")) + " history ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dni", label: "DNI/NIE/PASAPORTE" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var team_manager_history_full_staticRenderFns = []
team_manager_history_full_render._withStripped = true
var team_manager_history_full_esExports = { render: team_manager_history_full_render, staticRenderFns: team_manager_history_full_staticRenderFns }
/* harmony default export */ var team_manager_history_full_team_manager_history_full = (team_manager_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0fae038", team_manager_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full.vue
var team_manager_history_full_disposed = false
function team_manager_history_full_injectStyle (ssrContext) {
  if (team_manager_history_full_disposed) return
  __webpack_require__("yLTO")
}
var team_manager_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_manager_history_full___vue_template_functional__ = false
/* styles */
var team_manager_history_full___vue_styles__ = team_manager_history_full_injectStyle
/* scopeId */
var team_manager_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_manager_history_full___vue_module_identifier__ = null
var team_manager_history_full_Component = team_manager_history_full_normalizeComponent(
  team_manager_history_full,
  team_manager_history_full_team_manager_history_full,
  team_manager_history_full___vue_template_functional__,
  team_manager_history_full___vue_styles__,
  team_manager_history_full___vue_scopeId__,
  team_manager_history_full___vue_module_identifier__
)
team_manager_history_full_Component.options.__file = "src/entities/team-manager/team-manager-history/team-manager-history-full/team-manager-history-full.vue"
if (team_manager_history_full_Component.esModule && Object.keys(team_manager_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0fae038", team_manager_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-c0fae038", team_manager_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_manager_history_full_disposed = true
  })
})()}

/* harmony default export */ var team_manager_history_team_manager_history_full_team_manager_history_full = (team_manager_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var team_manager_history_single = ({
  name: 'app-team-manager-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team-manager/historySingle/loading',
    list: 'entities/team-manager/historySingle/list',
    pager: 'entities/team-manager/historySingle/pager',
    model: 'entities/team-manager/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/team-manager/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team-manager/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695f5a96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single.vue
var team_manager_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "coachList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.teamManager.plural")))
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: {
                      name: "teamManagerShow",
                      params: { id: _vm.model.id }
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.model.id))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.teamManager.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "dni",
              label: "DNI/NIE/PASAPORTE",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "dorsal", label: "Dorsal", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "position", label: "Position" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.position ? scope.row.position.label : ""
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "namePublic",
              label: "Nombre deportivo",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var team_manager_history_single_staticRenderFns = []
team_manager_history_single_render._withStripped = true
var team_manager_history_single_esExports = { render: team_manager_history_single_render, staticRenderFns: team_manager_history_single_staticRenderFns }
/* harmony default export */ var team_manager_history_single_team_manager_history_single = (team_manager_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-695f5a96", team_manager_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single.vue
var team_manager_history_single_disposed = false
function team_manager_history_single_injectStyle (ssrContext) {
  if (team_manager_history_single_disposed) return
  __webpack_require__("48eA")
}
var team_manager_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_manager_history_single___vue_template_functional__ = false
/* styles */
var team_manager_history_single___vue_styles__ = team_manager_history_single_injectStyle
/* scopeId */
var team_manager_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_manager_history_single___vue_module_identifier__ = null
var team_manager_history_single_Component = team_manager_history_single_normalizeComponent(
  team_manager_history_single,
  team_manager_history_single_team_manager_history_single,
  team_manager_history_single___vue_template_functional__,
  team_manager_history_single___vue_styles__,
  team_manager_history_single___vue_scopeId__,
  team_manager_history_single___vue_module_identifier__
)
team_manager_history_single_Component.options.__file = "src/entities/team-manager/team-manager-history/team-manager-history-single/team-manager-history-single.vue"
if (team_manager_history_single_Component.esModule && Object.keys(team_manager_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-695f5a96", team_manager_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-695f5a96", team_manager_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_manager_history_single_disposed = true
  })
})()}

/* harmony default export */ var team_manager_history_team_manager_history_single_team_manager_history_single = (team_manager_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/team-manager/team-manager-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


 // birthdate
 // birthdate
/* eslint-disable */

/* harmony default export */ var team_manager_show = ({
    name: "app-team-manager-show",

    props: {
        id: String
    },

    data: function data() {
        return {
            labels: {
                name: "Nombre",
                lastName: "Apellidos",
                picture: "Foto",
                dni: "Dni/Nie/Pasaporte",
                email: "Email de contacto",
                dorsal: "Dorsal",
                phone: "Teléfono",
                position: "Posición",
                namePublic: "Nombre deportivo"
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/team-manager/detail", this.id).catch(function () {
            return _this.$router.push({ name: "teamManagerList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/team-manager/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/team-manager/model",
        loading: "entities/team-manager/loading",
        hasRoleToDelete: "entities/team-manager/hasRoleToDelete",
        hasRoleToUpdate: "entities/team-manager/hasRoleToUpdate",
        hasRoleToRead: "entities/team-manager/hasRoleToRead",
        hasRoleToReadLogs: "entities/team-manager/hasRoleToReadLogs",
        hasRoleToCreate: "entities/team-manager/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "teamManagerEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this2 = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this2.$store.dispatch("entities/team-manager/destroy", _this2.model);
            }).then(function () {
                return _this2.$router.go(-1);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "teamManagerHistorySingle",
                params: { id: this.id }
            });
        },


        // Aux functions
        getDateFormat: function getDateFormat(dateString) {
            return moment_default()(dateString, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(js_cookie_default.a.get('language') || 'es').format('L');
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05fb2faf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/team-manager/team-manager-show.vue
var team_manager_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "teamManagerList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.teamManager.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.id))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.teamManager.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.teamManager.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "entities.teamManager.prop.lastName"
                                )
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.lastName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.teamManager.prop.dni")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.dni))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "entities.teamManager.prop.birthdate"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getDateFormat(_vm.model.birthdate))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.teamManager.prop.email")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.email))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.teamManager.prop.phone")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.phone))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "entities.teamManager.prop.picture"
                                )
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: _vm.model.picture.url,
                                  width: "10%",
                                  height: "10%"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Created at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "Updated at" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "grid-content bg-purple" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "page-title" }, [
                        _vm._v(_vm._s(_vm.$t("entities.team.singular")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.team.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.team.prop.category")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.team.category.label))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var team_manager_show_staticRenderFns = []
team_manager_show_render._withStripped = true
var team_manager_show_esExports = { render: team_manager_show_render, staticRenderFns: team_manager_show_staticRenderFns }
/* harmony default export */ var team_manager_team_manager_show = (team_manager_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05fb2faf", team_manager_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-show.vue
var team_manager_show_disposed = false
function team_manager_show_injectStyle (ssrContext) {
  if (team_manager_show_disposed) return
  __webpack_require__("j4uu")
}
var team_manager_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var team_manager_show___vue_template_functional__ = false
/* styles */
var team_manager_show___vue_styles__ = team_manager_show_injectStyle
/* scopeId */
var team_manager_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var team_manager_show___vue_module_identifier__ = null
var team_manager_show_Component = team_manager_show_normalizeComponent(
  team_manager_show,
  team_manager_team_manager_show,
  team_manager_show___vue_template_functional__,
  team_manager_show___vue_styles__,
  team_manager_show___vue_scopeId__,
  team_manager_show___vue_module_identifier__
)
team_manager_show_Component.options.__file = "src/entities/team-manager/team-manager-show.vue"
if (team_manager_show_Component.esModule && Object.keys(team_manager_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05fb2faf", team_manager_show_Component.options)
  } else {
    hotAPI.reload("data-v-05fb2faf", team_manager_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    team_manager_show_disposed = true
  })
})()}

/* harmony default export */ var entities_team_manager_team_manager_show = (team_manager_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-routes.js







var team_manager_routes_roles = auth_roles.values;

/* harmony default export */ var team_manager_routes = ([{
  name: 'teamManagerList',
  path: 'KteamManager',
  component: entities_team_manager_team_manager_list,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.activityViewer.id, team_manager_routes_roles.entityViewer.id, team_manager_routes_roles.entityEditor.id, team_manager_routes_roles.teamManagerViewer.id, team_manager_routes_roles.teamManagerEditor.id]
  }
}, {
  name: 'teamManagerNew',
  path: 'KteamManager/new',
  component: entities_team_manager_team_manager_form,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.entityEditor.id, team_manager_routes_roles.teamManagerEditor.id, team_manager_routes_roles.clubManager.id]
  }
}, {
  name: 'teamManagerEdit',
  path: 'KteamManager/:id/edit',
  component: entities_team_manager_team_manager_form,
  props: true,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.entityEditor.id, team_manager_routes_roles.teamManagerEditor.id, team_manager_routes_roles.clubManager.id]
  }
}, {
  name: 'teamManagerHistorySingle',
  path: 'KteamManager/:id/history',
  component: team_manager_history_team_manager_history_single_team_manager_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'teamManagerHistoryFull',
  path: 'KteamManager/history',
  component: team_manager_history_team_manager_history_full_team_manager_history_full,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'teamManagerShow',
  path: 'KteamManager/:id',
  component: entities_team_manager_team_manager_show,
  props: true,
  meta: {
    auth: true,
    roles: [team_manager_routes_roles.owner.id, team_manager_routes_roles.activityViewer.id, team_manager_routes_roles.entityViewer.id, team_manager_routes_roles.entityEditor.id, team_manager_routes_roles.teamManagerViewer.id, team_manager_routes_roles.teamManagerEditor.id, team_manager_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/team-manager/team-manager-module.js



var team_manager_module_components = [];
var team_manager_module_mixins = [];
var team_manager_module_filters = [];
var team_manager_module_directives = [];

/* harmony default export */ var team_manager_module = ({
  components: team_manager_module_components,
  mixins: team_manager_module_mixins,
  filters: team_manager_module_filters,
  directives: team_manager_module_directives,
  routes: team_manager_routes,
  store: team_manager_store
});
// CONCATENATED MODULE: ./src/entities/document/document-model.js



/* harmony default export */ var document_model = ({
  default: function _default() {
    return {
      id: null,
      name: '',
      attachments: []
    };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      attachments: file_model.toDatabase(data.attachments),

      name: data.name ? data.name : ''
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data, {
      // pictures: fileModel.toDatabase(data.pictures),
      attachments: file_model.toDatabase(data.attachments)
    });
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data, {
      // pictures: fileModel.toDatabase(data.pictures),
      attachments: file_model.toDatabase(data.attachments)
    });
  }
});
// CONCATENATED MODULE: ./src/entities/document/document-pager.js


/* harmony default export */ var document_pager = ({
  build: function build() {
    var keysToSearch = ['name'];

    var exportDefinitions = [
    // { value: 'id', label: 'id' },
    { value: 'name', label: 'name' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/document/document-service.js


/* eslint-disable */






var KEY_DOCUMENTS = 'documents';
var document_service_NAME_ENTITY = 'club';

/* harmony default export */ var document_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_DOCUMENTS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list.reverse());
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(KEY_DOCUMENTS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }

        file_service.fillDownloadURLs(KEY_DOCUMENTS, model, ['attachments'], model.attachments).then(function () {
          resolve(model);
        }).catch(function (error) {
          reject(error);
        });
      });
    });
  },


  /**
   * Elimina un club, solo en el caso de que el club no tenga equipos
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {

      var updates = {};
      updates['/' + KEY_DOCUMENTS + '/' + model.id] = null;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {

          // Data deleted successfully!
          file_service.deleteAll(KEY_DOCUMENTS, model, ['attachments'], model.attachments).then(function () {
            entity_logger.log(modelToDestroy, "deleted", KEY_DOCUMENTS, document_service_NAME_ENTITY);
            resolve();
          }).catch(function (error) {
            reject(error);
          });
        }
      });
    });
  },
  update: function update(model, loggedUser) {

    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadAll(KEY_DOCUMENTS, modelToUpdate, ['attachments'], modelToUpdate.attachments).then(function () {

        var updates = {};
        updates['/' + KEY_DOCUMENTS + '/' + modelToUpdate.id] = document_model.forUpdate(modelToUpdate);

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Logs
            entity_logger.log(modelToUpdate, "modified", KEY_DOCUMENTS, document_service_NAME_ENTITY);
            resolve();
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  create: function create(model, loggedUser) {
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(KEY_DOCUMENTS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      file_service.uploadAll(KEY_DOCUMENTS, modelToSave, ['attachments'], modelToSave.attachments).then(function () {
        firebase_init_db.ref(KEY_DOCUMENTS).child(modelToSave.id).set(document_model.forCreate(modelToSave), function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            entity_logger.log(modelToSave, "created", KEY_DOCUMENTS, document_service_NAME_ENTITY);
            resolve(modelToSave);
          }
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_DOCUMENTS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.name = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/document/document-store.js




 // Internationalization




/* eslint-disable */

/* harmony default export */ var document_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: document_pager.build(),
    model: document_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.documentEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.documentEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.documentViewer.id, roles.documentEditor.id, roles.clubManager.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.documentEditor.id]);
    },
    isClubManager: function isClubManager(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.clubManager.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || document_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = document_pager.build();
      state.model = document_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return document_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return document_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref4, document) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);
      // eslint-disable-next-line 
      var modelToSave = getters.model;

      if (document !== null) {
        modelToSave = document;
      }

      return document_service.save(modelToSave, rootGetters['auth/user']).then(function (modelSaved) {
        dispatch('shared/success', src_lang.t('entities.document.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
        return promise_default.a.resolve(modelSaved);
      });
    },
    destroy: function destroy(_ref5, document) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return document_service.destroy(document, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.document.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          rootGetters = _ref6.rootGetters;

      commit('LIST', []);
      commit('LOADING', true);

      return document_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      team_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'teams', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/document/document-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from "underscore"
/* eslint-disable */
/* harmony default export */ var document_form = ({
    name: "app-document-form",
    components: {
        'my-upload': node_modules_vue_image_crop_upload_upload_2
    },
    props: {
        id: String,
        previous: String
    },

    data: function data() {
        return {
            show: false,
            documentList: [],
            rules: {
                name: validators.string({
                    label: "Name",
                    required: true
                }),
                attachments: validators.hasOne({
                    label: "Document",
                    required: true
                })
            }
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/document/loadOptions");
        if (this.id) {
            this.$store.dispatch("entities/document/edit", this.id).catch(function () {
                return _this.$router.push({ name: "documentList" });
            });
        } else {
            this.$store.dispatch("entities/document/new");
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/document/model",
        loading: "entities/document/loading",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        options: "entities/document/options"
    }), {

        editing: function editing(state) {
            return !!state.id;
        }
    }),

    methods: {
        save: function save() {
            var _this2 = this;

            this.$refs.form.validate().then(function (valid) {
                if (!valid) {
                    return;
                }

                if (_this2.atachDocument()) {
                    _this2.$store.dispatch("entities/document/save", _this2.model).then(function (model) {
                        _this2.back();
                    });
                }
            });
        },
        back: function back() {
            if (this.previous === "show") {
                this.$router.push({
                    name: "documentShow",
                    params: { id: this.id }
                });
                return;
            }

            this.$router.push({ name: "documentList" });
        },
        atachDocument: function atachDocument() {
            this.model.attachments = this.$refs.attachments.data || [];

            console.log(this.model.attachments.length);

            if (this.model.attachments.length == 0) {
                console.log("false");

                return false;
            } else {
                console.log("true");

                return true;
            }
        },
        toggleShow: function toggleShow() {
            this.show = !this.show;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c6d2736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/document/document-form.vue
var document_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "documentList" } } },
                    [_vm._v("Documents")]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "documentShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.editing
                      ? _vm.$t("table.edit") + " Document"
                      : _vm.$t("table.add") + " Document"
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Documents", prop: "attachments" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("app-file-upload", {
                                ref: "attachments",
                                attrs: {
                                  stored: _vm.model.attachments,
                                  max: 1,
                                  size: 1000000,
                                  formats: ["pdf"]
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var document_form_staticRenderFns = []
document_form_render._withStripped = true
var document_form_esExports = { render: document_form_render, staticRenderFns: document_form_staticRenderFns }
/* harmony default export */ var document_document_form = (document_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c6d2736", document_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/document/document-form.vue
var document_form_disposed = false
function document_form_injectStyle (ssrContext) {
  if (document_form_disposed) return
  __webpack_require__("3m6p")
}
var document_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var document_form___vue_template_functional__ = false
/* styles */
var document_form___vue_styles__ = document_form_injectStyle
/* scopeId */
var document_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var document_form___vue_module_identifier__ = null
var document_form_Component = document_form_normalizeComponent(
  document_form,
  document_document_form,
  document_form___vue_template_functional__,
  document_form___vue_styles__,
  document_form___vue_scopeId__,
  document_form___vue_module_identifier__
)
document_form_Component.options.__file = "src/entities/document/document-form.vue"
if (document_form_Component.esModule && Object.keys(document_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c6d2736", document_form_Component.options)
  } else {
    hotAPI.reload("data-v-2c6d2736", document_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    document_form_disposed = true
  })
})()}

/* harmony default export */ var entities_document_document_form = (document_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/document/document-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ var document_list = ({
    name: "app-document-import",

    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/document/loading",
        list: "entities/document/list",
        pager: "entities/document/pager",
        hasRoleToDelete: "entities/document/hasRoleToDelete",
        hasRoleToUpdate: "entities/document/hasRoleToUpdate",
        hasRoleToRead: "entities/document/hasRoleToRead",
        hasRoleToReadLogs: "entities/document/hasRoleToReadLogs",
        hasRoleToCreate: "entities/document/hasRoleToCreate",
        isClubManager: "entities/document/isClubManager",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    filters: {
        capitalize: function capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        }
    },

    created: function created() {
        this.$store.dispatch("entities/document/list");
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        this.$store.dispatch("entities/document/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "documentNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "documentShow",
                    params: { id: row.id }
                });
            }
        },
        show: function show(id) {
            this.$router.push({
                name: "documentShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "documentEdit",
                params: { id: id }
            });
        },
        importCsv: function importCsv() {
            this.$router.push({
                name: "documentImportCsv"
            });
        },
        destroy: function destroy(model) {
            var _this = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this.$store.dispatch("entities/document/destroy", model);
            }).catch(function () {});
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60664e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/document/document-list.vue
var document_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(_vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("route.documents")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.document.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { attrs: { name: "documentImport" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no documents yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.document.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "attachments",
              label: _vm.$t("entities.document.singular")
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("app-file-link-list", {
                      attrs: { files: scope.row.attachments }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "modified",
                  label: _vm.$t("status.modifiedAt"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.modified))
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "created",
                  label: _vm.$t("status.created"),
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.created))
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.hasRoleToRead
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.details"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-search",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.show(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasRoleToDelete
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.delete"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy(scope.row)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var document_list_staticRenderFns = []
document_list_render._withStripped = true
var document_list_esExports = { render: document_list_render, staticRenderFns: document_list_staticRenderFns }
/* harmony default export */ var document_document_list = (document_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60664e10", document_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/document/document-list.vue
var document_list_disposed = false
function document_list_injectStyle (ssrContext) {
  if (document_list_disposed) return
  __webpack_require__("n6A1")
}
var document_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var document_list___vue_template_functional__ = false
/* styles */
var document_list___vue_styles__ = document_list_injectStyle
/* scopeId */
var document_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var document_list___vue_module_identifier__ = null
var document_list_Component = document_list_normalizeComponent(
  document_list,
  document_document_list,
  document_list___vue_template_functional__,
  document_list___vue_styles__,
  document_list___vue_scopeId__,
  document_list___vue_module_identifier__
)
document_list_Component.options.__file = "src/entities/document/document-list.vue"
if (document_list_Component.esModule && Object.keys(document_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-60664e10", document_list_Component.options)
  } else {
    hotAPI.reload("data-v-60664e10", document_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    document_list_disposed = true
  })
})()}

/* harmony default export */ var entities_document_document_list = (document_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/document/document-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable */

/* harmony default export */ var document_show = ({
    name: "app-document-show",

    props: {
        id: String
    },

    data: function data() {
        return {
            title: "Información del document",
            labels: {
                name: "Nombre document",
                emailManager: "Email de contacto",
                picture: "Escudo"
            },
            urlPdf: '',
            embedded: 'embedded=true'
        };
    },
    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/document/detail", this.id).then(function () {

            if (_this.model.attachments.length > 0) {
                _this.urlPdf = _this.model.attachments[0].url;
            }
        }).catch(function () {
            return _this.$router.push({ name: "documentList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/document/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/document/model",
        loading: "entities/document/loading",
        hasRoleToDelete: "entities/document/hasRoleToDelete",
        hasRoleToUpdate: "entities/document/hasRoleToUpdate",
        hasRoleToRead: "entities/document/hasRoleToRead",
        hasRoleToReadLogs: "entities/document/hasRoleToReadLogs",
        hasRoleToCreate: "entities/document/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "documentEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy(model) {
            var _this2 = this;

            //eslint-disable-next-line
            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: "warning"
            }).then(function () {
                return _this2.$store.dispatch("entities/document/destroy", model);
            }).then(function () {
                return _this2.$router.push({ name: "documentList" });
            }).catch(function () {});
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08019e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/document/document-show.vue
var document_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(_vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "documentList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.document.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.model.name))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c("app-file-link-list", {
                    attrs: { files: _vm.model.attachments }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row", [
                _c("embed", {
                  attrs: {
                    src: _vm.urlPdf,
                    height: "800px",
                    width: "100%",
                    type: "application/pdf"
                  }
                })
              ])
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var document_show_staticRenderFns = []
document_show_render._withStripped = true
var document_show_esExports = { render: document_show_render, staticRenderFns: document_show_staticRenderFns }
/* harmony default export */ var document_document_show = (document_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08019e22", document_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/document/document-show.vue
var document_show_disposed = false
function document_show_injectStyle (ssrContext) {
  if (document_show_disposed) return
  __webpack_require__("mPGO")
}
var document_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var document_show___vue_template_functional__ = false
/* styles */
var document_show___vue_styles__ = document_show_injectStyle
/* scopeId */
var document_show___vue_scopeId__ = "data-v-08019e22"
/* moduleIdentifier (server only) */
var document_show___vue_module_identifier__ = null
var document_show_Component = document_show_normalizeComponent(
  document_show,
  document_document_show,
  document_show___vue_template_functional__,
  document_show___vue_styles__,
  document_show___vue_scopeId__,
  document_show___vue_module_identifier__
)
document_show_Component.options.__file = "src/entities/document/document-show.vue"
if (document_show_Component.esModule && Object.keys(document_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-08019e22", document_show_Component.options)
  } else {
    hotAPI.reload("data-v-08019e22", document_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    document_show_disposed = true
  })
})()}

/* harmony default export */ var entities_document_document_show = (document_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/document/document-routes.js





var document_routes_roles = auth_roles.values;

/* harmony default export */ var document_routes = ([{
  name: 'documentList',
  path: 'document',
  component: entities_document_document_list,
  meta: {
    auth: true,
    roles: [document_routes_roles.owner.id, document_routes_roles.activityViewer.id, document_routes_roles.entityViewer.id, document_routes_roles.entityEditor.id, document_routes_roles.documentViewer.id, document_routes_roles.documentEditor.id, document_routes_roles.clubManager.id]
  }
}, {
  name: 'documentNew',
  path: 'document/new',
  component: entities_document_document_form,
  meta: {
    auth: true,
    roles: [document_routes_roles.owner.id, document_routes_roles.entityEditor.id, document_routes_roles.documentEditor.id]
  }
}, {
  name: 'documentEdit',
  path: 'document/:id/edit',
  component: entities_document_document_form,
  props: true,
  meta: {
    auth: true,
    roles: [document_routes_roles.owner.id, document_routes_roles.entityEditor.id, document_routes_roles.documentEditor.id]
  }
}, {
  name: 'documentShow',
  path: 'document/:id',
  component: entities_document_document_show,
  props: true,
  meta: {
    auth: true,
    roles: [document_routes_roles.owner.id, document_routes_roles.activityViewer.id, document_routes_roles.entityViewer.id, document_routes_roles.entityEditor.id, document_routes_roles.documentViewer.id, document_routes_roles.documentEditor.id, document_routes_roles.clubManager.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/document/document-module.js



var document_module_components = [];
var document_module_mixins = [];
var document_module_filters = [];
var document_module_directives = [];

/* harmony default export */ var document_module = ({
  components: document_module_components,
  mixins: document_module_mixins,
  filters: document_module_filters,
  directives: document_module_directives,
  routes: document_routes,
  store: document_store
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var KEY_FIELD_MANAGERS = "fieldManagers";

/* harmony default export */ var field_manager_history_full_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(KEY_FIELD_MANAGERS).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full-store.js


/* harmony default export */ var field_manager_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return field_manager_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var field_manager_history_single_service_KEY_FIELD_MANAGERS = "fieldManagers";
var field_manager_history_single_service_SIZE = 10;

/* harmony default export */ var field_manager_history_single_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(field_manager_history_single_service_KEY_FIELD_MANAGERS).orderByChild("modified").endAt(lastmodified - 1).limitToLast(field_manager_history_single_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < field_manager_history_single_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single-store.js



/* harmony default export */ var field_manager_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return field_manager_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-model.js


/* harmony default export */ var field_manager_model = ({
  default: function _default() {
    return {};
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-pager.js


/* harmony default export */ var field_manager_pager = ({
  build: function build() {
    var keysToSearch = ['name'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'email', label: 'Email' }, { value: 'phone', label: 'Phone' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-service.js







/* eslint-disable */
var field_manager_service_KEY_FIELD_MANAGERS = "fieldManagers";
var field_manager_service_NAME_ENTITY = 'field-manager';

/* harmony default export */ var field_manager_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy manager-model");
        }
        resolve(model);
      });
    });
  },
  findByEmail: function findByEmail(email) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).orderByChild("email").equalTo(email).once('value').then(function (snapshot) {
        var model = {};
        snapshot.forEach(function (it) {
          model = it.val();
        });

        if (!model == null || underscore_default.a.isEmpty(model)) {
          reject("User manager no exist");
        }

        resolve(model);
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- update");
    console.log(modelToUpdate);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).child(modelToUpdate.id).set(field_manager_model.forUpdate(modelToUpdate), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToUpdate, "modified", field_manager_service_KEY_FIELD_MANAGERS, field_manager_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  create: function create(model, loggedUser) {

    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- create");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).child(modelToSave.id).set(field_manager_model.forCreate(modelToSave), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", field_manager_service_KEY_FIELD_MANAGERS, field_manager_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(field_manager_service_KEY_FIELD_MANAGERS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-store.js




 // Internationalization







/* harmony default export */ var field_manager_store = ({
  namespaced: true,

  modules: {
    historyFull: field_manager_history_full_store,
    historySingle: field_manager_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: field_manager_pager.build(),
    model: field_manager_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.fieldManagerEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.fieldManagerEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.fieldManagerViewer.id, roles.fieldManagerEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.fieldManagerEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || field_manager_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = field_manager_pager.build();
      state.model = field_manager_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return field_manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return field_manager_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return field_manager_service.save(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.fieldManager.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return field_manager_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.fieldManager.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return field_manager_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      club_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'clubs', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/field-manager/field-manager-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var field_manager_form = ({
  name: 'app-fieldManager-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: false
        }),
        lastName: validators.string({
          label: 'LastName',
          required: false
        }),
        email: validators.string({
          label: 'Email',
          required: true
        }),
        phone: validators.string({
          label: 'Phone',
          required: false
        }),
        club: validators.hasOne({
          label: 'Club',
          required: false
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/fieldManager/loadOptions');

    if (this.id) {
      this.$store.dispatch('entities/fieldManager/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'fieldManagerList' });
      });
    } else {
      this.$store.dispatch('entities/fieldManager/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/fieldManager/model',
    loading: 'entities/fieldManager/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth",

    options: 'entities/fieldManager/options'
  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/fieldManager/save').then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'fieldManagerShow',
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: 'fieldManagerList' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a59b220","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-form.vue
var field_manager_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "fieldManagerList" } } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("entities.fieldManager.plural")) +
                          " "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "fieldManagerShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.fieldManager.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.fieldManager.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "LastName", prop: "lastName" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Phone", prop: "phone" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var field_manager_form_staticRenderFns = []
field_manager_form_render._withStripped = true
var field_manager_form_esExports = { render: field_manager_form_render, staticRenderFns: field_manager_form_staticRenderFns }
/* harmony default export */ var field_manager_field_manager_form = (field_manager_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a59b220", field_manager_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-form.vue
var field_manager_form_disposed = false
function field_manager_form_injectStyle (ssrContext) {
  if (field_manager_form_disposed) return
  __webpack_require__("ZqWO")
}
var field_manager_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var field_manager_form___vue_template_functional__ = false
/* styles */
var field_manager_form___vue_styles__ = field_manager_form_injectStyle
/* scopeId */
var field_manager_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var field_manager_form___vue_module_identifier__ = null
var field_manager_form_Component = field_manager_form_normalizeComponent(
  field_manager_form,
  field_manager_field_manager_form,
  field_manager_form___vue_template_functional__,
  field_manager_form___vue_styles__,
  field_manager_form___vue_scopeId__,
  field_manager_form___vue_module_identifier__
)
field_manager_form_Component.options.__file = "src/entities/field-manager/field-manager-form.vue"
if (field_manager_form_Component.esModule && Object.keys(field_manager_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1a59b220", field_manager_form_Component.options)
  } else {
    hotAPI.reload("data-v-1a59b220", field_manager_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    field_manager_form_disposed = true
  })
})()}

/* harmony default export */ var entities_field_manager_field_manager_form = (field_manager_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/field-manager/field-manager-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable */

/* harmony default export */ var field_manager_list = ({
  name: 'app-fieldManager-list',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/fieldManager/loading',
    list: 'entities/fieldManager/list',
    pager: 'entities/fieldManager/pager',
    hasRoleToDelete: "entities/fieldManager/hasRoleToDelete",
    hasRoleToUpdate: "entities/fieldManager/hasRoleToUpdate",
    hasRoleToRead: "entities/fieldManager/hasRoleToRead",
    hasRoleToReadLogs: "entities/fieldManager/hasRoleToReadLogs",
    hasRoleToCreate: "entities/fieldManager/hasRoleToCreate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/fieldManager/list');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/clear');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/fieldManager/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: 'fieldManagerNew'
      });
    },
    rowClick: function rowClick(row, column, cell, event) {
      if (cell.label !== this.$t("table.actions")) {
        this.$router.push({
          name: "fieldManagerShow",
          params: { id: row.id }
        });
      }
    },
    show: function show(id) {
      this.$router.push({
        name: 'fieldManagerShow',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'fieldManagerEdit',
        params: { id: id }
      });
    },
    destroy: function destroy(id) {
      var _this = this;

      this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
        confirmButtonText: this.$t("table.yes"),
        cancelButtonText: this.$t("table.no"),
        type: 'warning'
      }).then(function () {
        return _this.$store.dispatch('entities/fieldManager/destroy', id);
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({ name: 'fieldManagerHistoryFull' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e52d8fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-list.vue
var field_manager_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(" " + _vm._s(_vm.$t("entities.fieldManager.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.fieldManager.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list)
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no managers yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { size: "small", round: "" }
                          },
                          [_c("i", { staticClass: "el-icon-more" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-search",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.show(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.details")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToUpdate
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-pencil-square-o",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.edit(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.edit")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToDelete
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-trash",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.destroy(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.delete")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var field_manager_list_staticRenderFns = []
field_manager_list_render._withStripped = true
var field_manager_list_esExports = { render: field_manager_list_render, staticRenderFns: field_manager_list_staticRenderFns }
/* harmony default export */ var field_manager_field_manager_list = (field_manager_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e52d8fa", field_manager_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-list.vue
var field_manager_list_disposed = false
function field_manager_list_injectStyle (ssrContext) {
  if (field_manager_list_disposed) return
  __webpack_require__("3Nxa")
}
var field_manager_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var field_manager_list___vue_template_functional__ = false
/* styles */
var field_manager_list___vue_styles__ = field_manager_list_injectStyle
/* scopeId */
var field_manager_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var field_manager_list___vue_module_identifier__ = null
var field_manager_list_Component = field_manager_list_normalizeComponent(
  field_manager_list,
  field_manager_field_manager_list,
  field_manager_list___vue_template_functional__,
  field_manager_list___vue_styles__,
  field_manager_list___vue_scopeId__,
  field_manager_list___vue_module_identifier__
)
field_manager_list_Component.options.__file = "src/entities/field-manager/field-manager-list.vue"
if (field_manager_list_Component.esModule && Object.keys(field_manager_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4e52d8fa", field_manager_list_Component.options)
  } else {
    hotAPI.reload("data-v-4e52d8fa", field_manager_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    field_manager_list_disposed = true
  })
})()}

/* harmony default export */ var entities_field_manager_field_manager_list = (field_manager_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var field_manager_history_full = ({
  name: 'app-manager-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/fieldManager/historyFull/loading',
    list: 'entities/fieldManager/historyFull/list',
    last: 'entities/fieldManager/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/fieldManager/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/fieldManager/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24b088b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full.vue
var field_manager_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "managerList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.fieldManager.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(
          " " + _vm._s(_vm.$t("entities.fieldManager.plural")) + " history"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "Phone" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "club", label: "Club" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.club ? scope.row.club.name : "") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var field_manager_history_full_staticRenderFns = []
field_manager_history_full_render._withStripped = true
var field_manager_history_full_esExports = { render: field_manager_history_full_render, staticRenderFns: field_manager_history_full_staticRenderFns }
/* harmony default export */ var field_manager_history_full_field_manager_history_full = (field_manager_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24b088b0", field_manager_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full.vue
var field_manager_history_full_disposed = false
function field_manager_history_full_injectStyle (ssrContext) {
  if (field_manager_history_full_disposed) return
  __webpack_require__("Wode")
}
var field_manager_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var field_manager_history_full___vue_template_functional__ = false
/* styles */
var field_manager_history_full___vue_styles__ = field_manager_history_full_injectStyle
/* scopeId */
var field_manager_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var field_manager_history_full___vue_module_identifier__ = null
var field_manager_history_full_Component = field_manager_history_full_normalizeComponent(
  field_manager_history_full,
  field_manager_history_full_field_manager_history_full,
  field_manager_history_full___vue_template_functional__,
  field_manager_history_full___vue_styles__,
  field_manager_history_full___vue_scopeId__,
  field_manager_history_full___vue_module_identifier__
)
field_manager_history_full_Component.options.__file = "src/entities/field-manager/field-manager-history/field-manager-history-full/field-manager-history-full.vue"
if (field_manager_history_full_Component.esModule && Object.keys(field_manager_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24b088b0", field_manager_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-24b088b0", field_manager_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    field_manager_history_full_disposed = true
  })
})()}

/* harmony default export */ var field_manager_history_field_manager_history_full_field_manager_history_full = (field_manager_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var field_manager_history_single = ({
  name: 'app-manager-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/fieldManager/historySingle/loading',
    list: 'entities/fieldManager/historySingle/list',
    pager: 'entities/fieldManager/historySingle/pager',
    model: 'entities/fieldManager/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/fieldManager/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da6c4c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single.vue
var field_manager_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "managerList" } } }, [
            _vm._v("Managers")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "managerShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n    Manager " + _vm._s(_vm.$t("table.history")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.club ? scope.row.club.name : "") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var field_manager_history_single_staticRenderFns = []
field_manager_history_single_render._withStripped = true
var field_manager_history_single_esExports = { render: field_manager_history_single_render, staticRenderFns: field_manager_history_single_staticRenderFns }
/* harmony default export */ var field_manager_history_single_field_manager_history_single = (field_manager_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7da6c4c8", field_manager_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single.vue
var field_manager_history_single_disposed = false
function field_manager_history_single_injectStyle (ssrContext) {
  if (field_manager_history_single_disposed) return
  __webpack_require__("byeV")
}
var field_manager_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var field_manager_history_single___vue_template_functional__ = false
/* styles */
var field_manager_history_single___vue_styles__ = field_manager_history_single_injectStyle
/* scopeId */
var field_manager_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var field_manager_history_single___vue_module_identifier__ = null
var field_manager_history_single_Component = field_manager_history_single_normalizeComponent(
  field_manager_history_single,
  field_manager_history_single_field_manager_history_single,
  field_manager_history_single___vue_template_functional__,
  field_manager_history_single___vue_styles__,
  field_manager_history_single___vue_scopeId__,
  field_manager_history_single___vue_module_identifier__
)
field_manager_history_single_Component.options.__file = "src/entities/field-manager/field-manager-history/field-manager-history-single/field-manager-history-single.vue"
if (field_manager_history_single_Component.esModule && Object.keys(field_manager_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7da6c4c8", field_manager_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-7da6c4c8", field_manager_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    field_manager_history_single_disposed = true
  })
})()}

/* harmony default export */ var field_manager_history_field_manager_history_single_field_manager_history_single = (field_manager_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/field-manager/field-manager-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var field_manager_show = ({
  name: 'app-manager-show',

  props: {
    id: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/fieldManager/detail', this.id).catch(function () {
      return _this.$router.push({ name: 'fieldManagerList' });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/fieldManager/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/fieldManager/model',
    loading: 'entities/fieldManager/loading',
    hasRoleToDelete: "entities/fieldManager/hasRoleToDelete",
    hasRoleToUpdate: "entities/fieldManager/hasRoleToUpdate",
    hasRoleToRead: "entities/fieldManager/hasRoleToRead",
    hasRoleToReadLogs: "entities/fieldManager/hasRoleToReadLogs",
    hasRoleToCreate: "entities/fieldManager/hasRoleToCreate",
    isMobile: "shared/isMobile",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  })),

  methods: {
    edit: function edit() {
      this.$router.push({
        name: 'managerEdit',
        params: { id: this.id, previous: 'show' }
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this2.$store.dispatch('entities/fieldManager/destroy', _this2.id);
      }).then(function () {
        return _this2.$router.push({ name: 'fieldManagerList' });
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({
        name: 'managerHistorySingle',
        params: { id: this.id }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c28884e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/field-manager/field-manager-show.vue
var field_manager_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "fieldManagerList" } } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("entities.fieldManager.plural"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n       " +
                    _vm._s(_vm.$t("entities.fieldManager.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "LastName" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.model.lastName) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Email" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.email) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Phone" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.phone) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var field_manager_show_staticRenderFns = []
field_manager_show_render._withStripped = true
var field_manager_show_esExports = { render: field_manager_show_render, staticRenderFns: field_manager_show_staticRenderFns }
/* harmony default export */ var field_manager_field_manager_show = (field_manager_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c28884e", field_manager_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-show.vue
var field_manager_show_disposed = false
function field_manager_show_injectStyle (ssrContext) {
  if (field_manager_show_disposed) return
  __webpack_require__("10i9")
}
var field_manager_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var field_manager_show___vue_template_functional__ = false
/* styles */
var field_manager_show___vue_styles__ = field_manager_show_injectStyle
/* scopeId */
var field_manager_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var field_manager_show___vue_module_identifier__ = null
var field_manager_show_Component = field_manager_show_normalizeComponent(
  field_manager_show,
  field_manager_field_manager_show,
  field_manager_show___vue_template_functional__,
  field_manager_show___vue_styles__,
  field_manager_show___vue_scopeId__,
  field_manager_show___vue_module_identifier__
)
field_manager_show_Component.options.__file = "src/entities/field-manager/field-manager-show.vue"
if (field_manager_show_Component.esModule && Object.keys(field_manager_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c28884e", field_manager_show_Component.options)
  } else {
    hotAPI.reload("data-v-2c28884e", field_manager_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    field_manager_show_disposed = true
  })
})()}

/* harmony default export */ var entities_field_manager_field_manager_show = (field_manager_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-routes.js







var field_manager_routes_roles = auth_roles.values;

/* harmony default export */ var field_manager_routes = ([{
  name: 'fieldManagerList',
  path: 'field-manager',
  component: entities_field_manager_field_manager_list,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.activityViewer.id, field_manager_routes_roles.entityViewer.id, field_manager_routes_roles.entityEditor.id, field_manager_routes_roles.managerViewer.id, field_manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'fieldManagerNew',
  path: 'field-manager/new',
  component: entities_field_manager_field_manager_form,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.entityEditor.id, field_manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'fieldManagerEdit',
  path: 'field-manager/:id/edit',
  component: entities_field_manager_field_manager_form,
  props: true,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.entityEditor.id, field_manager_routes_roles.managerEditor.id]
  }
}, {
  name: 'fieldManagerHistorySingle',
  path: 'field-manager/:id/history',
  component: field_manager_history_field_manager_history_single_field_manager_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'fieldManagerHistoryFull',
  path: 'field-manager/history',
  component: field_manager_history_field_manager_history_full_field_manager_history_full,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.activityViewer.id]
  }
}, {
  name: 'fieldManagerShow',
  path: 'field-manager/:id',
  component: entities_field_manager_field_manager_show,
  props: true,
  meta: {
    auth: true,
    roles: [field_manager_routes_roles.owner.id, field_manager_routes_roles.activityViewer.id, field_manager_routes_roles.entityViewer.id, field_manager_routes_roles.entityEditor.id, field_manager_routes_roles.managerViewer.id, field_manager_routes_roles.managerEditor.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/field-manager/field-manager-module.js



var field_manager_module_components = [];
var field_manager_module_mixins = [];
var field_manager_module_filters = [];
var field_manager_module_directives = [];

/* harmony default export */ var field_manager_module = ({
  components: field_manager_module_components,
  mixins: field_manager_module_mixins,
  filters: field_manager_module_filters,
  directives: field_manager_module_directives,
  routes: field_manager_routes,
  store: field_manager_store
});
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-full/referee-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var referee_history_full_service_SIZE = 10;
var KEY_REFEREE = "referees";

/* harmony default export */ var referee_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(KEY_REFEREE).orderByChild("modified").endAt(lastmodified - 1).limitToLast(referee_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < referee_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-full/referee-history-full-store.js


/* harmony default export */ var referee_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return referee_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-single/referee-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */

var referee_history_single_service_KEY_REFEREE = "referees";

/* harmony default export */ var referee_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(referee_history_single_service_KEY_REFEREE).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-single/referee-history-single-store.js



/* harmony default export */ var referee_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'lastName', 'email', 'phone']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return referee_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-model.js


/* harmony default export */ var referee_model = ({
  default: function _default() {
    return {};
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name,
      lastName: data.lastName,
      email: data.email,
      phone: data.phone
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-pager.js


/* harmony default export */ var referee_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'lastName'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'lastName', label: 'LastName' }, { value: 'email', label: 'Email' }, { value: 'phone', label: 'Phone' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-service.js






/* eslint-disable */
var referee_service_KEY_REFEREE = "referees";
var referee_service_NAME_ENTITY = 'refereee';

/* harmony default export */ var referee_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          reject("Empy refereee-model");
        }
        resolve(model);
      });
    });
  },
  findByEmail: function findByEmail(email) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).orderByChild("email").equalTo(email).once('value').then(function (snapshot) {
        var model = {};
        snapshot.forEach(function (it) {
          model = it.val();
        });

        if (!model == null || underscore_default.a.isEmpty(model)) {
          reject("User refereee no exist");
        }

        resolve(model);
      });
    });
  },
  destroy: function destroy(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).child(id).set(null, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          resolve();
        }
      });
    });
  },
  update: function update(model, loggedUser) {
    var modelToUpdate = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- update");
    console.log(modelToUpdate);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).child(modelToUpdate.id).set(referee_model.forUpdate(modelToUpdate), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToUpdate, "modified", referee_service_KEY_REFEREE, referee_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  create: function create(model, loggedUser) {

    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(referee_service_KEY_REFEREE).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    console.log("<--- create");
    console.log(modelToSave);

    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).child(modelToSave.id).set(referee_model.forCreate(modelToSave), function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", referee_service_KEY_REFEREE, referee_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(referee_service_KEY_REFEREE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.label = childSnapshot.val().name;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/referee/referee-store.js




 // Internationalization







/* harmony default export */ var referee_store = ({
  namespaced: true,

  modules: {
    historyFull: referee_history_full_store,
    historySingle: referee_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: referee_pager.build(),
    model: referee_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.refereeEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.refereeEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.refereeViewer.id, roles.refereeEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.refereeEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || referee_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = referee_pager.build();
      state.model = referee_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return referee_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return referee_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    save: function save(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return referee_service.save(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.referee.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroy: function destroy(_ref5, id) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          rootGetters = _ref5.rootGetters;

      commit('LOADING', true);

      return referee_service.destroy(id, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.referee.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).then(function () {
        return dispatch('list');
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref6) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return referee_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref7) {
      var commit = _ref7.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref8) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      club_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'clubs', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/referee/referee-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var referee_form = ({
  name: 'app-referee-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: false
        }),
        lastName: validators.string({
          label: 'LastName',
          required: false
        }),
        email: validators.string({
          label: 'Email',
          required: true
        }),
        phone: validators.string({
          label: 'Phone',
          required: false
        }),
        club: validators.hasOne({
          label: 'Club',
          required: false
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/referee/loadOptions');

    if (this.id) {
      this.$store.dispatch('entities/referee/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'refereeList' });
      });
    } else {
      this.$store.dispatch('entities/referee/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/referee/model',
    loading: 'entities/referee/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth",

    options: 'entities/referee/options'
  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/referee/save').then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === 'show') {
        this.$router.push({
          name: 'refereeShow',
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: 'refereeList' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125fe4d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/referee/referee-form.vue
var referee_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "refereeList" } } },
                    [_vm._v("Managers")]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "refereeShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") + " Manager"
                        : _vm.$t("table.add") + " Manager"
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "LastName", prop: "lastName" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lastName", $$v)
                                  },
                                  expression: "model.lastName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Phone", prop: "phone" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "phone", $$v)
                                  },
                                  expression: "model.phone"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var referee_form_staticRenderFns = []
referee_form_render._withStripped = true
var referee_form_esExports = { render: referee_form_render, staticRenderFns: referee_form_staticRenderFns }
/* harmony default export */ var referee_referee_form = (referee_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-125fe4d4", referee_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/referee/referee-form.vue
var referee_form_disposed = false
function referee_form_injectStyle (ssrContext) {
  if (referee_form_disposed) return
  __webpack_require__("AaQT")
}
var referee_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var referee_form___vue_template_functional__ = false
/* styles */
var referee_form___vue_styles__ = referee_form_injectStyle
/* scopeId */
var referee_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var referee_form___vue_module_identifier__ = null
var referee_form_Component = referee_form_normalizeComponent(
  referee_form,
  referee_referee_form,
  referee_form___vue_template_functional__,
  referee_form___vue_styles__,
  referee_form___vue_scopeId__,
  referee_form___vue_module_identifier__
)
referee_form_Component.options.__file = "src/entities/referee/referee-form.vue"
if (referee_form_Component.esModule && Object.keys(referee_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-125fe4d4", referee_form_Component.options)
  } else {
    hotAPI.reload("data-v-125fe4d4", referee_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    referee_form_disposed = true
  })
})()}

/* harmony default export */ var entities_referee_referee_form = (referee_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/referee/referee-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* eslint-disable */

/* harmony default export */ var referee_list = ({
  name: 'app-referee-list',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/referee/loading',
    list: 'entities/referee/list',
    pager: 'entities/referee/pager',
    hasRoleToDelete: "entities/referee/hasRoleToDelete",
    hasRoleToUpdate: "entities/referee/hasRoleToUpdate",
    hasRoleToRead: "entities/referee/hasRoleToRead",
    hasRoleToReadLogs: "entities/referee/hasRoleToReadLogs",
    hasRoleToCreate: "entities/referee/hasRoleToCreate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/referee/list');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/clear');
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("entities/referee/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: 'refereeNew'
      });
    },
    rowClick: function rowClick(row, column, cell, event) {
      if (cell.label !== this.$t("table.actions")) {
        this.$router.push({
          name: "refereeShow",
          params: { id: row.id }
        });
      }
    },
    show: function show(id) {
      this.$router.push({
        name: 'refereeShow',
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: 'refereeEdit',
        params: { id: id }
      });
    },
    destroy: function destroy(id) {
      var _this = this;

      this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
        confirmButtonText: this.$t("table.yes"),
        cancelButtonText: this.$t("table.no"),
        type: 'warning'
      }).then(function () {
        return _this.$store.dispatch('entities/referee/destroy', id);
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({ name: 'refereeHistoryFull' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46590bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/referee/referee-list.vue
var referee_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(_vm._s(_vm.$t("entities.referee.plural")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.referee.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("table.history")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list)
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n         " +
                          _vm._s(_vm.$t("table.export")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": "There are no referees yet",
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { size: "small", round: "" }
                          },
                          [_c("i", { staticClass: "el-icon-more" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-search",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.show(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.details")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToUpdate
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-pencil-square-o",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.edit(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.edit")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToDelete
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-trash",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.destroy(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.$t("table.delete")) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var referee_list_staticRenderFns = []
referee_list_render._withStripped = true
var referee_list_esExports = { render: referee_list_render, staticRenderFns: referee_list_staticRenderFns }
/* harmony default export */ var referee_referee_list = (referee_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46590bae", referee_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/referee/referee-list.vue
var referee_list_disposed = false
function referee_list_injectStyle (ssrContext) {
  if (referee_list_disposed) return
  __webpack_require__("tvNc")
}
var referee_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var referee_list___vue_template_functional__ = false
/* styles */
var referee_list___vue_styles__ = referee_list_injectStyle
/* scopeId */
var referee_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var referee_list___vue_module_identifier__ = null
var referee_list_Component = referee_list_normalizeComponent(
  referee_list,
  referee_referee_list,
  referee_list___vue_template_functional__,
  referee_list___vue_styles__,
  referee_list___vue_scopeId__,
  referee_list___vue_module_identifier__
)
referee_list_Component.options.__file = "src/entities/referee/referee-list.vue"
if (referee_list_Component.esModule && Object.keys(referee_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-46590bae", referee_list_Component.options)
  } else {
    hotAPI.reload("data-v-46590bae", referee_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    referee_list_disposed = true
  })
})()}

/* harmony default export */ var entities_referee_referee_list = (referee_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/referee/referee-history/referee-history-full/referee-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var referee_history_full = ({
  name: 'app-referee-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/referee/historyFull/loading',
    list: 'entities/referee/historyFull/list',
    last: 'entities/referee/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/referee/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/referee/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f9e9398","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/referee/referee-history/referee-history-full/referee-history-full.vue
var referee_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "refereeList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.referee.plural")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.referee.singular")) + " history")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "lastName", label: "LastName" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "Phone" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var referee_history_full_staticRenderFns = []
referee_history_full_render._withStripped = true
var referee_history_full_esExports = { render: referee_history_full_render, staticRenderFns: referee_history_full_staticRenderFns }
/* harmony default export */ var referee_history_full_referee_history_full = (referee_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1f9e9398", referee_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-full/referee-history-full.vue
var referee_history_full_disposed = false
function referee_history_full_injectStyle (ssrContext) {
  if (referee_history_full_disposed) return
  __webpack_require__("soaP")
}
var referee_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var referee_history_full___vue_template_functional__ = false
/* styles */
var referee_history_full___vue_styles__ = referee_history_full_injectStyle
/* scopeId */
var referee_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var referee_history_full___vue_module_identifier__ = null
var referee_history_full_Component = referee_history_full_normalizeComponent(
  referee_history_full,
  referee_history_full_referee_history_full,
  referee_history_full___vue_template_functional__,
  referee_history_full___vue_styles__,
  referee_history_full___vue_scopeId__,
  referee_history_full___vue_module_identifier__
)
referee_history_full_Component.options.__file = "src/entities/referee/referee-history/referee-history-full/referee-history-full.vue"
if (referee_history_full_Component.esModule && Object.keys(referee_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1f9e9398", referee_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-1f9e9398", referee_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    referee_history_full_disposed = true
  })
})()}

/* harmony default export */ var referee_history_referee_history_full_referee_history_full = (referee_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/referee/referee-history/referee-history-single/referee-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var referee_history_single = ({
  name: 'app-referee-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/referee/historySingle/loading',
    list: 'entities/referee/historySingle/list',
    pager: 'entities/referee/historySingle/pager',
    model: 'entities/referee/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/referee/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39704914","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/referee/referee-history/referee-history-single/referee-history-single.vue
var referee_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "refereeList" } } }, [
            _vm._v(_vm._s(_vm.$t("entities.referee.plural")))
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "refereeShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("entities.referee.plural")) +
            " " +
            _vm._s(_vm.$t("table.history")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "lastName", label: "LastName", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "phone", label: "Phone", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.club ? scope.row.club.name : "") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var referee_history_single_staticRenderFns = []
referee_history_single_render._withStripped = true
var referee_history_single_esExports = { render: referee_history_single_render, staticRenderFns: referee_history_single_staticRenderFns }
/* harmony default export */ var referee_history_single_referee_history_single = (referee_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39704914", referee_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/referee/referee-history/referee-history-single/referee-history-single.vue
var referee_history_single_disposed = false
function referee_history_single_injectStyle (ssrContext) {
  if (referee_history_single_disposed) return
  __webpack_require__("XGY6")
}
var referee_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var referee_history_single___vue_template_functional__ = false
/* styles */
var referee_history_single___vue_styles__ = referee_history_single_injectStyle
/* scopeId */
var referee_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var referee_history_single___vue_module_identifier__ = null
var referee_history_single_Component = referee_history_single_normalizeComponent(
  referee_history_single,
  referee_history_single_referee_history_single,
  referee_history_single___vue_template_functional__,
  referee_history_single___vue_styles__,
  referee_history_single___vue_scopeId__,
  referee_history_single___vue_module_identifier__
)
referee_history_single_Component.options.__file = "src/entities/referee/referee-history/referee-history-single/referee-history-single.vue"
if (referee_history_single_Component.esModule && Object.keys(referee_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-39704914", referee_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-39704914", referee_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    referee_history_single_disposed = true
  })
})()}

/* harmony default export */ var referee_history_referee_history_single_referee_history_single = (referee_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/referee/referee-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var referee_show = ({
  name: 'app-referee-show',

  props: {
    id: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/referee/detail', this.id).catch(function () {
      return _this.$router.push({ name: 'refereeList' });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/referee/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: 'entities/referee/model',
    loading: 'entities/referee/loading',
    hasRoleToDelete: "entities/referee/hasRoleToDelete",
    hasRoleToUpdate: "entities/referee/hasRoleToUpdate",
    hasRoleToRead: "entities/referee/hasRoleToRead",
    hasRoleToReadLogs: "entities/referee/hasRoleToReadLogs",
    hasRoleToCreate: "entities/referee/hasRoleToCreate",
    isMobile: "shared/isMobile",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  })),

  methods: {
    edit: function edit() {
      this.$router.push({
        name: 'refereeEdit',
        params: { id: this.id, previous: 'show' }
      });
    },
    destroy: function destroy() {
      var _this2 = this;

      this.$confirm('Are you sure?', 'Confirm', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(function () {
        return _this2.$store.dispatch('entities/referee/destroy', _this2.id);
      }).then(function () {
        return _this2.$router.push({ name: 'refereeList' });
      }).catch(function () {});
    },
    history: function history() {
      this.$router.push({
        name: 'refereeHistorySingle',
        params: { id: this.id }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1c22e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/referee/referee-show.vue
var referee_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "refereeList" } } },
                    [_vm._v(" " + _vm._s(_vm.$t("entities.referee.plural")))]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  "\n       " +
                    _vm._s(_vm.$t("entities.referee.singular")) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  class: { show: true, "show-mobile": _vm.isMobile },
                  attrs: {
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "Id" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.id) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Name" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "LastName" } }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.model.lastName) + "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Email" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.email) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Phone" } }, [
                    _vm._v("\n        " + _vm._s(_vm.model.phone) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Created at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.created)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c("el-form-item", { attrs: { label: "Updated at" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(_vm.model.modified)) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _vm.hasRoleToUpdate
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToReadLogs
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-history",
                                type: "infor"
                              },
                              on: {
                                click: function($event) {
                                  _vm.history()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.history")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRoleToDelete
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                icon: "el-icon-fa-trash",
                                type: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.destroy()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("table.delete")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var referee_show_staticRenderFns = []
referee_show_render._withStripped = true
var referee_show_esExports = { render: referee_show_render, staticRenderFns: referee_show_staticRenderFns }
/* harmony default export */ var referee_referee_show = (referee_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c1c22e6", referee_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/referee/referee-show.vue
var referee_show_disposed = false
function referee_show_injectStyle (ssrContext) {
  if (referee_show_disposed) return
  __webpack_require__("3q8z")
}
var referee_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var referee_show___vue_template_functional__ = false
/* styles */
var referee_show___vue_styles__ = referee_show_injectStyle
/* scopeId */
var referee_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var referee_show___vue_module_identifier__ = null
var referee_show_Component = referee_show_normalizeComponent(
  referee_show,
  referee_referee_show,
  referee_show___vue_template_functional__,
  referee_show___vue_styles__,
  referee_show___vue_scopeId__,
  referee_show___vue_module_identifier__
)
referee_show_Component.options.__file = "src/entities/referee/referee-show.vue"
if (referee_show_Component.esModule && Object.keys(referee_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3c1c22e6", referee_show_Component.options)
  } else {
    hotAPI.reload("data-v-3c1c22e6", referee_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    referee_show_disposed = true
  })
})()}

/* harmony default export */ var entities_referee_referee_show = (referee_show_Component.exports);

// CONCATENATED MODULE: ./src/entities/referee/referee-routes.js







var referee_routes_roles = auth_roles.values;

/* harmony default export */ var referee_routes = ([{
  name: 'refereeList',
  path: 'referee',
  component: entities_referee_referee_list,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.activityViewer.id, referee_routes_roles.entityViewer.id, referee_routes_roles.entityEditor.id, referee_routes_roles.refereeViewer.id, referee_routes_roles.refereeEditor.id]
  }
}, {
  name: 'refereeNew',
  path: 'referee/new',
  component: entities_referee_referee_form,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.entityEditor.id, referee_routes_roles.refereeEditor.id]
  }
}, {
  name: 'refereeEdit',
  path: 'referee/:id/edit',
  component: entities_referee_referee_form,
  props: true,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.entityEditor.id, referee_routes_roles.refereeEditor.id]
  }
}, {
  name: 'refereeHistorySingle',
  path: 'referee/:id/history',
  component: referee_history_referee_history_single_referee_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.activityViewer.id]
  }
}, {
  name: 'refereeHistoryFull',
  path: 'referee/history',
  component: referee_history_referee_history_full_referee_history_full,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.activityViewer.id]
  }
}, {
  name: 'refereeShow',
  path: 'referee/:id',
  component: entities_referee_referee_show,
  props: true,
  meta: {
    auth: true,
    roles: [referee_routes_roles.owner.id, referee_routes_roles.activityViewer.id, referee_routes_roles.entityViewer.id, referee_routes_roles.entityEditor.id, referee_routes_roles.refereeViewer.id, referee_routes_roles.refereeEditor.id]
  }
}]);
// CONCATENATED MODULE: ./src/entities/referee/referee-module.js



var referee_module_components = [];
var referee_module_mixins = [];
var referee_module_filters = [];
var referee_module_directives = [];

/* harmony default export */ var referee_module = ({
  components: referee_module_components,
  mixins: referee_module_mixins,
  filters: referee_module_filters,
  directives: referee_module_directives,
  routes: referee_routes,
  store: referee_store
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


var tournament_history_full_service_SIZE = 10;
var KEY_TOURNAMETS = 'tournaments';

/* harmony default export */ var tournament_history_full_service = ({
  fetch: function fetch(lastmodified) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(KEY_TOURNAMETS).orderByChild("modified").endAt(lastmodified - 1).limitToLast(tournament_history_full_service_SIZE).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });

        var result = {
          data: list.reverse(),
          last: list.length < tournament_history_full_service_SIZE
        };

        resolve(result);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full-store.js


/* harmony default export */ var tournament_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : 10000000000000;

      return tournament_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single-service.js

// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */


var tournament_history_single_service_KEY_TOURNAMETS = 'tournaments';

/* harmony default export */ var tournament_history_single_service = ({
  list: function list(id) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref("log").child("logs").child(tournament_history_single_service_KEY_TOURNAMETS).orderByChild("id").equalTo(id).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single-store.js



/* harmony default export */ var tournament_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'locality', 'country', 'web']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'name', 'locality', 'country', 'web']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return tournament_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-model.js

// import fileModel from '@/shared/file/file-model';

/* harmony default export */ var tournament_model = ({
  default: function _default() {
    return {
      id: null,
      name: '',
      permises: { // USE!!
        settingGroups: true
        // pictures: [],
      } };
  },
  forSimple: function forSimple(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    };
  },
  forClub: function forClub(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category
    };
  },
  forPlayer: function forPlayer(data) {
    return {
      id: data.id,
      name: data.name,
      category: data.category,
      club: data.club
    };
  },
  forCreate: function forCreate(data) {
    return extends_default()({}, data);
  },
  forUpdate: function forUpdate(data) {
    return extends_default()({}, data);
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-pager.js


/* harmony default export */ var tournament_pager = ({
  build: function build() {
    var keysToSearch = ['name', 'category.label', 'club.name'];

    var exportDefinitions = [{ value: 'id', label: 'Id' }, { value: 'name', label: 'Name' }, { value: 'category.label', label: 'Category' }, { value: 'club.name', label: 'Club' }, { value: 'locality', label: 'Locality' }, { value: 'country', label: 'Country' }, { value: 'created', label: 'Created at' }, { value: 'modified', label: 'Updated at' }];

    return new pager(keysToSearch, exportDefinitions);
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-service.js


/* eslint-disable */





 // birthdate





//  import tournamentModel from './tournament-model';
var tournament_service_NAME_ENTITY = 'tournament';
var tournament_service_KEY_TOURNAMETS = 'tournaments';
var tournament_service_KEY_CLUBS = 'clubs';

/* harmony default export */ var tournament_service = ({
  list: function list() {
    return new promise_default.a(function (resolve) {
      // eslint-disable-next-line
      firebase_init_db.ref(tournament_service_KEY_TOURNAMETS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          list.push(childSnapshot.val());
        });
        resolve(list);
      });
    });
  },
  save: function save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },
  find: function find(id) {
    return new promise_default.a(function (resolve, reject) {
      firebase_init_db.ref(tournament_service_KEY_TOURNAMETS).child(id).once('value').then(function (snapshot) {
        var model = snapshot.val();

        if (!model) {
          return null;
        }
        resolve(model);
      });
    });
  },


  /**
   * Elimina un equipo, solo en el caso de que el club no tenga jugadores
   * @param {*} model 
   * @param {*} loggedUser 
   */
  destroy: function destroy(model, loggedUser) {
    var modelToDestroy = extends_default()({}, model, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {

      // 1. Comprobamos si el club tiene equipos 
      if (underscore_default.a.size(model.players) > 0) {
        reject(new Error("El equipo tiene jugadores asignados."));
      } else {
        var updates = {};
        updates['/' + tournament_service_KEY_TOURNAMETS + '/' + model.id] = null;

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            entity_logger.log(modelToDestroy, "deleted", tournament_service_KEY_TOURNAMETS, tournament_service_NAME_ENTITY);
            resolve();
          }
        });
      }
    });
  },
  update: function update(model, loggedUser) {
    return new promise_default.a(function (resolve, reject) {

      var modelToUpdate = extends_default()({}, model, {
        modified: firebase.database.ServerValue.TIMESTAMP,
        modifiedBy: { id: loggedUser.id, email: loggedUser.email }
      });

      var updates = {};
      updates['/' + tournament_service_KEY_CLUBS + '/' + modelToUpdate.club.id + '/' + tournament_service_KEY_TOURNAMETS + '/' + modelToUpdate.id] = tournament_model.forClub(modelToUpdate);;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          // Logs
          entity_logger.log(modelToUpdate, "modified", tournament_service_KEY_TOURNAMETS, tournament_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  create: function create(model, loggedUser) {

    console.log("<------ CREATE TOURNAMENT");
    var modelToSave = extends_default()({}, model, {
      id: firebase_init_db.ref(tournament_service_KEY_TOURNAMETS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + tournament_service_KEY_TOURNAMETS + '/' + modelToSave.id] = modelToSave;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", tournament_service_KEY_TOURNAMETS, tournament_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  exportAsPDF: function exportAsPDF(tournament) {
    return new promise_default.a(function (resolve, reject) {
      console.log(tournament);

      /**
       * PLAYERS PARSING
       */

      var playerDataList = [];
      var playerHeaderList = [['Nombre deportivo', 'Nombre', 'Apellidos', 'Dni', 'Fecha de nacim.', 'Dorsal']];

      // Players
      underscore_default.a.each(tournament.players, function (player, key, list) {
        var birthdate = moment_default()(player.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(js_cookie_default.a.get('language') || 'es').format('L');
        var values = [player.namePublic, player.name, player.lastName, player.dni, birthdate, player.dorsal];
        playerDataList.push(values);
      });

      /**
       * COACHES PARSING
       */

      var coachDataList = [];
      var coachHeaderList = [['Nombre', 'Apellidos', 'Dni']];

      // Coaches
      underscore_default.a.each(tournament.coaches, function (coach, key, list) {
        // var birthdate =  moment( coach.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [coach.name, coach.lastName, coach.dni];
        coachDataList.push(values);
      });

      /**
       * TOURNAMENT MANAGERS PARSING
       */

      var tournamentManagerDataList = [];
      var tournamentManagerHeaderList = [['Nombre', 'Apellidos', 'Dni']];

      // Managers
      underscore_default.a.each(tournament.tournamentManagers, function (tm, key, list) {
        // var birthdate =  moment( tm.birthdate, ["DD/MM/YYYY", "YYYY-MM-DD"]).locale(Cookies.get('language') || 'es' ).format('L');
        var values = [tm.name, tm.lastName, tm.dni];
        tournamentManagerDataList.push(values);
      });

      /*************************************************************
       *                                                           *
       *                CREAACION DEL DOC PDF                      *
       *                                                           *
       *************************************************************/

      var doc = new jspdf_min();
      var docName = tournament.name + '_' + tournament.category.label + '.pdf';
      var docTitle = "Datos del equipo";

      doc.setFontSize(22);
      doc.text(docTitle, 14, 20);
      doc.setFontSize(12);

      var img = new Image();
      img.addEventListener('load', function () {
        // doc.addImage(img, 'png', 10, 50);
      });
      img.src = '/static/logos/logo_dv7.png';
      doc.addImage(img, 'JPEG', 175, 12, 20, 45);

      // Team data
      //  Labels
      doc.text("Nombre:", 14, 35);
      doc.text("Categoría:", 14, 40);
      doc.text("Club:", 14, 45);

      doc.text(tournament.name, 40, 35);
      doc.text(tournament.category.label, 40, 40);
      doc.text(tournament.club.name, 40, 45);

      // Team information

      // Coaches
      doc.setFontSize(14);
      doc.text("Entrenadores", 14, 60);
      doc.autoTable({ head: coachHeaderList, body: coachDataList, startY: 65, theme: 'plain', styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      var finalYCoach = doc.previousAutoTable.finalY;

      // Team Managers
      doc.setFontSize(14);
      doc.text("Delegados", 14, finalYCoach + 15);
      doc.autoTable({ head: tournamentManagerHeaderList, body: tournamentManagerDataList, startY: finalYCoach + 20, styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });
      var finalYTeamManager = doc.previousAutoTable.finalY;

      // Players
      doc.setFontSize(14);
      doc.text("Jugadores", 14, finalYTeamManager + 15);
      doc.autoTable({ head: playerHeaderList, body: playerDataList, startY: finalYTeamManager + 20, styles: { cellPadding: 0.5, fontSize: 10, halign: 'center' } });

      doc.save(docName);
      resolve();
    });
  },
  listOptions: function listOptions() {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(tournament_service_KEY_TOURNAMETS).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var modelOption = {};
          modelOption.id = childSnapshot.key;
          modelOption.name = childSnapshot.val().name, modelOption.label = childSnapshot.val().name + ' · ' + childSnapshot.val().category.label;
          modelOption.club = childSnapshot.val().club;
          modelOption.category = childSnapshot.val().category;
          list.push(modelOption);
        });
        resolve(list);
      });
    });
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/setting-groups/setting-groups-service.js


// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */





// PATH
var KEY_TEAMS_PER_GROUP = 'teamsPerGroup';
var setting_groups_service_KEY_TEAMS = 'teams';
var KEY_GAMES_PER_GROUP = 'gamesPerGroup';
var KEY_GAMES = 'games';

var setting_groups_service_NAME_ENTITY = 'tournament';

/* harmony default export */ var setting_groups_service = ({
  saveGroup: function saveGroup(groupModel, loggedUser) {
    var modelToSave = {
      isClose: false,
      name: groupModel.name,
      teamList: groupModel.teamList,
      id: firebase_init_db.ref(KEY_TEAMS_PER_GROUP).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + modelToSave.id] = modelToSave;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "created", KEY_TEAMS_PER_GROUP, setting_groups_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  closeGroup: function closeGroup(groupModel, loggedUser) {
    var modelToSave = extends_default()({}, groupModel, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id + '/isClose'] = true;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          reject(error);
        } else {
          entity_logger.log(modelToSave, "close", KEY_TEAMS_PER_GROUP, setting_groups_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  openGroup: function openGroup(groupModel, loggedUser) {
    var modelToSave = extends_default()({}, groupModel, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id + '/isClose'] = false;

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          reject(error);
        } else {
          entity_logger.log(modelToSave, "close", KEY_TEAMS_PER_GROUP, setting_groups_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  listGroup: function listGroup(categoryId) {
    return new promise_default.a(function (resolve) {
      firebase_init_db.ref(KEY_TEAMS_PER_GROUP).child(categoryId).once('value').then(function (snapshot) {
        var list = [];
        snapshot.forEach(function (childSnapshot) {
          var teamList = [];

          if (!underscore_default.a.isEmpty(childSnapshot.val().teams)) {
            underscore_default.a.each(childSnapshot.val().teams, function (team) {
              teamList.push(team);
            });
          }

          console.log(teamList);

          var grooupModel = {
            name: childSnapshot.val().name,
            isClose: childSnapshot.val().isClose,
            teamList: teamList,
            categoryId: categoryId,
            id: childSnapshot.val().id
          };

          list.push(grooupModel);
        });
        resolve(list);
      });
    });
  },
  destroyGroup: function destroyGroup(groupModel, loggedUser) {
    var modelToDestroy = extends_default()({}, groupModel, {
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });
    return new promise_default.a(function (resolve, reject) {

      if (underscore_default.a.size(groupModel.teamList) > 0) {
        reject(new Error("El grupo tiene equipos asignados."));
      } else {
        var updates = {};
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id] = null;

        firebase_init_db.ref().update(updates, function (error) {
          if (error) {
            // The write failed...
            reject(error);
          } else {
            // Data saved successfully!
            entity_logger.log(modelToDestroy, "deleted", KEY_TEAMS_PER_GROUP, setting_groups_service_NAME_ENTITY);
            resolve();
          }
        });
      }
    });
  },
  addTeam: function addTeam(model, loggedUser) {
    var modelToSave = extends_default()({}, team_model.forSimple(model.team), {
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    });

    return new promise_default.a(function (resolve, reject) {
      var updates = {};

      if (model.from.groupId !== "") {
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + model.categoryId + '/' + model.from.groupId + '/' + setting_groups_service_KEY_TEAMS + '/' + model.team.id] = null;
      }

      if (model.to.groupId !== "") {
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + model.categoryId + '/' + model.to.groupId + '/' + setting_groups_service_KEY_TEAMS + '/' + model.team.id] = modelToSave;
        updates[setting_groups_service_KEY_TEAMS + '/' + model.team.id + '/hasGroup'] = true;
      } else {
        updates[setting_groups_service_KEY_TEAMS + '/' + model.team.id + '/hasGroup'] = false;
      }

      // Si muevo de un grupo  a la lista de equipos sin asignar, hasGroup=false
      // 

      firebase_init_db.ref().update(updates, function (error) {
        if (error) {
          // The write failed...
          reject(error);
        } else {
          // Data saved successfully!
          entity_logger.log(modelToSave, "add team", KEY_TEAMS_PER_GROUP, setting_groups_service_NAME_ENTITY);
          resolve();
        }
      });
    });
  },
  generateMatches: function generateMatches(modelGroup, loggedUser) {
    // delete teamTotalList[indexA];
    return new promise_default.a(function (resolve, reject) {
      var updates = {};

      var teamList = modelGroup.teamList;
      var teamTotalList = modelGroup.teamList;
      var games = [];

      for (var indexA = 0; indexA < teamList.length; indexA++) {
        for (var indexB = indexA + 1; indexB < teamList.length; indexB++) {
          console.log("<********teamList.length", teamList.length);
          console.log("<***************** A ", indexA);
          console.log("<***************** B ", indexB);

          var gameModelToSave = {
            id: firebase_init_db.ref().push().key,
            teamLocal: team_model.forGame(teamList[indexA]),
            teamAway: team_model.forGame(teamList[indexB]),
            created: firebase.database.ServerValue.TIMESTAMP,
            modified: firebase.database.ServerValue.TIMESTAMP,
            createdBy: { id: loggedUser.id, email: loggedUser.email },
            modifiedBy: { id: loggedUser.id, email: loggedUser.email },
            finally: false,
            place: '',
            date: '',
            referre: ''
          };

          console.log("<*****************");
          // console.log(gameModelToSave);

          updates['/' + KEY_GAMES_PER_GROUP + '/' + modelGroup.categoryId + '/' + modelGroup.id + '/' + KEY_GAMES + '/' + gameModelToSave.id] = gameModelToSave;
          updates['/' + KEY_GAMES + '/' + gameModelToSave.id] = gameModelToSave;

          if (indexA == teamList.length - 2) {
            firebase_init_db.ref().update(updates, function (error) {
              if (error) {
                // The write failed...
                reject(error);
              } else {
                console.log('FIIIIIIINNNNNN');

                // Data saved successfully!
                // logService.log(modelToSave, "add games", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
                resolve();
              }
            });
          }
        }
      }
    });
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/setting-groups/setting-groups-store.js

/* eslint-disable */

 // Internationalization


/* harmony default export */ var setting_groups_store = ({
  namespaced: true,

  state: {
    loading: false,
    groupList: [],
    teamList: []
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    teamList: function teamList(state) {
      return state.teamList;
    },
    groupList: function groupList(state) {
      return state.groupList;
    },
    pager: function pager(state) {
      return state.pager;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    TEAM_LIST: function TEAM_LIST(state, payload) {
      state.teamList = payload || [];
    },
    GROUP_LIST: function GROUP_LIST(state, payload) {
      state.groupList = payload || [];
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.teamList = [];
      state.groupList = [];
    }
  },

  actions: {
    setup: function setup(_ref, modelTeam) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      commit('LOADING', false);

      var error = new Error('Equipo no existe.');
      dispatch('shared/error', error, { root: true });
      return promise_default.a.reject(error);
    },
    listTeamsByCategoryId: function listTeamsByCategoryId(_ref2, categoryId) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters;

      console.log("LIST TEAMA BY CATEGORY");

      commit('TEAM_LIST', []);
      commit('LOADING', true);

      var teamListByCategories = rootGetters['entities/tournament/teamListGroupByCategory'];

      commit('TEAM_LIST', teamListByCategories[categoryId]);
      commit('LOADING', false);

      return promise_default.a.resolve(teamListByCategories);
    },
    saveGroup: function saveGroup(_ref3, model) {
      var getters = _ref3.getters,
          commit = _ref3.commit,
          rootGetters = _ref3.rootGetters,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      setting_groups_service.saveGroup(model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.tournament.group') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listGroup: function listGroup(_ref4, categoryId) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('GROUP_LIST', []);
      commit('LOADING', true);

      return setting_groups_service.listGroup(categoryId).then(function (list) {
        commit('GROUP_LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    destroyGroup: function destroyGroup(_ref5, model) {
      var getters = _ref5.getters,
          commit = _ref5.commit,
          rootGetters = _ref5.rootGetters,
          dispatch = _ref5.dispatch;

      commit('LOADING', true);

      return setting_groups_service.destroyGroup(model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.tournament.group') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    closeGroup: function closeGroup(_ref6, model) {
      var getters = _ref6.getters,
          commit = _ref6.commit,
          rootGetters = _ref6.rootGetters,
          dispatch = _ref6.dispatch;

      commit('LOADING', true);

      return setting_groups_service.closeGroup(model, rootGetters['auth/user']).then(function () {
        console.log("<--- GENERATE MATCHES");
        setting_groups_service.generateMatches(model, rootGetters['auth/user']);
      }).then(function () {
        commit('LOADING', false);
        console.log("<--- GENERATE MATCHES SUCCESS");

        dispatch('shared/success', src_lang.t('entities.tournament.group') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    openGroup: function openGroup(_ref7, model) {
      var getters = _ref7.getters,
          commit = _ref7.commit,
          rootGetters = _ref7.rootGetters,
          dispatch = _ref7.dispatch;

      commit('LOADING', true);

      return setting_groups_service.openGroup(model, rootGetters['auth/user']).then(function () {
        commit('LOADING', false);

        dispatch('shared/success', src_lang.t('entities.tournament.group') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    addTeamGroup: function addTeamGroup(_ref8, model) {
      var getters = _ref8.getters,
          commit = _ref8.commit,
          rootGetters = _ref8.rootGetters,
          dispatch = _ref8.dispatch;


      console.log("<--- ADD TEAM");
      if (model.to.groupId != model.from.groupId) {
        commit('LOADING', true);

        return setting_groups_service.addTeam(model, rootGetters['auth/user']).then(function () {
          dispatch('shared/success', src_lang.t('entities.tournament.group') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });
          commit('LOADING', false);
        }).catch(function (error) {
          commit('LOADING', false);
          dispatch('shared/error', error, { root: true });
          return promise_default.a.reject(error);
        });
      }
    },
    clear: function clear(_ref9) {
      var commit = _ref9.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/entities/tournament/tournament-store.js





 // Internationalization
// import _ from 'underscore'






 // NEW!!


// import playerService from '../player/player-service';
/* eslint-disable */
/* harmony default export */ var tournament_store = ({
  namespaced: true,

  modules: {
    historyFull: tournament_history_full_store,
    historySingle: tournament_history_single_store,
    settingGroups: setting_groups_store // NEW!!
  },

  state: {
    loading: false,
    list: [],
    teamList: [],
    teamListGroupByCategory: {},
    pager: tournament_pager.build(),
    model: tournament_model.default(),
    options: {}
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    teamList: function teamList(state) {
      return state.teamList;
    },
    teamListGroupByCategory: function teamListGroupByCategory(state) {
      return state.teamListGroupByCategory;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    options: function options(state) {
      return state.options;
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.tournamentEditor.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.tournamentEditor.id]);
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id, roles.entityViewer.id, roles.entityEditor.id, roles.tournamentViewer.id, roles.tournamentEditor.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToDelete: function hasRoleToDelete(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.entityEditor.id, roles.tournamentEditor.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    TEAM_LIST: function TEAM_LIST(state, payload) {
      state.teamList = payload || [];
    },
    TEAM_LIST_GROUP_BY_CATEGORY: function TEAM_LIST_GROUP_BY_CATEGORY(state, payload) {
      state.teamListGroupByCategory = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || tournament_model.default();
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = tournament_pager.build();
      state.model = tournament_model.default();
      state.options = {};
    },
    ADD_OPTIONS: function ADD_OPTIONS(state, payload) {
      state.options = assign_default()({}, state.options, defineProperty_default()({}, payload.key, payload.options));
    }
  },

  actions: {
    listTeams: function listTeams(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('TEAM_LIST', []);
      commit('LOADING', true);

      return team_service.listByCategoryWithoutGroup().then(function (teamListByCategory) {
        commit('LOADING', false);
        commit('TEAM_LIST_GROUP_BY_CATEGORY', teamListByCategory);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    detail: function detail(_ref2, id) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit('LOADING', true);

      return tournament_service.find(id).then(function (model) {

        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    new: function _new(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          rootGetters = _ref3.rootGetters;

      var tournament = rootGetters['entities/tournament/model'];

      var model = { tournament: tournament };

      commit('MODEL', model);
    },
    edit: function edit(_ref4, id) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return tournament_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      });
    },
    save: function save(_ref5, tournament) {
      var getters = _ref5.getters,
          commit = _ref5.commit,
          rootGetters = _ref5.rootGetters,
          dispatch = _ref5.dispatch;

      commit('LOADING', true);
      var modelToSave = getters.model;

      if (tournament !== null) {
        modelToSave = tournament;
      }
      return tournament_service.save(modelToSave, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.tournament.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      });
    },
    destroy: function destroy(_ref6, model) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch,
          rootGetters = _ref6.rootGetters;

      commit('LOADING', true);

      var tournament = rootGetters['entities/tournament/model'];
      var modelToDestroy = model;
      if (tournament.id !== null) {
        modelToDestroy = extends_default()({}, model, { tournament: tournament_model.forSimple(tournament) });
      }

      return tournament_service.destroy(modelToDestroy, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.tournament.singular') + ' ' + src_lang.t('notification.deletedSuccessfully'), { root: true });
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return tournament_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    listByClubId: function listByClubId(_ref8, tournamentId) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return tournament_service.listByClubId(tournamentId).then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref9) {
      var commit = _ref9.commit;

      commit('CLEAR');
    },
    loadOptions: function loadOptions(_ref10) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      category_service.listOptions().then(function (options) {
        commit('ADD_OPTIONS', { key: 'categories', options: options });
      }).catch(function (error) {
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
      // playerService.listOptions().then((options) => {
      //   commit('ADD_OPTIONS', { key: 'players', options });
      // }).catch((error) => {
      //   dispatch('shared/error', error, { root: true });
      //   return Promise.reject(error);
      // });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-form.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ var tournament_form = ({
  name: 'app-tournament-form',

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        name: validators.string({
          label: 'Name',
          required: true
        }),
        locality: validators.string({
          label: 'Locality',
          required: false
        }),
        players: validators.hasMany({
          label: 'Players',
          required: false
        }),
        country: validators.string({
          label: 'Country',
          required: false
        }),
        web: validators.string({
          label: 'Web',
          required: false
        })
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$store.dispatch('entities/tournament/loadOptions');

    if (this.id) {
      this.$store.dispatch('entities/tournament/edit', this.id).catch(function () {
        return _this.$router.push({ name: 'tournamentList' });
      });
    } else {

      this.$store.dispatch('entities/tournament/new');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/tournament/clear');
    this.$store.dispatch('entities/club/clear');
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    club: 'entities/club/model',
    model: 'entities/tournament/model',
    loading: 'entities/tournament/loading',
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth",
    options: 'entities/tournament/options'
  }), {

    editing: function editing(state) {
      return !!state.id;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch('entities/tournament/save', _this2.model).then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5444a14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-form.vue
var tournament_form_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "tournamentList" } } },
                    [_vm._v(_vm._s(_vm.$t("entities.tournament.plural")))]
                  ),
                  _vm._v(" "),
                  _vm.editing && _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "tournamentShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.name))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.edit")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.editing
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.$t("table.add")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.editing
                        ? _vm.$t("table.edit") +
                            " " +
                            _vm.$t("entities.tournament.singular")
                        : _vm.$t("table.add") +
                            " " +
                            _vm.$t("entities.tournament.singular")
                    )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth,
                    rules: _vm.rules
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Name", prop: "name" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                ref: "focus",
                                model: {
                                  value: _vm.model.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "name", $$v)
                                  },
                                  expression: "model.name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Locality", prop: "locality" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.locality,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "locality", $$v)
                                  },
                                  expression: "model.locality"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Country", prop: "country" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "country", $$v)
                                  },
                                  expression: "model.country"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Web", prop: "web" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.model.web,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "web", $$v)
                                  },
                                  expression: "model.web"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("\n          Save\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var tournament_form_staticRenderFns = []
tournament_form_render._withStripped = true
var tournament_form_esExports = { render: tournament_form_render, staticRenderFns: tournament_form_staticRenderFns }
/* harmony default export */ var tournament_tournament_form = (tournament_form_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5444a14", tournament_form_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-form.vue
var tournament_form_disposed = false
function tournament_form_injectStyle (ssrContext) {
  if (tournament_form_disposed) return
  __webpack_require__("Uc0E")
}
var tournament_form_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_form___vue_template_functional__ = false
/* styles */
var tournament_form___vue_styles__ = tournament_form_injectStyle
/* scopeId */
var tournament_form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_form___vue_module_identifier__ = null
var tournament_form_Component = tournament_form_normalizeComponent(
  tournament_form,
  tournament_tournament_form,
  tournament_form___vue_template_functional__,
  tournament_form___vue_styles__,
  tournament_form___vue_scopeId__,
  tournament_form___vue_module_identifier__
)
tournament_form_Component.options.__file = "src/entities/tournament/tournament-form.vue"
if (tournament_form_Component.esModule && Object.keys(tournament_form_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c5444a14", tournament_form_Component.options)
  } else {
    hotAPI.reload("data-v-c5444a14", tournament_form_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_form_disposed = true
  })
})()}

/* harmony default export */ var entities_tournament_tournament_form = (tournament_form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* eslint-disable */
/* harmony default export */ var tournament_list = ({
    name: "app-tournament-list",

    data: function data() {
        return {
            title: "Equipos",
            labels: {
                name: "Nombre",
                category: "Categoría"
            },
            breadcrumbLabels: {
                home: "Inicio",
                tournaments: "Equipos",
                edit: "Editar",
                new: "Nuevo"
            },
            emptyText: "There are no tournaments yet"
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/tournament/loading",
        list: "entities/tournament/list",
        pager: "entities/tournament/pager",
        hasRoleToDelete: "entities/tournament/hasRoleToDelete",
        hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
        hasRoleToRead: "entities/tournament/hasRoleToRead",
        hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
        hasRoleToCreate: "entities/tournament/hasRoleToCreate",
        isMobile: "shared/isMobile",
        paginationLayout: "shared/paginationLayout"
    })),

    created: function created() {
        this.$store.dispatch("entities/tournament/list");
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        this.$store.dispatch("entities/tournament/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);

        this.$store.dispatch("entities/tournament/list");
        next();
    },


    methods: {
        create: function create() {
            this.$router.push({
                name: "tournamentNew"
            });
        },
        rowClick: function rowClick(row, column, cell, event) {
            if (cell.label != this.$t("table.actions")) {
                this.$router.push({
                    name: "tournamentShow",
                    params: { id: row.id }
                });
            }
        },
        setting: function setting(tournament) {
            this.$router.push({
                name: "tournamentSettings",
                params: { id: tournament.id }
            });
        },
        exportTeamAsPdf: function exportTeamAsPdf(tournament) {
            this.$store.dispatch("entities/tournament/exportAsPDF", tournament);
        },
        show: function show(id) {
            console.log("*******");
            console.log(id);

            this.$router.push({
                name: "tournamentShow",
                params: { id: id }
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: "tournamentEdit",
                params: { id: id }
            });
        },
        destroy: function destroy(model) {
            var _this = this;

            this.$confirm(this.$t("table.areYouSure"), this.$t("table.confirm"), {
                confirmButtonText: this.$t("table.yes"),
                cancelButtonText: this.$t("table.no"),
                type: 'warning'
            }).then(function () {
                return _this.$store.dispatch("entities/tournament/destroy", model).then(function () {
                    _this.$store.dispatch("entities/tournament/list");
                });
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({ name: "tournamentHistoryFull" });
        },


        // Auz functions

        getSize: function getSize(obj) {
            return underscore_default.a.size(obj);
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d51fc60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-list.vue
var tournament_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasRoleToReadLogs
        ? _c(
            "el-breadcrumb",
            {
              staticStyle: { float: "right" },
              attrs: { "separator-class": "el-icon-arrow-right" }
            },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v(_vm._s(_vm.$t("route.home")))
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [
                _vm._v(" " + _vm._s(_vm.$t("entities.tournament.plural")) + " ")
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("entities.tournament.plural")))
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.add")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-history", type: "infor" },
                      on: {
                        click: function($event) {
                          _vm.history()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pager.hasDataToExport(_vm.list) && _vm.hasRoleToReadLogs
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        plain: true,
                        type: "success",
                        icon: "el-icon-fa-table"
                      },
                      on: {
                        click: function($event) {
                          _vm.pager.exportToCsv(_vm.list)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("table.export")))]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view", { attrs: { name: "playerImport" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "name",
              order: "ascending"
            },
            "empty-text": _vm.emptyText,
            border: ""
          },
          on: {
            "row-click": _vm.rowClick,
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: _vm.$t("entities.tournament.prop.name"),
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "category",
              label: _vm.$t("entities.tournament.prop.category"),
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      _vm._s(scope.row.category ? scope.row.category.label : "")
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "locality",
                  label: _vm.$t("entities.tournament.prop.locality"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "country",
                  label: _vm.$t("entities.tournament.prop.country"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c("el-table-column", {
                attrs: {
                  prop: "web",
                  label: _vm.$t("entities.tournament.prop.web"),
                  sortable: "custom"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              align: "center",
              label: _vm.$t("table.actions"),
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      { attrs: { trigger: "click" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "el-dropdown-link",
                            attrs: { size: "small", round: "" }
                          },
                          [_c("i", { staticClass: "el-icon-more" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-setting",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.setting(scope.row)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.setting")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToRead
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-search",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.show(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("table.details")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToUpdate
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-pencil-square-o",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.edit(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("table.edit")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasRoleToDelete
                              ? _c(
                                  "el-dropdown-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          icon: "el-icon-fa-trash",
                                          size: "small",
                                          type: "text"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.destroy(scope.row.id)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.$t("table.delete")) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var tournament_list_staticRenderFns = []
tournament_list_render._withStripped = true
var tournament_list_esExports = { render: tournament_list_render, staticRenderFns: tournament_list_staticRenderFns }
/* harmony default export */ var tournament_tournament_list = (tournament_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d51fc60", tournament_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-list.vue
var tournament_list_disposed = false
function tournament_list_injectStyle (ssrContext) {
  if (tournament_list_disposed) return
  __webpack_require__("6EuI")
}
var tournament_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_list___vue_template_functional__ = false
/* styles */
var tournament_list___vue_styles__ = tournament_list_injectStyle
/* scopeId */
var tournament_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_list___vue_module_identifier__ = null
var tournament_list_Component = tournament_list_normalizeComponent(
  tournament_list,
  tournament_tournament_list,
  tournament_list___vue_template_functional__,
  tournament_list___vue_styles__,
  tournament_list___vue_scopeId__,
  tournament_list___vue_module_identifier__
)
tournament_list_Component.options.__file = "src/entities/tournament/tournament-list.vue"
if (tournament_list_Component.esModule && Object.keys(tournament_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d51fc60", tournament_list_Component.options)
  } else {
    hotAPI.reload("data-v-5d51fc60", tournament_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_list_disposed = true
  })
})()}

/* harmony default export */ var entities_tournament_tournament_list = (tournament_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tournament_history_full = ({
  name: 'app-team-history-full',

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team/historyFull/loading',
    list: 'entities/team/historyFull/list',
    last: 'entities/team/historyFull/last'
  })),

  created: function created() {
    this.$store.dispatch('entities/team/historyFull/setup');
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team/historyFull/clear');
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: 'entities/team/historyFull/fetch'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05ba6a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full.vue
var tournament_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "teamList" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("entities.tournament.singular")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(
          "\n     " +
            _vm._s(_vm.$t("entities.tournament.singular")) +
            " " +
            _vm._s(_vm.$t("table.history")) +
            "\n  "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.modified)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "name", label: "Name" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "category", label: "Category" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.category ? scope.row.category.label : ""
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "club", label: "Club" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.club ? scope.row.club.name : "") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "locality", label: "Locality" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "country", label: "Country" }
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { prop: "web", label: "Web" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.created)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "deleted", label: "Deleted at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatDatetime")(scope.row.deleted)
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Deleted by", prop: "deletedBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("\n      Load more...\n    ")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var tournament_history_full_staticRenderFns = []
tournament_history_full_render._withStripped = true
var tournament_history_full_esExports = { render: tournament_history_full_render, staticRenderFns: tournament_history_full_staticRenderFns }
/* harmony default export */ var tournament_history_full_tournament_history_full = (tournament_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05ba6a4c", tournament_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full.vue
var tournament_history_full_disposed = false
function tournament_history_full_injectStyle (ssrContext) {
  if (tournament_history_full_disposed) return
  __webpack_require__("VUyi")
}
var tournament_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_history_full___vue_template_functional__ = false
/* styles */
var tournament_history_full___vue_styles__ = tournament_history_full_injectStyle
/* scopeId */
var tournament_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_history_full___vue_module_identifier__ = null
var tournament_history_full_Component = tournament_history_full_normalizeComponent(
  tournament_history_full,
  tournament_history_full_tournament_history_full,
  tournament_history_full___vue_template_functional__,
  tournament_history_full___vue_styles__,
  tournament_history_full___vue_scopeId__,
  tournament_history_full___vue_module_identifier__
)
tournament_history_full_Component.options.__file = "src/entities/tournament/tournament-history/tournament-history-full/tournament-history-full.vue"
if (tournament_history_full_Component.esModule && Object.keys(tournament_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05ba6a4c", tournament_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-05ba6a4c", tournament_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_history_full_disposed = true
  })
})()}

/* harmony default export */ var tournament_history_tournament_history_full_tournament_history_full = (tournament_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tournament_history_single = ({
  name: 'app-team-history-single',

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: 'entities/team/historySingle/loading',
    list: 'entities/team/historySingle/list',
    pager: 'entities/team/historySingle/pager',
    model: 'entities/team/historySingle/model',
    paginationLayout: "shared/paginationLayout"
  })),

  created: function created() {
    this.$store.dispatch('entities/team/historySingle/setup', this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch('entities/team/historySingle/clear');
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c77f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single.vue
var tournament_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "teamList" } } }, [
            _vm._v("Teams")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "teamShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("\n    Team " + _vm._s(_vm.$t("table.history")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.modified)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "name", label: "Name", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "category", label: "Category" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.category ? scope.row.category.label : ""
                        ) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "club", label: "Club" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.club ? scope.row.club.name : "") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "locality", label: "Locality", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "country", label: "Country", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "web", label: "Web", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.created)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deleted",
              label: "Deleted at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("formatDatetime")(scope.row.deleted)) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Deleted by",
              prop: "deletedBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var tournament_history_single_staticRenderFns = []
tournament_history_single_render._withStripped = true
var tournament_history_single_esExports = { render: tournament_history_single_render, staticRenderFns: tournament_history_single_staticRenderFns }
/* harmony default export */ var tournament_history_single_tournament_history_single = (tournament_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66c77f84", tournament_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single.vue
var tournament_history_single_disposed = false
function tournament_history_single_injectStyle (ssrContext) {
  if (tournament_history_single_disposed) return
  __webpack_require__("3/NM")
}
var tournament_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_history_single___vue_template_functional__ = false
/* styles */
var tournament_history_single___vue_styles__ = tournament_history_single_injectStyle
/* scopeId */
var tournament_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_history_single___vue_module_identifier__ = null
var tournament_history_single_Component = tournament_history_single_normalizeComponent(
  tournament_history_single,
  tournament_history_single_tournament_history_single,
  tournament_history_single___vue_template_functional__,
  tournament_history_single___vue_styles__,
  tournament_history_single___vue_scopeId__,
  tournament_history_single___vue_module_identifier__
)
tournament_history_single_Component.options.__file = "src/entities/tournament/tournament-history/tournament-history-single/tournament-history-single.vue"
if (tournament_history_single_Component.esModule && Object.keys(tournament_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-66c77f84", tournament_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-66c77f84", tournament_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_history_single_disposed = true
  })
})()}

/* harmony default export */ var tournament_history_tournament_history_single_tournament_history_single = (tournament_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Tournament from "@/entities/tournament/tournament-list";

/* harmony default export */ var tournament_show = ({
    name: "app-tournament-show",

    // components: {
    //     tournamentList: Tournament
    // },

    props: {
        id: String
    },

    created: function created() {
        var _this = this;

        this.$store.dispatch("entities/tournament/detail", this.id).catch(function () {
            return _this.$router.push({ name: "tournamentList" });
        });
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/tournament/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/tournament/model",
        loading: "entities/tournament/loading",
        hasRoleToDelete: "entities/tournament/hasRoleToDelete",
        hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
        hasRoleToRead: "entities/tournament/hasRoleToRead",
        hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
        hasRoleToCreate: "entities/tournament/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "tournamentEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this2 = this;

            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            }).then(function () {
                return _this2.$store.dispatch("entities/tournament/destroy", _this2.model);
            }).then(function () {
                return _this2.$router.go(-1);
            }).catch(function () {});
        },
        history: function history() {
            this.$router.push({
                name: "tournamentHistorySingle",
                params: { id: this.id }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cefe4af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-show.vue
var tournament_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "tournamentList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.tournament.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("entities.tournament.singular")))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form",
                        {
                          class: { show: true, "show-mobile": _vm.isMobile },
                          attrs: {
                            "label-position": _vm.labelPosition,
                            "label-width": _vm.labelWidth
                          },
                          nativeOn: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _vm.hasRoleToReadLogs
                            ? _c("el-form-item", { attrs: { label: "Id" } }, [
                                _vm._v(_vm._s(_vm.model.id))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("entities.tournament.prop.name")
                              }
                            },
                            [_vm._v(_vm._s(_vm.model.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "entities.tournament.prop.category"
                                )
                              }
                            },
                            [
                              _c("app-entity-link", {
                                attrs: {
                                  entityName: "category",
                                  property: _vm.model.category
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("entities.club.singular") }
                            },
                            [_vm._v(_vm._s(_vm.model.club.name))]
                          ),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "entities.tournament.prop.locality"
                                    )
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.locality))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "entities.tournament.prop.country"
                                    )
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.country))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "entities.tournament.prop.web"
                                    )
                                  }
                                },
                                [_vm._v(_vm._s(_vm.model.web))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                { attrs: { label: _vm.$t("status.created") } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.created
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasRoleToReadLogs
                            ? _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("status.modifiedAt") }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDatetime")(
                                        _vm.model.modified
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group mt-3" },
                            [
                              _vm.hasRoleToUpdate
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-pencil-square-o",
                                        type: "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.edit()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.edit")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToReadLogs
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-history",
                                        type: "infor"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.history()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.history")))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasRoleToDelete
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        icon: "el-icon-fa-trash",
                                        type: "danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.destroy()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("table.delete")))]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var tournament_show_staticRenderFns = []
tournament_show_render._withStripped = true
var tournament_show_esExports = { render: tournament_show_render, staticRenderFns: tournament_show_staticRenderFns }
/* harmony default export */ var tournament_tournament_show = (tournament_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cefe4af", tournament_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-show.vue
var tournament_show_disposed = false
function tournament_show_injectStyle (ssrContext) {
  if (tournament_show_disposed) return
  __webpack_require__("j4TU")
}
var tournament_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_show___vue_template_functional__ = false
/* styles */
var tournament_show___vue_styles__ = tournament_show_injectStyle
/* scopeId */
var tournament_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_show___vue_module_identifier__ = null
var tournament_show_Component = tournament_show_normalizeComponent(
  tournament_show,
  tournament_tournament_show,
  tournament_show___vue_template_functional__,
  tournament_show___vue_styles__,
  tournament_show___vue_scopeId__,
  tournament_show___vue_module_identifier__
)
tournament_show_Component.options.__file = "src/entities/tournament/tournament-show.vue"
if (tournament_show_Component.esModule && Object.keys(tournament_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6cefe4af", tournament_show_Component.options)
  } else {
    hotAPI.reload("data-v-6cefe4af", tournament_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_show_disposed = true
  })
})()}

/* harmony default export */ var entities_tournament_tournament_show = (tournament_show_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.umd.min.js
var vuedraggable_umd_min = __webpack_require__("6Top");
var vuedraggable_umd_min_default = /*#__PURE__*/__webpack_require__.n(vuedraggable_umd_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/setting-groups/setting-groups.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import _ from "underscore";
// import Cookies from 'js-cookie' // birthdate

/* eslint-disable */
 // birthdate

/* harmony default export */ var setting_groups = ({
    name: "app-setting-groups-list",

    components: {
        draggable: vuedraggable_umd_min_default.a
    },

    props: {
        categoryId: String
    },

    data: function data() {
        return {
            options: ["A", "B", "C", "D"],
            list1: [],
            list2: [{ name: "Juan", id: 5 }, { name: "Edgard", id: 6 }, { name: "Johnson", id: 7 }],

            bgColorGrupoCerrado: "background: red;", // Style
            centerDialogVisible: false,

            form: { groupName: "" }, // USE!!
            currentItem: {} // USE!!
        };
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        loading: "entities/tournament/settingGroups/loading",
        teamList: "entities/tournament/settingGroups/teamList", // USE!!
        groupList: "entities/tournament/settingGroups/groupList", // USE!!
        modelSetting: "entities/tournament/model",
        isMobile: "shared/isMobile"
    })),

    created: function created() {
        this.$store.dispatch("entities/tournament/settingGroups/listTeamsByCategoryId", this.categoryId);
        this.$store.dispatch("entities/tournament/settingGroups/listGroup", this.categoryId);
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteLeave ");
        this.$store.dispatch("entities/tournament/settingGroups/clear");
        next();
    },
    beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        this.$store.dispatch("entities/tournament/settingGroups/listTeamsByCategoryId", to.params.categoryId);
        this.$store.dispatch("entities/tournament/settingGroups/listGroup", to.params.categoryId);
        next();
    },


    methods: {
        saveGroup: function saveGroup() {
            var _this = this;

            var modelToSave = {
                categoryId: this.categoryId,
                name: this.form.groupName,
                teamList: []
            };

            if (modelToSave.name !== "") {
                this.$store.dispatch("entities/tournament/settingGroups/saveGroup", modelToSave).then(function () {
                    _this.$store.dispatch("entities/tournament/settingGroups/listGroup", _this.categoryId);
                });

                this.form.groupName = "";
            }
        },
        destroyGroup: function destroyGroup(groupModel) {
            var _this2 = this;

            this.$store.dispatch("entities/tournament/settingGroups/destroyGroup", groupModel).then(function () {
                _this2.$store.dispatch("entities/tournament/settingGroups/listGroup", _this2.categoryId);
            });

            this.form.groupName = "";
        },
        generateMatchesGroup: function generateMatchesGroup(groupModel) {
            var _this3 = this;

            // cerrar grupo
            if (!groupModel.isClose) {
                this.$store.dispatch("entities/tournament/settingGroups/closeGroup", groupModel).then(function () {
                    _this3.$store.dispatch("entities/tournament/settingGroups/listGroup", _this3.categoryId);
                });
            } else {
                this.$store.dispatch("entities/tournament/settingGroups/openGroup", groupModel).then(function () {
                    _this3.$store.dispatch("entities/tournament/settingGroups/listGroup", _this3.categoryId);
                });
            }
        },


        // Groups functions

        /*
            Comprueba si se puede mover un elemento
        */

        checkMove: function checkMove(card, origin) {
            this.currentItem = card.draggedContext.element;

            return this.modelSetting.permises.settingGroups;
        },

        onEnd: function onEnd(card) {
            console.log("<--- END", card);
            var toGroupId = card.to.id;
            var fromGroupId = card.from.id;
            var modelToSave = {
                to: { groupId: card.to.id },
                from: { groupId: card.from.id },
                team: this.currentItem,
                categoryId: this.categoryId
            };

            this.$store.dispatch("entities/tournament/settingGroups/addTeamGroup", modelToSave);
        },

        onMoved: function onMoved(card) {
            console.log("<--- ON MOVED");
        }

        // beforeUpdate(to, from, next) {
        //     next()
        // },

        // created() {
        //     this.dialogTableVisible = true;
        // },
    } });
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f9406c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/setting-groups/setting-groups.vue
var setting_groups_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Crear grupo" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Nombre" },
                                model: {
                                  value: _vm.form.groupName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "groupName", $$v)
                                  },
                                  expression: "form.groupName"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.saveGroup }
                                },
                                [_vm._v("Crear")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-row",
                        _vm._l(_vm.groupList, function(item, index) {
                          return _c(
                            "el-col",
                            {
                              key: item.id,
                              attrs: { span: 4, label: item, name: item }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "grid-content bg-purple" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "board-column" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "board-column-header",
                                              style: item.isClose
                                                ? _vm.bgColorGrupoCerrado
                                                : ""
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.name) +
                                                  "\n                                        "
                                              ),
                                              _vm._v(" "),
                                              _c("el-button", {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  type: item.isClose
                                                    ? "warning"
                                                    : "success",
                                                  icon: item.isClose
                                                    ? "el-icon-setting"
                                                    : "el-icon-check",
                                                  circle: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.generateMatchesGroup(
                                                      item
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              !item.isClose &&
                                              item.teamList.length == 0
                                                ? _c("el-button", {
                                                    staticStyle: {
                                                      float: "right"
                                                    },
                                                    attrs: {
                                                      type: "danger",
                                                      icon: "el-icon-delete",
                                                      circle: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.destroyGroup(item)
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "draggable",
                                            {
                                              staticClass:
                                                "board-column-content",
                                              attrs: {
                                                list: item.teamList,
                                                group: item.isClose
                                                  ? item.id
                                                  : "groups",
                                                id: item.id,
                                                move: _vm.checkMove
                                              },
                                              on: {
                                                moved: _vm.onMoved,
                                                end: _vm.onEnd
                                              }
                                            },
                                            _vm._l(item.teamList, function(
                                              element
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: element.id,
                                                  staticClass: "board-item"
                                                },
                                                [_vm._v(_vm._s(element.name))]
                                              )
                                            })
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 4 } }, [
                    _c("div", { staticClass: "grid-content bg-purple" }, [
                      _c("div", { staticClass: "grid-content bg-purple" }, [
                        _c(
                          "div",
                          { staticClass: "board-column" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "board-column-header",
                                staticStyle: { background: "gray" }
                              },
                              [_vm._v("Equipos sin grupo")]
                            ),
                            _vm._v(" "),
                            _c(
                              "draggable",
                              {
                                staticClass: "board-column-content",
                                attrs: {
                                  list: _vm.teamList,
                                  group: "groups",
                                  move: _vm.checkMove
                                },
                                on: { end: _vm.onEnd, moved: _vm.onMoved }
                              },
                              _vm._l(_vm.teamList, function(element) {
                                return _c(
                                  "div",
                                  {
                                    key: element.id,
                                    staticClass: "board-item",
                                    attrs: { id: element.id }
                                  },
                                  [_vm._v(_vm._s(element.name))]
                                )
                              })
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var setting_groups_staticRenderFns = []
setting_groups_render._withStripped = true
var setting_groups_esExports = { render: setting_groups_render, staticRenderFns: setting_groups_staticRenderFns }
/* harmony default export */ var setting_groups_setting_groups = (setting_groups_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f9406c6", setting_groups_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/setting-groups/setting-groups.vue
var setting_groups_disposed = false
function setting_groups_injectStyle (ssrContext) {
  if (setting_groups_disposed) return
  __webpack_require__("r6ir")
}
var setting_groups_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var setting_groups___vue_template_functional__ = false
/* styles */
var setting_groups___vue_styles__ = setting_groups_injectStyle
/* scopeId */
var setting_groups___vue_scopeId__ = "data-v-8f9406c6"
/* moduleIdentifier (server only) */
var setting_groups___vue_module_identifier__ = null
var setting_groups_Component = setting_groups_normalizeComponent(
  setting_groups,
  setting_groups_setting_groups,
  setting_groups___vue_template_functional__,
  setting_groups___vue_styles__,
  setting_groups___vue_scopeId__,
  setting_groups___vue_module_identifier__
)
setting_groups_Component.options.__file = "src/entities/tournament/setting-groups/setting-groups.vue"
if (setting_groups_Component.esModule && Object.keys(setting_groups_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8f9406c6", setting_groups_Component.options)
  } else {
    hotAPI.reload("data-v-8f9406c6", setting_groups_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    setting_groups_disposed = true
  })
})()}

/* harmony default export */ var tournament_setting_groups_setting_groups = (setting_groups_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/tournament/tournament-settings.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */
/* harmony default export */ var tournament_settings = ({
    name: "app-tournament-show",

    components: {
        settingGroups: tournament_setting_groups_setting_groups
    },

    props: {
        id: String
    },

    data: function data() {
        return {
            activeName: 'first'
        };
    },
    created: function created() {
        // this.$store
        //     .dispatch("entities/tournament/detail", this.id)
        //     .catch(() => this.$router.push({ name: "tournamentList" }));
        this.$store.dispatch('entities/tournament/loadOptions');
        this.$store.dispatch("entities/tournament/listTeams");

        // this.$router.push({ name: "settingGroups" })
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        // this.$store.dispatch("entities/tournament/clear");
        next();
    },


    computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
        model: "entities/tournament/model",
        loading: "entities/tournament/loading",
        hasRoleToDelete: "entities/tournament/hasRoleToDelete",
        hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
        hasRoleToRead: "entities/tournament/hasRoleToRead",
        hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
        hasRoleToCreate: "entities/tournament/hasRoleToCreate",
        isMobile: "shared/isMobile",
        labelPosition: "shared/labelPosition",
        labelWidth: "shared/labelWidth",
        options: 'entities/tournament/options',
        teamList: "entities/tournament/teamList"
    })),

    methods: {
        edit: function edit() {
            this.$router.push({
                name: "tournamentEdit",
                params: { id: this.id, previous: "show" }
            });
        },
        destroy: function destroy() {
            var _this = this;

            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            }).then(function () {
                return _this.$store.dispatch("entities/tournament/destroy", _this.model);
            }).then(function () {
                return _this.$router.go(-1);
            }).catch(function () {});
        },
        handleClick: function handleClick(tab, event) {
            // // 1.1 Cargamos los equipos por categoria
            // this.$store.dispatch("entities/tournament/settingGroups/listTeamsByCategoryId", tab.name)
            // // 1.2 Cargamos los grupos por categoria
            // this.$store.dispatch("entities/tournament/settingGroups/listGroup", tab.name)

            // 2. Mostramos la vista
            this.$router.push({
                name: "settingGroups",
                params: { categoryId: tab.name }
            });
        },
        history: function history() {
            this.$router.push({
                name: "tournamentHistorySingle",
                params: { id: this.id }
            });
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709f65d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/tournament/tournament-settings.vue
var tournament_settings_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _vm.hasRoleToReadLogs
                ? _c(
                    "el-breadcrumb",
                    {
                      staticStyle: { float: "right" },
                      attrs: { "separator-class": "el-icon-arrow-right" }
                    },
                    [
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/" } } },
                        [_vm._v(_vm._s(_vm.$t("route.home")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { name: "tournamentList" } } },
                        [_vm._v(_vm._s(_vm.$t("entities.tournament.plural")))]
                      ),
                      _vm._v(" "),
                      _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.model.name))])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(_vm.$t("entities.tournament.settingGroups.title"))
                )
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "page-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("entities.tournament.settingGroups.description")
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "border-card", "tab-position": "top" },
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName"
                        }
                      },
                      [
                        _vm._l(_vm.options.categories, function(item, index) {
                          return _c("el-tab-pane", {
                            key: item.id,
                            attrs: { label: item.label, name: item.id }
                          })
                        }),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "fade", mode: "out-in" } },
                          [_c("router-view")],
                          1
                        )
                      ],
                      2
                    )
                  ]
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var tournament_settings_staticRenderFns = []
tournament_settings_render._withStripped = true
var tournament_settings_esExports = { render: tournament_settings_render, staticRenderFns: tournament_settings_staticRenderFns }
/* harmony default export */ var tournament_tournament_settings = (tournament_settings_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-709f65d5", tournament_settings_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/tournament/tournament-settings.vue
var tournament_settings_disposed = false
function tournament_settings_injectStyle (ssrContext) {
  if (tournament_settings_disposed) return
  __webpack_require__("hFvu")
}
var tournament_settings_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var tournament_settings___vue_template_functional__ = false
/* styles */
var tournament_settings___vue_styles__ = tournament_settings_injectStyle
/* scopeId */
var tournament_settings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tournament_settings___vue_module_identifier__ = null
var tournament_settings_Component = tournament_settings_normalizeComponent(
  tournament_settings,
  tournament_tournament_settings,
  tournament_settings___vue_template_functional__,
  tournament_settings___vue_styles__,
  tournament_settings___vue_scopeId__,
  tournament_settings___vue_module_identifier__
)
tournament_settings_Component.options.__file = "src/entities/tournament/tournament-settings.vue"
if (tournament_settings_Component.esModule && Object.keys(tournament_settings_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-709f65d5", tournament_settings_Component.options)
  } else {
    hotAPI.reload("data-v-709f65d5", tournament_settings_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    tournament_settings_disposed = true
  })
})()}

/* harmony default export */ var entities_tournament_tournament_settings = (tournament_settings_Component.exports);

// CONCATENATED MODULE: ./src/entities/tournament/tournament-routes.js









var tournament_routes_roles = auth_roles.values;

/* harmony default export */ var tournament_routes = ([{
  name: 'tournamentList',
  path: 'tournament',
  component: entities_tournament_tournament_list,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.activityViewer.id, tournament_routes_roles.entityViewer.id, tournament_routes_roles.entityEditor.id, tournament_routes_roles.tournamentViewer.id, tournament_routes_roles.tournamentEditor.id]
  }
}, {
  name: 'tournamentNew',
  path: 'tournament/new',
  component: entities_tournament_tournament_form,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.entityEditor.id, tournament_routes_roles.tournamentEditor.id, tournament_routes_roles.clubManager.id]
  }
}, {
  name: 'tournamentEdit',
  path: 'tournament/:id/edit',
  component: entities_tournament_tournament_form,
  props: true,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.entityEditor.id, tournament_routes_roles.tournamentEditor.id]
  }
}, {
  name: 'tournamentHistorySingle',
  path: 'tournament/:id/history',
  component: tournament_history_tournament_history_single_tournament_history_single,
  props: true,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.activityViewer.id]
  }
}, {
  name: 'tournamentHistoryFull',
  path: 'tournament/history',
  component: tournament_history_tournament_history_full_tournament_history_full,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.activityViewer.id]
  }
}, {
  name: 'tournamentShow',
  path: 'tournament/:id',
  component: entities_tournament_tournament_show,
  props: true,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.activityViewer.id, tournament_routes_roles.entityViewer.id, tournament_routes_roles.entityEditor.id, tournament_routes_roles.tournamentViewer.id, tournament_routes_roles.tournamentEditor.id, tournament_routes_roles.clubManager.id]
  }
}, {
  name: 'tournamentSettings',
  path: 'tournament/settings/:id',
  component: entities_tournament_tournament_settings,
  props: true,
  meta: {
    auth: true,
    roles: [tournament_routes_roles.owner.id, tournament_routes_roles.activityViewer.id, tournament_routes_roles.entityViewer.id, tournament_routes_roles.entityEditor.id, tournament_routes_roles.tournamentViewer.id, tournament_routes_roles.tournamentEditor.id, tournament_routes_roles.clubManager.id]
  },
  children: [{
    name: 'settingGroups',
    path: 'settingGroups/:categoryId',
    component: tournament_setting_groups_setting_groups,
    props: true,
    meta: { auth: true }
  }]
}]);
// CONCATENATED MODULE: ./src/entities/tournament/tournament-module.js



var tournament_module_components = [];
var tournament_module_mixins = [];
var tournament_module_filters = [];
var tournament_module_directives = [];

/* harmony default export */ var tournament_module = ({
  components: tournament_module_components,
  mixins: tournament_module_mixins,
  filters: tournament_module_filters,
  directives: tournament_module_directives,
  routes: tournament_routes,
  store: tournament_store
});
// CONCATENATED MODULE: ./src/entities/entities-routes.js















/* harmony default export */ var entities_routes = ([{
  path: '/entities',
  component: shared_layout_main_layout,
  meta: { auth: true },
  children: [].concat(toConsumableArray_default()(club_module.routes), toConsumableArray_default()(team_module.routes), toConsumableArray_default()(category_module.routes), toConsumableArray_default()(player_module.routes), toConsumableArray_default()(manager_module.routes), toConsumableArray_default()(position_module.routes), toConsumableArray_default()(coach_module.routes), toConsumableArray_default()(team_manager_module.routes), toConsumableArray_default()(document_module.routes), toConsumableArray_default()(field_manager_module.routes), toConsumableArray_default()(referee_module.routes), toConsumableArray_default()(tournament_module.routes))
}]);
// CONCATENATED MODULE: ./src/entities/entities.js
/* harmony default export */ var entities = ({
  value: function value() {
    return [{
      label: 'User',
      name: 'user',
      routePath: 'user',
      databasePath: 'users',
      displayProperty: 'email'
    }, {
      label: 'Club',
      name: 'club',
      routePath: 'club',
      databasePath: 'clubs',
      displayProperty: 'name'
    }, {
      label: 'Team',
      name: 'team',
      routePath: 'team',
      databasePath: 'teams',
      displayProperty: 'name'
    }, {
      label: 'Category',
      name: 'category',
      routePath: 'category',
      databasePath: 'categories',
      displayProperty: 'name'
    }, {
      label: 'Player',
      name: 'player',
      routePath: 'player',
      databasePath: 'players',
      displayProperty: 'id'
    }, {
      label: 'Manager',
      name: 'manager',
      routePath: 'manager',
      databasePath: 'managers',
      displayProperty: 'name'
    }, {
      label: 'Position',
      name: 'position',
      routePath: 'position',
      databasePath: 'positions',
      displayProperty: 'name'
    }];
  },

  get: function get(name) {
    return this.value().find(function (e) {
      return e.name === name;
    });
  },
  findByDatabasePath: function findByDatabasePath(databasePath) {
    return this.value().find(function (e) {
      return e.databasePath === databasePath;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/entities/entity-link.vue
//
//
//
//
//
//
//



/* harmony default export */ var entity_link = ({
  name: "app-entity-link",

  props: {
    entityName: String,
    property: Object
  },

  computed: {
    entity: function entity() {
      return entities.get(this.entityName);
    },
    hasRoleToRead: function hasRoleToRead() {
      return this.$store.getters["entities/" + this.entity.name.singular + "/hasRoleToRead"];
    },
    route: function route() {
      return {
        name: this.entity.name.singular + "Show",
        params: { id: this.property.id }
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8ebf40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/entities/entity-link.vue
var entity_link_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.property
    ? _c(
        "div",
        [
          _vm.hasRoleToRead
            ? _c("router-link", { attrs: { to: _vm.route } }, [
                _vm._v(_vm._s(_vm.property.label))
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hasRoleToRead
            ? _c("span", [_vm._v(_vm._s(_vm.property.label))])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var entity_link_staticRenderFns = []
entity_link_render._withStripped = true
var entity_link_esExports = { render: entity_link_render, staticRenderFns: entity_link_staticRenderFns }
/* harmony default export */ var entities_entity_link = (entity_link_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8ebf40", entity_link_esExports)
  }
}
// CONCATENATED MODULE: ./src/entities/entity-link.vue
var entity_link_disposed = false
function entity_link_injectStyle (ssrContext) {
  if (entity_link_disposed) return
  __webpack_require__("iKfW")
}
var entity_link_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var entity_link___vue_template_functional__ = false
/* styles */
var entity_link___vue_styles__ = entity_link_injectStyle
/* scopeId */
var entity_link___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var entity_link___vue_module_identifier__ = null
var entity_link_Component = entity_link_normalizeComponent(
  entity_link,
  entities_entity_link,
  entity_link___vue_template_functional__,
  entity_link___vue_styles__,
  entity_link___vue_scopeId__,
  entity_link___vue_module_identifier__
)
entity_link_Component.options.__file = "src/entities/entity-link.vue"
if (entity_link_Component.esModule && Object.keys(entity_link_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7c8ebf40", entity_link_Component.options)
  } else {
    hotAPI.reload("data-v-7c8ebf40", entity_link_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    entity_link_disposed = true
  })
})()}

/* harmony default export */ var src_entities_entity_link = (entity_link_Component.exports);

// CONCATENATED MODULE: ./src/entities/entities-module.js
















var entities_module_entities = [club_module, team_module, category_module, player_module, manager_module, position_module, coach_module, team_manager_module, document_module, field_manager_module, referee_module, tournament_module];

var extractFromEntities = function extractFromEntities(property) {
  return entities_module_entities.map(function (entity) {
    return entity[property] || [];
  }).reduce(function (a, b) {
    return a.concat(b);
  }, []);
};

/* harmony default export */ var entities_module = ({
  components: [src_entities_entity_link].concat(toConsumableArray_default()(extractFromEntities('components'))),
  mixins: [].concat(toConsumableArray_default()(extractFromEntities('mixins'))),
  filters: [].concat(toConsumableArray_default()(extractFromEntities('filters'))),
  directives: [].concat(toConsumableArray_default()(extractFromEntities('directives'))),
  routes: entities_routes,
  store: {
    namespaced: true,

    modules: {
      club: club_module.store,
      team: team_module.store,
      category: category_module.store,
      player: player_module.store,
      manager: manager_module.store,
      position: position_module.store,
      coach: coach_module.store,
      "team-manager": team_manager_module.store,
      document: document_module.store,
      fieldManager: field_manager_module.store,
      referee: referee_module.store,
      tournament: tournament_module.store
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-detail.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var user_detail = ({
  name: "app-user-detail",

  props: {
    user: Object
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    hasRoleToUpdate: "user/hasRoleToUpdate",
    hasRoleToReadLogs: "user/hasRoleToReadLogs",
    hasRoleToReadActivity: "user/hasRoleToReadActivity"
  })),

  methods: {
    history: function history() {
      this.$router.push({
        name: "userHistorySingle",
        params: { id: this.user.id }
      });
    },
    activity: function activity() {
      this.$router.push({
        name: "userActivity",
        params: { id: this.user.id }
      });
    },
    edit: function edit() {
      this.$router.push({
        name: "userEdit",
        params: { id: this.user.id, previous: "show" }
      });
    },
    roleLabel: function roleLabel(roleId) {
      return auth_roles.labelOf(roleId);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0017d2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-detail.vue
var user_detail_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      staticClass: "show",
      attrs: { "label-width": "180px", "label-position": "right" }
    },
    [
      _c("el-form-item", { attrs: { label: "Id" } }, [
        _vm._v(_vm._s(_vm.user.id))
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Email" } }, [
        _vm._v(_vm._s(_vm.user.email))
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Roles" } },
        _vm._l(_vm.user.roles, function(role) {
          return _c("div", { key: role }, [_vm._v(_vm._s(_vm.roleLabel(role)))])
        })
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Created at" } }, [
        _vm._v(_vm._s(_vm._f("formatDatetime")(_vm.user.created)))
      ]),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "Updated at" } }, [
        _vm._v(_vm._s(_vm._f("formatDatetime")(_vm.user.modified)))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _vm.hasRoleToUpdate
            ? _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-fa-pencil-square-o",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      _vm.edit()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("table.edit")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadLogs
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-fa-history", type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.history()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("table.history")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasRoleToReadActivity
            ? _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-fa-eye", type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.activity()
                    }
                  }
                },
                [_vm._v("Activity")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var user_detail_staticRenderFns = []
user_detail_render._withStripped = true
var user_detail_esExports = { render: user_detail_render, staticRenderFns: user_detail_staticRenderFns }
/* harmony default export */ var user_user_detail = (user_detail_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0017d2d9", user_detail_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-detail.vue
var user_detail_disposed = false
function user_detail_injectStyle (ssrContext) {
  if (user_detail_disposed) return
  __webpack_require__("STxz")
}
var user_detail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_detail___vue_template_functional__ = false
/* styles */
var user_detail___vue_styles__ = user_detail_injectStyle
/* scopeId */
var user_detail___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_detail___vue_module_identifier__ = null
var user_detail_Component = user_detail_normalizeComponent(
  user_detail,
  user_user_detail,
  user_detail___vue_template_functional__,
  user_detail___vue_styles__,
  user_detail___vue_scopeId__,
  user_detail___vue_module_identifier__
)
user_detail_Component.options.__file = "src/user/user-detail.vue"
if (user_detail_Component.esModule && Object.keys(user_detail_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0017d2d9", user_detail_Component.options)
  } else {
    hotAPI.reload("data-v-0017d2d9", user_detail_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_detail_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_detail = (user_detail_Component.exports);

// CONCATENATED MODULE: ./src/user/user-history/user-history-full/user-history-full-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';

/* harmony default export */ var user_history_full_service = ({
  /* eslint-disable */
  fetch: function fetch(lastmodified) {
    // eslint-disable-next-line 

    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/users/history`, {
    //       params: { lastmodified }
    //     })
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/user/user-history/user-history-full/user-history-full-store.js


/* harmony default export */ var user_history_full_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    last: true
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    last: function last(state) {
      return state.last;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    LAST: function LAST(state, payload) {
      state.last = !!payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.last = true;
    }
  },

  actions: {
    setup: function setup(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('CLEAR');
      return dispatch('fetch');
    },
    fetch: function fetch(_ref2) {
      var commit = _ref2.commit,
          getters = _ref2.getters;

      commit('LOADING', true);

      var lastmodified = getters.list && getters.list.length ? getters.list[getters.list.length - 1].modified : null;

      return user_history_full_service.fetch(lastmodified).then(function (response) {
        commit('LAST', response.last);
        commit('LIST', getters.list.concat(response.data));
        commit('LOADING', false);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/user/user-history/user-history-single/user-history-single-service.js
// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
/* harmony default export */ var user_history_single_service = ({
  list: function list(id) {
    // return firebaseAxios().then((axios) =>
    //   axios
    //     .get(`/users/${id}/history`)
    //     .then((response) => response.data)
    // );
  }
});
// CONCATENATED MODULE: ./src/user/user-history/user-history-single/user-history-single-store.js




/* harmony default export */ var user_history_single_store = ({
  namespaced: true,

  state: {
    loading: false,
    list: [],
    pager: new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'email']),
    model: null
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload;
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['modifiedBy.email', 'createdBy.email', 'deletedBy.email', 'email']);
      state.model = null;
    }
  },

  actions: {
    setup: function setup(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters;

      commit('LOADING', true);

      return dispatch('list', id).then(function () {
        if (!getters.list || !getters.list.length) {
          commit('MODEL', {});
        } else {
          commit('MODEL', getters.list[0]);
        }

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref2, id) {
      var commit = _ref2.commit;

      commit('LIST', []);

      return user_history_single_service.list(id).then(function (list) {
        commit('LIST', list);
      });
    },
    clear: function clear(_ref3) {
      var commit = _ref3.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./src/user/user-store.js



 // Internationalization




/* harmony default export */ var user_store = ({
  namespaced: true,

  modules: {
    historyFull: user_history_full_store,
    historySingle: user_history_single_store
  },

  state: {
    loading: false,
    list: [],
    pager: new pager(['email']),
    model: { emails: [] }
  },

  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    list: function list(state) {
      return state.list;
    },
    pager: function pager(state) {
      return state.pager;
    },
    model: function model(state) {
      return state.model;
    },
    hasRoleToRead: function hasRoleToRead(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.securityReviewer.id, roles.activityViewer.id]);
    },
    hasRoleToReadActivity: function hasRoleToReadActivity(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToReadLogs: function hasRoleToReadLogs(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.activityViewer.id]);
    },
    hasRoleToUpdate: function hasRoleToUpdate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.securityReviewer.id]);
    },
    hasRoleToCreate: function hasRoleToCreate(state, getters, rootState, rootGetters) {
      var roles = auth_roles.values;
      return rootGetters['auth/hasRole']([roles.owner.id, roles.securityReviewer.id]);
    }
  },

  mutations: {
    LOADING: function LOADING(state, payload) {
      state.loading = !!payload;
    },
    LIST: function LIST(state, payload) {
      state.list = payload || [];
    },
    MODEL: function MODEL(state, payload) {
      state.model = payload || { emails: [] };
    },
    CLEAR: function CLEAR(state) {
      state.loading = false;
      state.list = [];
      state.pager = new pager(['email']);
      state.model = {};
    }
  },

  actions: {
    detail: function detail(_ref, id) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('LOADING', true);

      return user_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    new: function _new(_ref2) {
      var commit = _ref2.commit;

      commit('MODEL', null);
    },
    edit: function edit(_ref3, id) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      commit('LOADING', true);

      return user_service.find(id).then(function (model) {
        if (!model || !model.id) {
          return promise_default.a.reject(new Error('Not found'));
        }

        commit('MODEL', model);
        commit('LOADING', false);
        return promise_default.a.resolve();
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    update: function update(_ref4) {
      var getters = _ref4.getters,
          commit = _ref4.commit,
          rootGetters = _ref4.rootGetters,
          dispatch = _ref4.dispatch;

      commit('LOADING', true);

      return user_service.update(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', 'User saved successfully!', { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    create: function create(_ref5) {
      var getters = _ref5.getters,
          commit = _ref5.commit,
          rootGetters = _ref5.rootGetters,
          dispatch = _ref5.dispatch;

      commit('LOADING', true);

      return user_service.createAll(getters.model, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.user.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    addProperty: function addProperty(_ref6, property) {
      var getters = _ref6.getters,
          commit = _ref6.commit,
          rootGetters = _ref6.rootGetters,
          dispatch = _ref6.dispatch;

      // console.log(" ADD PRPERTY - STORE ", property);

      commit('LOADING', true);

      return user_service.addAllUsersProperty(property, rootGetters['auth/user']).then(function () {
        dispatch('shared/success', src_lang.t('entities.user.singular') + ' ' + src_lang.t('notification.savedSuccessfully'), { root: true });

        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    list: function list(_ref7) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      commit('LIST', []);
      commit('LOADING', true);

      return user_service.list().then(function (list) {
        commit('LIST', list);
        commit('LOADING', false);
      }).catch(function (error) {
        commit('LOADING', false);
        dispatch('shared/error', error, { root: true });
        return promise_default.a.reject(error);
      });
    },
    clear: function clear(_ref8) {
      var commit = _ref8.commit;

      commit('CLEAR');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-list.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var user_list = ({
  name: "app-user-list",

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "user/loading",
    list: "user/list",
    pager: "user/pager",
    hasRoleToCreate: "user/hasRoleToCreate",
    hasRoleToUpdate: "user/hasRoleToUpdate",
    isMobile: "shared/isMobile",
    paginationLayout: "shared/paginationLayout"
  })),

  data: function data() {
    return {
      vOpenDialog: false,
      form: {
        property: ''
        // key: ''
      }
    };
  },
  created: function created() {
    this.$store.dispatch("user/list");
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("user/list");
    next();
  },


  methods: {
    create: function create() {
      this.$router.push({
        name: "userNew"
      });
    },
    addProperty: function addProperty() {
      var _this = this;

      if (this.form.property !== "") {
        this.$store.dispatch("user/addProperty", this.form.property).then(function () {
          // Reseteamos los datos
          _this.form.property = '';
          _this.vOpenDialog = false;
        });
      }
    },
    show: function show(id) {
      this.$router.push({
        name: "userShow",
        params: { id: id }
      });
    },
    edit: function edit(id) {
      this.$router.push({
        name: "userEdit",
        params: { id: id }
      });
    },
    viewActivity: function viewActivity(id) {
      this.$router.push({
        name: "userActivity",
        params: { id: id }
      });
    },
    roleLabel: function roleLabel(roleId) {
      return auth_roles.labelOf(roleId);
    },
    history: function history() {
      this.$router.push({ name: "userHistoryFull" });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-407cd8a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-list.vue
var user_list_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("route.users")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v(" " + _vm._s(_vm.$t("entities.user.plural")) + " ")
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, md: 8 } },
            [
              _c(
                "el-form",
                {
                  staticClass: "search",
                  attrs: { inline: true },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-input",
                        {
                          attrs: { placeholder: _vm.$t("table.search") },
                          model: {
                            value: _vm.pager.search,
                            callback: function($$v) {
                              _vm.$set(_vm.pager, "search", $$v)
                            },
                            expression: "pager.search"
                          }
                        },
                        [
                          _c("el-button", {
                            attrs: { slot: "append", icon: "el-icon-search" },
                            slot: "append"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "button-group", attrs: { xs: 24, md: 16 } },
            [
              _vm.hasRoleToCreate
                ? _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-fa-file-o", type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.create()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("table.add")) + "\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-circle-plus-outline",
                    type: "primary"
                  },
                  on: {
                    click: function($event) {
                      _vm.vOpenDialog = true
                    }
                  }
                },
                [
                  _vm._v(
                    "\n    " + _vm._s(_vm.$t("table.addProperty")) + "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "Asignar property a todos",
                    visible: _vm.vOpenDialog,
                    width: "30%",
                    center: ""
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.vOpenDialog = $event
                    }
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "demo-form-inline",
                          attrs: { inline: true, model: _vm.form }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Nombre de la property" },
                                model: {
                                  value: _vm.form.property,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "property", $$v)
                                  },
                                  expression: "form.property"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              _vm.vOpenDialog = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("table.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addProperty }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("table.confirm")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-fa-history", type: "infor" },
                  on: {
                    click: function($event) {
                      _vm.history()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("table.history")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "email",
              order: "ascending"
            },
            "empty-text": "There are no users yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "roles", label: "Roles" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.roles, function(role) {
                    return _c("div", { key: role }, [
                      _vm._v(_vm._s(_vm.roleLabel(role)))
                    ])
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "created", label: "Created At", sortable: "custom" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDatetime")(scope.row.created)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: _vm.isMobile ? undefined : "right",
              label: "Operations",
              align: "center",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Details", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            icon: "el-icon-fa-search",
                            size: "small",
                            type: "text"
                          },
                          on: {
                            click: function($event) {
                              _vm.show(scope.row.id)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.hasRoleToUpdate
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("table.edit"),
                              placement: "top"
                            }
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                icon: "el-icon-fa-pencil-square-o",
                                size: "small",
                                type: "text"
                              },
                              on: {
                                click: function($event) {
                                  _vm.edit(scope.row.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      { attrs: { content: "Activity", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            icon: "el-icon-fa-eye",
                            size: "small",
                            type: "text"
                          },
                          on: {
                            click: function($event) {
                              _vm.viewActivity(scope.row.id)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var user_list_staticRenderFns = []
user_list_render._withStripped = true
var user_list_esExports = { render: user_list_render, staticRenderFns: user_list_staticRenderFns }
/* harmony default export */ var user_user_list = (user_list_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-407cd8a6", user_list_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-list.vue
var user_list_disposed = false
function user_list_injectStyle (ssrContext) {
  if (user_list_disposed) return
  __webpack_require__("UKI4")
}
var user_list_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_list___vue_template_functional__ = false
/* styles */
var user_list___vue_styles__ = user_list_injectStyle
/* scopeId */
var user_list___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_list___vue_module_identifier__ = null
var user_list_Component = user_list_normalizeComponent(
  user_list,
  user_user_list,
  user_list___vue_template_functional__,
  user_list___vue_styles__,
  user_list___vue_scopeId__,
  user_list___vue_module_identifier__
)
user_list_Component.options.__file = "src/user/user-list.vue"
if (user_list_Component.esModule && Object.keys(user_list_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-407cd8a6", user_list_Component.options)
  } else {
    hotAPI.reload("data-v-407cd8a6", user_list_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_list_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_list = (user_list_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-history/user-history-full/user-history-full.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var user_history_full = ({
  name: "app-user-history-full",

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "user/historyFull/loading",
    list: "user/historyFull/list",
    last: "user/historyFull/last"
  })),

  created: function created() {
    this.$store.dispatch("user/historyFull/setup");
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/historyFull/clear");
    next();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    fetch: "user/historyFull/fetch"
  }), {
    roleLabel: function roleLabel(roleId) {
      return auth_roles.labelOf(roleId);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78c3cb9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-history/user-history-full/user-history-full.vue
var user_history_full_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "userList" } } }, [
            _vm._v("Users")
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("Users " + _vm._s(_vm.$t("table.history")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "empty-text": "There is no history yet",
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "modified", label: "Updated at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.modified))
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Updated by", prop: "modifiedBy.email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "email", label: "Email" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "roles", label: "Roles" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return _vm._l(scope.row.roles, function(role) {
                        return _c("div", { key: role }, [
                          _vm._v(_vm._s(_vm.roleLabel(role)))
                        ])
                      })
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "created", label: "Created at", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm._f("formatDatetime")(scope.row.created))
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Created by", prop: "createdBy.email" }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.last
            ? _c(
                "el-button",
                {
                  staticClass: "mt-3 w-100",
                  attrs: { type: "infor", icon: "el-icon-fa-plus" },
                  on: {
                    click: function($event) {
                      _vm.fetch()
                    }
                  }
                },
                [_vm._v("Load more...")]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var user_history_full_staticRenderFns = []
user_history_full_render._withStripped = true
var user_history_full_esExports = { render: user_history_full_render, staticRenderFns: user_history_full_staticRenderFns }
/* harmony default export */ var user_history_full_user_history_full = (user_history_full_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78c3cb9c", user_history_full_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-history/user-history-full/user-history-full.vue
var user_history_full_disposed = false
function user_history_full_injectStyle (ssrContext) {
  if (user_history_full_disposed) return
  __webpack_require__("itn9")
}
var user_history_full_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_history_full___vue_template_functional__ = false
/* styles */
var user_history_full___vue_styles__ = user_history_full_injectStyle
/* scopeId */
var user_history_full___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_history_full___vue_module_identifier__ = null
var user_history_full_Component = user_history_full_normalizeComponent(
  user_history_full,
  user_history_full_user_history_full,
  user_history_full___vue_template_functional__,
  user_history_full___vue_styles__,
  user_history_full___vue_scopeId__,
  user_history_full___vue_module_identifier__
)
user_history_full_Component.options.__file = "src/user/user-history/user-history-full/user-history-full.vue"
if (user_history_full_Component.esModule && Object.keys(user_history_full_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-78c3cb9c", user_history_full_Component.options)
  } else {
    hotAPI.reload("data-v-78c3cb9c", user_history_full_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_history_full_disposed = true
  })
})()}

/* harmony default export */ var user_history_user_history_full_user_history_full = (user_history_full_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-history/user-history-single/user-history-single.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var user_history_single = ({
  name: "app-user-history-single",

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "user/historySingle/loading",
    list: "user/historySingle/list",
    pager: "user/historySingle/pager",
    model: "user/historySingle/model",
    paginationLayout: "shared/paginationLayout"
  })),

  methods: {
    roleLabel: function roleLabel(roleId) {
      return auth_roles.labelOf(roleId);
    }
  },

  created: function created() {
    this.$store.dispatch("user/historySingle/setup", this.id);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/historySingle/clear");
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c557b64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-history/user-history-single/user-history-single.vue
var user_history_single_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        {
          staticStyle: { float: "right" },
          attrs: { "separator-class": "el-icon-arrow-right" }
        },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _vm._v(" " + _vm._s(_vm.$t("route.home")))
          ]),
          _vm._v(" "),
          _c("el-breadcrumb-item", { attrs: { to: { name: "userList" } } }, [
            _vm._v("Users")
          ]),
          _vm._v(" "),
          _vm.model
            ? _c(
                "el-breadcrumb-item",
                {
                  attrs: {
                    to: { name: "userShow", params: { id: _vm.model.id } }
                  }
                },
                [_vm._v(_vm._s(_vm.model.email))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-breadcrumb-item", [_vm._v(_vm._s(_vm.$t("table.history")))])
        ],
        1
      ),
      _vm._v(" "),
      _c("h2", { staticClass: "page-title" }, [
        _vm._v("User " + _vm._s(_vm.$t("table.history")))
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "search",
          attrs: { inline: true },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "el-form-item",
            [
              _c(
                "el-input",
                {
                  attrs: { placeholder: _vm.$t("table.search") },
                  model: {
                    value: _vm.pager.search,
                    callback: function($$v) {
                      _vm.$set(_vm.pager, "search", $$v)
                    },
                    expression: "pager.search"
                  }
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    slot: "append"
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.pager.paginate(_vm.list),
            "default-sort": {
              prop: "modified",
              order: "descending"
            },
            "empty-text": "There is no history yet",
            border: ""
          },
          on: {
            "sort-change": function(args) {
              return _vm.pager.sortChange(args)
            }
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "modified",
              label: "Updated at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDatetime")(scope.row.modified)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Updated by",
              prop: "modifiedBy.email",
              sortable: "custom"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "email", label: "Email", sortable: "custom" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "roles", label: "Roles" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.roles, function(role) {
                    return _c("div", { key: role }, [
                      _vm._v(_vm._s(_vm.roleLabel(role)))
                    ])
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "created",
              label: "Created at",
              width: "180",
              sortable: "custom"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(_vm._s(_vm._f("formatDatetime")(scope.row.created)))
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "Created by",
              prop: "createdBy.email",
              sortable: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-3" },
        [
          _c("el-pagination", {
            staticStyle: { float: "right" },
            attrs: {
              "current-page": _vm.pager.currentPage,
              layout: _vm.paginationLayout,
              total: _vm.pager.filteredAndSortedList(_vm.list).length,
              background: ""
            },
            on: {
              "size-change": function(args) {
                return _vm.pager.pageSizeChange(args)
              },
              "update:currentPage": function($event) {
                _vm.$set(_vm.pager, "currentPage", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var user_history_single_staticRenderFns = []
user_history_single_render._withStripped = true
var user_history_single_esExports = { render: user_history_single_render, staticRenderFns: user_history_single_staticRenderFns }
/* harmony default export */ var user_history_single_user_history_single = (user_history_single_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c557b64", user_history_single_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-history/user-history-single/user-history-single.vue
var user_history_single_disposed = false
function user_history_single_injectStyle (ssrContext) {
  if (user_history_single_disposed) return
  __webpack_require__("udEE")
}
var user_history_single_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_history_single___vue_template_functional__ = false
/* styles */
var user_history_single___vue_styles__ = user_history_single_injectStyle
/* scopeId */
var user_history_single___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_history_single___vue_module_identifier__ = null
var user_history_single_Component = user_history_single_normalizeComponent(
  user_history_single,
  user_history_single_user_history_single,
  user_history_single___vue_template_functional__,
  user_history_single___vue_styles__,
  user_history_single___vue_scopeId__,
  user_history_single___vue_module_identifier__
)
user_history_single_Component.options.__file = "src/user/user-history/user-history-single/user-history-single.vue"
if (user_history_single_Component.esModule && Object.keys(user_history_single_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c557b64", user_history_single_Component.options)
  } else {
    hotAPI.reload("data-v-4c557b64", user_history_single_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_history_single_disposed = true
  })
})()}

/* harmony default export */ var user_history_user_history_single_user_history_single = (user_history_single_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-show.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var user_show = ({
  name: "app-user-show",

  props: {
    id: String
  },

  data: function data() {
    return {
      tab: "0"
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "user/loading",
    model: "user/model"
  })),

  created: function created() {
    var _this = this;

    this.$store.dispatch("user/detail", this.id).catch(function () {
      return _this.$router.push({ name: "userList" });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d488f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-show.vue
var user_show_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "userList" } } },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _vm.model
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.model.email))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [_vm._v("User")]),
              _vm._v(" "),
              _vm.tab === "0"
                ? _c("app-user-detail", { attrs: { user: _vm.model } })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var user_show_staticRenderFns = []
user_show_render._withStripped = true
var user_show_esExports = { render: user_show_render, staticRenderFns: user_show_staticRenderFns }
/* harmony default export */ var user_user_show = (user_show_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47d488f6", user_show_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-show.vue
var user_show_disposed = false
function user_show_injectStyle (ssrContext) {
  if (user_show_disposed) return
  __webpack_require__("G7YU")
}
var user_show_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_show___vue_template_functional__ = false
/* styles */
var user_show___vue_styles__ = user_show_injectStyle
/* scopeId */
var user_show___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_show___vue_module_identifier__ = null
var user_show_Component = user_show_normalizeComponent(
  user_show,
  user_user_show,
  user_show___vue_template_functional__,
  user_show___vue_styles__,
  user_show___vue_scopeId__,
  user_show___vue_module_identifier__
)
user_show_Component.options.__file = "src/user/user-show.vue"
if (user_show_Component.esModule && Object.keys(user_show_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47d488f6", user_show_Component.options)
  } else {
    hotAPI.reload("data-v-47d488f6", user_show_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_show_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_show = (user_show_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-edit.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var user_edit = ({
  name: "app-user-edit",

  props: {
    id: String,
    previous: String
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch("user/edit", this.id).catch(function () {
      return _this.$router.push({ name: "userList" });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: "user/model",
    loading: "user/loading",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  }), {

    editing: function editing(state) {
      return !!state.id;
    },

    roles: function roles() {
      return auth_roles.asArray;
    }
  }),

  methods: {
    save: function save() {
      var _this2 = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this2.$store.dispatch("user/update").then(function () {
          _this2.back();
        });
      });
    },
    back: function back() {
      if (this.previous === "show") {
        this.$router.push({
          name: "userShow",
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: "userList" });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fc50012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-edit.vue
var user_edit_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "userList" } } },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _vm.model
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.model.email))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v(_vm._s(_vm.$t("table.edit")) + " User")
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Email", prop: "email" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "email", $$v)
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Roles", prop: "roles" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { multiple: "", filterable: "" },
                                  model: {
                                    value: _vm.model.roles,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "roles", $$v)
                                    },
                                    expression: "model.roles"
                                  }
                                },
                                [
                                  _vm.roles
                                    ? _vm._l(_vm.roles, function(option) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option.id
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var user_edit_staticRenderFns = []
user_edit_render._withStripped = true
var user_edit_esExports = { render: user_edit_render, staticRenderFns: user_edit_staticRenderFns }
/* harmony default export */ var user_user_edit = (user_edit_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fc50012", user_edit_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-edit.vue
var user_edit_disposed = false
function user_edit_injectStyle (ssrContext) {
  if (user_edit_disposed) return
  __webpack_require__("zuGX")
}
var user_edit_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_edit___vue_template_functional__ = false
/* styles */
var user_edit___vue_styles__ = user_edit_injectStyle
/* scopeId */
var user_edit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_edit___vue_module_identifier__ = null
var user_edit_Component = user_edit_normalizeComponent(
  user_edit,
  user_user_edit,
  user_edit___vue_template_functional__,
  user_edit___vue_styles__,
  user_edit___vue_scopeId__,
  user_edit___vue_module_identifier__
)
user_edit_Component.options.__file = "src/user/user-edit.vue"
if (user_edit_Component.esModule && Object.keys(user_edit_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fc50012", user_edit_Component.options)
  } else {
    hotAPI.reload("data-v-4fc50012", user_edit_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_edit_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_edit = (user_edit_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-new.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var user_new_emailsValidator = function emailsValidator() {
  var requiredFn = function requiredFn(rule, value, callback) {
    if (!value || !value.length) {
      callback(new Error("Must select at least one email"));
      return;
    }

    callback();
  };

  var emailFn = function emailFn(rule, value, callback) {
    if (!value || !value.length) {
      callback();
      return;
    }

    var isEmailValid = function isEmailValid(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    };

    // eslint-disable-next-line
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = get_iterator_default()(value), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var email = _step.value;

        if (!isEmailValid(email)) {
          callback(new Error("Email " + email + " is invalid"));
          return;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    callback();
  };

  var output = [];

  output.push({
    type: "array",
    required: true,
    validator: requiredFn
  });

  output.push({
    type: "array",
    validator: emailFn
  });

  return output;
};

var rolesValidator = function rolesValidator() {
  var requiredFn = function requiredFn(rule, value, callback) {
    if (!value || !value.length) {
      callback(new Error("Must select at least one role"));
      return;
    }

    callback();
  };

  var output = [];

  output.push({
    type: "array",
    required: true,
    validator: requiredFn
  });

  return output;
};

/* harmony default export */ var user_new = ({
  name: "app-user-new",

  props: {
    id: String,
    previous: String
  },

  data: function data() {
    return {
      rules: {
        emails: user_new_emailsValidator(),
        roles: rolesValidator()
      }
    };
  },
  created: function created() {
    this.$store.dispatch("user/new");
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    model: "user/model",
    loading: "user/loading",
    labelPosition: "shared/labelPosition",
    labelWidth: "shared/labelWidth"
  }), {

    editing: function editing(state) {
      return !!state.id;
    },

    roles: function roles() {
      return auth_roles.asArray;
    }
  }),

  methods: {
    save: function save() {
      var _this = this;

      this.$refs.form.validate().then(function (valid) {
        if (!valid) {
          return;
        }

        _this.$store.dispatch("user/create").then(function () {
          _this.back();
        });
      });
    },
    back: function back() {
      if (this.previous === "show") {
        this.$router.push({
          name: "userShow",
          params: { id: this.id }
        });
        return;
      }

      this.$router.push({ name: "userList" });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6949c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-new.vue
var user_new_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "userList" } } },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("New")])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [_vm._v("New Users")]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    rules: _vm.rules,
                    model: _vm.model,
                    "label-position": _vm.labelPosition,
                    "label-width": _vm.labelWidth
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                      _vm.save($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "block" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Emails", prop: "emails" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c("el-select", {
                                attrs: {
                                  "default-first-option": "",
                                  multiple: "",
                                  filterable: "",
                                  "allow-create": "",
                                  placeholder: "Emails",
                                  "no-data-text":
                                    "Please inform the email and press enter"
                                },
                                model: {
                                  value: _vm.model.emails,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "emails", $$v)
                                  },
                                  expression: "model.emails"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "Roles", prop: "roles" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { lg: 11, md: 16, sm: 24 } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    placeholder: "Roles"
                                  },
                                  model: {
                                    value: _vm.model.roles,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "roles", $$v)
                                    },
                                    expression: "model.roles"
                                  }
                                },
                                [
                                  _vm.roles
                                    ? _vm._l(_vm.roles, function(option) {
                                        return _c("el-option", {
                                          key: option.id,
                                          attrs: {
                                            label: option.label,
                                            value: option.id
                                          }
                                        })
                                      })
                                    : _vm._e()
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "button-group mt-3" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            type: "primary",
                            icon: "el-icon-fa-floppy-o"
                          },
                          on: {
                            click: function($event) {
                              _vm.save()
                            }
                          }
                        },
                        [_vm._v("Save")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            icon: "el-icon-fa-times"
                          },
                          on: {
                            click: function($event) {
                              _vm.back()
                            }
                          }
                        },
                        [_vm._v("Cancel")]
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var user_new_staticRenderFns = []
user_new_render._withStripped = true
var user_new_esExports = { render: user_new_render, staticRenderFns: user_new_staticRenderFns }
/* harmony default export */ var user_user_new = (user_new_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d6949c8", user_new_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-new.vue
var user_new_disposed = false
function user_new_injectStyle (ssrContext) {
  if (user_new_disposed) return
  __webpack_require__("jyal")
}
var user_new_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_new___vue_template_functional__ = false
/* styles */
var user_new___vue_styles__ = user_new_injectStyle
/* scopeId */
var user_new___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_new___vue_module_identifier__ = null
var user_new_Component = user_new_normalizeComponent(
  user_new,
  user_user_new,
  user_new___vue_template_functional__,
  user_new___vue_styles__,
  user_new___vue_scopeId__,
  user_new___vue_module_identifier__
)
user_new_Component.options.__file = "src/user/user-new.vue"
if (user_new_Component.esModule && Object.keys(user_new_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d6949c8", user_new_Component.options)
  } else {
    hotAPI.reload("data-v-6d6949c8", user_new_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_new_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_new = (user_new_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/user/user-activity.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var user_activity = ({
  name: "app-user-activity",

  props: {
    id: String
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])({
    loading: "user/loading",
    model: "user/model"
  })),

  created: function created() {
    var _this = this;

    this.$store.dispatch("user/detail", this.id).catch(function () {
      return _this.$router.push({ name: "userList" });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/clear");
    next();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c247ad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/user/user-activity.vue
var user_activity_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "div",
            [
              _c(
                "el-breadcrumb",
                {
                  staticStyle: { float: "right" },
                  attrs: { "separator-class": "el-icon-arrow-right" }
                },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v(" " + _vm._s(_vm.$t("route.home")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-breadcrumb-item",
                    { attrs: { to: { name: "userList" } } },
                    [_vm._v("Users")]
                  ),
                  _vm._v(" "),
                  _vm.model
                    ? _c(
                        "el-breadcrumb-item",
                        {
                          attrs: {
                            to: {
                              name: "userShow",
                              params: { id: _vm.model.id }
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.model.email))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("Activity")])
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "page-title" }, [
                _vm._v("User Activity Log")
              ]),
              _vm._v(" "),
              _c("app-activity-list", { attrs: { user: _vm.model } })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var user_activity_staticRenderFns = []
user_activity_render._withStripped = true
var user_activity_esExports = { render: user_activity_render, staticRenderFns: user_activity_staticRenderFns }
/* harmony default export */ var user_user_activity = (user_activity_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c247ad2", user_activity_esExports)
  }
}
// CONCATENATED MODULE: ./src/user/user-activity.vue
var user_activity_disposed = false
function user_activity_injectStyle (ssrContext) {
  if (user_activity_disposed) return
  __webpack_require__("gbTs")
}
var user_activity_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var user_activity___vue_template_functional__ = false
/* styles */
var user_activity___vue_styles__ = user_activity_injectStyle
/* scopeId */
var user_activity___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var user_activity___vue_module_identifier__ = null
var user_activity_Component = user_activity_normalizeComponent(
  user_activity,
  user_user_activity,
  user_activity___vue_template_functional__,
  user_activity___vue_styles__,
  user_activity___vue_scopeId__,
  user_activity___vue_module_identifier__
)
user_activity_Component.options.__file = "src/user/user-activity.vue"
if (user_activity_Component.esModule && Object.keys(user_activity_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c247ad2", user_activity_Component.options)
  } else {
    hotAPI.reload("data-v-4c247ad2", user_activity_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    user_activity_disposed = true
  })
})()}

/* harmony default export */ var src_user_user_activity = (user_activity_Component.exports);

// CONCATENATED MODULE: ./src/user/user-routes.js










var user_routes_roles = auth_roles.values;

/* harmony default export */ var user_routes = ([{
  path: '',
  component: shared_layout_main_layout,
  meta: { auth: true },
  children: [{
    name: 'userList',
    path: 'user',
    component: src_user_user_list,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.securityReviewer.id, user_routes_roles.activityViewer.id]
    }
  }, {
    name: 'userEdit',
    path: 'user/:id/edit',
    component: src_user_user_edit,
    props: true,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.securityReviewer.id]
    }
  }, {
    name: 'userNew',
    path: 'user/new',
    component: src_user_user_new,
    props: true,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.securityReviewer.id]
    }
  }, {
    name: 'userActivity',
    path: 'user/:id/activity',
    component: src_user_user_activity,
    props: true,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.activityViewer.id]
    }
  }, {
    name: 'userHistorySingle',
    path: 'user/:id/history',
    component: user_history_user_history_single_user_history_single,
    props: true,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.activityViewer.id]
    }
  }, {
    name: 'userHistoryFull',
    path: 'user/history',
    component: user_history_user_history_full_user_history_full,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.activityViewer.id]
    }
  }, {
    name: 'userShow',
    path: 'user/:id',
    component: src_user_user_show,
    props: true,
    meta: {
      auth: true,
      roles: [user_routes_roles.owner.id, user_routes_roles.securityReviewer.id]
    }
  }]
}]);
// CONCATENATED MODULE: ./src/user/user-module.js




var user_module_components = [src_user_user_detail];

/* harmony default export */ var user_module = ({
  components: user_module_components,
  routes: user_routes,
  store: user_store
});
// CONCATENATED MODULE: ./src/app-module.js












var rootPath = '/dashboard';

var modules = {
  shared: shared_module,
  dashboard: dashboard_module,
  activity: activity_module,
  auth: auth_module,
  user: user_module,
  entities: entities_module
};

// start - boilerplate code

var exists = function exists(el) {
  return !!el;
};

function setupComponentsFiltersDirectivesAndMixins() {
  keys_default()(modules).map(function (key) {
    return modules[key].components;
  }).filter(exists).forEach(function (components) {
    components.forEach(function (component) {
      vue_esm["default"].component(component.name, component);
    });
  });

  keys_default()(modules).map(function (key) {
    return modules[key].filters;
  }).filter(exists).forEach(function (components) {
    components.forEach(function (filter) {
      vue_esm["default"].filter(filter.name, filter.implementation);
    });
  });

  keys_default()(modules).map(function (key) {
    return modules[key].directives;
  }).filter(exists).forEach(function (directives) {
    directives.forEach(function (directive) {
      vue_esm["default"].directive(directive.name, directive.implementation);
    });
  });

  keys_default()(modules).map(function (key) {
    return modules[key].mixins;
  }).filter(exists).forEach(function (mixins) {
    mixins.forEach(function (mixin) {
      vue_esm["default"].mixin(mixin);
    });
  });
}

var app_module_routes = [{ path: '/', redirect: rootPath }].concat(toConsumableArray_default()(keys_default()(modules).filter(function (key) {
  return !!modules[key].routes;
}).map(function (key) {
  return modules[key].routes;
}).reduce(function (a, b) {
  return a.concat(b);
}, [])), [{ path: '*', redirect: '/' }]);

var router = null;

var app_module_routerAsync = function routerAsync() {
  if (!router) {
    router = new vue_router_esm["a" /* default */]({
      mode: 'history',
      routes: app_module_routes,
      scrollBehavior: function scrollBehavior() {
        return { x: 0, y: 0 };
      }
    });
  }

  return router;
};

var app_module_buildStores = function buildStores() {
  var output = {};

  keys_default()(modules).filter(function (key) {
    return !!modules[key].store;
  }).forEach(function (key) {
    output[key] = modules[key].store;
  });

  return output;
};

var app_module_store = null;

var app_module_storeAsync = function storeAsync() {
  if (!app_module_store) {
    app_module_store = new vuex_esm["a" /* default */].Store({ modules: app_module_buildStores() });
  }

  return app_module_store;
};

/* harmony default export */ var app_module = ({
  setupComponentsFiltersDirectivesAndMixins: setupComponentsFiltersDirectivesAndMixins,
  routerAsync: app_module_routerAsync,
  storeAsync: app_module_storeAsync
});

// end - boilerplate code
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./src/components/SvgIcon/index.vue
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ var SvgIcon = ({
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName: function iconName() {
      return '#icon-' + this.iconClass;
    },
    svgClass: function svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69eaab1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/SvgIcon/index.vue
var SvgIcon_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    _vm._g(
      { class: _vm.svgClass, attrs: { "aria-hidden": "true" } },
      _vm.$listeners
    ),
    [_c("use", { attrs: { "xlink:href": _vm.iconName } })]
  )
}
var SvgIcon_staticRenderFns = []
SvgIcon_render._withStripped = true
var SvgIcon_esExports = { render: SvgIcon_render, staticRenderFns: SvgIcon_staticRenderFns }
/* harmony default export */ var components_SvgIcon = (SvgIcon_esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69eaab1e", SvgIcon_esExports)
  }
}
// CONCATENATED MODULE: ./src/components/SvgIcon/index.vue
var SvgIcon_disposed = false
function SvgIcon_injectStyle (ssrContext) {
  if (SvgIcon_disposed) return
  __webpack_require__("gVkB")
}
var SvgIcon_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var SvgIcon___vue_template_functional__ = false
/* styles */
var SvgIcon___vue_styles__ = SvgIcon_injectStyle
/* scopeId */
var SvgIcon___vue_scopeId__ = "data-v-69eaab1e"
/* moduleIdentifier (server only) */
var SvgIcon___vue_module_identifier__ = null
var SvgIcon_Component = SvgIcon_normalizeComponent(
  SvgIcon,
  components_SvgIcon,
  SvgIcon___vue_template_functional__,
  SvgIcon___vue_styles__,
  SvgIcon___vue_scopeId__,
  SvgIcon___vue_module_identifier__
)
SvgIcon_Component.options.__file = "src/components/SvgIcon/index.vue"
if (SvgIcon_Component.esModule && Object.keys(SvgIcon_Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-69eaab1e", SvgIcon_Component.options)
  } else {
    hotAPI.reload("data-v-69eaab1e", SvgIcon_Component.options)
' + '  }
  module.hot.dispose(function (data) {
    SvgIcon_disposed = true
  })
})()}

/* harmony default export */ var src_components_SvgIcon = (SvgIcon_Component.exports);

// CONCATENATED MODULE: ./src/icons/index.js

 // svg组件

// register globally
vue_esm["default"].component('svg-icon', src_components_SvgIcon);

var req = __webpack_require__("90Fk");
var requireAll = function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
};
requireAll(req);
// CONCATENATED MODULE: ./src/main.js










 // Internationalization
 // icon

vue_esm["default"].use(vue_router_esm["a" /* default */]);
vue_esm["default"].config.productionTip = "development" === 'production';
// Vue.use(ElementUI);
vue_esm["default"].use(vuex_esm["a" /* default */]);
app_module.setupComponentsFiltersDirectivesAndMixins();
firebaseInit();

vue_esm["default"].use(element_ui_common_default.a, {
  size: js_cookie_default.a.get('size') || 'medium', // set element-ui default size
  i18n: function i18n(key, value) {
    return src_lang.t(key, value);
  }
});
// eslint-disable-next-line
new vue_esm["default"]({
  el: '#app',
  store: app_module.storeAsync(),
  router: app_module.routerAsync(),
  i18n: src_lang,
  template: '<app/>',
  components: { App: src_app }
});

/***/ }),

/***/ "O26P":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qgzI");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3f3d6fa8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8f68016\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./activity.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-d8f68016\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./activity.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ODCA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "OLl3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-excel",
  "use": "icon-excel-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-excel\"><path d=\"M78.208 16.576v8.384h38.72v5.376h-38.72v8.704h38.72v5.376h-38.72v8.576h38.72v5.376h-38.72v8.576h38.72v5.376h-38.72v8.576h38.72v5.376h-38.72v8.512h38.72v5.376h-38.72v11.136H128v-94.72H78.208zM0 114.368L72.128 128V0L0 13.632v100.736z\" /><path d=\"M28.672 82.56h-11.2l14.784-23.488-14.08-22.592h11.52l8.192 14.976 8.448-14.976h11.136l-14.08 22.208L58.368 82.56H46.656l-8.768-15.68z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "OOLB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-example",
  "use": "icon-example-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-example\"><path d=\"M96.258 57.462h31.421C124.794 27.323 100.426 2.956 70.287.07v31.422a32.856 32.856 0 0 1 25.971 25.97zm-38.796-25.97V.07C27.323 2.956 2.956 27.323.07 57.462h31.422a32.856 32.856 0 0 1 25.97-25.97zm12.825 64.766v31.421c30.46-2.885 54.507-27.253 57.713-57.712H96.579c-2.886 13.466-13.146 23.726-26.292 26.291zM31.492 70.287H.07c2.886 30.46 27.253 54.507 57.713 57.713V96.579c-13.466-2.886-23.726-13.146-26.291-26.292z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "PQZG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "PnGU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("DMMu");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1bd954fb", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74017252\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./email-unverified.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-74017252\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./email-unverified.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Pv/A":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pPgk");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("17f1abbc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-36a124af\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-36a124af\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Pvew":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "PwkO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.set-language[data-v-47227766] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "QBsE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7pS5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a793aad4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a92822f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./file-upload.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a92822f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./file-upload.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "QSLb":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "QjmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-password",
  "use": "icon-password-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-password\"><path d=\"M108.8 44.322H89.6v-5.36c0-9.04-3.308-24.163-25.6-24.163-23.145 0-25.6 16.881-25.6 24.162v5.361H19.2v-5.36C19.2 15.281 36.798 0 64 0c27.202 0 44.8 15.281 44.8 38.961v5.361zm-32 39.356c0-5.44-5.763-9.832-12.8-9.832-7.037 0-12.8 4.392-12.8 9.832 0 3.682 2.567 6.808 6.407 8.477v11.205c0 2.718 2.875 4.962 6.4 4.962 3.524 0 6.4-2.244 6.4-4.962V92.155c3.833-1.669 6.393-4.795 6.393-8.477zM128 64v49.201c0 8.158-8.645 14.799-19.2 14.799H19.2C8.651 128 0 121.359 0 113.201V64c0-8.153 8.645-14.799 19.2-14.799h89.6c10.555 0 19.2 6.646 19.2 14.799z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Qn9o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-screenfull",
  "use": "icon-screenfull-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-screenfull\"><path d=\"M38.47 52L52 38.462l-23.648-23.67L43.209 0H.035L0 43.137l14.757-14.865L38.47 52zm74.773 47.726L89.526 76 76 89.536l23.648 23.672L84.795 128h43.174L128 84.863l-14.757 14.863zM89.538 52l23.668-23.648L128 43.207V.038L84.866 0 99.73 14.76 76 38.472 89.538 52zM38.46 76L14.792 99.651 0 84.794v43.173l43.137.033-14.865-14.757L52 89.53 38.46 76z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Qpzp":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "R2jY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-qq",
  "use": "icon-qq-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-qq\"><path d=\"M18.448 57.545l-.244-.744-.198-.968-.132-.53v-2.181l.236-.859.24-.908.317-.953.428-1.06.561-1.103.794-1.104v-.773l.077-.724.123-.984.34-1.106.313-1.194.25-.548.289-.511.371-.569.405-.423v-2.73l.234-1.407.236-1.633.42-1.955.577-2.035.43-1.118.426-1.217.468-1.135.559-1.216.57-1.332.655-1.247.737-1.331.929-1.33.43-.762.457-.624.995-1.406 1.025-1.403 1.163-1.444 1.246-1.405 1.352-1.384 1.41-1.423 1.708-1.536 1.083-.934 1.322-1.008 1.34-.89 1.448-.855 1.392-.76 1.57-.63 1.667-.775 1.657-.532 1.653-.552 1.787-.548 1.785-.417 1.876-.347L59.128.68l1.879-.245 1.876-.252 2.002-.106h5.912l1.97.243 1.981.231 2.019.207 1.874.441 1.979.413 1.857.475 2.035.53 1.862.646 1.782.738 1.904.78 1.736.853 1.689.95 1.655 1.044 1.425.971.662.548.693.401 1.323 1.1 1.115 1.064 1.112 1.1 1.083 1.214.894 1.178 1.064 1.217.74 1.306.752 1.162.798 1.352.661 1.175 1.113 2.489.546 1.286.428 1.192.428 1.294.384 1.217.267 1.047.347 1.231.607 2.198.388 1.924.253 1.861.217 1.497.342 2.28.077.362.274.41.737 1.18.473.8.42.832.534.892.472 1.07.307 1.093.334 1.2.252 1.232.115.605.106.746v.648l-.106.643v.8l-.192.774-.35 1.5-.403.76-.299.852v.213l.142.264.4.623 1.746 2.53 1.377 1.9.66 1.267.889 1.389.774 1.52.893 1.627.894 1.828 1.006 2.069.567 1.268.518 1.239.447 1.307.44 1.175.336 1.235.342 1.16.432 2.261.343 2.31.235 2.05v2.891l-.158 1.025-.226 1.768-.308 1.59-.48 1.44-.18.588-.336.707-.28.493-.375.607-.33.383-.42.494-.375.4-.401.34-.48.207-.432.207-.355.114h-.543l-.346-.114-.66-.32-.302-.212-.317-.223-.347-.304-.35-.342-.579-.63-.684-.89-.539-.917-.538-.734-.526-.855-.741-1.517-.833-1.579-.098-.055h-.138l-.338.247-.196.415-.326.516-.567 1.533-.856 2.182-1.096 2.626-.824 1.308-.864 1.366-1.027 1.536-1.09 1.503-.557.68-.676.743-1.555 1.497.136.135.21.214.777.446 3.235 1.524 1.41.779 1.347.756 1.332.953 1.187.982.574.443.432.511.445.593.367.643.198.533.242.64.105.554.115.647-.115.433v.44l-.105.454-.242.415-.092.325-.22.394-.587.784-.543.627-.42.47-.35.348-.893.638-1.01.556-1.077.532-1.155.511-1.287.495-.693.207-.608.167-1.496.342-1.545.325-1.552.323-1.689.27-1.74.072-1.785.21h-5.539l-1.998-.114-1.86-.168-2.005-.27-1.99-.209-2.095-.286-2.03-.495-1.981-.374-1.968-.552-2.019-.707-1.98-.585-1.044-.342-.927-.323-.586-.223-.582-.12h-1.647l-1.904-.131-.962-.096-1.24-.135-.795.705-1.085.665-1.471.701-1.628.875-.99.475-1.033.376-2.281.914-1.24.305-1.3.343-1.803.344-1.13.086-1.193.1-1.246.135-1.45.053h-5.926l-3.346-.053-3.25-.321-1.644-.23-1.589-.23-1.546-.227-1.547-.305-1.442-.456-1.434-.325-1.294-.51-1.223-.474-1.142-.533-.99-.583-.984-.71-.336-.343-.44-.415-.334-.362-.3-.417-.278-.415-.215-.42-.311-.89-.109-.46-.138-.51v-.473l.138-.533v-.53l.109-.53v-1.069l.052-.564.259-.647.215-.646.39-.779.286-.3.236-.348.615-.738.49-.38.464-.266.428-.338.676-.21.543-.324.676-.341.77-.227.775-.231.897-.192.85-.11 1.008-.13 1.093-.081.284-.092h.063l.137-.115v-.13l-.2-.266-.58-.27-1.45-1.231-.975-.761-1.127-.967-1.136-1.082-1.181-1.382-1.36-1.558-.508-.843-.672-.87-.58-1.007-.522-1.1-.704-1.047-.459-1.194-.547-1.192-.546-1.33-.397-1.273-.378-1.575-.112-.057h-.115l-.059-.113h-.14l-.23.113-.114.057-.158.264-.057.321-.119.286-.206.477-.664 1.157-.345.701-.546.612-.58.736-.641.816-.677.724-.795.701-.734.658-.814.524-.89.546-.855.325-1.008.247-.99.095h-.233l-.228-.095-.18-.384-.29-.188-.38-.912-.237-.493-.255-.707-.21-.734-.113-.724-.313-1.648-.12-.972v-3.185l.12-2.379.196-1.214.23-1.252.21-1.347.374-1.254.42-1.443.431-1.407.578-1.448.545-1.38.754-1.4.699-1.52.855-1.425 1.006-1.538 1.023-1.382 1.069-1.538.891-1.071 1.142-1.227 1.202-1.237.56-.59.678-.662.985-.836 1.012-.853 1.647-1.446 1.242-.889z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "R6TZ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BLO3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("58d72cc9", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-616779a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-616779a0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RG2q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.team-uploader{\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.team-uploader:hover {\n  border-color: #409EFF;\n}\n.team-uploader-icon {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports


/***/ }),

/***/ "RMpR":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cYMA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("b86a6c10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-56777f84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-56777f84\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "RjYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-chart",
  "use": "icon-chart-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-chart\"><path d=\"M0 54.857h36.571V128H0V54.857zM91.429 27.43H128V128H91.429V27.429zM45.714 0h36.572v128H45.714V0z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Rrua":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n#app > .version-app[data-v-ebb540f2] {\n  position: absolute;\n  color: #909399;\n  left: 10px;\n  bottom: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "SBEl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-international",
  "use": "icon-international-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-international\"><path d=\"M83.287 103.01c-1.57-3.84-6.778-10.414-15.447-19.548-2.327-2.444-2.182-4.306-1.338-9.862v-.64c.553-3.81 1.513-6.05 14.313-8.087 6.516-1.018 8.203 1.57 10.589 5.178l.785 1.193a12.625 12.625 0 0 0 6.43 5.207c1.134.524 2.53 1.164 4.421 2.24 4.596 2.53 4.596 5.41 4.596 11.753v.727a26.91 26.91 0 0 1-5.178 17.454 59.055 59.055 0 0 1-19.025 11.026c3.49-6.546.814-14.313 0-16.553l-.146-.087zM64 5.12a58.502 58.502 0 0 1 25.484 5.818 54.313 54.313 0 0 0-12.859 10.327c-.93 1.28-1.716 2.473-2.472 3.579-2.444 3.694-3.637 5.352-5.818 5.614a25.105 25.105 0 0 1-4.219 0c-4.276-.29-10.094-.64-11.956 4.422-1.193 3.23-1.396 11.956 2.444 16.495.66 1.077.778 2.4.32 3.578a7.01 7.01 0 0 1-2.066 3.229 18.938 18.938 0 0 1-2.909-2.91 18.91 18.91 0 0 0-8.32-6.603c-1.25-.349-2.647-.64-3.985-.93-3.782-.786-8.03-1.688-9.019-3.812a14.895 14.895 0 0 1-.727-5.818 21.935 21.935 0 0 0-1.396-9.25 8.873 8.873 0 0 0-5.557-4.946A58.705 58.705 0 0 1 64 5.12zM0 64c0 35.346 28.654 64 64 64 35.346 0 64-28.654 64-64 0-35.346-28.654-64-64-64C28.654 0 0 28.654 0 64z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "STxz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("+0ZI");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4d66b7a2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0017d2d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-detail.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-0017d2d9\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-detail.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "SUo5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "SVqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-bug",
  "use": "icon-bug-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-bug\"><path d=\"M127.88 73.143c0 1.412-.506 2.635-1.518 3.669-1.011 1.033-2.209 1.55-3.592 1.55h-17.887c0 9.296-1.783 17.178-5.35 23.645l16.609 17.044c1.011 1.034 1.517 2.257 1.517 3.67 0 1.412-.506 2.635-1.517 3.668-.958 1.033-2.155 1.55-3.593 1.55-1.438 0-2.635-.517-3.593-1.55l-15.811-16.063a15.49 15.49 0 0 1-1.196 1.06c-.532.434-1.65 1.208-3.353 2.322a50.104 50.104 0 0 1-5.192 2.974c-1.758.87-3.94 1.658-6.546 2.364-2.607.706-5.189 1.06-7.748 1.06V47.044H58.89v73.062c-2.716 0-5.417-.367-8.106-1.102-2.688-.734-5.003-1.631-6.945-2.692a66.769 66.769 0 0 1-5.268-3.179c-1.571-1.057-2.73-1.94-3.476-2.65L33.9 109.34l-14.611 16.877c-1.066 1.14-2.344 1.711-3.833 1.711-1.277 0-2.422-.434-3.434-1.304-1.012-.978-1.557-2.187-1.635-3.627-.079-1.44.333-2.705 1.236-3.794l16.129-18.51c-3.087-6.197-4.63-13.644-4.63-22.342H5.235c-1.383 0-2.58-.517-3.592-1.55S.125 74.545.125 73.132c0-1.412.506-2.635 1.518-3.668 1.012-1.034 2.21-1.55 3.592-1.55h17.887V43.939L9.308 29.833c-1.012-1.033-1.517-2.256-1.517-3.669 0-1.412.505-2.635 1.517-3.668 1.012-1.034 2.21-1.55 3.593-1.55s2.58.516 3.593 1.55l13.813 14.106h67.396l13.814-14.106c1.012-1.034 2.21-1.55 3.592-1.55 1.384 0 2.581.516 3.593 1.55 1.012 1.033 1.518 2.256 1.518 3.668 0 1.413-.506 2.636-1.518 3.67l-13.814 14.105v23.975h17.887c1.383 0 2.58.516 3.593 1.55 1.011 1.033 1.517 2.256 1.517 3.668l-.005.01zM89.552 26.175H38.448c0-7.23 2.489-13.386 7.466-18.469C50.892 2.623 56.92.082 64 .082c7.08 0 13.108 2.541 18.086 7.624 4.977 5.083 7.466 11.24 7.466 18.469z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "Ta+H":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ic9d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a055ff60", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07d0a174\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./image-upload.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07d0a174\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./image-upload.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "TgHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-peoples",
  "use": "icon-peoples-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-peoples\"><path d=\"M95.648 118.762c0 5.035-3.563 9.121-7.979 9.121H7.98c-4.416 0-7.979-4.086-7.979-9.121C0 100.519 15.408 83.47 31.152 76.75c-9.099-6.43-15.216-17.863-15.216-30.987v-9.128c0-20.16 14.293-36.518 31.893-36.518s31.894 16.358 31.894 36.518v9.122c0 13.137-6.123 24.556-15.216 30.993 15.738 6.726 31.141 23.769 31.141 42.012z\" /><path d=\"M106.032 118.252h15.867c3.376 0 6.101-3.125 6.101-6.972 0-13.957-11.787-26.984-23.819-32.123 6.955-4.919 11.638-13.66 11.638-23.704v-6.985c0-15.416-10.928-27.926-24.39-27.926-1.674 0-3.306.193-4.89.561 1.936 4.713 3.018 9.974 3.018 15.526v9.121c0 13.137-3.056 23.111-11.066 30.993 14.842 4.41 27.312 23.42 27.541 41.509z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "TlbJ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "TrdI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "UKI4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("wrPP");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("76c2f92d", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-407cd8a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-list.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-407cd8a6\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "UWrJ":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("nkP+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5f6c9ec4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ff25a2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ff25a2c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Uc0E":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("r3Ym");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("511bb20b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c5444a14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c5444a14\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ue8Q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.set-language[data-v-53bfe5cb] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "VGLB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("m01e");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4d3e4107", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b65f3320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-import-csv.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b65f3320\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-import-csv.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "VQ92":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "VUyi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("yVSS");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("718863e3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05ba6a4c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05ba6a4c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "VdD3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 130 130",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 130 130\" id=\"icon-user\"><path d=\"M63.444 64.996c20.633 0 37.359-14.308 37.359-31.953 0-17.649-16.726-31.952-37.359-31.952-20.631 0-37.36 14.303-37.358 31.952 0 17.645 16.727 31.953 37.359 31.953zM80.57 75.65H49.434c-26.652 0-48.26 18.477-48.26 41.27v2.664c0 9.316 21.608 9.325 48.26 9.325H80.57c26.649 0 48.256-.344 48.256-9.325v-2.663c0-22.794-21.605-41.271-48.256-41.271z\" stroke=\"#979797\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "W7jK":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "WHiB":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "WU6E":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Wode":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("jHxn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5f7f95aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24b088b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24b088b0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WpYO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "XGA4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Hg/M");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("011071ec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-663ca114\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-663ca114\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "XGY6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("cd49");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6de01eae", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-39704914\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-39704914\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Xgqo":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ibri");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("894143ba", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3004e8ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3004e8ae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Y/El":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "Y4jG":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "YBJj":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "YEm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-ic_category",
  "use": "icon-ic_category-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_category\">\n<path d=\"M53.5,78.8v10.8H69c1.9,0,3.5,1.6,3.5,3.5S71,96.6,69,96.6H31c-1.9,0-3.5-1.6-3.5-3.5s1.6-3.5,3.5-3.5h15.5V78.8\n\tc-11.2-1.5-20.2-10-22.4-21h-4c-3.9,0-7-3.2-7-7V36.6c0-3.9,3.2-7,7-7h3.5v-3.4c0-3.9,3.2-7,7-7h38.7c3.9,0,7,3.2,7,7v3.4h3.5\n\tc3.9,0,7,3.2,7,7v14.1c0,3.9-3.2,7-7,7h-4C73.7,68.7,64.7,77.3,53.5,78.8z M23.6,36.6h-3.5v14.1h3.5V36.6z M76.4,36.6v14.1h3.5V36.6\n\tH76.4z M30.6,26.2v26.4c0,10.7,8.7,19.4,19.4,19.4s19.4-8.7,19.4-19.4V26.2H30.6z\" />\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "YZ+8":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "YaZN":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.set-language[data-v-825d0c1c] {\n  position: absolute;\n  font-size: 25px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "YkD6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("G2aV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("46b22673", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-26a19b9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./privacyPolicy.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-26a19b9a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./privacyPolicy.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ZKfx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ZQtL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("g/ne");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("437327c4", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c9ef7c60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c9ef7c60\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./player-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ZWNV":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ZqWO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TlbJ");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1de0fc4a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a59b220\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a59b220\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "a5Jc":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.team-uploader{\n  border: 1px dashed #d9d9d9;\n  border-radius: 6px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  width: 178px;\n  height: 178px;\n}\n.team-uploader:hover {\n  border-color: #409EFF;\n}\n.team-uploader-icon {\n  font-size: 28px;\n  color: #8c939d;\n  width: 178px;\n  height: 178px;\n  line-height: 178px;\n  text-align: center;\n}\n.avatar {\n  width: 178px;\n  height: 178px;\n  display: block;\n}\n", ""]);

// exports


/***/ }),

/***/ "aJWS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.el-menu.collapsed span[data-v-3ff739f8] {\n    visibility: hidden;\n}\n", ""]);

// exports


/***/ }),

/***/ "aLWN":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("fZp9");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("c858c222", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34c287b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./password-reset.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34c287b2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./password-reset.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "agpV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2MVh");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("43a19dc2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0f85c0c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-form.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0f85c0c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./manager-form.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "azsu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("aJWS");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9c35a402", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ff739f8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./menu.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3ff739f8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./menu.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bLmq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("pkvw");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0e804be2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57b264e2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-57b264e2\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bb3d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "bhRE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ODCA");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("49a9d37a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a5f2a12\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1a5f2a12\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./club-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "bqlW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "byeV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("xzoO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("14ee2287", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7da6c4c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7da6c4c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./field-manager-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "cYMA":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "cd49":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "cd9B":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "dLIY":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("mpxn");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("50fe9aaf", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f0023e5\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./image-carousel.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5f0023e5\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./image-carousel.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "dME6":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "e0TX":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ejHW":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "fZp9":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.set-language[data-v-34c287b2] {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n", ""]);

// exports


/***/ }),

/***/ "g/ne":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "gVkB":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("vQpd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("915974e8", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69eaab1e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-69eaab1e\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "gbTs":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZKfx");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("50aa1e24", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c247ad2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-activity.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c247ad2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-activity.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "geVL":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YBJj");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("98add94e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5dac92f4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5dac92f4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hFvu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ZWNV");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("827f8600", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-709f65d5\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-settings.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-709f65d5\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-settings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hdtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-theme",
  "use": "icon-theme-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-theme\"><path d=\"M125.5 36.984L95.336 2.83C93.735 1.018 91.565 0 89.3 0c-2.263 0-4.433 1.018-6.033 2.83l-3.786 4.286c-1.6 1.812-3.77 2.83-6.032 2.831H54.553c-2.263 0-4.434-1.018-6.033-2.83L44.734 2.83C43.134 1.018 40.964 0 38.701 0c-2.263 0-4.434 1.018-6.034 2.83L2.5 36.984C.9 38.796 0 41.254 0 43.815c0 2.562.899 5.02 2.5 6.831L14.565 64.31c2.178 2.468 5.367 3.403 8.33 2.444 1.35-.435 2.709.592 2.709 2.18v49.407c0 5.313 3.84 9.66 8.532 9.66h59.726c4.693 0 8.532-4.347 8.532-9.66V68.934c0-1.59 1.36-2.616 2.71-2.181 2.962.96 6.15.024 8.329-2.444L125.5 50.646c1.6-1.811 2.499-4.269 2.499-6.83 0-2.563-.899-5.02-2.5-6.832z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "hugX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("E+mH");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("08533ccd", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../css-loader/index.js?{\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ef6ccc6\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0&bustCache!./upload-2.vue", function() {
     var newContent = require("!!../css-loader/index.js?{\"sourceMap\":false}!../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-5ef6ccc6\",\"scoped\":false,\"hasInlineConfig\":false}!../vue-loader/lib/selector.js?type=styles&index=0&bustCache!./upload-2.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hz2d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.version[data-v-13e1eccb] {\n    position: absolute;\n    color: #909399;\n    left: 20px;\n    bottom: 10px;\n}\n", ""]);

// exports


/***/ }),

/***/ "iH+/":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("FUO8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("0e7ffce2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33a14c38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./termsConditions.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-33a14c38\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./termsConditions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "iKfW":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("SUo5");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5e266f01", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c8ebf40\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./entity-link.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7c8ebf40\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./entity-link.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ibri":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ic9d":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ig9B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-money",
  "use": "icon-money-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-money\"><path d=\"M54.122 127.892v-28.68H7.513V87.274h46.609v-12.4H7.513v-12.86h38.003L.099 0h22.6l32.556 45.07c3.617 5.144 6.44 9.611 8.487 13.385 1.788-3.05 4.89-7.779 9.301-14.186L103.93 0h24.01L82.385 62.013h38.34v12.862h-46.41v12.4h46.41v11.937h-46.41v28.68H54.123z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "itn9":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1ehH");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("04b9f13a", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-78c3cb9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-history-full.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-78c3cb9c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "j4TU":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oR9o");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("06d23a5c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6cefe4af\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6cefe4af\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./tournament-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "j4uu":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WU6E");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7eb7845e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05fb2faf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-05fb2faf\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jHxn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "jRi0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-shopping",
  "use": "icon-shopping-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-shopping\"><path d=\"M42.913 101.36c1.642 0 3.198.332 4.667.996a12.28 12.28 0 0 1 3.89 2.772c1.123 1.184 1.987 2.582 2.592 4.193.605 1.612.908 3.318.908 5.118 0 1.8-.303 3.507-.908 5.118-.605 1.611-1.469 3.01-2.593 4.194a13.3 13.3 0 0 1-3.889 2.843 10.582 10.582 0 0 1-4.667 1.066c-1.729 0-3.306-.355-4.732-1.066a13.604 13.604 0 0 1-3.825-2.843c-1.123-1.185-1.988-2.583-2.593-4.194a14.437 14.437 0 0 1-.907-5.118c0-1.8.302-3.506.907-5.118.605-1.61 1.47-3.009 2.593-4.193a12.515 12.515 0 0 1 3.825-2.772c1.426-.664 3.003-.996 4.732-.996zm53.932.285c1.643 0 3.22.331 4.733.995a11.386 11.386 0 0 1 3.889 2.772c1.08 1.185 1.945 2.583 2.593 4.194.648 1.61.972 3.317.972 5.118 0 1.8-.324 3.506-.972 5.117-.648 1.611-1.513 3.01-2.593 4.194a12.253 12.253 0 0 1-3.89 2.843 11 11 0 0 1-4.732 1.066 10.58 10.58 0 0 1-4.667-1.066 12.478 12.478 0 0 1-3.824-2.843c-1.08-1.185-1.945-2.583-2.593-4.194a13.581 13.581 0 0 1-.973-5.117c0-1.801.325-3.507.973-5.118.648-1.611 1.512-3.01 2.593-4.194a11.559 11.559 0 0 1 3.824-2.772 11.212 11.212 0 0 1 4.667-.995zm21.781-80.747c2.42 0 4.3.355 5.64 1.066 1.34.71 2.29 1.587 2.852 2.63a6.427 6.427 0 0 1 .778 3.34c-.044 1.185-.195 2.204-.454 3.057-.26.853-.8 2.606-1.62 5.26a589.268 589.268 0 0 1-2.788 8.743 1236.373 1236.373 0 0 0-3.047 9.453c-.994 3.128-1.75 5.592-2.269 7.393-1.123 3.79-2.55 6.42-4.278 7.89-1.728 1.469-3.846 2.203-6.352 2.203H39.023l1.945 12.795h65.342c4.148 0 6.223 1.943 6.223 5.828 0 1.896-.41 3.53-1.232 4.905-.821 1.374-2.442 2.061-4.862 2.061H38.505c-1.729 0-3.176-.426-4.343-1.28-1.167-.852-2.14-1.966-2.917-3.34a21.277 21.277 0 0 1-1.88-4.478 44.128 44.128 0 0 1-1.102-4.55c-.087-.568-.324-1.942-.713-4.122-.39-2.18-.865-4.904-1.426-8.174l-1.88-10.947c-.692-4.027-1.383-8.079-2.075-12.154-1.642-9.572-3.5-20.234-5.574-31.986H6.87c-1.296 0-2.377-.356-3.24-1.067a9.024 9.024 0 0 1-2.14-2.558 10.416 10.416 0 0 1-1.167-3.2C.108 8.53 0 7.488 0 6.54c0-1.896.583-3.46 1.75-4.69C2.917.615 4.494 0 6.482 0h13.095c1.728 0 3.111.284 4.148.853 1.037.569 1.858 1.28 2.463 2.132a8.548 8.548 0 0 1 1.297 2.701c.26.948.475 1.754.648 2.417.173.758.346 1.825.519 3.199.173 1.374.345 2.772.518 4.193.26 1.706.519 3.507.778 5.403h88.678z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "jYcp":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ejHW");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("dba126ea", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c27f1fe8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c27f1fe8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./position-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jmxS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("hz2d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("948c9796", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13e1eccb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13e1eccb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./index.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "jyal":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("rJ2W");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7c4d2923", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d6949c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-new.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6d6949c8\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-new.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "kA1i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-guide 2",
  "use": "icon-guide 2-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1000 1000\" id=\"icon-guide 2\"><path d=\"M11.576 547.9l282.848 126.404 409.285-383.26 137.057-128.341L361.234 714.22l362.77 146.362c8.742 3.327 18.733-1.33 21.855-10.644v-.666L999.985.374 10.327 514.636c-8.742 4.657-11.864 15.302-8.117 24.616 2.497 3.991 5.62 7.318 9.366 8.648zM360.61 999.626l141.112-161.663-141.112-61.206v222.869z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "kuNs":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "m01e":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "mPGO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("F9zM");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("79e9b124", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08019e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-show.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-08019e22\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-show.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "mpxn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "n6A1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("bb3d");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("d0dac1aa", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60664e10\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-60664e10\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./document-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nkP+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.excel-upload-input[data-v-3ff25a2c]{\n  display: none;\n  z-index: -9999;\n}\n.drop[data-v-3ff25a2c]{\n  border: 2px dashed #bbb;\n  width: 80%;\n  height: 30%;\n  line-height: 160px;\n  margin: 0 auto;\n  font-size: 24px;\n  border-radius: 5px;\n  text-align: center;\n  color: #bbb;\n  position: relative;\n}\n", ""]);

// exports


/***/ }),

/***/ "no6o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-eye-open",
  "use": "icon-eye-open-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye-open\"><defs><style></style></defs><path d=\"M512 128q69.675 0 135.51 21.163t115.498 54.997 93.483 74.837 73.685 82.006 51.67 74.837 32.17 54.827L1024 512q-2.347 4.992-6.315 13.483T998.87 560.17t-31.658 51.669-44.331 59.99-56.832 64.34-69.504 60.16-82.347 51.5-94.848 34.687T512 896q-69.675 0-135.51-21.163t-115.498-54.826-93.483-74.326-73.685-81.493-51.67-74.496-32.17-54.997L0 513.707q2.347-4.992 6.315-13.483t18.816-34.816 31.658-51.84 44.331-60.33 56.832-64.683 69.504-60.331 82.347-51.84 94.848-34.816T512 128.085zm0 85.333q-46.677 0-91.648 12.331t-81.152 31.83-70.656 47.146-59.648 54.485-48.853 57.686-37.675 52.821-26.325 43.99q12.33 21.674 26.325 43.52t37.675 52.351 48.853 57.003 59.648 53.845T339.2 767.02t81.152 31.488T512 810.667t91.648-12.331 81.152-31.659 70.656-46.848 59.648-54.186 48.853-57.344 37.675-52.651T927.957 512q-12.33-21.675-26.325-43.648t-37.675-52.65-48.853-57.345-59.648-54.186-70.656-46.848-81.152-31.659T512 213.334zm0 128q70.656 0 120.661 50.006T682.667 512 632.66 632.661 512 682.667 391.339 632.66 341.333 512t50.006-120.661T512 341.333zm0 85.334q-35.328 0-60.33 25.002T426.666 512t25.002 60.33T512 597.334t60.33-25.002T597.334 512t-25.002-60.33T512 426.666z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "o0ps":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("yHls");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ba9c1a10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76d25228\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-76d25228\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "oR9o":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "oSYw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-table",
  "use": "icon-table-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-table\"><path d=\"M.006.064h127.988v31.104H.006V.064zm0 38.016h38.396v41.472H.006V38.08zm0 48.384h38.396v41.472H.006V86.464zM44.802 38.08h38.396v41.472H44.802V38.08zm0 48.384h38.396v41.472H44.802V86.464zM89.598 38.08h38.396v41.472H89.598zm0 48.384h38.396v41.472H89.598z\" /><path d=\"M.006.064h127.988v31.104H.006V.064zm0 38.016h38.396v41.472H.006V38.08zm0 48.384h38.396v41.472H.006V86.464zM44.802 38.08h38.396v41.472H44.802V38.08zm0 48.384h38.396v41.472H44.802V86.464zM89.598 38.08h38.396v41.472H89.598zm0 48.384h38.396v41.472H89.598z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "p7dQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "pPgk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "pYJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-wechat",
  "use": "icon-wechat-usage",
  "viewBox": "0 0 128 110",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 110\" id=\"icon-wechat\"><path d=\"M86.635 33.334c1.467 0 2.917.113 4.358.283C87.078 14.392 67.58.111 45.321.111 20.44.111.055 17.987.055 40.687c0 13.104 6.781 23.863 18.115 32.209l-4.527 14.352 15.82-8.364c5.666 1.182 10.207 2.395 15.858 2.395 1.42 0 2.829-.073 4.227-.189-.886-3.19-1.398-6.53-1.398-9.996 0-20.845 16.98-37.76 38.485-37.76zm-24.34-12.936c3.407 0 5.665 2.363 5.665 5.954 0 3.576-2.258 5.97-5.666 5.97-3.392 0-6.795-2.395-6.795-5.97 0-3.591 3.403-5.954 6.795-5.954zM30.616 32.323c-3.393 0-6.818-2.395-6.818-5.971 0-3.591 3.425-5.954 6.818-5.954 3.392 0 5.65 2.363 5.65 5.954 0 3.576-2.258 5.97-5.65 5.97z\" /><path d=\"M127.945 70.52c0-19.075-18.108-34.623-38.448-34.623-21.537 0-38.5 15.548-38.5 34.623 0 19.108 16.963 34.622 38.5 34.622 4.508 0 9.058-1.2 13.584-2.395l12.414 7.167-3.404-11.923c9.087-7.184 15.854-16.712 15.854-27.471zm-50.928-5.97c-2.254 0-4.53-2.362-4.53-4.773 0-2.378 2.276-4.771 4.53-4.771 3.422 0 5.665 2.393 5.665 4.771 0 2.41-2.243 4.773-5.665 4.773zm24.897 0c-2.24 0-4.498-2.362-4.498-4.773 0-2.378 2.258-4.771 4.498-4.771 3.392 0 5.665 2.393 5.665 4.771 0 2.41-2.273 4.773-5.665 4.773z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "phNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-ic_team",
  "use": "icon-ic_team-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_team\">\n<title>15</title>\n<g>\n\t<path d=\"M81.3,19.4C63.9,19.1,54.5,11.3,52.1,9c-1.2-1.1-3-1.1-4.2,0c-2.4,2.4-11.8,10.1-29.2,10.5c-1.6,0.1-2.9,1.4-2.9,3v22.1\n\t\tc0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8c11.6-9.1,18.6-23.8,18.6-39.3V22.4\n\t\tC84.2,20.8,82.9,19.5,81.3,19.4z\" />\n</g>\n</symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "pkvw":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "qgzI":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "qj5l":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "ql+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-edit",
  "use": "icon-edit-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-edit\"><path d=\"M106.133 67.2a4.797 4.797 0 0 0-4.8 4.8c0 .187.014.36.027.533h-.027V118.4H9.6V26.667h50.133c2.654 0 4.8-2.147 4.8-4.8 0-2.654-2.146-4.8-4.8-4.8H9.6a9.594 9.594 0 0 0-9.6 9.6V118.4c0 5.307 4.293 9.6 9.6 9.6h91.733c5.307 0 9.6-4.293 9.6-9.6V72.533h-.026c.013-.173.026-.346.026-.533 0-2.653-2.146-4.8-4.8-4.8z\" /><path d=\"M125.16 13.373L114.587 2.8c-3.747-3.747-9.854-3.72-13.6.027l-52.96 52.96a4.264 4.264 0 0 0-.907 1.36L33.813 88.533c-.746 1.76-.226 3.534.907 4.68 1.133 1.147 2.92 1.667 4.693.92l31.4-13.293c.507-.213.96-.52 1.36-.907l52.96-52.96c3.747-3.746 3.774-9.853.027-13.6zM66.107 72.4l-18.32 7.76 7.76-18.32L92.72 24.667l10.56 10.56L66.107 72.4zm52.226-52.227l-8.266 8.267-10.56-10.56 8.266-8.267.027-.026 10.56 10.56-.027.026z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "qsCE":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "qssz":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("PQZG");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("9bc8739c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24da51fc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-24da51fc\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "r3Ym":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "r6ir":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ga39");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3f11c3ec", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f9406c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./setting-groups.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8f9406c6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./setting-groups.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "r75F":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "rJ2W":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "s2cW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-component",
  "use": "icon-component-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-component\"><path d=\"M0 0h54.857v54.857H0V0zm0 73.143h54.857V128H0V73.143zm73.143 0H128V128H73.143V73.143zm27.428-18.286C115.72 54.857 128 42.577 128 27.43 128 12.28 115.72 0 100.571 0 85.423 0 73.143 12.28 73.143 27.429c0 15.148 12.28 27.428 27.428 27.428z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sEM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-404",
  "use": "icon-404-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-404\"><path d=\"M121.718 73.272v9.953c3.957-7.584 6.199-16.05 6.199-24.995C127.917 26.079 99.273 0 63.958 0 28.644 0 0 26.079 0 58.23c0 .403.028.806.028 1.21l22.97-25.953h13.34l-19.76 27.187h6.42V53.77l13.728-19.477v49.361H22.998V73.272H2.158c5.951 20.284 23.608 36.208 45.998 41.399-1.44 3.3-5.618 11.263-12.565 12.674-8.607 1.764 23.358.428 46.163-13.178 17.519-4.611 31.938-15.849 39.77-30.513h-13.506V73.272H85.02V59.464l22.998-25.977h13.008l-19.429 27.187h6.421v-7.433l13.727-19.402v39.433h-.027zm-78.24 2.822a10.516 10.516 0 0 1-.996-4.535V44.548c0-1.613.332-3.124.996-4.535a11.66 11.66 0 0 1 2.713-3.68c1.134-1.032 2.49-1.864 4.04-2.468 1.55-.605 3.21-.908 4.982-.908h11.292c1.77 0 3.431.303 4.981.908 1.522.604 2.85 1.41 3.986 2.418l-12.26 16.303v-2.898a1.96 1.96 0 0 0-.665-1.512c-.443-.403-.996-.604-1.66-.604-.665 0-1.218.201-1.661.604a1.96 1.96 0 0 0-.664 1.512v9.071L44.364 77.606a10.556 10.556 0 0 1-.886-1.512zm35.73-4.535c0 1.613-.332 3.124-.997 4.535a11.66 11.66 0 0 1-2.712 3.68c-1.134 1.032-2.49 1.864-4.04 2.469-1.55.604-3.21.907-4.982.907H55.185c-1.77 0-3.431-.303-4.981-.907-1.55-.605-2.906-1.437-4.041-2.47a12.49 12.49 0 0 1-1.384-1.512l13.727-18.217v6.375c0 .605.222 1.109.665 1.512.442.403.996.604 1.66.604.664 0 1.218-.201 1.66-.604a1.96 1.96 0 0 0 .665-1.512V53.87L75.97 36.838c.913.932 1.66 1.99 2.214 3.175.664 1.41.996 2.922.996 4.535v27.011h.028z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "sTIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-form",
  "use": "icon-form-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-form\"><path d=\"M84.068 23.784c-1.02 0-1.877-.32-2.572-.96a8.588 8.588 0 0 1-1.738-2.237 11.524 11.524 0 0 1-1.042-2.621c-.232-.895-.348-1.641-.348-2.238V0h.278c.834 0 1.622.085 2.363.256.742.17 1.645.575 2.711 1.214 1.066.64 2.363 1.535 3.892 2.686 1.53 1.15 3.453 2.664 5.77 4.54 2.502 2.045 4.494 3.771 5.977 5.178 1.483 1.406 2.618 2.6 3.406 3.58.787.98 1.274 1.812 1.46 2.494.185.682.277 1.278.277 1.79v2.046H84.068zM127.3 84.01c.278.682.464 1.535.556 2.558.093 1.023-.37 2.003-1.39 2.94-.463.427-.88.832-1.25 1.215-.372.384-.696.704-.974.96a6.69 6.69 0 0 1-.973.767l-11.816-10.741a44.331 44.331 0 0 0 1.877-1.535 31.028 31.028 0 0 1 1.737-1.406c1.112-.938 2.317-1.343 3.615-1.215 1.297.128 2.363.405 3.197.83.927.427 1.923 1.173 2.989 2.239 1.065 1.065 1.876 2.195 2.432 3.388zM78.23 95.902c2.038 0 3.752-.511 5.143-1.534l-26.969 25.83H18.037c-1.761 0-3.684-.47-5.77-1.407a24.549 24.549 0 0 1-5.838-3.709 21.373 21.373 0 0 1-4.518-5.306c-1.204-2.003-1.807-4.07-1.807-6.202V16.495c0-1.79.44-3.665 1.32-5.626A18.41 18.41 0 0 1 5.04 5.562a21.798 21.798 0 0 1 5.213-3.964C12.198.533 14.237 0 16.37 0h53.24v15.984c0 1.62.278 3.367.834 5.242a16.704 16.704 0 0 0 2.572 5.179c1.159 1.577 2.665 2.898 4.518 3.964 1.853 1.066 4.078 1.598 6.673 1.598h20.295v42.325L85.458 92.45c1.02-1.364 1.529-2.856 1.529-4.476 0-2.216-.857-4.113-2.572-5.69-1.714-1.577-3.776-2.366-6.186-2.366H26.1c-2.409 0-4.448.789-6.116 2.366-1.668 1.577-2.502 3.474-2.502 5.69 0 2.217.834 4.092 2.502 5.626 1.668 1.535 3.707 2.302 6.117 2.302h52.13zM26.1 47.951c-2.41 0-4.449.789-6.117 2.366-1.668 1.577-2.502 3.473-2.502 5.69 0 2.216.834 4.092 2.502 5.626 1.668 1.534 3.707 2.302 6.117 2.302h52.13c2.409 0 4.47-.768 6.185-2.302 1.715-1.534 2.572-3.41 2.572-5.626 0-2.217-.857-4.113-2.572-5.69-1.714-1.577-3.776-2.366-6.186-2.366H26.1zm52.407 64.063l1.807-1.663 3.476-3.196a479.75 479.75 0 0 0 4.587-4.284 500.757 500.757 0 0 1 5.004-4.667c3.985-3.666 8.48-7.758 13.485-12.276l11.677 10.741-13.485 12.404-5.004 4.603-4.587 4.22a179.46 179.46 0 0 0-3.267 3.068c-.88.853-1.367 1.322-1.46 1.407-.463.341-.973.703-1.529 1.087-.556.383-1.112.703-1.668.959-.556.256-1.413.575-2.572.959a83.5 83.5 0 0 1-3.545 1.087 72.2 72.2 0 0 1-3.475.895c-1.112.256-1.946.426-2.502.511-1.112.17-1.854.043-2.224-.383-.371-.426-.464-1.151-.278-2.174.092-.511.278-1.279.556-2.302.278-1.023.602-2.067.973-3.132l1.042-3.005c.325-.938.58-1.577.765-1.918a10.157 10.157 0 0 1 2.224-2.941z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "soaP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("TrdI");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("7fffe174", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f9e9398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1f9e9398\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "tvNc":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("JrO2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("562beebc", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-46590bae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-46590bae\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./referee-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "udEE":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("G0jH");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("3cff95c3", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c557b64\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-history-single.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c557b64\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vQpd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.svg-icon[data-v-69eaab1e] {\n  width: 1em;\n  height: 1em;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}\n.menu-icon[data-v-69eaab1e] {\n  width: 28px;\n  height: 28px;\n  vertical-align: -0.65em;\n}\n", ""]);

// exports


/***/ }),

/***/ "vR5l":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YZ+8");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("694d4b08", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13831732\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./registration.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-13831732\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./registration.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vRhf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-drag",
  "use": "icon-drag-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-drag\"><path d=\"M73.137 29.08h-9.209 29.7L63.886.093 34.373 29.08h20.49v27.035H27.238v17.948h27.625v27.133h18.274V74.063h27.41V56.115h-27.41V29.08zm-9.245 98.827l27.518-26.711H36.59l27.302 26.71zM.042 64.982l27.196 27.029V38.167L.042 64.982zm100.505-26.815V92.01l27.41-27.029-27.41-26.815z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "vUvT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-icon",
  "use": "icon-icon-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-icon\"><path d=\"M115.147.062a13 13 0 0 1 4.94.945c1.55.63 2.907 1.526 4.069 2.688a13.148 13.148 0 0 1 2.761 4.069c.678 1.55 1.017 3.245 1.017 5.086v102.3c0 3.681-1.187 6.733-3.56 9.155-2.373 2.422-5.352 3.633-8.937 3.633H12.992c-3.875 0-7-1.26-9.373-3.779-2.373-2.518-3.56-5.667-3.56-9.445V12.704c0-3.39 1.163-6.345 3.488-8.863C5.872 1.32 8.972.062 12.847.062h102.3zM81.434 109.047c1.744 0 3.003-.412 3.778-1.235.775-.824 1.163-1.914 1.163-3.27 0-1.26-.388-2.325-1.163-3.197-.775-.872-2.034-1.307-3.778-1.307H72.57c.097-.194.145-.485.145-.872V27.09h9.01c1.743 0 2.954-.436 3.633-1.308.678-.872 1.017-1.938 1.017-3.197 0-1.26-.34-2.325-1.017-3.197-.679-.872-1.89-1.308-3.633-1.308H46.268c-1.743 0-2.954.436-3.632 1.308-.678.872-1.018 1.938-1.018 3.197 0 1.26.34 2.325 1.018 3.197.678.872 1.889 1.308 3.632 1.308h8.138v72.075c0 .193.024.339.073.436.048.096.072.242.072.436H46.56c-1.744 0-3.003.435-3.778 1.307-.775.872-1.163 1.938-1.163 3.197 0 1.356.388 2.446 1.163 3.27.775.823 2.034 1.235 3.778 1.235h34.875z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "vmNq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("VQ92");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("76ef3bff", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-388deab0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-388deab0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./category-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "vp8P":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "vuHp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-list",
  "use": "icon-list-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-list\"><path d=\"M1.585 12.087c0 6.616 3.974 11.98 8.877 11.98 4.902 0 8.877-5.364 8.877-11.98 0-6.616-3.975-11.98-8.877-11.98-4.903 0-8.877 5.364-8.877 11.98zM125.86.107H35.613c-1.268 0-2.114 1.426-2.114 2.852v18.255c0 1.712 1.057 2.853 2.114 2.853h90.247c1.268 0 2.114-1.426 2.114-2.853V2.96c0-1.711-1.057-2.852-2.114-2.852zM.106 62.86c0 6.615 3.974 11.979 8.876 11.979 4.903 0 8.877-5.364 8.877-11.98 0-6.616-3.974-11.98-8.877-11.98-4.902 0-8.876 5.364-8.876 11.98zM124.17 50.88H33.921c-1.268 0-2.114 1.425-2.114 2.851v18.256c0 1.711 1.057 2.852 2.114 2.852h90.247c1.268 0 2.114-1.426 2.114-2.852V53.73c0-1.426-.846-2.852-2.114-2.852zM.106 115.913c0 6.616 3.974 11.98 8.876 11.98 4.903 0 8.877-5.364 8.877-11.98 0-6.616-3.974-11.98-8.877-11.98-4.902 0-8.876 5.364-8.876 11.98zm124.064-11.98H33.921c-1.268 0-2.114 1.426-2.114 2.853v18.255c0 1.711 1.057 2.852 2.114 2.852h90.247c1.268 0 2.114-1.426 2.114-2.852v-18.255c0-1.427-.846-2.853-2.114-2.853z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "wYKH":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1xAo");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("202d3546", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07187b70\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-history-single.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-07187b70\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./coach-history-single.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "whpb":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YaZN");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("a1276a24", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-825d0c1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./header.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-825d0c1c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./header.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "wrPP":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "wuZk":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "xerS":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Ue8Q");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("291c0962", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-53bfe5cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./registrationManager.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-53bfe5cb\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./registrationManager.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xzoO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "y4wQ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "y7ee":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("GbHL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("15927c21", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c7726d3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./file-link-list.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4c7726d3\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./file-link-list.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yHls":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "yLTO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e0TX");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("78012ad1", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0fae038\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-history-full.vue", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-c0fae038\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./team-manager-history-full.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "yQyx":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "yVSS":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ "z74U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-guide",
  "use": "icon-guide-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-guide\"><path d=\"M1.482 70.131l36.204 16.18 69.932-65.485-61.38 70.594 46.435 18.735c1.119.425 2.397-.17 2.797-1.363v-.085L127.998.047 1.322 65.874c-1.12.597-1.519 1.959-1.04 3.151.32.511.72.937 1.2 1.107zm44.676 57.821L64.22 107.26l-18.062-7.834v28.527z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "zUKd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__ = __webpack_require__("Wc9H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__ = __webpack_require__("IaZV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build__);


var symbol = new __WEBPACK_IMPORTED_MODULE_0_svg_baker_runtime_browser_symbol___default.a({
  "id": "icon-documentation",
  "use": "icon-documentation-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-documentation\"><path d=\"M71.984 44.815H115.9L71.984 9.642v35.173zM16.094.05h63.875l47.906 38.37v76.74c0 3.392-1.682 6.645-4.677 9.044-2.995 2.399-7.056 3.746-11.292 3.746H16.094c-4.236 0-8.297-1.347-11.292-3.746-2.995-2.399-4.677-5.652-4.677-9.044V12.84C.125 5.742 7.23.05 16.094.05zm71.86 102.32V89.58h-71.86v12.79h71.86zm23.952-25.58V64H16.094v12.79h95.812z\" /></symbol>"
});
var result = __WEBPACK_IMPORTED_MODULE_1_svg_sprite_loader_runtime_browser_sprite_build___default.a.add(symbol);
/* harmony default export */ __webpack_exports__["default"] = (symbol);

/***/ }),

/***/ "zuGX":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("r75F");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("fe5d67e6", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4fc50012\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-edit.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4fc50012\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./user-edit.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "zwJz":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3c2e857df8ebd44a2c68.js